import { a as e, c as t, i as n, l as r, o as i, r as a, s as o, t as s, u as c } from "./FlxChatWrapper-DWjf0z5o.js";
import { r as l, t as u } from "./FlxTaskManager-BTvayi2Y.js";
import { n as d, t as f } from "./PortalContainerContext-Co8FnIZt.js";
import { i as p, n as m, o as h, r as g, t as _ } from "./SuspensePending-B3k-vHs1.js";
import { a as v, d as y, f as b, g as x, h as S, i as C, n as w, o as ee, r as te, s as ne, t as re, u as ie, w as ae } from "./useVoiceUpload-Db2XyZN1.js";
import * as oe from "@flowx/core-sdk";
import { COMMENT_PICKER_IGNORE_ATTRIBUTE as se, ChatMessageType as ce, ComponentIdentifierEnum as le, DefaultMessageType as ue, SseMessageType as de, SseTaskEventType as fe, SseTaskMessageType as T, TaskActions as pe, activeChatSessionIdStore as E, addComponentsToRegistry as me, addInterceptors as he, addProcessEndFunc as ge, addProcessStartFunc as _e, addToNavigationStack as ve, allActiveNodesAndContexts$ as ye, buildCommentAddress as be, buildMessageTimeGroupLabels as xe, canNavigateToTemplateConfig$ as Se, canPopSubprocess$ as Ce, chatRendererAnalyticsConfigs as we, chatStore as Te, closeModal as Ee, commentHasText as De, config as Oe, conversationsListPaginationStore as ke, createCollectionChildDecorationCache as Ae, decorateCollectionChildren as je, deprecatedAlias as Me, dismissProcess as Ne, emitScreenAnalytics as Pe, fetchBulkAssignees as Fe, fetchDocument as Ie, fetchTaskAssignees as Le, fetchTaskComments as Re, fetchTaskHistory as ze, fetchView as Be, fetchViewTasks as Ve, formatDateWithAppSettings as He, formatMessageTimestamp as Ue, getActiveUiFlowSessionId as We, getComponentDefinition as Ge, getCurrentReadOnlyState as Ke, getCurrentRootTemplateConfig$ as qe, getCustomComponents as Je, getEnumeration as Ye, getEnumerationItems as Xe, getEnumerationOptions as Ze, getLastAgentSuggestions as Qe, getMediaItemUrl as $e, getOpenModal as et, getProcessInstanceUuidFromUrl as tt, getReusableTestDataStore as nt, getRootTemplateConfigForId as rt, getStaticAsset as it, getStaticAssetByKey as at, getStaticAssetByKeyTrimmed as ot, getSubstitutionTag as st, getSubstitutionTagContent as ct, getTaskManagerResources as lt, getTemplateConfigByFlowxUuid as ut, getUiFlowBlockedLabels as dt, getUiFlowGlobalTemplateConfigs as ft, getUiFlowRestoredProcessEmbedded as pt, getUiFlowTemplateConfigs as mt, getUrlQueryParamValue as ht, groupSessionsByDate as gt, hideToast as _t, initChat as vt, initChatSession as yt, initProcess as bt, initReusableTest as xt, initSseConnection as St, initTestCustomComponentRuntime as Ct, initUiFlow as wt, isGlobalConfigVisibleForRoot as Tt, isRootTemplateConfig as Et, isUserTaskRoot as Dt, loadChatSessionHistory as Ot, loadConversationsList as kt, loadMoreConversations as At, loadedTemplateIndex as jt, localizeString as D, mockTemplateConfig as Mt, navigateToTemplateConfig as Nt, navigationStack as Pt, nextCommentDraftNumber as Ft, normalizeSuggestedPrompts as It, openModal$ as Lt, popSubprocessFromNavigation as Rt, processNotificationsByActiveProcess$ as zt, processReloadGenerationStore as Bt, publishCommentBox as Vt, publishCommentBoxAnchor as Ht, readOnlyScreenTemplateConfig$ as Ut, registerCommentSessionController as Wt, removeComment as Gt, reportCommentHasText as Kt, resetChatStores as qt, resetComponentDefinitionRegistry as Jt, resetNavigationStack as Yt, resetStores as Xt, resetUiFlowStores as Zt, resolveConnectionOptions as Qt, resolveCustomLoaderProvider as $t, resolveDeprecatedOption as en, resolveMarker as tn, resolveMessageActionsConfig as nn, resolveMessageTimestamp as rn, resolveRootNavigationQueryParams as an, sameViewportRect as on, saveComment as sn, screenAnalyticsOnDisplay$ as cn, screenTemplateConfig$ as ln, setAccessToken as un, setActiveChatSessionId as dn, setProcessInstanceUuidInUrl as fn, snapshotAndClearNavigationStack as pn, startNewUiFlowSession as mn, templateConfigsByParentTemplateId$ as hn, templateSequenceStore as gn, triggerDisplayEvent as _n, uiFlowBlockedReason$ as vn, uiFlowGlobalTemplateConfigsForCurrentRoot$ as yn, uiFlowProcessStore as bn, uiFlowRestoredProcessEmbedded$ as xn, uiFlowTemplates$ as Sn, uiStore$ as Cn, updateBulkTaskAction as wn, updateTaskAction as Tn, updateTaskPriority as En, updateUrlWithQueryParam as Dn, updateUrlWithQueryParams as On, urlUpdate$ as kn, viewNavigationStack$ as An, warnDeprecatedOption as jn, whenUiFlowSteady as Mn, withoutPartSuffix as Nn } from "@flowx/core-sdk";
import * as Pn from "react";
import Fn, { Suspense as In, createContext as Ln, memo as Rn, startTransition as zn, useCallback as O, useContext as Bn, useEffect as Vn, useLayoutEffect as Hn, useMemo as k, useRef as A, useState as Un } from "react";
import * as Wn from "observable-hooks";
import { useObservable as Gn, useObservableState as Kn, useSubscription as qn } from "observable-hooks";
import * as Jn from "clsx";
import Yn, { clsx as Xn } from "clsx";
import Zn from "lodash/isEqual";
import * as Qn from "rxjs";
import { EMPTY as $n, combineLatest as er, concatMap as tr, debounceTime as nr, defer as rr, distinctUntilChanged as ir, filter as ar, from as or, map as sr, of as cr, shareReplay as lr, skip as ur, switchMap as dr, withLatestFrom as fr } from "rxjs";
import * as pr from "@flowx/core-theme";
import { ThemeComponent as j, computePosition as mr } from "@flowx/core-theme";
import * as hr from "@flowx/react-theme";
import { getIconAsset as gr, getThemingClassName as M, useCustomStyles as _r, useLayoutStyles as vr } from "@flowx/react-theme";
import * as yr from "@flowx/react-ui-toolkit";
import { FlxBreadcrumbs as br, FlxButton as xr, FlxChat as Sr, FlxChatHeader as Cr, FlxChatHistory as wr, FlxChatHistoryItem as Tr, FlxChatHistorySection as Er, FlxChatInput as Dr, FlxChatMessage as Or, FlxChatMessageActions as kr, FlxChatMessageFeedback as Ar, FlxChatMessages as jr, FlxChatReasoning as Mr, FlxChatSuggestedPrompts as Nr, FlxIcon as Pr, FlxModal as Fr, FlxSpinner as Ir, FlxToast as Lr, MemoFlxCard as Rr, MemoFlxCardContent as zr, MemoFlxIcon as Br, MemoFlxMessage as Vr, Tooltip as Hr, getFileExtension as Ur } from "@flowx/react-ui-toolkit";
import * as Wr from "react-dom";
import { createPortal as Gr } from "react-dom";
import { Fragment as Kr, jsx as N, jsxs as qr } from "react/jsx-runtime";
import * as Jr from "valtio";
import * as Yr from "lodash";
import { ErrorBoundary as Xr, getErrorMessage as Zr } from "react-error-boundary";
import * as Qr from "@internationalized/date";
import * as $r from "ag-grid-community";
import * as ei from "ag-grid-react";
import * as ti from "date-fns";
import * as ni from "react-dom/client";
import { AlertDialog as ri } from "@base-ui/react/alert-dialog";
import './src.css';// libs/sdk/react/src/components/ui-wrapper/toast/ToastWrapper.tsx
var ii = Cn.pipe(sr((e) => e.toasts)), ai = () => {
	let e = Kn(ii, []), t = M(j.Message) || "", n = k(() => {
		let e = gr(j.Message, "successIcon"), t = gr(j.Message, "errorIcon");
		return {
			success: /* @__PURE__ */ N(Br, {
				name: "success",
				path: e ? at(e) : void 0,
				className: "type-icon"
			}),
			error: /* @__PURE__ */ N(Br, {
				name: "error",
				path: t ? at(t) : void 0,
				className: "type-icon"
			})
		};
	}, []), r = d();
	if (e.length === 0) return null;
	let i = /* @__PURE__ */ N("ul", {
		role: "region",
		"aria-label": "Notifications",
		className: "container-wrapper",
		children: e.map((e, r) => {
			let i = e.withTheme ? n[e.messageType || ue] : null;
			return /* @__PURE__ */ N(Lr, {
				data: e,
				"data-testid": e?.title,
				onCloseToast: () => {
					_t(r);
				},
				className: Xn({
					[t]: e.withTheme,
					"fill with-theme": e.withTheme
				}),
				iconComponent: i
			}, r);
		})
	});
	return Gr(i, r ?? document.body);
};
// libs/sdk/react/src/components/sdk/custom-component/FlxCustomComponentErrorBoundary.tsx
function oi({ error: e }) {
	let t = Zr(e) ?? "Unknown error";
	return /* @__PURE__ */ qr("div", {
		className: "flx-cc-error",
		children: [/* @__PURE__ */ N("strong", { children: "Component error" }), /* @__PURE__ */ N("div", {
			className: "flx-cc-error-message",
			children: t
		})]
	});
}
var si = Rn(function({ componentIdentifier: e, children: t }) {
	let n = k(() => [e], [e]), r = O((t, n) => {
		console.error(`[FlowX] Custom component "${e}" crashed during rendering:`, t, n.componentStack);
	}, [e]);
	return /* @__PURE__ */ N(Xr, {
		FallbackComponent: oi,
		resetKeys: n,
		onError: r,
		children: t
	});
}), P;
(function(e) {
	e[e.NONE = 0] = "NONE", e[e._abstract = 1] = "_abstract", e[e._accessor = 2] = "_accessor", e[e._as = 3] = "_as", e[e._assert = 4] = "_assert", e[e._asserts = 5] = "_asserts", e[e._async = 6] = "_async", e[e._await = 7] = "_await", e[e._checks = 8] = "_checks", e[e._constructor = 9] = "_constructor", e[e._declare = 10] = "_declare", e[e._enum = 11] = "_enum", e[e._exports = 12] = "_exports", e[e._from = 13] = "_from", e[e._get = 14] = "_get", e[e._global = 15] = "_global", e[e._implements = 16] = "_implements", e[e._infer = 17] = "_infer", e[e._interface = 18] = "_interface", e[e._is = 19] = "_is", e[e._keyof = 20] = "_keyof", e[e._mixins = 21] = "_mixins", e[e._module = 22] = "_module", e[e._namespace = 23] = "_namespace", e[e._of = 24] = "_of", e[e._opaque = 25] = "_opaque", e[e._out = 26] = "_out", e[e._override = 27] = "_override", e[e._private = 28] = "_private", e[e._protected = 29] = "_protected", e[e._proto = 30] = "_proto", e[e._public = 31] = "_public", e[e._readonly = 32] = "_readonly", e[e._require = 33] = "_require", e[e._satisfies = 34] = "_satisfies", e[e._set = 35] = "_set", e[e._static = 36] = "_static", e[e._symbol = 37] = "_symbol", e[e._type = 38] = "_type", e[e._unique = 39] = "_unique", e[e._using = 40] = "_using";
})(P ||= {});
// node_modules/sucrase/dist/esm/parser/tokenizer/types.js
/* istanbul ignore file */
var F;
(function(e) {
	e[e.PRECEDENCE_MASK = 15] = "PRECEDENCE_MASK", e[e.IS_KEYWORD = 16] = "IS_KEYWORD", e[e.IS_ASSIGN = 32] = "IS_ASSIGN", e[e.IS_RIGHT_ASSOCIATIVE = 64] = "IS_RIGHT_ASSOCIATIVE", e[e.IS_PREFIX = 128] = "IS_PREFIX", e[e.IS_POSTFIX = 256] = "IS_POSTFIX", e[e.IS_EXPRESSION_START = 512] = "IS_EXPRESSION_START", e[e.num = 512] = "num", e[e.bigint = 1536] = "bigint", e[e.decimal = 2560] = "decimal", e[e.regexp = 3584] = "regexp", e[e.string = 4608] = "string", e[e.name = 5632] = "name", e[e.eof = 6144] = "eof", e[e.bracketL = 7680] = "bracketL", e[e.bracketR = 8192] = "bracketR", e[e.braceL = 9728] = "braceL", e[e.braceBarL = 10752] = "braceBarL", e[e.braceR = 11264] = "braceR", e[e.braceBarR = 12288] = "braceBarR", e[e.parenL = 13824] = "parenL", e[e.parenR = 14336] = "parenR", e[e.comma = 15360] = "comma", e[e.semi = 16384] = "semi", e[e.colon = 17408] = "colon", e[e.doubleColon = 18432] = "doubleColon", e[e.dot = 19456] = "dot", e[e.question = 20480] = "question", e[e.questionDot = 21504] = "questionDot", e[e.arrow = 22528] = "arrow", e[e.template = 23552] = "template", e[e.ellipsis = 24576] = "ellipsis", e[e.backQuote = 25600] = "backQuote", e[e.dollarBraceL = 27136] = "dollarBraceL", e[e.at = 27648] = "at", e[e.hash = 29184] = "hash", e[e.eq = 29728] = "eq", e[e.assign = 30752] = "assign", e[e.preIncDec = 32640] = "preIncDec", e[e.postIncDec = 33664] = "postIncDec", e[e.bang = 34432] = "bang", e[e.tilde = 35456] = "tilde", e[e.pipeline = 35841] = "pipeline", e[e.nullishCoalescing = 36866] = "nullishCoalescing", e[e.logicalOR = 37890] = "logicalOR", e[e.logicalAND = 38915] = "logicalAND", e[e.bitwiseOR = 39940] = "bitwiseOR", e[e.bitwiseXOR = 40965] = "bitwiseXOR", e[e.bitwiseAND = 41990] = "bitwiseAND", e[e.equality = 43015] = "equality", e[e.lessThan = 44040] = "lessThan", e[e.greaterThan = 45064] = "greaterThan", e[e.relationalOrEqual = 46088] = "relationalOrEqual", e[e.bitShiftL = 47113] = "bitShiftL", e[e.bitShiftR = 48137] = "bitShiftR", e[e.plus = 49802] = "plus", e[e.minus = 50826] = "minus", e[e.modulo = 51723] = "modulo", e[e.star = 52235] = "star", e[e.slash = 53259] = "slash", e[e.exponent = 54348] = "exponent", e[e.jsxName = 55296] = "jsxName", e[e.jsxText = 56320] = "jsxText", e[e.jsxEmptyText = 57344] = "jsxEmptyText", e[e.jsxTagStart = 58880] = "jsxTagStart", e[e.jsxTagEnd = 59392] = "jsxTagEnd", e[e.typeParameterStart = 60928] = "typeParameterStart", e[e.nonNullAssertion = 61440] = "nonNullAssertion", e[e._break = 62480] = "_break", e[e._case = 63504] = "_case", e[e._catch = 64528] = "_catch", e[e._continue = 65552] = "_continue", e[e._debugger = 66576] = "_debugger", e[e._default = 67600] = "_default", e[e._do = 68624] = "_do", e[e._else = 69648] = "_else", e[e._finally = 70672] = "_finally", e[e._for = 71696] = "_for", e[e._function = 73232] = "_function", e[e._if = 73744] = "_if", e[e._return = 74768] = "_return", e[e._switch = 75792] = "_switch", e[e._throw = 77456] = "_throw", e[e._try = 77840] = "_try", e[e._var = 78864] = "_var", e[e._let = 79888] = "_let", e[e._const = 80912] = "_const", e[e._while = 81936] = "_while", e[e._with = 82960] = "_with", e[e._new = 84496] = "_new", e[e._this = 85520] = "_this", e[e._super = 86544] = "_super", e[e._class = 87568] = "_class", e[e._extends = 88080] = "_extends", e[e._export = 89104] = "_export", e[e._import = 90640] = "_import", e[e._yield = 91664] = "_yield", e[e._null = 92688] = "_null", e[e._true = 93712] = "_true", e[e._false = 94736] = "_false", e[e._in = 95256] = "_in", e[e._instanceof = 96280] = "_instanceof", e[e._typeof = 97936] = "_typeof", e[e._void = 98960] = "_void", e[e._delete = 99984] = "_delete", e[e._async = 100880] = "_async", e[e._get = 101904] = "_get", e[e._set = 102928] = "_set", e[e._declare = 103952] = "_declare", e[e._readonly = 104976] = "_readonly", e[e._abstract = 106e3] = "_abstract", e[e._static = 107024] = "_static", e[e._public = 107536] = "_public", e[e._private = 108560] = "_private", e[e._protected = 109584] = "_protected", e[e._override = 110608] = "_override", e[e._as = 112144] = "_as", e[e._enum = 113168] = "_enum", e[e._type = 114192] = "_type", e[e._implements = 115216] = "_implements";
})(F ||= {});
function ci(e) {
	switch (e) {
		case F.num: return "num";
		case F.bigint: return "bigint";
		case F.decimal: return "decimal";
		case F.regexp: return "regexp";
		case F.string: return "string";
		case F.name: return "name";
		case F.eof: return "eof";
		case F.bracketL: return "[";
		case F.bracketR: return "]";
		case F.braceL: return "{";
		case F.braceBarL: return "{|";
		case F.braceR: return "}";
		case F.braceBarR: return "|}";
		case F.parenL: return "(";
		case F.parenR: return ")";
		case F.comma: return ",";
		case F.semi: return ";";
		case F.colon: return ":";
		case F.doubleColon: return "::";
		case F.dot: return ".";
		case F.question: return "?";
		case F.questionDot: return "?.";
		case F.arrow: return "=>";
		case F.template: return "template";
		case F.ellipsis: return "...";
		case F.backQuote: return "`";
		case F.dollarBraceL: return "${";
		case F.at: return "@";
		case F.hash: return "#";
		case F.eq: return "=";
		case F.assign: return "_=";
		case F.preIncDec: return "++/--";
		case F.postIncDec: return "++/--";
		case F.bang: return "!";
		case F.tilde: return "~";
		case F.pipeline: return "|>";
		case F.nullishCoalescing: return "??";
		case F.logicalOR: return "||";
		case F.logicalAND: return "&&";
		case F.bitwiseOR: return "|";
		case F.bitwiseXOR: return "^";
		case F.bitwiseAND: return "&";
		case F.equality: return "==/!=";
		case F.lessThan: return "<";
		case F.greaterThan: return ">";
		case F.relationalOrEqual: return "<=/>=";
		case F.bitShiftL: return "<<";
		case F.bitShiftR: return ">>/>>>";
		case F.plus: return "+";
		case F.minus: return "-";
		case F.modulo: return "%";
		case F.star: return "*";
		case F.slash: return "/";
		case F.exponent: return "**";
		case F.jsxName: return "jsxName";
		case F.jsxText: return "jsxText";
		case F.jsxEmptyText: return "jsxEmptyText";
		case F.jsxTagStart: return "jsxTagStart";
		case F.jsxTagEnd: return "jsxTagEnd";
		case F.typeParameterStart: return "typeParameterStart";
		case F.nonNullAssertion: return "nonNullAssertion";
		case F._break: return "break";
		case F._case: return "case";
		case F._catch: return "catch";
		case F._continue: return "continue";
		case F._debugger: return "debugger";
		case F._default: return "default";
		case F._do: return "do";
		case F._else: return "else";
		case F._finally: return "finally";
		case F._for: return "for";
		case F._function: return "function";
		case F._if: return "if";
		case F._return: return "return";
		case F._switch: return "switch";
		case F._throw: return "throw";
		case F._try: return "try";
		case F._var: return "var";
		case F._let: return "let";
		case F._const: return "const";
		case F._while: return "while";
		case F._with: return "with";
		case F._new: return "new";
		case F._this: return "this";
		case F._super: return "super";
		case F._class: return "class";
		case F._extends: return "extends";
		case F._export: return "export";
		case F._import: return "import";
		case F._yield: return "yield";
		case F._null: return "null";
		case F._true: return "true";
		case F._false: return "false";
		case F._in: return "in";
		case F._instanceof: return "instanceof";
		case F._typeof: return "typeof";
		case F._void: return "void";
		case F._delete: return "delete";
		case F._async: return "async";
		case F._get: return "get";
		case F._set: return "set";
		case F._declare: return "declare";
		case F._readonly: return "readonly";
		case F._abstract: return "abstract";
		case F._static: return "static";
		case F._public: return "public";
		case F._private: return "private";
		case F._protected: return "protected";
		case F._override: return "override";
		case F._as: return "as";
		case F._enum: return "enum";
		case F._type: return "type";
		case F._implements: return "implements";
		default: return "";
	}
}
// node_modules/sucrase/dist/esm/parser/tokenizer/state.js
var li = class {
	constructor(e, t, n) {
		this.startTokenIndex = e, this.endTokenIndex = t, this.isFunctionScope = n;
	}
}, ui = class {
	constructor(e, t, n, r, i, a, o, s, c, l, u, d, f) {
		this.potentialArrowAt = e, this.noAnonFunctionType = t, this.inDisallowConditionalTypesContext = n, this.tokensLength = r, this.scopesLength = i, this.pos = a, this.type = o, this.contextualKeyword = s, this.start = c, this.end = l, this.isType = u, this.scopeDepth = d, this.error = f;
	}
}, di = class e {
	constructor() {
		e.prototype.__init.call(this), e.prototype.__init2.call(this), e.prototype.__init3.call(this), e.prototype.__init4.call(this), e.prototype.__init5.call(this), e.prototype.__init6.call(this), e.prototype.__init7.call(this), e.prototype.__init8.call(this), e.prototype.__init9.call(this), e.prototype.__init10.call(this), e.prototype.__init11.call(this), e.prototype.__init12.call(this), e.prototype.__init13.call(this);
	}
	__init() {
		this.potentialArrowAt = -1;
	}
	__init2() {
		this.noAnonFunctionType = !1;
	}
	__init3() {
		this.inDisallowConditionalTypesContext = !1;
	}
	__init4() {
		this.tokens = [];
	}
	__init5() {
		this.scopes = [];
	}
	__init6() {
		this.pos = 0;
	}
	__init7() {
		this.type = F.eof;
	}
	__init8() {
		this.contextualKeyword = P.NONE;
	}
	__init9() {
		this.start = 0;
	}
	__init10() {
		this.end = 0;
	}
	__init11() {
		this.isType = !1;
	}
	__init12() {
		this.scopeDepth = 0;
	}
	__init13() {
		this.error = null;
	}
	snapshot() {
		return new ui(this.potentialArrowAt, this.noAnonFunctionType, this.inDisallowConditionalTypesContext, this.tokens.length, this.scopes.length, this.pos, this.type, this.contextualKeyword, this.start, this.end, this.isType, this.scopeDepth, this.error);
	}
	restoreFromSnapshot(e) {
		this.potentialArrowAt = e.potentialArrowAt, this.noAnonFunctionType = e.noAnonFunctionType, this.inDisallowConditionalTypesContext = e.inDisallowConditionalTypesContext, this.tokens.length = e.tokensLength, this.scopes.length = e.scopesLength, this.pos = e.pos, this.type = e.type, this.contextualKeyword = e.contextualKeyword, this.start = e.start, this.end = e.end, this.isType = e.isType, this.scopeDepth = e.scopeDepth, this.error = e.error;
	}
}, I;
(function(e) {
	e[e.backSpace = 8] = "backSpace", e[e.lineFeed = 10] = "lineFeed", e[e.tab = 9] = "tab", e[e.carriageReturn = 13] = "carriageReturn", e[e.shiftOut = 14] = "shiftOut", e[e.space = 32] = "space", e[e.exclamationMark = 33] = "exclamationMark", e[e.quotationMark = 34] = "quotationMark", e[e.numberSign = 35] = "numberSign", e[e.dollarSign = 36] = "dollarSign", e[e.percentSign = 37] = "percentSign", e[e.ampersand = 38] = "ampersand", e[e.apostrophe = 39] = "apostrophe", e[e.leftParenthesis = 40] = "leftParenthesis", e[e.rightParenthesis = 41] = "rightParenthesis", e[e.asterisk = 42] = "asterisk", e[e.plusSign = 43] = "plusSign", e[e.comma = 44] = "comma", e[e.dash = 45] = "dash", e[e.dot = 46] = "dot", e[e.slash = 47] = "slash", e[e.digit0 = 48] = "digit0", e[e.digit1 = 49] = "digit1", e[e.digit2 = 50] = "digit2", e[e.digit3 = 51] = "digit3", e[e.digit4 = 52] = "digit4", e[e.digit5 = 53] = "digit5", e[e.digit6 = 54] = "digit6", e[e.digit7 = 55] = "digit7", e[e.digit8 = 56] = "digit8", e[e.digit9 = 57] = "digit9", e[e.colon = 58] = "colon", e[e.semicolon = 59] = "semicolon", e[e.lessThan = 60] = "lessThan", e[e.equalsTo = 61] = "equalsTo", e[e.greaterThan = 62] = "greaterThan", e[e.questionMark = 63] = "questionMark", e[e.atSign = 64] = "atSign", e[e.uppercaseA = 65] = "uppercaseA", e[e.uppercaseB = 66] = "uppercaseB", e[e.uppercaseC = 67] = "uppercaseC", e[e.uppercaseD = 68] = "uppercaseD", e[e.uppercaseE = 69] = "uppercaseE", e[e.uppercaseF = 70] = "uppercaseF", e[e.uppercaseG = 71] = "uppercaseG", e[e.uppercaseH = 72] = "uppercaseH", e[e.uppercaseI = 73] = "uppercaseI", e[e.uppercaseJ = 74] = "uppercaseJ", e[e.uppercaseK = 75] = "uppercaseK", e[e.uppercaseL = 76] = "uppercaseL", e[e.uppercaseM = 77] = "uppercaseM", e[e.uppercaseN = 78] = "uppercaseN", e[e.uppercaseO = 79] = "uppercaseO", e[e.uppercaseP = 80] = "uppercaseP", e[e.uppercaseQ = 81] = "uppercaseQ", e[e.uppercaseR = 82] = "uppercaseR", e[e.uppercaseS = 83] = "uppercaseS", e[e.uppercaseT = 84] = "uppercaseT", e[e.uppercaseU = 85] = "uppercaseU", e[e.uppercaseV = 86] = "uppercaseV", e[e.uppercaseW = 87] = "uppercaseW", e[e.uppercaseX = 88] = "uppercaseX", e[e.uppercaseY = 89] = "uppercaseY", e[e.uppercaseZ = 90] = "uppercaseZ", e[e.leftSquareBracket = 91] = "leftSquareBracket", e[e.backslash = 92] = "backslash", e[e.rightSquareBracket = 93] = "rightSquareBracket", e[e.caret = 94] = "caret", e[e.underscore = 95] = "underscore", e[e.graveAccent = 96] = "graveAccent", e[e.lowercaseA = 97] = "lowercaseA", e[e.lowercaseB = 98] = "lowercaseB", e[e.lowercaseC = 99] = "lowercaseC", e[e.lowercaseD = 100] = "lowercaseD", e[e.lowercaseE = 101] = "lowercaseE", e[e.lowercaseF = 102] = "lowercaseF", e[e.lowercaseG = 103] = "lowercaseG", e[e.lowercaseH = 104] = "lowercaseH", e[e.lowercaseI = 105] = "lowercaseI", e[e.lowercaseJ = 106] = "lowercaseJ", e[e.lowercaseK = 107] = "lowercaseK", e[e.lowercaseL = 108] = "lowercaseL", e[e.lowercaseM = 109] = "lowercaseM", e[e.lowercaseN = 110] = "lowercaseN", e[e.lowercaseO = 111] = "lowercaseO", e[e.lowercaseP = 112] = "lowercaseP", e[e.lowercaseQ = 113] = "lowercaseQ", e[e.lowercaseR = 114] = "lowercaseR", e[e.lowercaseS = 115] = "lowercaseS", e[e.lowercaseT = 116] = "lowercaseT", e[e.lowercaseU = 117] = "lowercaseU", e[e.lowercaseV = 118] = "lowercaseV", e[e.lowercaseW = 119] = "lowercaseW", e[e.lowercaseX = 120] = "lowercaseX", e[e.lowercaseY = 121] = "lowercaseY", e[e.lowercaseZ = 122] = "lowercaseZ", e[e.leftCurlyBrace = 123] = "leftCurlyBrace", e[e.verticalBar = 124] = "verticalBar", e[e.rightCurlyBrace = 125] = "rightCurlyBrace", e[e.tilde = 126] = "tilde", e[e.nonBreakingSpace = 160] = "nonBreakingSpace", e[e.oghamSpaceMark = 5760] = "oghamSpaceMark", e[e.lineSeparator = 8232] = "lineSeparator", e[e.paragraphSeparator = 8233] = "paragraphSeparator";
})(I ||= {});
// node_modules/sucrase/dist/esm/parser/traverser/base.js
var fi, L, R, z, B, pi;
function mi() {
	return pi++;
}
function hi(e) {
	if ("pos" in e) {
		let t = _i(e.pos);
		e.message += ` (${t.line}:${t.column})`, e.loc = t;
	}
	return e;
}
var gi = class {
	constructor(e, t) {
		this.line = e, this.column = t;
	}
};
function _i(e) {
	let t = 1, n = 1;
	for (let r = 0; r < e; r++) B.charCodeAt(r) === I.lineFeed ? (t++, n = 1) : n++;
	return new gi(t, n);
}
function vi(e, t, n, r) {
	B = e, z = new di(), pi = 1, fi = t, L = n, R = r;
}
// node_modules/sucrase/dist/esm/parser/traverser/util.js
function V(e) {
	return z.contextualKeyword === e;
}
function yi(e) {
	let t = Ji();
	return t.type === F.name && t.contextualKeyword === e;
}
function bi(e) {
	return z.contextualKeyword === e && J(F.name);
}
function xi(e) {
	bi(e) || U();
}
function Si() {
	return Y(F.eof) || Y(F.braceR) || Ci();
}
function Ci() {
	let e = z.tokens[z.tokens.length - 1], t = e ? e.end : 0;
	for (let e = t; e < z.start; e++) {
		let t = B.charCodeAt(e);
		if (t === I.lineFeed || t === I.carriageReturn || t === 8232 || t === 8233) return !0;
	}
	return !1;
}
function wi() {
	let e = Yi();
	for (let t = z.end; t < e; t++) {
		let e = B.charCodeAt(t);
		if (e === I.lineFeed || e === I.carriageReturn || e === 8232 || e === 8233) return !0;
	}
	return !1;
}
function Ti() {
	return J(F.semi) || Si();
}
function Ei() {
	Ti() || U("Unexpected token, expected \";\"");
}
function H(e) {
	J(e) || U(`Unexpected token, expected "${ci(e)}"`);
}
function U(e = "Unexpected token", t = z.start) {
	if (z.error) return;
	let n = SyntaxError(e);
	n.pos = t, z.error = n, z.pos = B.length, X(F.eof);
}
// node_modules/sucrase/dist/esm/parser/util/whitespace.js
var Di = [
	9,
	11,
	12,
	I.space,
	I.nonBreakingSpace,
	I.oghamSpaceMark,
	8192,
	8193,
	8194,
	8195,
	8196,
	8197,
	8198,
	8199,
	8200,
	8201,
	8202,
	8239,
	8287,
	12288,
	65279
], Oi = /(?:\s|\/\/.*|\/\*[^]*?\*\/)*/g, ki = /* @__PURE__ */ new Uint8Array(65536);
for (let e of Di) ki[e] = 1;
// node_modules/sucrase/dist/esm/parser/util/identifier.js
function Ai(e) {
	if (e < 48) return e === 36;
	if (e < 58) return !0;
	if (e < 65) return !1;
	if (e < 91) return !0;
	if (e < 97) return e === 95;
	if (e < 123) return !0;
	if (e < 128) return !1;
	throw Error("Should not be called with non-ASCII char code.");
}
var ji = /* @__PURE__ */ new Uint8Array(65536);
for (let e = 0; e < 128; e++) ji[e] = +!!Ai(e);
for (let e = 128; e < 65536; e++) ji[e] = 1;
for (let e of Di) ji[e] = 0;
ji[8232] = 0, ji[8233] = 0;
var Mi = ji.slice();
for (let e = I.digit0; e <= I.digit9; e++) Mi[e] = 0;
// node_modules/sucrase/dist/esm/parser/tokenizer/readWordTree.js
var Ni = new Int32Array([
	-1,
	27,
	783,
	918,
	1755,
	2376,
	2862,
	3483,
	-1,
	3699,
	-1,
	4617,
	4752,
	4833,
	5130,
	5508,
	5940,
	-1,
	6480,
	6939,
	7749,
	8181,
	8451,
	8613,
	-1,
	8829,
	-1,
	-1,
	-1,
	54,
	243,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	432,
	-1,
	-1,
	-1,
	675,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	81,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	108,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	135,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	162,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	189,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	216,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	P._abstract << 1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	270,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	297,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	324,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	351,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	378,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	405,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	P._accessor << 1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	P._as << 1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	459,
	-1,
	-1,
	-1,
	-1,
	-1,
	594,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	486,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	513,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	540,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	P._assert << 1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	567,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	P._asserts << 1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	621,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	648,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	P._async << 1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	702,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	729,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	756,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	P._await << 1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	810,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	837,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	864,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	891,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	(F._break << 1) + 1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	945,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	1107,
	-1,
	-1,
	-1,
	1242,
	-1,
	-1,
	1350,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	972,
	1026,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	999,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	(F._case << 1) + 1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	1053,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	1080,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	(F._catch << 1) + 1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	1134,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	1161,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	1188,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	1215,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	P._checks << 1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	1269,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	1296,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	1323,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	(F._class << 1) + 1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	1377,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	1404,
	1620,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	1431,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	(F._const << 1) + 1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	1458,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	1485,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	1512,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	1539,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	1566,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	1593,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	P._constructor << 1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	1647,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	1674,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	1701,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	1728,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	(F._continue << 1) + 1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	1782,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	2349,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	1809,
	1971,
	-1,
	-1,
	2106,
	-1,
	-1,
	-1,
	-1,
	-1,
	2241,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	1836,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	1863,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	1890,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	1917,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	1944,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	(F._debugger << 1) + 1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	1998,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	2025,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	2052,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	2079,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	P._declare << 1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	2133,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	2160,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	2187,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	2214,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	(F._default << 1) + 1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	2268,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	2295,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	2322,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	(F._delete << 1) + 1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	(F._do << 1) + 1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	2403,
	-1,
	2484,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	2565,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	2430,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	2457,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	(F._else << 1) + 1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	2511,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	2538,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	P._enum << 1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	2592,
	-1,
	-1,
	-1,
	2727,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	2619,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	2646,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	2673,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	(F._export << 1) + 1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	2700,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	P._exports << 1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	2754,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	2781,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	2808,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	2835,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	(F._extends << 1) + 1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	2889,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	2997,
	-1,
	-1,
	-1,
	-1,
	-1,
	3159,
	-1,
	-1,
	3213,
	-1,
	-1,
	3294,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	2916,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	2943,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	2970,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	(F._false << 1) + 1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	3024,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	3051,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	3078,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	3105,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	3132,
	-1,
	(F._finally << 1) + 1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	3186,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	(F._for << 1) + 1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	3240,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	3267,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	P._from << 1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	3321,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	3348,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	3375,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	3402,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	3429,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	3456,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	(F._function << 1) + 1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	3510,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	3564,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	3537,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	P._get << 1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	3591,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	3618,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	3645,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	3672,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	P._global << 1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	3726,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	3753,
	4077,
	-1,
	-1,
	-1,
	-1,
	4590,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	(F._if << 1) + 1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	3780,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	3807,
	-1,
	-1,
	3996,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	3834,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	3861,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	3888,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	3915,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	3942,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	3969,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	P._implements << 1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	4023,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	4050,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	(F._import << 1) + 1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	(F._in << 1) + 1,
	-1,
	-1,
	-1,
	-1,
	-1,
	4104,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	4185,
	4401,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	4131,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	4158,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	P._infer << 1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	4212,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	4239,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	4266,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	4293,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	4320,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	4347,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	4374,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	(F._instanceof << 1) + 1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	4428,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	4455,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	4482,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	4509,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	4536,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	4563,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	P._interface << 1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	P._is << 1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	4644,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	4671,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	4698,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	4725,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	P._keyof << 1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	4779,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	4806,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	(F._let << 1) + 1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	4860,
	-1,
	-1,
	-1,
	-1,
	-1,
	4995,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	4887,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	4914,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	4941,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	4968,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	P._mixins << 1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	5022,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	5049,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	5076,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	5103,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	P._module << 1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	5157,
	-1,
	-1,
	-1,
	5373,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	5427,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	5184,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	5211,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	5238,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	5265,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	5292,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	5319,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	5346,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	P._namespace << 1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	5400,
	-1,
	-1,
	-1,
	(F._new << 1) + 1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	5454,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	5481,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	(F._null << 1) + 1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	5535,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	5562,
	-1,
	-1,
	-1,
	-1,
	5697,
	5751,
	-1,
	-1,
	-1,
	-1,
	P._of << 1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	5589,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	5616,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	5643,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	5670,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	P._opaque << 1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	5724,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	P._out << 1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	5778,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	5805,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	5832,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	5859,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	5886,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	5913,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	P._override << 1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	5967,
	-1,
	-1,
	6345,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	5994,
	-1,
	-1,
	-1,
	-1,
	-1,
	6129,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	6021,
	-1,
	-1,
	-1,
	-1,
	-1,
	6048,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	6075,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	6102,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	P._private << 1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	6156,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	6183,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	6318,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	6210,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	6237,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	6264,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	6291,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	P._protected << 1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	P._proto << 1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	6372,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	6399,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	6426,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	6453,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	P._public << 1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	6507,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	6534,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	6696,
	-1,
	-1,
	6831,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	6561,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	6588,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	6615,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	6642,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	6669,
	-1,
	P._readonly << 1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	6723,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	6750,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	6777,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	6804,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	P._require << 1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	6858,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	6885,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	6912,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	(F._return << 1) + 1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	6966,
	-1,
	-1,
	-1,
	7182,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	7236,
	7371,
	-1,
	7479,
	-1,
	7614,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	6993,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	7020,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	7047,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	7074,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	7101,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	7128,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	7155,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	P._satisfies << 1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	7209,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	P._set << 1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	7263,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	7290,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	7317,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	7344,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	P._static << 1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	7398,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	7425,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	7452,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	(F._super << 1) + 1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	7506,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	7533,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	7560,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	7587,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	(F._switch << 1) + 1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	7641,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	7668,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	7695,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	7722,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	P._symbol << 1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	7776,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	7938,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	8046,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	7803,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	7857,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	7830,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	(F._this << 1) + 1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	7884,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	7911,
	-1,
	-1,
	-1,
	(F._throw << 1) + 1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	7965,
	-1,
	-1,
	-1,
	8019,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	7992,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	(F._true << 1) + 1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	(F._try << 1) + 1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	8073,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	8100,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	P._type << 1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	8127,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	8154,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	(F._typeof << 1) + 1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	8208,
	-1,
	-1,
	-1,
	-1,
	8343,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	8235,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	8262,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	8289,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	8316,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	P._unique << 1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	8370,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	8397,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	8424,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	P._using << 1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	8478,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	8532,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	8505,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	(F._var << 1) + 1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	8559,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	8586,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	(F._void << 1) + 1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	8640,
	8748,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	8667,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	8694,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	8721,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	(F._while << 1) + 1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	8775,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	8802,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	(F._with << 1) + 1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	8856,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	8883,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	8910,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	8937,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	(F._yield << 1) + 1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1,
	-1
]);
// node_modules/sucrase/dist/esm/parser/tokenizer/readWord.js
function Pi() {
	let e = 0, t = 0, n = z.pos;
	for (; n < B.length && (t = B.charCodeAt(n), !(t < I.lowercaseA || t > I.lowercaseZ));) {
		let r = Ni[e + (t - I.lowercaseA) + 1];
		if (r === -1) break;
		e = r, n++;
	}
	let r = Ni[e];
	if (r > -1 && !ji[t]) z.pos = n, r & 1 ? X(r >>> 1) : X(F.name, r >>> 1);
	else {
		for (; n < B.length;) {
			let e = B.charCodeAt(n);
			if (ji[e]) n++;
			else if (e === I.backslash) {
				if (n += 2, B.charCodeAt(n) === I.leftCurlyBrace) {
					for (; n < B.length && B.charCodeAt(n) !== I.rightCurlyBrace;) n++;
					n++;
				}
			} else if (e === I.atSign && B.charCodeAt(n + 1) === I.atSign) n += 2;
			else break;
		}
		z.pos = n, X(F.name);
	}
}
// node_modules/sucrase/dist/esm/parser/tokenizer/index.js
var W;
(function(e) {
	e[e.Access = 0] = "Access", e[e.ExportAccess = 1] = "ExportAccess", e[e.TopLevelDeclaration = 2] = "TopLevelDeclaration", e[e.FunctionScopedDeclaration = 3] = "FunctionScopedDeclaration", e[e.BlockScopedDeclaration = 4] = "BlockScopedDeclaration", e[e.ObjectShorthandTopLevelDeclaration = 5] = "ObjectShorthandTopLevelDeclaration", e[e.ObjectShorthandFunctionScopedDeclaration = 6] = "ObjectShorthandFunctionScopedDeclaration", e[e.ObjectShorthandBlockScopedDeclaration = 7] = "ObjectShorthandBlockScopedDeclaration", e[e.ObjectShorthand = 8] = "ObjectShorthand", e[e.ImportDeclaration = 9] = "ImportDeclaration", e[e.ObjectKey = 10] = "ObjectKey", e[e.ImportAccess = 11] = "ImportAccess";
})(W ||= {});
var Fi;
(function(e) {
	e[e.NoChildren = 0] = "NoChildren", e[e.OneChild = 1] = "OneChild", e[e.StaticChildren = 2] = "StaticChildren", e[e.KeyAfterPropSpread = 3] = "KeyAfterPropSpread";
})(Fi ||= {});
function Ii(e) {
	let t = e.identifierRole;
	return t === W.TopLevelDeclaration || t === W.FunctionScopedDeclaration || t === W.BlockScopedDeclaration || t === W.ObjectShorthandTopLevelDeclaration || t === W.ObjectShorthandFunctionScopedDeclaration || t === W.ObjectShorthandBlockScopedDeclaration;
}
function Li(e) {
	let t = e.identifierRole;
	return t === W.FunctionScopedDeclaration || t === W.BlockScopedDeclaration || t === W.ObjectShorthandFunctionScopedDeclaration || t === W.ObjectShorthandBlockScopedDeclaration;
}
function Ri(e) {
	let t = e.identifierRole;
	return t === W.TopLevelDeclaration || t === W.ObjectShorthandTopLevelDeclaration || t === W.ImportDeclaration;
}
function zi(e) {
	let t = e.identifierRole;
	return t === W.TopLevelDeclaration || t === W.BlockScopedDeclaration || t === W.ObjectShorthandTopLevelDeclaration || t === W.ObjectShorthandBlockScopedDeclaration;
}
function Bi(e) {
	let t = e.identifierRole;
	return t === W.FunctionScopedDeclaration || t === W.ObjectShorthandFunctionScopedDeclaration;
}
function Vi(e) {
	return e.identifierRole === W.ObjectShorthandTopLevelDeclaration || e.identifierRole === W.ObjectShorthandBlockScopedDeclaration || e.identifierRole === W.ObjectShorthandFunctionScopedDeclaration;
}
var Hi = class {
	constructor() {
		this.type = z.type, this.contextualKeyword = z.contextualKeyword, this.start = z.start, this.end = z.end, this.scopeDepth = z.scopeDepth, this.isType = z.isType, this.identifierRole = null, this.jsxRole = null, this.shadowsGlobal = !1, this.isAsyncOperation = !1, this.contextId = null, this.rhsEndIndex = null, this.isExpression = !1, this.numNullishCoalesceStarts = 0, this.numNullishCoalesceEnds = 0, this.isOptionalChainStart = !1, this.isOptionalChainEnd = !1, this.subscriptStartIndex = null, this.nullishStartIndex = null;
	}
};
function G() {
	z.tokens.push(new Hi()), Qi();
}
function Ui() {
	z.tokens.push(new Hi()), z.start = z.pos, xa();
}
function Wi() {
	z.type === F.assign && --z.pos, ga();
}
function K(e) {
	for (let t = z.tokens.length - e; t < z.tokens.length; t++) z.tokens[t].isType = !0;
	let t = z.isType;
	return z.isType = !0, t;
}
function q(e) {
	z.isType = e;
}
function J(e) {
	return Y(e) ? (G(), !0) : !1;
}
function Gi(e) {
	let t = z.isType;
	z.isType = !0, J(e), z.isType = t;
}
function Y(e) {
	return z.type === e;
}
function Ki() {
	let e = z.snapshot();
	G();
	let t = z.type;
	return z.restoreFromSnapshot(e), t;
}
var qi = class {
	constructor(e, t) {
		this.type = e, this.contextualKeyword = t;
	}
};
function Ji() {
	let e = z.snapshot();
	G();
	let t = z.type, n = z.contextualKeyword;
	return z.restoreFromSnapshot(e), new qi(t, n);
}
function Yi() {
	return Xi(z.pos);
}
function Xi(e) {
	return Oi.lastIndex = e, e + Oi.exec(B)[0].length;
}
function Zi() {
	return B.charCodeAt(Yi());
}
function Qi() {
	if (na(), z.start = z.pos, z.pos >= B.length) {
		let e = z.tokens;
		e.length >= 2 && e[e.length - 1].start >= B.length && e[e.length - 2].start >= B.length && U("Unexpectedly reached the end of input."), X(F.eof);
	} else $i(B.charCodeAt(z.pos));
}
function $i(e) {
	Mi[e] || e === I.backslash || e === I.atSign && B.charCodeAt(z.pos + 1) === I.atSign ? Pi() : ma(e);
}
function ea() {
	for (; B.charCodeAt(z.pos) !== I.asterisk || B.charCodeAt(z.pos + 1) !== I.slash;) if (z.pos++, z.pos > B.length) {
		U("Unterminated comment", z.pos - 2);
		return;
	}
	z.pos += 2;
}
function ta(e) {
	let t = B.charCodeAt(z.pos += e);
	if (z.pos < B.length) for (; t !== I.lineFeed && t !== I.carriageReturn && t !== I.lineSeparator && t !== I.paragraphSeparator && ++z.pos < B.length;) t = B.charCodeAt(z.pos);
}
function na() {
	for (; z.pos < B.length;) {
		let e = B.charCodeAt(z.pos);
		switch (e) {
			case I.carriageReturn: B.charCodeAt(z.pos + 1) === I.lineFeed && ++z.pos;
			case I.lineFeed:
			case I.lineSeparator:
			case I.paragraphSeparator:
				++z.pos;
				break;
			case I.slash:
				switch (B.charCodeAt(z.pos + 1)) {
					case I.asterisk:
						z.pos += 2, ea();
						break;
					case I.slash:
						ta(2);
						break;
					default: return;
				}
				break;
			default: if (ki[e]) ++z.pos;
			else return;
		}
	}
}
function X(e, t = P.NONE) {
	z.end = z.pos, z.type = e, z.contextualKeyword = t;
}
function ra() {
	let e = B.charCodeAt(z.pos + 1);
	e >= I.digit0 && e <= I.digit9 ? ya(!0) : e === I.dot && B.charCodeAt(z.pos + 2) === I.dot ? (z.pos += 3, X(F.ellipsis)) : (++z.pos, X(F.dot));
}
function ia() {
	B.charCodeAt(z.pos + 1) === I.equalsTo ? ha(F.assign, 2) : ha(F.slash, 1);
}
function aa(e) {
	let t = e === I.asterisk ? F.star : F.modulo, n = 1, r = B.charCodeAt(z.pos + 1);
	e === I.asterisk && r === I.asterisk && (n++, r = B.charCodeAt(z.pos + 2), t = F.exponent), r === I.equalsTo && B.charCodeAt(z.pos + 2) !== I.greaterThan && (n++, t = F.assign), ha(t, n);
}
function oa(e) {
	let t = B.charCodeAt(z.pos + 1);
	if (t === e) B.charCodeAt(z.pos + 2) === I.equalsTo ? ha(F.assign, 3) : ha(e === I.verticalBar ? F.logicalOR : F.logicalAND, 2);
	else {
		if (e === I.verticalBar) {
			if (t === I.greaterThan) {
				ha(F.pipeline, 2);
				return;
			}
			if (t === I.rightCurlyBrace && R) {
				ha(F.braceBarR, 2);
				return;
			}
		}
		t === I.equalsTo ? ha(F.assign, 2) : ha(e === I.verticalBar ? F.bitwiseOR : F.bitwiseAND, 1);
	}
}
function sa() {
	B.charCodeAt(z.pos + 1) === I.equalsTo ? ha(F.assign, 2) : ha(F.bitwiseXOR, 1);
}
function ca(e) {
	let t = B.charCodeAt(z.pos + 1);
	t === e ? ha(F.preIncDec, 2) : t === I.equalsTo ? ha(F.assign, 2) : e === I.plusSign ? ha(F.plus, 1) : ha(F.minus, 1);
}
function la() {
	let e = B.charCodeAt(z.pos + 1);
	if (e === I.lessThan) {
		if (B.charCodeAt(z.pos + 2) === I.equalsTo) {
			ha(F.assign, 3);
			return;
		}
		z.isType ? ha(F.lessThan, 1) : ha(F.bitShiftL, 2);
	} else e === I.equalsTo ? ha(F.relationalOrEqual, 2) : ha(F.lessThan, 1);
}
function ua() {
	if (z.isType) {
		ha(F.greaterThan, 1);
		return;
	}
	let e = B.charCodeAt(z.pos + 1);
	if (e === I.greaterThan) {
		let e = B.charCodeAt(z.pos + 2) === I.greaterThan ? 3 : 2;
		if (B.charCodeAt(z.pos + e) === I.equalsTo) {
			ha(F.assign, e + 1);
			return;
		}
		ha(F.bitShiftR, e);
	} else e === I.equalsTo ? ha(F.relationalOrEqual, 2) : ha(F.greaterThan, 1);
}
function da() {
	z.type === F.greaterThan && (--z.pos, ua());
}
function fa(e) {
	let t = B.charCodeAt(z.pos + 1);
	t === I.equalsTo ? ha(F.equality, B.charCodeAt(z.pos + 2) === I.equalsTo ? 3 : 2) : e === I.equalsTo && t === I.greaterThan ? (z.pos += 2, X(F.arrow)) : ha(e === I.equalsTo ? F.eq : F.bang, 1);
}
function pa() {
	let e = B.charCodeAt(z.pos + 1), t = B.charCodeAt(z.pos + 2);
	e === I.questionMark && !(R && z.isType) ? t === I.equalsTo ? ha(F.assign, 3) : ha(F.nullishCoalescing, 2) : e === I.dot && !(t >= I.digit0 && t <= I.digit9) ? (z.pos += 2, X(F.questionDot)) : (++z.pos, X(F.question));
}
function ma(e) {
	switch (e) {
		case I.numberSign:
			++z.pos, X(F.hash);
			return;
		case I.dot:
			ra();
			return;
		case I.leftParenthesis:
			++z.pos, X(F.parenL);
			return;
		case I.rightParenthesis:
			++z.pos, X(F.parenR);
			return;
		case I.semicolon:
			++z.pos, X(F.semi);
			return;
		case I.comma:
			++z.pos, X(F.comma);
			return;
		case I.leftSquareBracket:
			++z.pos, X(F.bracketL);
			return;
		case I.rightSquareBracket:
			++z.pos, X(F.bracketR);
			return;
		case I.leftCurlyBrace:
			R && B.charCodeAt(z.pos + 1) === I.verticalBar ? ha(F.braceBarL, 2) : (++z.pos, X(F.braceL));
			return;
		case I.rightCurlyBrace:
			++z.pos, X(F.braceR);
			return;
		case I.colon:
			B.charCodeAt(z.pos + 1) === I.colon ? ha(F.doubleColon, 2) : (++z.pos, X(F.colon));
			return;
		case I.questionMark:
			pa();
			return;
		case I.atSign:
			++z.pos, X(F.at);
			return;
		case I.graveAccent:
			++z.pos, X(F.backQuote);
			return;
		case I.digit0: {
			let e = B.charCodeAt(z.pos + 1);
			if (e === I.lowercaseX || e === I.uppercaseX || e === I.lowercaseO || e === I.uppercaseO || e === I.lowercaseB || e === I.uppercaseB) {
				va();
				return;
			}
		}
		case I.digit1:
		case I.digit2:
		case I.digit3:
		case I.digit4:
		case I.digit5:
		case I.digit6:
		case I.digit7:
		case I.digit8:
		case I.digit9:
			ya(!1);
			return;
		case I.quotationMark:
		case I.apostrophe:
			ba(e);
			return;
		case I.slash:
			ia();
			return;
		case I.percentSign:
		case I.asterisk:
			aa(e);
			return;
		case I.verticalBar:
		case I.ampersand:
			oa(e);
			return;
		case I.caret:
			sa();
			return;
		case I.plusSign:
		case I.dash:
			ca(e);
			return;
		case I.lessThan:
			la();
			return;
		case I.greaterThan:
			ua();
			return;
		case I.equalsTo:
		case I.exclamationMark:
			fa(e);
			return;
		case I.tilde:
			ha(F.tilde, 1);
			return;
	}
	U(`Unexpected character '${String.fromCharCode(e)}'`, z.pos);
}
function ha(e, t) {
	z.pos += t, X(e);
}
function ga() {
	let e = z.pos, t = !1, n = !1;
	for (;;) {
		if (z.pos >= B.length) {
			U("Unterminated regular expression", e);
			return;
		}
		let r = B.charCodeAt(z.pos);
		if (t) t = !1;
		else {
			if (r === I.leftSquareBracket) n = !0;
			else if (r === I.rightSquareBracket && n) n = !1;
			else if (r === I.slash && !n) break;
			t = r === I.backslash;
		}
		++z.pos;
	}
	++z.pos, Sa(), X(F.regexp);
}
function _a() {
	for (;;) {
		let e = B.charCodeAt(z.pos);
		if (e >= I.digit0 && e <= I.digit9 || e === I.underscore) z.pos++;
		else break;
	}
}
function va() {
	for (z.pos += 2;;) {
		let e = B.charCodeAt(z.pos);
		if (e >= I.digit0 && e <= I.digit9 || e >= I.lowercaseA && e <= I.lowercaseF || e >= I.uppercaseA && e <= I.uppercaseF || e === I.underscore) z.pos++;
		else break;
	}
	B.charCodeAt(z.pos) === I.lowercaseN ? (++z.pos, X(F.bigint)) : X(F.num);
}
function ya(e) {
	let t = !1, n = !1;
	e || _a();
	let r = B.charCodeAt(z.pos);
	r === I.dot && (++z.pos, _a(), r = B.charCodeAt(z.pos)), (r === I.uppercaseE || r === I.lowercaseE) && (r = B.charCodeAt(++z.pos), (r === I.plusSign || r === I.dash) && ++z.pos, _a(), r = B.charCodeAt(z.pos)), r === I.lowercaseN ? (++z.pos, t = !0) : r === I.lowercaseM && (++z.pos, n = !0), X(t ? F.bigint : n ? F.decimal : F.num);
}
function ba(e) {
	for (z.pos++;;) {
		if (z.pos >= B.length) {
			U("Unterminated string constant");
			return;
		}
		let t = B.charCodeAt(z.pos);
		if (t === I.backslash) z.pos++;
		else if (t === e) break;
		z.pos++;
	}
	z.pos++, X(F.string);
}
function xa() {
	for (;;) {
		if (z.pos >= B.length) {
			U("Unterminated template");
			return;
		}
		let e = B.charCodeAt(z.pos);
		if (e === I.graveAccent || e === I.dollarSign && B.charCodeAt(z.pos + 1) === I.leftCurlyBrace) {
			if (z.pos === z.start && Y(F.template)) {
				if (e === I.dollarSign) {
					z.pos += 2, X(F.dollarBraceL);
					return;
				}
				++z.pos, X(F.backQuote);
				return;
			}
			X(F.template);
			return;
		}
		e === I.backslash && z.pos++, z.pos++;
	}
}
function Sa() {
	for (; z.pos < B.length;) {
		let e = B.charCodeAt(z.pos);
		if (ji[e]) z.pos++;
		else if (e === I.backslash) {
			if (z.pos += 2, B.charCodeAt(z.pos) === I.leftCurlyBrace) {
				for (; z.pos < B.length && B.charCodeAt(z.pos) !== I.rightCurlyBrace;) z.pos++;
				z.pos++;
			}
		} else break;
	}
}
// node_modules/sucrase/dist/esm/util/getImportExportSpecifierInfo.js
function Ca(e, t = e.currentIndex()) {
	let n = t + 1;
	if (wa(e, n)) {
		let r = e.identifierNameAtIndex(t);
		return {
			isType: !1,
			leftName: r,
			rightName: r,
			endIndex: n
		};
	}
	if (n++, wa(e, n)) return {
		isType: !0,
		leftName: null,
		rightName: null,
		endIndex: n
	};
	if (n++, wa(e, n)) return {
		isType: !1,
		leftName: e.identifierNameAtIndex(t),
		rightName: e.identifierNameAtIndex(t + 2),
		endIndex: n
	};
	if (n++, wa(e, n)) return {
		isType: !0,
		leftName: null,
		rightName: null,
		endIndex: n
	};
	throw Error(`Unexpected import/export specifier at ${t}`);
}
function wa(e, t) {
	let n = e.tokens[t];
	return n.type === F.braceR || n.type === F.comma;
}
// node_modules/sucrase/dist/esm/parser/plugins/jsx/xhtml.js
var Ta = /* @__PURE__ */ new Map([
	["quot", "\""],
	["amp", "&"],
	["apos", "'"],
	["lt", "<"],
	["gt", ">"],
	["nbsp", "\xA0"],
	["iexcl", "¡"],
	["cent", "¢"],
	["pound", "£"],
	["curren", "¤"],
	["yen", "¥"],
	["brvbar", "¦"],
	["sect", "§"],
	["uml", "¨"],
	["copy", "©"],
	["ordf", "ª"],
	["laquo", "«"],
	["not", "¬"],
	["shy", "­"],
	["reg", "®"],
	["macr", "¯"],
	["deg", "°"],
	["plusmn", "±"],
	["sup2", "²"],
	["sup3", "³"],
	["acute", "´"],
	["micro", "µ"],
	["para", "¶"],
	["middot", "·"],
	["cedil", "¸"],
	["sup1", "¹"],
	["ordm", "º"],
	["raquo", "»"],
	["frac14", "¼"],
	["frac12", "½"],
	["frac34", "¾"],
	["iquest", "¿"],
	["Agrave", "À"],
	["Aacute", "Á"],
	["Acirc", "Â"],
	["Atilde", "Ã"],
	["Auml", "Ä"],
	["Aring", "Å"],
	["AElig", "Æ"],
	["Ccedil", "Ç"],
	["Egrave", "È"],
	["Eacute", "É"],
	["Ecirc", "Ê"],
	["Euml", "Ë"],
	["Igrave", "Ì"],
	["Iacute", "Í"],
	["Icirc", "Î"],
	["Iuml", "Ï"],
	["ETH", "Ð"],
	["Ntilde", "Ñ"],
	["Ograve", "Ò"],
	["Oacute", "Ó"],
	["Ocirc", "Ô"],
	["Otilde", "Õ"],
	["Ouml", "Ö"],
	["times", "×"],
	["Oslash", "Ø"],
	["Ugrave", "Ù"],
	["Uacute", "Ú"],
	["Ucirc", "Û"],
	["Uuml", "Ü"],
	["Yacute", "Ý"],
	["THORN", "Þ"],
	["szlig", "ß"],
	["agrave", "à"],
	["aacute", "á"],
	["acirc", "â"],
	["atilde", "ã"],
	["auml", "ä"],
	["aring", "å"],
	["aelig", "æ"],
	["ccedil", "ç"],
	["egrave", "è"],
	["eacute", "é"],
	["ecirc", "ê"],
	["euml", "ë"],
	["igrave", "ì"],
	["iacute", "í"],
	["icirc", "î"],
	["iuml", "ï"],
	["eth", "ð"],
	["ntilde", "ñ"],
	["ograve", "ò"],
	["oacute", "ó"],
	["ocirc", "ô"],
	["otilde", "õ"],
	["ouml", "ö"],
	["divide", "÷"],
	["oslash", "ø"],
	["ugrave", "ù"],
	["uacute", "ú"],
	["ucirc", "û"],
	["uuml", "ü"],
	["yacute", "ý"],
	["thorn", "þ"],
	["yuml", "ÿ"],
	["OElig", "Œ"],
	["oelig", "œ"],
	["Scaron", "Š"],
	["scaron", "š"],
	["Yuml", "Ÿ"],
	["fnof", "ƒ"],
	["circ", "ˆ"],
	["tilde", "˜"],
	["Alpha", "Α"],
	["Beta", "Β"],
	["Gamma", "Γ"],
	["Delta", "Δ"],
	["Epsilon", "Ε"],
	["Zeta", "Ζ"],
	["Eta", "Η"],
	["Theta", "Θ"],
	["Iota", "Ι"],
	["Kappa", "Κ"],
	["Lambda", "Λ"],
	["Mu", "Μ"],
	["Nu", "Ν"],
	["Xi", "Ξ"],
	["Omicron", "Ο"],
	["Pi", "Π"],
	["Rho", "Ρ"],
	["Sigma", "Σ"],
	["Tau", "Τ"],
	["Upsilon", "Υ"],
	["Phi", "Φ"],
	["Chi", "Χ"],
	["Psi", "Ψ"],
	["Omega", "Ω"],
	["alpha", "α"],
	["beta", "β"],
	["gamma", "γ"],
	["delta", "δ"],
	["epsilon", "ε"],
	["zeta", "ζ"],
	["eta", "η"],
	["theta", "θ"],
	["iota", "ι"],
	["kappa", "κ"],
	["lambda", "λ"],
	["mu", "μ"],
	["nu", "ν"],
	["xi", "ξ"],
	["omicron", "ο"],
	["pi", "π"],
	["rho", "ρ"],
	["sigmaf", "ς"],
	["sigma", "σ"],
	["tau", "τ"],
	["upsilon", "υ"],
	["phi", "φ"],
	["chi", "χ"],
	["psi", "ψ"],
	["omega", "ω"],
	["thetasym", "ϑ"],
	["upsih", "ϒ"],
	["piv", "ϖ"],
	["ensp", " "],
	["emsp", " "],
	["thinsp", " "],
	["zwnj", "‌"],
	["zwj", "‍"],
	["lrm", "‎"],
	["rlm", "‏"],
	["ndash", "–"],
	["mdash", "—"],
	["lsquo", "‘"],
	["rsquo", "’"],
	["sbquo", "‚"],
	["ldquo", "“"],
	["rdquo", "”"],
	["bdquo", "„"],
	["dagger", "†"],
	["Dagger", "‡"],
	["bull", "•"],
	["hellip", "…"],
	["permil", "‰"],
	["prime", "′"],
	["Prime", "″"],
	["lsaquo", "‹"],
	["rsaquo", "›"],
	["oline", "‾"],
	["frasl", "⁄"],
	["euro", "€"],
	["image", "ℑ"],
	["weierp", "℘"],
	["real", "ℜ"],
	["trade", "™"],
	["alefsym", "ℵ"],
	["larr", "←"],
	["uarr", "↑"],
	["rarr", "→"],
	["darr", "↓"],
	["harr", "↔"],
	["crarr", "↵"],
	["lArr", "⇐"],
	["uArr", "⇑"],
	["rArr", "⇒"],
	["dArr", "⇓"],
	["hArr", "⇔"],
	["forall", "∀"],
	["part", "∂"],
	["exist", "∃"],
	["empty", "∅"],
	["nabla", "∇"],
	["isin", "∈"],
	["notin", "∉"],
	["ni", "∋"],
	["prod", "∏"],
	["sum", "∑"],
	["minus", "−"],
	["lowast", "∗"],
	["radic", "√"],
	["prop", "∝"],
	["infin", "∞"],
	["ang", "∠"],
	["and", "∧"],
	["or", "∨"],
	["cap", "∩"],
	["cup", "∪"],
	["int", "∫"],
	["there4", "∴"],
	["sim", "∼"],
	["cong", "≅"],
	["asymp", "≈"],
	["ne", "≠"],
	["equiv", "≡"],
	["le", "≤"],
	["ge", "≥"],
	["sub", "⊂"],
	["sup", "⊃"],
	["nsub", "⊄"],
	["sube", "⊆"],
	["supe", "⊇"],
	["oplus", "⊕"],
	["otimes", "⊗"],
	["perp", "⊥"],
	["sdot", "⋅"],
	["lceil", "⌈"],
	["rceil", "⌉"],
	["lfloor", "⌊"],
	["rfloor", "⌋"],
	["lang", "〈"],
	["rang", "〉"],
	["loz", "◊"],
	["spades", "♠"],
	["clubs", "♣"],
	["hearts", "♥"],
	["diams", "♦"]
]);
// node_modules/sucrase/dist/esm/util/getJSXPragmaInfo.js
function Ea(e) {
	let [t, n] = Da(e.jsxPragma || "React.createElement"), [r, i] = Da(e.jsxFragmentPragma || "React.Fragment");
	return {
		base: t,
		suffix: n,
		fragmentBase: r,
		fragmentSuffix: i
	};
}
function Da(e) {
	let t = e.indexOf(".");
	return t === -1 && (t = e.length), [e.slice(0, t), e.slice(t)];
}
// node_modules/sucrase/dist/esm/transformers/Transformer.js
var Oa = class {
	getPrefixCode() {
		return "";
	}
	getHoistedCode() {
		return "";
	}
	getSuffixCode() {
		return "";
	}
}, ka = class e extends Oa {
	__init() {
		this.lastLineNumber = 1;
	}
	__init2() {
		this.lastIndex = 0;
	}
	__init3() {
		this.filenameVarName = null;
	}
	__init4() {
		this.esmAutomaticImportNameResolutions = {};
	}
	__init5() {
		this.cjsAutomaticModuleNameResolutions = {};
	}
	constructor(t, n, r, i, a) {
		super(), this.rootTransformer = t, this.tokens = n, this.importProcessor = r, this.nameManager = i, this.options = a, e.prototype.__init.call(this), e.prototype.__init2.call(this), e.prototype.__init3.call(this), e.prototype.__init4.call(this), e.prototype.__init5.call(this), this.jsxPragmaInfo = Ea(a), this.isAutomaticRuntime = a.jsxRuntime === "automatic", this.jsxImportSource = a.jsxImportSource || "react";
	}
	process() {
		return this.tokens.matches1(F.jsxTagStart) ? (this.processJSXTag(), !0) : !1;
	}
	getPrefixCode() {
		let e = "";
		if (this.filenameVarName && (e += `const ${this.filenameVarName} = ${JSON.stringify(this.options.filePath || "")};`), this.isAutomaticRuntime) {
			if (this.importProcessor) for (let [t, n] of Object.entries(this.cjsAutomaticModuleNameResolutions)) e += `var ${n} = require("${t}");`;
			else {
				let { createElement: t, ...n } = this.esmAutomaticImportNameResolutions;
				t && (e += `import {createElement as ${t}} from "${this.jsxImportSource}";`);
				let r = Object.entries(n).map(([e, t]) => `${e} as ${t}`).join(", ");
				if (r) {
					let t = this.jsxImportSource + (this.options.production ? "/jsx-runtime" : "/jsx-dev-runtime");
					e += `import {${r}} from "${t}";`;
				}
			}
		}
		return e;
	}
	processJSXTag() {
		let { jsxRole: e, start: t } = this.tokens.currentToken(), n = this.options.production ? null : this.getElementLocationCode(t);
		this.isAutomaticRuntime && e !== Fi.KeyAfterPropSpread ? this.transformTagToJSXFunc(n, e) : this.transformTagToCreateElement(n);
	}
	getElementLocationCode(e) {
		return `lineNumber: ${this.getLineNumberForIndex(e)}`;
	}
	getLineNumberForIndex(e) {
		let t = this.tokens.code;
		for (; this.lastIndex < e && this.lastIndex < t.length;) t[this.lastIndex] === "\n" && this.lastLineNumber++, this.lastIndex++;
		return this.lastLineNumber;
	}
	transformTagToJSXFunc(e, t) {
		let n = t === Fi.StaticChildren;
		this.tokens.replaceToken(this.getJSXFuncInvocationCode(n));
		let r = null;
		if (this.tokens.matches1(F.jsxTagEnd)) this.tokens.replaceToken(`${this.getFragmentCode()}, {`), this.processAutomaticChildrenAndEndProps(t);
		else {
			if (this.processTagIntro(), this.tokens.appendCode(", {"), r = this.processProps(!0), this.tokens.matches2(F.slash, F.jsxTagEnd)) this.tokens.appendCode("}");
			else if (this.tokens.matches1(F.jsxTagEnd)) this.tokens.removeToken(), this.processAutomaticChildrenAndEndProps(t);
			else throw Error("Expected either /> or > at the end of the tag.");
			r && this.tokens.appendCode(`, ${r}`);
		}
		for (this.options.production || (r === null && this.tokens.appendCode(", void 0"), this.tokens.appendCode(`, ${n}, ${this.getDevSource(e)}, this`)), this.tokens.removeInitialToken(); !this.tokens.matches1(F.jsxTagEnd);) this.tokens.removeToken();
		this.tokens.replaceToken(")");
	}
	transformTagToCreateElement(e) {
		if (this.tokens.replaceToken(this.getCreateElementInvocationCode()), this.tokens.matches1(F.jsxTagEnd)) this.tokens.replaceToken(`${this.getFragmentCode()}, null`), this.processChildren(!0);
		else if (this.processTagIntro(), this.processPropsObjectWithDevInfo(e), !this.tokens.matches2(F.slash, F.jsxTagEnd)) {
			if (this.tokens.matches1(F.jsxTagEnd)) this.tokens.removeToken(), this.processChildren(!0);
			else throw Error("Expected either /> or > at the end of the tag.");
		}
		for (this.tokens.removeInitialToken(); !this.tokens.matches1(F.jsxTagEnd);) this.tokens.removeToken();
		this.tokens.replaceToken(")");
	}
	getJSXFuncInvocationCode(e) {
		return this.options.production ? e ? this.claimAutoImportedFuncInvocation("jsxs", "/jsx-runtime") : this.claimAutoImportedFuncInvocation("jsx", "/jsx-runtime") : this.claimAutoImportedFuncInvocation("jsxDEV", "/jsx-dev-runtime");
	}
	getCreateElementInvocationCode() {
		if (this.isAutomaticRuntime) return this.claimAutoImportedFuncInvocation("createElement", "");
		{
			let { jsxPragmaInfo: e } = this;
			return `${this.importProcessor && this.importProcessor.getIdentifierReplacement(e.base) || e.base}${e.suffix}(`;
		}
	}
	getFragmentCode() {
		if (this.isAutomaticRuntime) return this.claimAutoImportedName("Fragment", this.options.production ? "/jsx-runtime" : "/jsx-dev-runtime");
		{
			let { jsxPragmaInfo: e } = this;
			return (this.importProcessor && this.importProcessor.getIdentifierReplacement(e.fragmentBase) || e.fragmentBase) + e.fragmentSuffix;
		}
	}
	claimAutoImportedFuncInvocation(e, t) {
		let n = this.claimAutoImportedName(e, t);
		return this.importProcessor ? `${n}.call(void 0, ` : `${n}(`;
	}
	claimAutoImportedName(e, t) {
		if (this.importProcessor) {
			let n = this.jsxImportSource + t;
			return this.cjsAutomaticModuleNameResolutions[n] || (this.cjsAutomaticModuleNameResolutions[n] = this.importProcessor.getFreeIdentifierForPath(n)), `${this.cjsAutomaticModuleNameResolutions[n]}.${e}`;
		}
		return this.esmAutomaticImportNameResolutions[e] || (this.esmAutomaticImportNameResolutions[e] = this.nameManager.claimFreeName(`_${e}`)), this.esmAutomaticImportNameResolutions[e];
	}
	processTagIntro() {
		let e = this.tokens.currentIndex() + 1;
		for (; this.tokens.tokens[e].isType || !this.tokens.matches2AtIndex(e - 1, F.jsxName, F.jsxName) && !this.tokens.matches2AtIndex(e - 1, F.greaterThan, F.jsxName) && !this.tokens.matches1AtIndex(e, F.braceL) && !this.tokens.matches1AtIndex(e, F.jsxTagEnd) && !this.tokens.matches2AtIndex(e, F.slash, F.jsxTagEnd);) e++;
		if (e === this.tokens.currentIndex() + 1) {
			let e = this.tokens.identifierName();
			Aa(e) && this.tokens.replaceToken(`'${e}'`);
		}
		for (; this.tokens.currentIndex() < e;) this.rootTransformer.processToken();
	}
	processPropsObjectWithDevInfo(e) {
		let t = this.options.production ? "" : `__self: this, __source: ${this.getDevSource(e)}`;
		!this.tokens.matches1(F.jsxName) && !this.tokens.matches1(F.braceL) ? t ? this.tokens.appendCode(`, {${t}}`) : this.tokens.appendCode(", null") : (this.tokens.appendCode(", {"), this.processProps(!1), t ? this.tokens.appendCode(` ${t}}`) : this.tokens.appendCode("}"));
	}
	processProps(e) {
		let t = null;
		for (;;) {
			if (this.tokens.matches2(F.jsxName, F.eq)) {
				let n = this.tokens.identifierName();
				if (e && n === "key") {
					t !== null && this.tokens.appendCode(t.replace(/[^\n]/g, "")), this.tokens.removeToken(), this.tokens.removeToken();
					let e = this.tokens.snapshot();
					this.processPropValue(), t = this.tokens.dangerouslyGetAndRemoveCodeSinceSnapshot(e);
					continue;
				}
				this.processPropName(n), this.tokens.replaceToken(": "), this.processPropValue();
			} else if (this.tokens.matches1(F.jsxName)) {
				let e = this.tokens.identifierName();
				this.processPropName(e), this.tokens.appendCode(": true");
			} else if (this.tokens.matches1(F.braceL)) this.tokens.replaceToken(""), this.rootTransformer.processBalancedCode(), this.tokens.replaceToken("");
			else break;
			this.tokens.appendCode(",");
		}
		return t;
	}
	processPropName(e) {
		e.includes("-") ? this.tokens.replaceToken(`'${e}'`) : this.tokens.copyToken();
	}
	processPropValue() {
		this.tokens.matches1(F.braceL) ? (this.tokens.replaceToken(""), this.rootTransformer.processBalancedCode(), this.tokens.replaceToken("")) : this.tokens.matches1(F.jsxTagStart) ? this.processJSXTag() : this.processStringPropValue();
	}
	processStringPropValue() {
		let e = this.tokens.currentToken(), t = this.tokens.code.slice(e.start + 1, e.end - 1), n = Ma(t), r = Na(t);
		this.tokens.replaceToken(r + n);
	}
	processAutomaticChildrenAndEndProps(e) {
		e === Fi.StaticChildren ? (this.tokens.appendCode(" children: ["), this.processChildren(!1), this.tokens.appendCode("]}")) : (e === Fi.OneChild && this.tokens.appendCode(" children: "), this.processChildren(!1), this.tokens.appendCode("}"));
	}
	processChildren(e) {
		let t = e;
		for (;;) {
			if (this.tokens.matches2(F.jsxTagStart, F.slash)) return;
			let e = !1;
			if (this.tokens.matches1(F.braceL)) this.tokens.matches2(F.braceL, F.braceR) ? (this.tokens.replaceToken(""), this.tokens.replaceToken("")) : (this.tokens.replaceToken(t ? ", " : ""), this.rootTransformer.processBalancedCode(), this.tokens.replaceToken(""), e = !0);
			else if (this.tokens.matches1(F.jsxTagStart)) this.tokens.appendCode(t ? ", " : ""), this.processJSXTag(), e = !0;
			else if (this.tokens.matches1(F.jsxText) || this.tokens.matches1(F.jsxEmptyText)) e = this.processChildTextElement(t);
			else throw Error("Unexpected token when processing JSX children.");
			e && (t = !0);
		}
	}
	processChildTextElement(e) {
		let t = this.tokens.currentToken(), n = this.tokens.code.slice(t.start, t.end), r = Ma(n), i = ja(n);
		return i === "\"\"" ? (this.tokens.replaceToken(r), !1) : (this.tokens.replaceToken(`${e ? ", " : ""}${i}${r}`), !0);
	}
	getDevSource(e) {
		return `{fileName: ${this.getFilenameVarName()}, ${e}}`;
	}
	getFilenameVarName() {
		return this.filenameVarName ||= this.nameManager.claimFreeName("_jsxFileName"), this.filenameVarName;
	}
};
function Aa(e) {
	let t = e.charCodeAt(0);
	return t >= I.lowercaseA && t <= I.lowercaseZ;
}
function ja(e) {
	let t = "", n = "", r = !1, i = !1;
	for (let a = 0; a < e.length; a++) {
		let o = e[a];
		if (o === " " || o === "	" || o === "\r") r || (n += o);
		else if (o === "\n") n = "", r = !0;
		else {
			if (i && r && (t += " "), t += n, n = "", o === "&") {
				let { entity: n, newI: r } = Pa(e, a + 1);
				a = r - 1, t += n;
			} else t += o;
			i = !0, r = !1;
		}
	}
	return r || (t += n), JSON.stringify(t);
}
function Ma(e) {
	let t = 0, n = 0;
	for (let r of e) r === "\n" ? (t++, n = 0) : r === " " && n++;
	return "\n".repeat(t) + " ".repeat(n);
}
function Na(e) {
	let t = "";
	for (let n = 0; n < e.length; n++) {
		let r = e[n];
		if (r === "\n") {
			if (/\s/.test(e[n + 1])) for (t += " "; n < e.length && /\s/.test(e[n + 1]);) n++;
			else t += "\n";
		} else if (r === "&") {
			let { entity: r, newI: i } = Pa(e, n + 1);
			t += r, n = i - 1;
		} else t += r;
	}
	return JSON.stringify(t);
}
function Pa(e, t) {
	let n = "", r = 0, i, a = t;
	if (e[a] === "#") {
		let t = 10;
		a++;
		let n;
		if (e[a] === "x") for (t = 16, a++, n = a; a < e.length && Ia(e.charCodeAt(a));) a++;
		else for (n = a; a < e.length && Fa(e.charCodeAt(a));) a++;
		if (e[a] === ";") {
			let r = e.slice(n, a);
			r && (a++, i = String.fromCodePoint(parseInt(r, t)));
		}
	} else for (; a < e.length && r++ < 10;) {
		let t = e[a];
		if (a++, t === ";") {
			i = Ta.get(n);
			break;
		}
		n += t;
	}
	return i ? {
		entity: i,
		newI: a
	} : {
		entity: "&",
		newI: t
	};
}
function Fa(e) {
	return e >= I.digit0 && e <= I.digit9;
}
function Ia(e) {
	return e >= I.digit0 && e <= I.digit9 || e >= I.lowercaseA && e <= I.lowercaseF || e >= I.uppercaseA && e <= I.uppercaseF;
}
// node_modules/sucrase/dist/esm/util/getNonTypeIdentifiers.js
function La(e, t) {
	let n = Ea(t), r = /* @__PURE__ */ new Set();
	for (let t = 0; t < e.tokens.length; t++) {
		let i = e.tokens[t];
		i.type !== F.name || i.isType || i.identifierRole !== W.Access && i.identifierRole !== W.ObjectShorthand && i.identifierRole !== W.ExportAccess || i.shadowsGlobal || r.add(e.identifierNameForToken(i)), i.type === F.jsxTagStart && r.add(n.base), i.type === F.jsxTagStart && t + 1 < e.tokens.length && e.tokens[t + 1].type === F.jsxTagEnd && (r.add(n.base), r.add(n.fragmentBase)), i.type === F.jsxName && i.identifierRole === W.Access && (Aa(e.identifierNameForToken(i)) && e.tokens[t + 1].type !== F.dot || r.add(e.identifierNameForToken(i)));
	}
	return r;
}
// node_modules/sucrase/dist/esm/CJSImportProcessor.js
var Ra = class e {
	__init() {
		this.nonTypeIdentifiers = /* @__PURE__ */ new Set();
	}
	__init2() {
		this.importInfoByPath = /* @__PURE__ */ new Map();
	}
	__init3() {
		this.importsToReplace = /* @__PURE__ */ new Map();
	}
	__init4() {
		this.identifierReplacements = /* @__PURE__ */ new Map();
	}
	__init5() {
		this.exportBindingsByLocalName = /* @__PURE__ */ new Map();
	}
	constructor(t, n, r, i, a, o, s) {
		this.nameManager = t, this.tokens = n, this.enableLegacyTypeScriptModuleInterop = r, this.options = i, this.isTypeScriptTransformEnabled = a, this.keepUnusedImports = o, this.helperManager = s, e.prototype.__init.call(this), e.prototype.__init2.call(this), e.prototype.__init3.call(this), e.prototype.__init4.call(this), e.prototype.__init5.call(this);
	}
	preprocessTokens() {
		for (let e = 0; e < this.tokens.tokens.length; e++) this.tokens.matches1AtIndex(e, F._import) && !this.tokens.matches3AtIndex(e, F._import, F.name, F.eq) && this.preprocessImportAtIndex(e), this.tokens.matches1AtIndex(e, F._export) && !this.tokens.matches2AtIndex(e, F._export, F.eq) && this.preprocessExportAtIndex(e);
		this.generateImportReplacements();
	}
	pruneTypeOnlyImports() {
		this.nonTypeIdentifiers = La(this.tokens, this.options);
		for (let [e, t] of this.importInfoByPath.entries()) t.hasBareImport || t.hasStarExport || t.exportStarNames.length > 0 || t.namedExports.length > 0 || [
			...t.defaultNames,
			...t.wildcardNames,
			...t.namedImports.map(({ localName: e }) => e)
		].every((e) => this.shouldAutomaticallyElideImportedName(e)) && this.importsToReplace.set(e, "");
	}
	shouldAutomaticallyElideImportedName(e) {
		return this.isTypeScriptTransformEnabled && !this.keepUnusedImports && !this.nonTypeIdentifiers.has(e);
	}
	generateImportReplacements() {
		for (let [e, t] of this.importInfoByPath.entries()) {
			let { defaultNames: n, wildcardNames: r, namedImports: i, namedExports: a, exportStarNames: o, hasStarExport: s } = t;
			if (n.length === 0 && r.length === 0 && i.length === 0 && a.length === 0 && o.length === 0 && !s) {
				this.importsToReplace.set(e, `require('${e}');`);
				continue;
			}
			let c = this.getFreeIdentifierForPath(e), l;
			l = this.enableLegacyTypeScriptModuleInterop ? c : r.length > 0 ? r[0] : this.getFreeIdentifierForPath(e);
			let u = `var ${c} = require('${e}');`;
			if (r.length > 0) for (let e of r) {
				let t = this.enableLegacyTypeScriptModuleInterop ? c : `${this.helperManager.getHelperName("interopRequireWildcard")}(${c})`;
				u += ` var ${e} = ${t};`;
			}
			else o.length > 0 && l !== c ? u += ` var ${l} = ${this.helperManager.getHelperName("interopRequireWildcard")}(${c});` : n.length > 0 && l !== c && (u += ` var ${l} = ${this.helperManager.getHelperName("interopRequireDefault")}(${c});`);
			for (let { importedName: e, localName: t } of a) u += ` ${this.helperManager.getHelperName("createNamedExportFrom")}(${c}, '${t}', '${e}');`;
			for (let e of o) u += ` exports.${e} = ${l};`;
			s && (u += ` ${this.helperManager.getHelperName("createStarExport")}(${c});`), this.importsToReplace.set(e, u);
			for (let e of n) this.identifierReplacements.set(e, `${l}.default`);
			for (let { importedName: e, localName: t } of i) this.identifierReplacements.set(t, `${c}.${e}`);
		}
	}
	getFreeIdentifierForPath(e) {
		let t = e.split("/"), n = t[t.length - 1].replace(/\W/g, "");
		return this.nameManager.claimFreeName(`_${n}`);
	}
	preprocessImportAtIndex(e) {
		let t = [], n = [], r = [];
		if (e++, (this.tokens.matchesContextualAtIndex(e, P._type) || this.tokens.matches1AtIndex(e, F._typeof)) && !this.tokens.matches1AtIndex(e + 1, F.comma) && !this.tokens.matchesContextualAtIndex(e + 1, P._from) || this.tokens.matches1AtIndex(e, F.parenL)) return;
		if (this.tokens.matches1AtIndex(e, F.name) && (t.push(this.tokens.identifierNameAtIndex(e)), e++, this.tokens.matches1AtIndex(e, F.comma) && e++), this.tokens.matches1AtIndex(e, F.star) && (e += 2, n.push(this.tokens.identifierNameAtIndex(e)), e++), this.tokens.matches1AtIndex(e, F.braceL)) {
			let n = this.getNamedImports(e + 1);
			e = n.newIndex;
			for (let e of n.namedImports) e.importedName === "default" ? t.push(e.localName) : r.push(e);
		}
		if (this.tokens.matchesContextualAtIndex(e, P._from) && e++, !this.tokens.matches1AtIndex(e, F.string)) throw Error("Expected string token at the end of import statement.");
		let i = this.tokens.stringValueAtIndex(e), a = this.getImportInfo(i);
		a.defaultNames.push(...t), a.wildcardNames.push(...n), a.namedImports.push(...r), t.length === 0 && n.length === 0 && r.length === 0 && (a.hasBareImport = !0);
	}
	preprocessExportAtIndex(e) {
		if (this.tokens.matches2AtIndex(e, F._export, F._var) || this.tokens.matches2AtIndex(e, F._export, F._let) || this.tokens.matches2AtIndex(e, F._export, F._const)) this.preprocessVarExportAtIndex(e);
		else if (this.tokens.matches2AtIndex(e, F._export, F._function) || this.tokens.matches2AtIndex(e, F._export, F._class)) {
			let t = this.tokens.identifierNameAtIndex(e + 2);
			this.addExportBinding(t, t);
		} else if (this.tokens.matches3AtIndex(e, F._export, F.name, F._function)) {
			let t = this.tokens.identifierNameAtIndex(e + 3);
			this.addExportBinding(t, t);
		} else this.tokens.matches2AtIndex(e, F._export, F.braceL) ? this.preprocessNamedExportAtIndex(e) : this.tokens.matches2AtIndex(e, F._export, F.star) && this.preprocessExportStarAtIndex(e);
	}
	preprocessVarExportAtIndex(e) {
		let t = 0;
		for (let n = e + 2;; n++) if (this.tokens.matches1AtIndex(n, F.braceL) || this.tokens.matches1AtIndex(n, F.dollarBraceL) || this.tokens.matches1AtIndex(n, F.bracketL)) t++;
		else if (this.tokens.matches1AtIndex(n, F.braceR) || this.tokens.matches1AtIndex(n, F.bracketR)) t--;
		else if (t === 0 && !this.tokens.matches1AtIndex(n, F.name)) break;
		else if (this.tokens.matches1AtIndex(1, F.eq)) {
			let e = this.tokens.currentToken().rhsEndIndex;
			if (e == null) throw Error("Expected = token with an end index.");
			n = e - 1;
		} else {
			let e = this.tokens.tokens[n];
			if (Ii(e)) {
				let e = this.tokens.identifierNameAtIndex(n);
				this.identifierReplacements.set(e, `exports.${e}`);
			}
		}
	}
	preprocessNamedExportAtIndex(e) {
		e += 2;
		let { newIndex: t, namedImports: n } = this.getNamedImports(e);
		if (e = t, this.tokens.matchesContextualAtIndex(e, P._from)) e++;
		else {
			for (let { importedName: e, localName: t } of n) this.addExportBinding(e, t);
			return;
		}
		if (!this.tokens.matches1AtIndex(e, F.string)) throw Error("Expected string token at the end of import statement.");
		let r = this.tokens.stringValueAtIndex(e);
		this.getImportInfo(r).namedExports.push(...n);
	}
	preprocessExportStarAtIndex(e) {
		let t = null;
		if (this.tokens.matches3AtIndex(e, F._export, F.star, F._as) ? (e += 3, t = this.tokens.identifierNameAtIndex(e), e += 2) : e += 3, !this.tokens.matches1AtIndex(e, F.string)) throw Error("Expected string token at the end of star export statement.");
		let n = this.tokens.stringValueAtIndex(e), r = this.getImportInfo(n);
		t === null ? r.hasStarExport = !0 : r.exportStarNames.push(t);
	}
	getNamedImports(e) {
		let t = [];
		for (;;) {
			if (this.tokens.matches1AtIndex(e, F.braceR)) {
				e++;
				break;
			}
			let n = Ca(this.tokens, e);
			if (e = n.endIndex, n.isType || t.push({
				importedName: n.leftName,
				localName: n.rightName
			}), this.tokens.matches2AtIndex(e, F.comma, F.braceR)) {
				e += 2;
				break;
			}
			if (this.tokens.matches1AtIndex(e, F.braceR)) {
				e++;
				break;
			}
			if (this.tokens.matches1AtIndex(e, F.comma)) e++;
			else throw Error(`Unexpected token: ${JSON.stringify(this.tokens.tokens[e])}`);
		}
		return {
			newIndex: e,
			namedImports: t
		};
	}
	getImportInfo(e) {
		let t = this.importInfoByPath.get(e);
		if (t) return t;
		let n = {
			defaultNames: [],
			wildcardNames: [],
			namedImports: [],
			namedExports: [],
			hasBareImport: !1,
			exportStarNames: [],
			hasStarExport: !1
		};
		return this.importInfoByPath.set(e, n), n;
	}
	addExportBinding(e, t) {
		this.exportBindingsByLocalName.has(e) || this.exportBindingsByLocalName.set(e, []), this.exportBindingsByLocalName.get(e).push(t);
	}
	claimImportCode(e) {
		let t = this.importsToReplace.get(e);
		return this.importsToReplace.set(e, ""), t || "";
	}
	getIdentifierReplacement(e) {
		return this.identifierReplacements.get(e) || null;
	}
	resolveExportBinding(e) {
		let t = this.exportBindingsByLocalName.get(e);
		return !t || t.length === 0 ? null : t.map((e) => `exports.${e}`).join(" = ");
	}
	getGlobalNames() {
		return /* @__PURE__ */ new Set([...this.identifierReplacements.keys(), ...this.exportBindingsByLocalName.keys()]);
	}
}, za = 44, Ba = 59, Va = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/", Ha = /* @__PURE__ */ new Uint8Array(64), Ua = /* @__PURE__ */ new Uint8Array(128);
for (let e = 0; e < Va.length; e++) {
	let t = Va.charCodeAt(e);
	Ha[e] = t, Ua[t] = e;
}
function Wa(e, t) {
	do {
		let n = t & 31;
		t >>>= 5, t > 0 && (n |= 32), e.write(Ha[n]);
	} while (t > 0);
}
function Ga(e) {
	return e < 0 ? -e << 1 | 1 : e << 1;
}
var Ka = 16384, qa = typeof TextDecoder < "u" ? /* @__PURE__ */ new TextDecoder() : typeof Buffer < "u" ? { decode(e) {
	return Buffer.from(e.buffer, e.byteOffset, e.byteLength).toString();
} } : { decode(e) {
	let t = "";
	for (let n = 0; n < e.length; n++) t += String.fromCharCode(e[n]);
	return t;
} }, Ja = class {
	constructor() {
		this.pos = 0, this.out = "", this.buffer = new Uint8Array(Ka);
	}
	write(e) {
		let { buffer: t } = this;
		t[this.pos++] = e, this.pos === Ka && (this.out += qa.decode(t), this.pos = 0);
	}
	flush() {
		let { buffer: e, out: t, pos: n } = this;
		return n > 0 ? t + qa.decode(e.subarray(0, n)) : t;
	}
};
function Ya(e) {
	let t = new Ja(), n = 0, r = 0, i = 0, a = 0;
	for (let o = 0; o < e.length; o++) {
		let s = e[o];
		if (o > 0 && t.write(Ba), s.length === 0) continue;
		let c = 0;
		for (let e = 0; e < s.length; e++) {
			let o = s[e];
			e > 0 && t.write(za), Wa(t, Ga(o[0] - c)), c = o[0], o.length !== 1 && (Wa(t, Ga(o[1] - n)), Wa(t, Ga(o[2] - r)), Wa(t, Ga(o[3] - i)), n = o[1], r = o[2], i = o[3], o.length !== 4 && (Wa(t, Ga(o[4] - a)), a = o[4]));
		}
	}
	return t.flush();
}
(/* @__PURE__ */ t(((e, t, n) => {
	(function(n, r) {
		typeof e == "object" && t !== void 0 ? t.exports = r() : typeof define == "function" && define.amd ? define(r) : (n = typeof globalThis < "u" ? globalThis : n || self, n.resolveURI = r());
	})(n, (function() {
		let e = /^[\w+.-]+:\/\//, t = /^([\w+.-]+:)\/\/([^@/#?]*@)?([^:/#?]*)(:\d+)?(\/[^#?]*)?(\?[^#]*)?(#.*)?/, n = /^file:(?:\/\/((?![a-z]:)[^/#?]*)?)?(\/?[^#?]*)(\?[^#]*)?(#.*)?/i;
		function r(t) {
			return e.test(t);
		}
		function i(e) {
			return e.startsWith("//");
		}
		function a(e) {
			return e.startsWith("/");
		}
		function o(e) {
			return e.startsWith("file:");
		}
		function s(e) {
			return /^[.?#]/.test(e);
		}
		function c(e) {
			let n = t.exec(e);
			return u(n[1], n[2] || "", n[3], n[4] || "", n[5] || "/", n[6] || "", n[7] || "");
		}
		function l(e) {
			let t = n.exec(e), r = t[2];
			return u("file:", "", t[1] || "", "", a(r) ? r : "/" + r, t[3] || "", t[4] || "");
		}
		function u(e, t, n, r, i, a, o) {
			return {
				scheme: e,
				user: t,
				host: n,
				port: r,
				path: i,
				query: a,
				hash: o,
				type: 7
			};
		}
		function d(e) {
			if (i(e)) {
				let t = c("http:" + e);
				return t.scheme = "", t.type = 6, t;
			}
			if (a(e)) {
				let t = c("http://foo.com" + e);
				return t.scheme = "", t.host = "", t.type = 5, t;
			}
			if (o(e)) return l(e);
			if (r(e)) return c(e);
			let t = c("http://foo.com/" + e);
			return t.scheme = "", t.host = "", t.type = e ? e.startsWith("?") ? 3 : e.startsWith("#") ? 2 : 4 : 1, t;
		}
		function f(e) {
			if (e.endsWith("/..")) return e;
			let t = e.lastIndexOf("/");
			return e.slice(0, t + 1);
		}
		function p(e, t) {
			m(t, t.type), e.path = e.path === "/" ? t.path : f(t.path) + e.path;
		}
		function m(e, t) {
			let n = t <= 4, r = e.path.split("/"), i = 1, a = 0, o = !1;
			for (let e = 1; e < r.length; e++) {
				let t = r[e];
				t ? (o = !1, t !== "." && (t === ".." ? a ? (o = !0, a--, i--) : n && (r[i++] = t) : (r[i++] = t, a++))) : o = !0;
			}
			let s = "";
			for (let e = 1; e < i; e++) s += "/" + r[e];
			(!s || o && !s.endsWith("/..")) && (s += "/"), e.path = s;
		}
		function h(e, t) {
			if (!e && !t) return "";
			let n = d(e), r = n.type;
			if (t && r !== 7) {
				let e = d(t), i = e.type;
				switch (r) {
					case 1: n.hash = e.hash;
					case 2: n.query = e.query;
					case 3:
					case 4: p(n, e);
					case 5: n.user = e.user, n.host = e.host, n.port = e.port;
					case 6: n.scheme = e.scheme;
				}
				i > r && (r = i);
			}
			m(n, r);
			let i = n.query + n.hash;
			switch (r) {
				case 2:
				case 3: return i;
				case 4: {
					let r = n.path.slice(1);
					return r ? s(t || e) && !s(r) ? "./" + r + i : r + i : i || ".";
				}
				case 5: return n.path + i;
				default: return n.scheme + "//" + n.user + n.host + n.port + n.path + i;
			}
		}
		return h;
	}));
})))();
// node_modules/@jridgewell/gen-mapping/dist/gen-mapping.mjs
var Xa = class {
	constructor() {
		this._indexes = { __proto__: null }, this.array = [];
	}
};
function Za(e) {
	return e;
}
function Qa(e, t) {
	return Za(e)._indexes[t];
}
function $a(e, t) {
	let n = Qa(e, t);
	if (n !== void 0) return n;
	let { array: r, _indexes: i } = Za(e);
	return i[t] = r.push(t) - 1;
}
var eo = 0, to = 1, no = 2, ro = 3, io = 4, ao = -1, oo = class {
	constructor({ file: e, sourceRoot: t } = {}) {
		this._names = new Xa(), this._sources = new Xa(), this._sourcesContent = [], this._mappings = [], this.file = e, this.sourceRoot = t, this._ignoreList = new Xa();
	}
};
function so(e) {
	return e;
}
var co = (e, t, n, r, i, a, o, s) => fo(!0, e, t, n, r, i, a, o, s);
function lo(e) {
	let { _mappings: t, _sources: n, _sourcesContent: r, _names: i, _ignoreList: a } = so(e);
	return go(t), {
		version: 3,
		file: e.file || void 0,
		names: i.array,
		sourceRoot: e.sourceRoot || void 0,
		sources: n.array,
		sourcesContent: r,
		mappings: t,
		ignoreList: a.array
	};
}
function uo(e) {
	let t = lo(e);
	return Object.assign({}, t, { mappings: Ya(t.mappings) });
}
function fo(e, t, n, r, i, a, o, s, c) {
	let { _mappings: l, _sources: u, _sourcesContent: d, _names: f } = so(t), p = po(l, n), m = mo(p, r);
	if (!i) return e && _o(p, m) ? void 0 : ho(p, m, [r]);
	let h = $a(u, i), g = s ? $a(f, s) : ao;
	if (h === d.length && (d[h] = c ?? null), !(e && vo(p, m, h, a, o, g))) return ho(p, m, s ? [
		r,
		h,
		a,
		o,
		g
	] : [
		r,
		h,
		a,
		o
	]);
}
function po(e, t) {
	for (let n = e.length; n <= t; n++) e[n] = [];
	return e[t];
}
function mo(e, t) {
	let n = e.length;
	for (let r = n - 1; r >= 0 && !(t >= e[r][eo]); n = r--);
	return n;
}
function ho(e, t, n) {
	for (let n = e.length; n > t; n--) e[n] = e[n - 1];
	e[t] = n;
}
function go(e) {
	let { length: t } = e, n = t;
	for (let t = n - 1; t >= 0 && !(e[t].length > 0); n = t, t--);
	n < t && (e.length = n);
}
function _o(e, t) {
	return t === 0 || e[t - 1].length === 1;
}
function vo(e, t, n, r, i, a) {
	if (t === 0) return !1;
	let o = e[t - 1];
	return o.length !== 1 && n === o[to] && r === o[no] && i === o[ro] && a === (o.length === 5 ? o[io] : ao);
}
// node_modules/sucrase/dist/esm/computeSourceMap.js
function yo({ code: e, mappings: t }, n, r, i, a) {
	let o = bo(i, a), s = new oo({ file: r.compiledFilename }), c = 0, l = t[0];
	for (; l === void 0 && c < t.length - 1;) c++, l = t[c];
	let u = 0, d = 0;
	l !== d && co(s, u, 0, n, u, 0);
	for (let r = 0; r < e.length; r++) {
		if (r === l) {
			let e = l - d, i = o[c];
			for (co(s, u, e, n, u, i); (l === r || l === void 0) && c < t.length - 1;) c++, l = t[c];
		}
		e.charCodeAt(r) === I.lineFeed && (u++, d = r + 1, l !== d && co(s, u, 0, n, u, 0));
	}
	let { sourceRoot: f, sourcesContent: p, ...m } = uo(s);
	return m;
}
function bo(e, t) {
	let n = Array(t.length), r = 0, i = t[r].start, a = 0;
	for (let o = 0; o < e.length; o++) o === i && (n[r] = i - a, r++, i = t[r].start), e.charCodeAt(o) === I.lineFeed && (a = o + 1);
	return n;
}
// node_modules/sucrase/dist/esm/HelperManager.js
var xo = {
	require: "\n    import {createRequire as CREATE_REQUIRE_NAME} from \"module\";\n    const require = CREATE_REQUIRE_NAME(import.meta.url);\n  ",
	interopRequireWildcard: "\n    function interopRequireWildcard(obj) {\n      if (obj && obj.__esModule) {\n        return obj;\n      } else {\n        var newObj = {};\n        if (obj != null) {\n          for (var key in obj) {\n            if (Object.prototype.hasOwnProperty.call(obj, key)) {\n              newObj[key] = obj[key];\n            }\n          }\n        }\n        newObj.default = obj;\n        return newObj;\n      }\n    }\n  ",
	interopRequireDefault: "\n    function interopRequireDefault(obj) {\n      return obj && obj.__esModule ? obj : { default: obj };\n    }\n  ",
	createNamedExportFrom: "\n    function createNamedExportFrom(obj, localName, importedName) {\n      Object.defineProperty(exports, localName, {enumerable: true, configurable: true, get: () => obj[importedName]});\n    }\n  ",
	createStarExport: "\n    function createStarExport(obj) {\n      Object.keys(obj)\n        .filter((key) => key !== \"default\" && key !== \"__esModule\")\n        .forEach((key) => {\n          if (exports.hasOwnProperty(key)) {\n            return;\n          }\n          Object.defineProperty(exports, key, {enumerable: true, configurable: true, get: () => obj[key]});\n        });\n    }\n  ",
	nullishCoalesce: "\n    function nullishCoalesce(lhs, rhsFn) {\n      if (lhs != null) {\n        return lhs;\n      } else {\n        return rhsFn();\n      }\n    }\n  ",
	asyncNullishCoalesce: "\n    async function asyncNullishCoalesce(lhs, rhsFn) {\n      if (lhs != null) {\n        return lhs;\n      } else {\n        return await rhsFn();\n      }\n    }\n  ",
	optionalChain: "\n    function optionalChain(ops) {\n      let lastAccessLHS = undefined;\n      let value = ops[0];\n      let i = 1;\n      while (i < ops.length) {\n        const op = ops[i];\n        const fn = ops[i + 1];\n        i += 2;\n        if ((op === 'optionalAccess' || op === 'optionalCall') && value == null) {\n          return undefined;\n        }\n        if (op === 'access' || op === 'optionalAccess') {\n          lastAccessLHS = value;\n          value = fn(value);\n        } else if (op === 'call' || op === 'optionalCall') {\n          value = fn((...args) => value.call(lastAccessLHS, ...args));\n          lastAccessLHS = undefined;\n        }\n      }\n      return value;\n    }\n  ",
	asyncOptionalChain: "\n    async function asyncOptionalChain(ops) {\n      let lastAccessLHS = undefined;\n      let value = ops[0];\n      let i = 1;\n      while (i < ops.length) {\n        const op = ops[i];\n        const fn = ops[i + 1];\n        i += 2;\n        if ((op === 'optionalAccess' || op === 'optionalCall') && value == null) {\n          return undefined;\n        }\n        if (op === 'access' || op === 'optionalAccess') {\n          lastAccessLHS = value;\n          value = await fn(value);\n        } else if (op === 'call' || op === 'optionalCall') {\n          value = await fn((...args) => value.call(lastAccessLHS, ...args));\n          lastAccessLHS = undefined;\n        }\n      }\n      return value;\n    }\n  ",
	optionalChainDelete: "\n    function optionalChainDelete(ops) {\n      const result = OPTIONAL_CHAIN_NAME(ops);\n      return result == null ? true : result;\n    }\n  ",
	asyncOptionalChainDelete: "\n    async function asyncOptionalChainDelete(ops) {\n      const result = await ASYNC_OPTIONAL_CHAIN_NAME(ops);\n      return result == null ? true : result;\n    }\n  "
}, So = class e {
	__init() {
		this.helperNames = {};
	}
	__init2() {
		this.createRequireName = null;
	}
	constructor(t) {
		this.nameManager = t, e.prototype.__init.call(this), e.prototype.__init2.call(this);
	}
	getHelperName(e) {
		let t = this.helperNames[e];
		return t || (t = this.nameManager.claimFreeName(`_${e}`), this.helperNames[e] = t, t);
	}
	emitHelpers() {
		let e = "";
		this.helperNames.optionalChainDelete && this.getHelperName("optionalChain"), this.helperNames.asyncOptionalChainDelete && this.getHelperName("asyncOptionalChain");
		for (let [t, n] of Object.entries(xo)) {
			let r = this.helperNames[t], i = n;
			t === "optionalChainDelete" ? i = i.replace("OPTIONAL_CHAIN_NAME", this.helperNames.optionalChain) : t === "asyncOptionalChainDelete" ? i = i.replace("ASYNC_OPTIONAL_CHAIN_NAME", this.helperNames.asyncOptionalChain) : t === "require" && (this.createRequireName === null && (this.createRequireName = this.nameManager.claimFreeName("_createRequire")), i = i.replace(/CREATE_REQUIRE_NAME/g, this.createRequireName)), r && (e += " ", e += i.replace(t, r).replace(/\s+/g, " ").trim());
		}
		return e;
	}
};
// node_modules/sucrase/dist/esm/identifyShadowedGlobals.js
function Co(e, t, n) {
	wo(e, n) && To(e, t, n);
}
function wo(e, t) {
	for (let n of e.tokens) if (n.type === F.name && !n.isType && Li(n) && t.has(e.identifierNameForToken(n))) return !0;
	return !1;
}
function To(e, t, n) {
	let r = [], i = t.length - 1;
	for (let a = e.tokens.length - 1;; a--) {
		for (; r.length > 0 && r[r.length - 1].startTokenIndex === a + 1;) r.pop();
		for (; i >= 0 && t[i].endTokenIndex === a + 1;) r.push(t[i]), i--;
		if (a < 0) break;
		let o = e.tokens[a], s = e.identifierNameForToken(o);
		if (r.length > 1 && !o.isType && o.type === F.name && n.has(s)) {
			if (zi(o)) Eo(r[r.length - 1], e, s);
			else if (Bi(o)) {
				let t = r.length - 1;
				for (; t > 0 && !r[t].isFunctionScope;) t--;
				if (t < 0) throw Error("Did not find parent function scope.");
				Eo(r[t], e, s);
			}
		}
	}
	if (r.length > 0) throw Error("Expected empty scope stack after processing file.");
}
function Eo(e, t, n) {
	for (let r = e.startTokenIndex; r < e.endTokenIndex; r++) {
		let e = t.tokens[r];
		(e.type === F.name || e.type === F.jsxName) && t.identifierNameForToken(e) === n && (e.shadowsGlobal = !0);
	}
}
// node_modules/sucrase/dist/esm/util/getIdentifierNames.js
function Do(e, t) {
	let n = [];
	for (let r of t) r.type === F.name && n.push(e.slice(r.start, r.end));
	return n;
}
// node_modules/sucrase/dist/esm/NameManager.js
var Oo = class e {
	__init() {
		this.usedNames = /* @__PURE__ */ new Set();
	}
	constructor(t, n) {
		e.prototype.__init.call(this), this.usedNames = new Set(Do(t, n));
	}
	claimFreeName(e) {
		let t = this.findFreeName(e);
		return this.usedNames.add(t), t;
	}
	findFreeName(e) {
		if (!this.usedNames.has(e)) return e;
		let t = 2;
		for (; this.usedNames.has(e + String(t));) t++;
		return e + String(t);
	}
}, ko = /* @__PURE__ */ t(((e, t, n) => {
	var r = n && n.__extends || (function() {
		var e = function(t, n) {
			return e = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(e, t) {
				e.__proto__ = t;
			} || function(e, t) {
				for (var n in t) t.hasOwnProperty(n) && (e[n] = t[n]);
			}, e(t, n);
		};
		return function(t, n) {
			e(t, n);
			function r() {
				this.constructor = t;
			}
			t.prototype = n === null ? Object.create(n) : (r.prototype = n.prototype, new r());
		};
	})();
	Object.defineProperty(e, "__esModule", { value: !0 }), e.DetailContext = e.NoopContext = e.VError = void 0;
	var i = function(e) {
		r(t, e);
		function t(n, r) {
			var i = e.call(this, r) || this;
			return i.path = n, Object.setPrototypeOf(i, t.prototype), i;
		}
		return t;
	}(Error);
	e.VError = i, e.NoopContext = function() {
		function e() {}
		return e.prototype.fail = function(e, t, n) {
			return !1;
		}, e.prototype.unionResolver = function() {
			return this;
		}, e.prototype.createContext = function() {
			return this;
		}, e.prototype.resolveUnion = function(e) {}, e;
	}();
	var a = function() {
		function e() {
			this._propNames = [""], this._messages = [null], this._score = 0;
		}
		return e.prototype.fail = function(e, t, n) {
			return this._propNames.push(e), this._messages.push(t), this._score += n, !1;
		}, e.prototype.unionResolver = function() {
			return new o();
		}, e.prototype.resolveUnion = function(e) {
			for (var t, n, r = e, i = null, a = 0, o = r.contexts; a < o.length; a++) {
				var s = o[a];
				(!i || s._score >= i._score) && (i = s);
			}
			i && i._score > 0 && ((t = this._propNames).push.apply(t, i._propNames), (n = this._messages).push.apply(n, i._messages));
		}, e.prototype.getError = function(e) {
			for (var t = [], n = this._propNames.length - 1; n >= 0; n--) {
				var r = this._propNames[n];
				e += typeof r == "number" ? "[" + r + "]" : r ? "." + r : "";
				var a = this._messages[n];
				a && t.push(e + " " + a);
			}
			return new i(e, t.join("; "));
		}, e.prototype.getErrorDetail = function(e) {
			for (var t = [], n = this._propNames.length - 1; n >= 0; n--) {
				var r = this._propNames[n];
				e += typeof r == "number" ? "[" + r + "]" : r ? "." + r : "";
				var i = this._messages[n];
				i && t.push({
					path: e,
					message: i
				});
			}
			for (var a = null, n = t.length - 1; n >= 0; n--) a && (t[n].nested = [a]), a = t[n];
			return a;
		}, e;
	}();
	e.DetailContext = a;
	var o = function() {
		function e() {
			this.contexts = [];
		}
		return e.prototype.createContext = function() {
			var e = new a();
			return this.contexts.push(e), e;
		}, e;
	}();
})), Ao = /* @__PURE__ */ t(((e, t, n) => {
	var r = n && n.__extends || (function() {
		var e = function(t, n) {
			return e = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(e, t) {
				e.__proto__ = t;
			} || function(e, t) {
				for (var n in t) t.hasOwnProperty(n) && (e[n] = t[n]);
			}, e(t, n);
		};
		return function(t, n) {
			e(t, n);
			function r() {
				this.constructor = t;
			}
			t.prototype = n === null ? Object.create(n) : (r.prototype = n.prototype, new r());
		};
	})();
	Object.defineProperty(e, "__esModule", { value: !0 }), e.basicTypes = e.BasicType = e.TParamList = e.TParam = e.param = e.TFunc = e.func = e.TProp = e.TOptional = e.opt = e.TIface = e.iface = e.TEnumLiteral = e.enumlit = e.TEnumType = e.enumtype = e.TIntersection = e.intersection = e.TUnion = e.union = e.TTuple = e.tuple = e.TArray = e.array = e.TLiteral = e.lit = e.TName = e.name = e.TType = void 0;
	var i = ko(), a = function() {
		function e() {}
		return e;
	}();
	e.TType = a;
	function o(e) {
		return typeof e == "string" ? c(e) : e;
	}
	function s(e, t) {
		var n = e[t];
		if (!n) throw Error("Unknown type " + t);
		return n;
	}
	function c(e) {
		return new l(e);
	}
	e.name = c;
	var l = function(e) {
		r(t, e);
		function t(t) {
			var n = e.call(this) || this;
			return n.name = t, n._failMsg = "is not a " + t, n;
		}
		return t.prototype.getChecker = function(e, n, r) {
			var i = this, a = s(e, this.name), o = a.getChecker(e, n, r);
			return a instanceof de || a instanceof t ? o : function(e, t) {
				return o(e, t) ? !0 : t.fail(null, i._failMsg, 0);
			};
		}, t;
	}(a);
	e.TName = l;
	function u(e) {
		return new d(e);
	}
	e.lit = u;
	var d = function(e) {
		r(t, e);
		function t(t) {
			var n = e.call(this) || this;
			return n.value = t, n.name = JSON.stringify(t), n._failMsg = "is not " + n.name, n;
		}
		return t.prototype.getChecker = function(e, t) {
			var n = this;
			return function(e, t) {
				return e === n.value || t.fail(null, n._failMsg, -1);
			};
		}, t;
	}(a);
	e.TLiteral = d;
	function f(e) {
		return new p(o(e));
	}
	e.array = f;
	var p = function(e) {
		r(t, e);
		function t(t) {
			var n = e.call(this) || this;
			return n.ttype = t, n;
		}
		return t.prototype.getChecker = function(e, t) {
			var n = this.ttype.getChecker(e, t);
			return function(e, t) {
				if (!Array.isArray(e)) return t.fail(null, "is not an array", 0);
				for (var r = 0; r < e.length; r++) if (!n(e[r], t)) return t.fail(r, null, 1);
				return !0;
			};
		}, t;
	}(a);
	e.TArray = p;
	function m() {
		return new h([...arguments].map(function(e) {
			return o(e);
		}));
	}
	e.tuple = m;
	var h = function(e) {
		r(t, e);
		function t(t) {
			var n = e.call(this) || this;
			return n.ttypes = t, n;
		}
		return t.prototype.getChecker = function(e, t) {
			var n = this.ttypes.map(function(n) {
				return n.getChecker(e, t);
			}), r = function(e, t) {
				if (!Array.isArray(e)) return t.fail(null, "is not an array", 0);
				for (var r = 0; r < n.length; r++) if (!n[r](e[r], t)) return t.fail(r, null, 1);
				return !0;
			};
			return t ? function(e, t) {
				return r(e, t) ? e.length <= n.length || t.fail(n.length, "is extraneous", 2) : !1;
			} : r;
		}, t;
	}(a);
	e.TTuple = h;
	function g() {
		return new _([...arguments].map(function(e) {
			return o(e);
		}));
	}
	e.union = g;
	var _ = function(e) {
		r(t, e);
		function t(t) {
			var n = e.call(this) || this;
			n.ttypes = t;
			var r = t.map(function(e) {
				return e instanceof l || e instanceof d ? e.name : null;
			}).filter(function(e) {
				return e;
			}), i = t.length - r.length;
			return r.length ? (i > 0 && r.push(i + " more"), n._failMsg = "is none of " + r.join(", ")) : n._failMsg = "is none of " + i + " types", n;
		}
		return t.prototype.getChecker = function(e, t) {
			var n = this, r = this.ttypes.map(function(n) {
				return n.getChecker(e, t);
			});
			return function(e, t) {
				for (var i = t.unionResolver(), a = 0; a < r.length; a++) if (r[a](e, i.createContext())) return !0;
				return t.resolveUnion(i), t.fail(null, n._failMsg, 0);
			};
		}, t;
	}(a);
	e.TUnion = _;
	function v() {
		return new y([...arguments].map(function(e) {
			return o(e);
		}));
	}
	e.intersection = v;
	var y = function(e) {
		r(t, e);
		function t(t) {
			var n = e.call(this) || this;
			return n.ttypes = t, n;
		}
		return t.prototype.getChecker = function(e, t) {
			var n = /* @__PURE__ */ new Set(), r = this.ttypes.map(function(r) {
				return r.getChecker(e, t, n);
			});
			return function(e, t) {
				return r.every(function(n) {
					return n(e, t);
				}) ? !0 : t.fail(null, null, 0);
			};
		}, t;
	}(a);
	e.TIntersection = y;
	function b(e) {
		return new x(e);
	}
	e.enumtype = b;
	var x = function(e) {
		r(t, e);
		function t(t) {
			var n = e.call(this) || this;
			return n.members = t, n.validValues = /* @__PURE__ */ new Set(), n._failMsg = "is not a valid enum value", n.validValues = new Set(Object.keys(t).map(function(e) {
				return t[e];
			})), n;
		}
		return t.prototype.getChecker = function(e, t) {
			var n = this;
			return function(e, t) {
				return n.validValues.has(e) ? !0 : t.fail(null, n._failMsg, 0);
			};
		}, t;
	}(a);
	e.TEnumType = x;
	function S(e, t) {
		return new C(e, t);
	}
	e.enumlit = S;
	var C = function(e) {
		r(t, e);
		function t(t, n) {
			var r = e.call(this) || this;
			return r.enumName = t, r.prop = n, r._failMsg = "is not " + t + "." + n, r;
		}
		return t.prototype.getChecker = function(e, t) {
			var n = this, r = s(e, this.enumName);
			if (!(r instanceof x)) throw Error("Type " + this.enumName + " used in enumlit is not an enum type");
			var i = r.members[this.prop];
			if (!r.members.hasOwnProperty(this.prop)) throw Error("Unknown value " + this.enumName + "." + this.prop + " used in enumlit");
			return function(e, t) {
				return e === i || t.fail(null, n._failMsg, -1);
			};
		}, t;
	}(a);
	e.TEnumLiteral = C;
	function w(e) {
		return Object.keys(e).map(function(t) {
			return ee(t, e[t]);
		});
	}
	function ee(e, t) {
		return t instanceof ie ? new ae(e, t.ttype, !0) : new ae(e, o(t), !1);
	}
	function te(e, t) {
		return new ne(e, w(t));
	}
	e.iface = te;
	var ne = function(e) {
		r(t, e);
		function t(t, n) {
			var r = e.call(this) || this;
			return r.bases = t, r.props = n, r.propSet = new Set(n.map(function(e) {
				return e.name;
			})), r;
		}
		return t.prototype.getChecker = function(e, t, n) {
			var r = this, a = this.bases.map(function(n) {
				return s(e, n).getChecker(e, t);
			}), o = this.props.map(function(n) {
				return n.ttype.getChecker(e, t);
			}), c = new i.NoopContext(), l = this.props.map(function(e, t) {
				return !e.isOpt && !o[t](void 0, c);
			}), u = function(e, t) {
				if (typeof e != "object" || !e) return t.fail(null, "is not an object", 0);
				for (var n = 0; n < a.length; n++) if (!a[n](e, t)) return !1;
				for (var n = 0; n < o.length; n++) {
					var i = r.props[n].name, s = e[i];
					if (s === void 0) {
						if (l[n]) return t.fail(i, "is missing", 1);
					} else if (!o[n](s, t)) return t.fail(i, null, 1);
				}
				return !0;
			};
			if (!t) return u;
			var d = this.propSet;
			return n && (this.propSet.forEach(function(e) {
				return n.add(e);
			}), d = n), function(e, t) {
				if (!u(e, t)) return !1;
				for (var n in e) if (!d.has(n)) return t.fail(n, "is extraneous", 2);
				return !0;
			};
		}, t;
	}(a);
	e.TIface = ne;
	function re(e) {
		return new ie(o(e));
	}
	e.opt = re;
	var ie = function(e) {
		r(t, e);
		function t(t) {
			var n = e.call(this) || this;
			return n.ttype = t, n;
		}
		return t.prototype.getChecker = function(e, t) {
			var n = this.ttype.getChecker(e, t);
			return function(e, t) {
				return e === void 0 || n(e, t);
			};
		}, t;
	}(a);
	e.TOptional = ie;
	var ae = function() {
		function e(e, t, n) {
			this.name = e, this.ttype = t, this.isOpt = n;
		}
		return e;
	}();
	e.TProp = ae;
	function oe(e) {
		return new se(new ue([...arguments].slice(1)), o(e));
	}
	e.func = oe;
	var se = function(e) {
		r(t, e);
		function t(t, n) {
			var r = e.call(this) || this;
			return r.paramList = t, r.result = n, r;
		}
		return t.prototype.getChecker = function(e, t) {
			return function(e, t) {
				return typeof e == "function" || t.fail(null, "is not a function", 0);
			};
		}, t;
	}(a);
	e.TFunc = se;
	function ce(e, t, n) {
		return new le(e, o(t), !!n);
	}
	e.param = ce;
	var le = function() {
		function e(e, t, n) {
			this.name = e, this.ttype = t, this.isOpt = n;
		}
		return e;
	}();
	e.TParam = le;
	var ue = function(e) {
		r(t, e);
		function t(t) {
			var n = e.call(this) || this;
			return n.params = t, n;
		}
		return t.prototype.getChecker = function(e, t) {
			var n = this, r = this.params.map(function(n) {
				return n.ttype.getChecker(e, t);
			}), a = new i.NoopContext(), o = this.params.map(function(e, t) {
				return !e.isOpt && !r[t](void 0, a);
			}), s = function(e, t) {
				if (!Array.isArray(e)) return t.fail(null, "is not an array", 0);
				for (var i = 0; i < r.length; i++) {
					var a = n.params[i];
					if (e[i] === void 0) {
						if (o[i]) return t.fail(a.name, "is missing", 1);
					} else if (!r[i](e[i], t)) return t.fail(a.name, null, 1);
				}
				return !0;
			};
			return t ? function(e, t) {
				return s(e, t) ? e.length <= r.length || t.fail(r.length, "is extraneous", 2) : !1;
			} : s;
		}, t;
	}(a);
	e.TParamList = ue;
	var de = function(e) {
		r(t, e);
		function t(t, n) {
			var r = e.call(this) || this;
			return r.validator = t, r.message = n, r;
		}
		return t.prototype.getChecker = function(e, t) {
			var n = this;
			return function(e, t) {
				return n.validator(e) ? !0 : t.fail(null, n.message, 0);
			};
		}, t;
	}(a);
	e.BasicType = de, e.basicTypes = {
		any: new de(function(e) {
			return !0;
		}, "is invalid"),
		number: new de(function(e) {
			return typeof e == "number";
		}, "is not a number"),
		object: new de(function(e) {
			return typeof e == "object" && e;
		}, "is not an object"),
		boolean: new de(function(e) {
			return typeof e == "boolean";
		}, "is not a boolean"),
		string: new de(function(e) {
			return typeof e == "string";
		}, "is not a string"),
		symbol: new de(function(e) {
			return typeof e == "symbol";
		}, "is not a symbol"),
		void: new de(function(e) {
			return e == null;
		}, "is not void"),
		undefined: new de(function(e) {
			return e === void 0;
		}, "is not undefined"),
		null: new de(function(e) {
			return e === null;
		}, "is not null"),
		never: new de(function(e) {
			return !1;
		}, "is unexpected"),
		Date: new de(T("[object Date]"), "is not a Date"),
		RegExp: new de(T("[object RegExp]"), "is not a RegExp")
	};
	var fe = Object.prototype.toString;
	function T(e) {
		return function(t) {
			return typeof t == "object" && t && fe.call(t) === e;
		};
	}
	typeof Buffer < "u" && (e.basicTypes.Buffer = new de(function(e) {
		return Buffer.isBuffer(e);
	}, "is not a Buffer"));
	for (var pe = function(t) {
		e.basicTypes[t.name] = new de(function(e) {
			return e instanceof t;
		}, "is not a " + t.name);
	}, E = 0, me = [
		Int8Array,
		Uint8Array,
		Uint8ClampedArray,
		Int16Array,
		Uint16Array,
		Int32Array,
		Uint32Array,
		Float32Array,
		Float64Array,
		ArrayBuffer
	]; E < me.length; E++) {
		var he = me[E];
		pe(he);
	}
})), jo = /* @__PURE__ */ c((/* @__PURE__ */ t(((e, t, n) => {
	var r = n && n.__spreadArrays || function() {
		for (var e = 0, t = 0, n = arguments.length; t < n; t++) e += arguments[t].length;
		for (var r = Array(e), i = 0, t = 0; t < n; t++) for (var a = arguments[t], o = 0, s = a.length; o < s; o++, i++) r[i] = a[o];
		return r;
	};
	Object.defineProperty(e, "__esModule", { value: !0 }), e.Checker = e.createCheckers = void 0;
	var i = Ao(), a = ko(), o = Ao();
	Object.defineProperty(e, "TArray", {
		enumerable: !0,
		get: function() {
			return o.TArray;
		}
	}), Object.defineProperty(e, "TEnumType", {
		enumerable: !0,
		get: function() {
			return o.TEnumType;
		}
	}), Object.defineProperty(e, "TEnumLiteral", {
		enumerable: !0,
		get: function() {
			return o.TEnumLiteral;
		}
	}), Object.defineProperty(e, "TFunc", {
		enumerable: !0,
		get: function() {
			return o.TFunc;
		}
	}), Object.defineProperty(e, "TIface", {
		enumerable: !0,
		get: function() {
			return o.TIface;
		}
	}), Object.defineProperty(e, "TLiteral", {
		enumerable: !0,
		get: function() {
			return o.TLiteral;
		}
	}), Object.defineProperty(e, "TName", {
		enumerable: !0,
		get: function() {
			return o.TName;
		}
	}), Object.defineProperty(e, "TOptional", {
		enumerable: !0,
		get: function() {
			return o.TOptional;
		}
	}), Object.defineProperty(e, "TParam", {
		enumerable: !0,
		get: function() {
			return o.TParam;
		}
	}), Object.defineProperty(e, "TParamList", {
		enumerable: !0,
		get: function() {
			return o.TParamList;
		}
	}), Object.defineProperty(e, "TProp", {
		enumerable: !0,
		get: function() {
			return o.TProp;
		}
	}), Object.defineProperty(e, "TTuple", {
		enumerable: !0,
		get: function() {
			return o.TTuple;
		}
	}), Object.defineProperty(e, "TType", {
		enumerable: !0,
		get: function() {
			return o.TType;
		}
	}), Object.defineProperty(e, "TUnion", {
		enumerable: !0,
		get: function() {
			return o.TUnion;
		}
	}), Object.defineProperty(e, "TIntersection", {
		enumerable: !0,
		get: function() {
			return o.TIntersection;
		}
	}), Object.defineProperty(e, "array", {
		enumerable: !0,
		get: function() {
			return o.array;
		}
	}), Object.defineProperty(e, "enumlit", {
		enumerable: !0,
		get: function() {
			return o.enumlit;
		}
	}), Object.defineProperty(e, "enumtype", {
		enumerable: !0,
		get: function() {
			return o.enumtype;
		}
	}), Object.defineProperty(e, "func", {
		enumerable: !0,
		get: function() {
			return o.func;
		}
	}), Object.defineProperty(e, "iface", {
		enumerable: !0,
		get: function() {
			return o.iface;
		}
	}), Object.defineProperty(e, "lit", {
		enumerable: !0,
		get: function() {
			return o.lit;
		}
	}), Object.defineProperty(e, "name", {
		enumerable: !0,
		get: function() {
			return o.name;
		}
	}), Object.defineProperty(e, "opt", {
		enumerable: !0,
		get: function() {
			return o.opt;
		}
	}), Object.defineProperty(e, "param", {
		enumerable: !0,
		get: function() {
			return o.param;
		}
	}), Object.defineProperty(e, "tuple", {
		enumerable: !0,
		get: function() {
			return o.tuple;
		}
	}), Object.defineProperty(e, "union", {
		enumerable: !0,
		get: function() {
			return o.union;
		}
	}), Object.defineProperty(e, "intersection", {
		enumerable: !0,
		get: function() {
			return o.intersection;
		}
	}), Object.defineProperty(e, "BasicType", {
		enumerable: !0,
		get: function() {
			return o.BasicType;
		}
	});
	var s = ko();
	Object.defineProperty(e, "VError", {
		enumerable: !0,
		get: function() {
			return s.VError;
		}
	});
	function c() {
		for (var e = [...arguments], t = Object.assign.apply(Object, r([{}, i.basicTypes], e)), n = {}, a = 0, o = e; a < o.length; a++) for (var s = o[a], c = 0, u = Object.keys(s); c < u.length; c++) {
			var d = u[c];
			n[d] = new l(t, s[d]);
		}
		return n;
	}
	e.createCheckers = c;
	var l = function() {
		function e(e, t, n) {
			if (n === void 0 && (n = "value"), this.suite = e, this.ttype = t, this._path = n, this.props = /* @__PURE__ */ new Map(), t instanceof i.TIface) for (var r = 0, a = t.props; r < a.length; r++) {
				var o = a[r];
				this.props.set(o.name, o.ttype);
			}
			this.checkerPlain = this.ttype.getChecker(e, !1), this.checkerStrict = this.ttype.getChecker(e, !0);
		}
		return e.prototype.setReportedPath = function(e) {
			this._path = e;
		}, e.prototype.check = function(e) {
			return this._doCheck(this.checkerPlain, e);
		}, e.prototype.test = function(e) {
			return this.checkerPlain(e, new a.NoopContext());
		}, e.prototype.validate = function(e) {
			return this._doValidate(this.checkerPlain, e);
		}, e.prototype.strictCheck = function(e) {
			return this._doCheck(this.checkerStrict, e);
		}, e.prototype.strictTest = function(e) {
			return this.checkerStrict(e, new a.NoopContext());
		}, e.prototype.strictValidate = function(e) {
			return this._doValidate(this.checkerStrict, e);
		}, e.prototype.getProp = function(t) {
			var n = this.props.get(t);
			if (!n) throw Error("Type has no property " + t);
			return new e(this.suite, n, this._path + "." + t);
		}, e.prototype.methodArgs = function(t) {
			var n = this._getMethod(t);
			return new e(this.suite, n.paramList);
		}, e.prototype.methodResult = function(t) {
			var n = this._getMethod(t);
			return new e(this.suite, n.result);
		}, e.prototype.getArgs = function() {
			if (!(this.ttype instanceof i.TFunc)) throw Error("getArgs() applied to non-function");
			return new e(this.suite, this.ttype.paramList);
		}, e.prototype.getResult = function() {
			if (!(this.ttype instanceof i.TFunc)) throw Error("getResult() applied to non-function");
			return new e(this.suite, this.ttype.result);
		}, e.prototype.getType = function() {
			return this.ttype;
		}, e.prototype._doCheck = function(e, t) {
			if (!e(t, new a.NoopContext())) {
				var n = new a.DetailContext();
				throw e(t, n), n.getError(this._path);
			}
		}, e.prototype._doValidate = function(e, t) {
			if (e(t, new a.NoopContext())) return null;
			var n = new a.DetailContext();
			return e(t, n), n.getErrorDetail(this._path);
		}, e.prototype._getMethod = function(e) {
			var t = this.props.get(e);
			if (!t) throw Error("Type has no property " + e);
			if (!(t instanceof i.TFunc)) throw Error("Property " + e + " is not a method");
			return t;
		}, e;
	}();
	e.Checker = l;
})))()), Mo = {
	Transform: jo.union(jo.lit("jsx"), jo.lit("typescript"), jo.lit("flow"), jo.lit("imports"), jo.lit("react-hot-loader"), jo.lit("jest")),
	SourceMapOptions: jo.iface([], { compiledFilename: "string" }),
	Options: jo.iface([], {
		transforms: jo.array("Transform"),
		disableESTransforms: jo.opt("boolean"),
		jsxRuntime: jo.opt(jo.union(jo.lit("classic"), jo.lit("automatic"), jo.lit("preserve"))),
		production: jo.opt("boolean"),
		jsxImportSource: jo.opt("string"),
		jsxPragma: jo.opt("string"),
		jsxFragmentPragma: jo.opt("string"),
		keepUnusedImports: jo.opt("boolean"),
		preserveDynamicImport: jo.opt("boolean"),
		injectCreateRequireForImportRequire: jo.opt("boolean"),
		enableLegacyTypeScriptModuleInterop: jo.opt("boolean"),
		enableLegacyBabel5ModuleInterop: jo.opt("boolean"),
		sourceMapOptions: jo.opt("SourceMapOptions"),
		filePath: jo.opt("string")
	})
}, { Options: No } = (0, jo.createCheckers)(Mo);
function Po(e) {
	No.strictCheck(e);
}
// node_modules/sucrase/dist/esm/parser/traverser/lval.js
function Fo() {
	G(), $c(!1);
}
function Io(e) {
	G(), Bo(e);
}
function Lo(e) {
	Z(), zo(e);
}
function Ro() {
	Z(), z.tokens[z.tokens.length - 1].identifierRole = W.ImportDeclaration;
}
function zo(e) {
	let t;
	t = z.scopeDepth === 0 ? W.TopLevelDeclaration : e ? W.BlockScopedDeclaration : W.FunctionScopedDeclaration, z.tokens[z.tokens.length - 1].identifierRole = t;
}
function Bo(e) {
	switch (z.type) {
		case F._this: {
			let e = K(0);
			G(), q(e);
			return;
		}
		case F._yield:
		case F.name:
			z.type = F.name, Lo(e);
			return;
		case F.bracketL:
			G(), Vo(F.bracketR, e, !0);
			return;
		case F.braceL:
			kl(!0, e);
			return;
		default: U();
	}
}
function Vo(e, t, n = !1, r = !1, i = 0) {
	let a = !0, o = !1, s = z.tokens.length;
	for (; !J(e) && !z.error;) if (a ? a = !1 : (H(F.comma), z.tokens[z.tokens.length - 1].contextId = i, !o && z.tokens[s].isType && (z.tokens[z.tokens.length - 1].isType = !0, o = !0)), !(n && Y(F.comma))) {
		if (J(e)) break;
		if (Y(F.ellipsis)) {
			Io(t), Uo(), J(F.comma), H(e);
			break;
		}
		Ho(r, t);
	}
}
function Ho(e, t) {
	e && Jo([
		P._public,
		P._protected,
		P._private,
		P._readonly,
		P._override
	]), Wo(t), Uo(), Wo(t, !0);
}
function Uo() {
	R ? Zu() : L && Nc();
}
function Wo(e, t = !1) {
	if (t || Bo(e), !J(F.eq)) return;
	let n = z.tokens.length - 1;
	$c(), z.tokens[n].rhsEndIndex = z.tokens.length;
}
// node_modules/sucrase/dist/esm/parser/plugins/typescript.js
function Go() {
	return Y(F.name);
}
function Ko() {
	return Y(F.name) || !!(z.type & F.IS_KEYWORD) || Y(F.string) || Y(F.num) || Y(F.bigint) || Y(F.decimal);
}
function qo() {
	let e = z.snapshot();
	return G(), (Y(F.bracketL) || Y(F.braceL) || Y(F.star) || Y(F.ellipsis) || Y(F.hash) || Ko()) && !Ci() ? !0 : (z.restoreFromSnapshot(e), !1);
}
function Jo(e) {
	for (; Yo(e) !== null;);
}
function Yo(e) {
	if (!Y(F.name)) return null;
	let t = z.contextualKeyword;
	if (e.indexOf(t) !== -1 && qo()) {
		switch (t) {
			case P._readonly:
				z.tokens[z.tokens.length - 1].type = F._readonly;
				break;
			case P._abstract:
				z.tokens[z.tokens.length - 1].type = F._abstract;
				break;
			case P._static:
				z.tokens[z.tokens.length - 1].type = F._static;
				break;
			case P._public:
				z.tokens[z.tokens.length - 1].type = F._public;
				break;
			case P._private:
				z.tokens[z.tokens.length - 1].type = F._private;
				break;
			case P._protected:
				z.tokens[z.tokens.length - 1].type = F._protected;
				break;
			case P._override:
				z.tokens[z.tokens.length - 1].type = F._override;
				break;
			case P._declare: z.tokens[z.tokens.length - 1].type = F._declare;
		}
		return t;
	}
	return null;
}
function Xo() {
	for (Z(); J(F.dot);) Z();
}
function Zo() {
	Xo(), !Ci() && Y(F.lessThan) && fc();
}
function Qo() {
	G(), Bs();
}
function $o() {
	G();
}
function es() {
	H(F._typeof), Y(F._import) ? ts() : Xo(), !Ci() && Y(F.lessThan) && fc();
}
function ts() {
	H(F._import), H(F.parenL), H(F.string), H(F.parenR), J(F.dot) && Xo(), Y(F.lessThan) && fc();
}
function ns() {
	J(F._const);
	let e = J(F._in), t = bi(P._out);
	J(F._const), (e || t) && !Y(F.name) ? z.tokens[z.tokens.length - 1].type = F.name : Z(), J(F._extends) && Vs(), J(F.eq) && Vs();
}
function rs() {
	Y(F.lessThan) && is();
}
function is() {
	let e = K(0);
	for (Y(F.lessThan) || Y(F.typeParameterStart) ? G() : U(); !J(F.greaterThan) && !z.error;) ns(), J(F.comma);
	q(e);
}
function as(e) {
	let t = e === F.arrow;
	rs(), H(F.parenL), z.scopeDepth++, os(!1), z.scopeDepth--, (t || Y(e)) && Fs(e);
}
function os(e) {
	Vo(F.parenR, e);
}
function ss() {
	J(F.comma) || Ei();
}
function cs() {
	as(F.colon), ss();
}
function ls() {
	let e = z.snapshot();
	G();
	let t = J(F.name) && Y(F.colon);
	return z.restoreFromSnapshot(e), t;
}
function us() {
	if (!(Y(F.bracketL) && ls())) return !1;
	let e = K(0);
	return H(F.bracketL), Z(), Bs(), H(F.bracketR), Ls(), ss(), q(e), !0;
}
function ds(e) {
	J(F.question), !e && (Y(F.parenL) || Y(F.lessThan)) ? (as(F.colon), ss()) : (Ls(), ss());
}
function fs() {
	if (Y(F.parenL) || Y(F.lessThan)) {
		cs();
		return;
	}
	if (Y(F._new)) {
		G(), Y(F.parenL) || Y(F.lessThan) ? cs() : ds(!1);
		return;
	}
	let e = !!Yo([P._readonly]);
	us() || ((V(P._get) || V(P._set)) && qo(), Pl(-1), ds(e));
}
function ps() {
	ms();
}
function ms() {
	for (H(F.braceL); !J(F.braceR) && !z.error;) fs();
}
function hs() {
	let e = z.snapshot(), t = gs();
	return z.restoreFromSnapshot(e), t;
}
function gs() {
	return G(), J(F.plus) || J(F.minus) ? V(P._readonly) : (V(P._readonly) && G(), !Y(F.bracketL) || (G(), !Go()) ? !1 : (G(), Y(F._in)));
}
function _s() {
	Z(), H(F._in), Vs();
}
function vs() {
	H(F.braceL), Y(F.plus) || Y(F.minus) ? (G(), xi(P._readonly)) : bi(P._readonly), H(F.bracketL), _s(), bi(P._as) && Vs(), H(F.bracketR), Y(F.plus) || Y(F.minus) ? (G(), H(F.question)) : J(F.question), Rs(), Ei(), H(F.braceR);
}
function ys() {
	for (H(F.bracketL); !J(F.bracketR) && !z.error;) bs(), J(F.comma);
}
function bs() {
	J(F.ellipsis) ? Vs() : (Vs(), J(F.question)), J(F.colon) && Vs();
}
function xs() {
	H(F.parenL), Vs(), H(F.parenR);
}
function Ss() {
	for (Ui(), Ui(); !Y(F.backQuote) && !z.error;) H(F.dollarBraceL), Vs(), Ui(), Ui();
	G();
}
var Cs;
(function(e) {
	e[e.TSFunctionType = 0] = "TSFunctionType", e[e.TSConstructorType = 1] = "TSConstructorType", e[e.TSAbstractConstructorType = 2] = "TSAbstractConstructorType";
})(Cs ||= {});
function ws(e) {
	e === Cs.TSAbstractConstructorType && xi(P._abstract), (e === Cs.TSConstructorType || e === Cs.TSAbstractConstructorType) && H(F._new);
	let t = z.inDisallowConditionalTypesContext;
	z.inDisallowConditionalTypesContext = !1, as(F.arrow), z.inDisallowConditionalTypesContext = t;
}
function Ts() {
	switch (z.type) {
		case F.name:
			Zo();
			return;
		case F._void:
		case F._null:
			G();
			return;
		case F.string:
		case F.num:
		case F.bigint:
		case F.decimal:
		case F._true:
		case F._false:
			bl();
			return;
		case F.minus:
			G(), bl();
			return;
		case F._this:
			$o(), V(P._is) && !Ci() && Qo();
			return;
		case F._typeof:
			es();
			return;
		case F._import:
			ts();
			return;
		case F.braceL:
			hs() ? vs() : ps();
			return;
		case F.bracketL:
			ys();
			return;
		case F.parenL:
			xs();
			return;
		case F.backQuote:
			Ss();
			return;
		default: if (z.type & F.IS_KEYWORD) {
			G(), z.tokens[z.tokens.length - 1].type = F.name;
			return;
		}
	}
	U();
}
function Es() {
	for (Ts(); !Ci() && J(F.bracketL);) J(F.bracketR) || (Vs(), H(F.bracketR));
}
function Ds() {
	if (xi(P._infer), Z(), Y(F._extends)) {
		let e = z.snapshot();
		H(F._extends);
		let t = z.inDisallowConditionalTypesContext;
		z.inDisallowConditionalTypesContext = !0, Vs(), z.inDisallowConditionalTypesContext = t, (z.error || !z.inDisallowConditionalTypesContext && Y(F.question)) && z.restoreFromSnapshot(e);
	}
}
function Os() {
	if (V(P._keyof) || V(P._unique) || V(P._readonly)) G(), Os();
	else if (V(P._infer)) Ds();
	else {
		let e = z.inDisallowConditionalTypesContext;
		z.inDisallowConditionalTypesContext = !1, Es(), z.inDisallowConditionalTypesContext = e;
	}
}
function ks() {
	if (J(F.bitwiseAND), Os(), Y(F.bitwiseAND)) for (; J(F.bitwiseAND);) Os();
}
function As() {
	if (J(F.bitwiseOR), ks(), Y(F.bitwiseOR)) for (; J(F.bitwiseOR);) ks();
}
function js() {
	return Y(F.lessThan) ? !0 : Y(F.parenL) && Ns();
}
function Ms() {
	if (Y(F.name) || Y(F._this)) return G(), !0;
	if (Y(F.braceL) || Y(F.bracketL)) {
		let e = 1;
		for (G(); e > 0 && !z.error;) Y(F.braceL) || Y(F.bracketL) ? e++ : (Y(F.braceR) || Y(F.bracketR)) && e--, G();
		return !0;
	}
	return !1;
}
function Ns() {
	let e = z.snapshot(), t = Ps();
	return z.restoreFromSnapshot(e), t;
}
function Ps() {
	return G(), !!(Y(F.parenR) || Y(F.ellipsis) || Ms() && (Y(F.colon) || Y(F.comma) || Y(F.question) || Y(F.eq) || Y(F.parenR) && (G(), Y(F.arrow))));
}
function Fs(e) {
	let t = K(0);
	H(e), zs() || Vs(), q(t);
}
function Is() {
	Y(F.colon) && Fs(F.colon);
}
function Ls() {
	Y(F.colon) && Bs();
}
function Rs() {
	J(F.colon) && Vs();
}
function zs() {
	let e = z.snapshot();
	return V(P._asserts) ? (G(), bi(P._is) ? (Vs(), !0) : Go() || Y(F._this) ? (G(), bi(P._is) && Vs(), !0) : (z.restoreFromSnapshot(e), !1)) : Go() || Y(F._this) ? (G(), V(P._is) && !Ci() ? (G(), Vs(), !0) : (z.restoreFromSnapshot(e), !1)) : !1;
}
function Bs() {
	let e = K(0);
	H(F.colon), Vs(), q(e);
}
function Vs() {
	if (Us(), z.inDisallowConditionalTypesContext || Ci() || !J(F._extends)) return;
	let e = z.inDisallowConditionalTypesContext;
	z.inDisallowConditionalTypesContext = !0, Us(), z.inDisallowConditionalTypesContext = e, H(F.question), Vs(), H(F.colon), Vs();
}
function Hs() {
	return V(P._abstract) && Ki() === F._new;
}
function Us() {
	js() ? ws(Cs.TSFunctionType) : Y(F._new) ? ws(Cs.TSConstructorType) : Hs() ? ws(Cs.TSAbstractConstructorType) : As();
}
function Ws() {
	let e = K(1);
	Vs(), H(F.greaterThan), q(e), ol();
}
function Gs() {
	if (J(F.jsxTagStart)) {
		z.tokens[z.tokens.length - 1].type = F.typeParameterStart;
		let e = K(1);
		for (; !Y(F.greaterThan) && !z.error;) Vs(), J(F.comma);
		qc(), q(e);
	}
}
function Ks() {
	for (; !Y(F.braceL) && !z.error;) qs(), J(F.comma);
}
function qs() {
	Xo(), Y(F.lessThan) && fc();
}
function Js() {
	Lo(!1), rs(), J(F._extends) && Ks(), ms();
}
function Ys() {
	Lo(!1), rs(), H(F.eq), Vs(), Ei();
}
function Xs() {
	if (Y(F.string) ? bl() : Z(), J(F.eq)) {
		let e = z.tokens.length - 1;
		$c(), z.tokens[e].rhsEndIndex = z.tokens.length;
	}
}
function Zs() {
	for (Lo(!1), H(F.braceL); !J(F.braceR) && !z.error;) Xs(), J(F.comma);
}
function Qs() {
	H(F.braceL), Rd(F.braceR);
}
function $s() {
	Lo(!1), J(F.dot) ? $s() : Qs();
}
function ec() {
	V(P._global) ? Z() : Y(F.string) ? _l() : U(), Y(F.braceL) ? Qs() : Ei();
}
function tc() {
	Ro(), H(F.eq), rc(), Ei();
}
function nc() {
	return V(P._require) && Ki() === F.parenL;
}
function rc() {
	nc() ? ic() : Xo();
}
function ic() {
	xi(P._require), H(F.parenL), Y(F.string) || U(), bl(), H(F.parenR);
}
function ac() {
	if (Ti()) return !1;
	switch (z.type) {
		case F._function: {
			let e = K(1);
			G();
			let t = z.start;
			return Ud(t, !0), q(e), !0;
		}
		case F._class: {
			let e = K(1);
			return Gd(!0, !1), q(e), !0;
		}
		case F._const: if (Y(F._const) && yi(P._enum)) {
			let e = K(1);
			return H(F._const), xi(P._enum), z.tokens[z.tokens.length - 1].type = F._enum, Zs(), q(e), !0;
		}
		case F._var:
		case F._let: {
			let e = K(1);
			return Md(z.type !== F._var), q(e), !0;
		}
		case F.name: {
			let e = K(1), t = z.contextualKeyword, n = !1;
			return t === P._global ? (ec(), n = !0) : n = cc(t, !0), q(e), n;
		}
		default: return !1;
	}
}
function oc() {
	return cc(z.contextualKeyword, !0);
}
function sc(e) {
	switch (e) {
		case P._declare: {
			let e = z.tokens.length - 1;
			if (ac()) return z.tokens[e].type = F._declare, !0;
			break;
		}
		case P._global:
			if (Y(F.braceL)) return Qs(), !0;
			break;
		default: return cc(e, !1);
	}
	return !1;
}
function cc(e, t) {
	switch (e) {
		case P._abstract:
			if (lc(t) && Y(F._class)) return z.tokens[z.tokens.length - 1].type = F._abstract, Gd(!0, !1), !0;
			break;
		case P._enum:
			if (lc(t) && Y(F.name)) return z.tokens[z.tokens.length - 1].type = F._enum, Zs(), !0;
			break;
		case P._interface:
			if (lc(t) && Y(F.name)) {
				let e = K(t ? 2 : 1);
				return Js(), q(e), !0;
			}
			break;
		case P._module:
			if (lc(t)) {
				if (Y(F.string)) {
					let e = K(t ? 2 : 1);
					return ec(), q(e), !0;
				}
				if (Y(F.name)) {
					let e = K(t ? 2 : 1);
					return $s(), q(e), !0;
				}
			}
			break;
		case P._namespace:
			if (lc(t) && Y(F.name)) {
				let e = K(t ? 2 : 1);
				return $s(), q(e), !0;
			}
			break;
		case P._type: if (lc(t) && Y(F.name)) {
			let e = K(t ? 2 : 1);
			return Ys(), q(e), !0;
		}
	}
	return !1;
}
function lc(e) {
	return e ? (G(), !0) : !Ti();
}
function uc() {
	let e = z.snapshot();
	return is(), Wd(), Is(), H(F.arrow), z.error ? (z.restoreFromSnapshot(e), !1) : (Rl(!0), !0);
}
function dc() {
	z.type === F.bitShiftL && (--z.pos, X(F.lessThan)), fc();
}
function fc() {
	let e = K(0);
	for (H(F.lessThan); !Y(F.greaterThan) && !z.error;) Vs(), J(F.comma);
	e ? (H(F.greaterThan), q(e)) : (q(e), da(), H(F.greaterThan), z.tokens[z.tokens.length - 1].isType = !0);
}
function pc() {
	if (Y(F.name)) switch (z.contextualKeyword) {
		case P._abstract:
		case P._declare:
		case P._enum:
		case P._interface:
		case P._module:
		case P._namespace:
		case P._type: return !0;
	}
	return !1;
}
function mc(e, t) {
	if (Y(F.colon) && Fs(F.colon), !Y(F.braceL) && Ti()) {
		let t = z.tokens.length - 1;
		for (; t >= 0 && (z.tokens[t].start >= e || z.tokens[t].type === F._default || z.tokens[t].type === F._export);) z.tokens[t].isType = !0, t--;
	} else Rl(!1, t);
}
function hc(e, t, n) {
	if (!Ci() && J(F.bang)) z.tokens[z.tokens.length - 1].type = F.nonNullAssertion;
	else {
		if (Y(F.lessThan) || Y(F.bitShiftL)) {
			let n = z.snapshot();
			if (!t && fl() && uc()) return;
			if (dc(), !t && J(F.parenL) ? (z.tokens[z.tokens.length - 1].subscriptStartIndex = e, pl()) : Y(F.backQuote) ? Ol() : (z.type === F.greaterThan || z.type !== F.parenL && z.type & F.IS_EXPRESSION_START && !Ci()) && U(), z.error) z.restoreFromSnapshot(n);
			else return;
		} else !t && Y(F.questionDot) && Ki() === F.lessThan && (G(), z.tokens[e].isOptionalChainStart = !0, z.tokens[z.tokens.length - 1].subscriptStartIndex = e, fc(), H(F.parenL), pl());
		dl(e, t, n);
	}
}
function gc() {
	if (J(F._import)) return V(P._type) && Ki() !== F.eq && xi(P._type), tc(), !0;
	if (J(F.eq)) return Qc(), Ei(), !0;
	if (bi(P._as)) return xi(P._namespace), Z(), Ei(), !0;
	if (V(P._type)) {
		let e = Ki();
		(e === F.braceL || e === F.star) && G();
	}
	return !1;
}
function _c() {
	Z(), Y(F.comma) || Y(F.braceR) ? z.tokens[z.tokens.length - 1].identifierRole = W.ImportDeclaration : (Z(), Y(F.comma) || Y(F.braceR) ? (z.tokens[z.tokens.length - 1].identifierRole = W.ImportDeclaration, z.tokens[z.tokens.length - 2].isType = !0, z.tokens[z.tokens.length - 1].isType = !0) : (Z(), Y(F.comma) || Y(F.braceR) ? (z.tokens[z.tokens.length - 3].identifierRole = W.ImportAccess, z.tokens[z.tokens.length - 1].identifierRole = W.ImportDeclaration) : (Z(), z.tokens[z.tokens.length - 3].identifierRole = W.ImportAccess, z.tokens[z.tokens.length - 1].identifierRole = W.ImportDeclaration, z.tokens[z.tokens.length - 4].isType = !0, z.tokens[z.tokens.length - 3].isType = !0, z.tokens[z.tokens.length - 2].isType = !0, z.tokens[z.tokens.length - 1].isType = !0)));
}
function vc() {
	Z(), Y(F.comma) || Y(F.braceR) ? z.tokens[z.tokens.length - 1].identifierRole = W.ExportAccess : (Z(), Y(F.comma) || Y(F.braceR) ? (z.tokens[z.tokens.length - 1].identifierRole = W.ExportAccess, z.tokens[z.tokens.length - 2].isType = !0, z.tokens[z.tokens.length - 1].isType = !0) : (Z(), Y(F.comma) || Y(F.braceR) ? z.tokens[z.tokens.length - 3].identifierRole = W.ExportAccess : (Z(), z.tokens[z.tokens.length - 3].identifierRole = W.ExportAccess, z.tokens[z.tokens.length - 4].isType = !0, z.tokens[z.tokens.length - 3].isType = !0, z.tokens[z.tokens.length - 2].isType = !0, z.tokens[z.tokens.length - 1].isType = !0)));
}
function yc() {
	if (V(P._abstract) && Ki() === F._class) return z.type = F._abstract, G(), Gd(!0, !0), !0;
	if (V(P._interface)) {
		let e = K(2);
		return cc(P._interface, !0), q(e), !0;
	}
	return !1;
}
function bc() {
	if (z.type === F._const) {
		let e = Ji();
		if (e.type === F.name && e.contextualKeyword === P._enum) return H(F._const), xi(P._enum), z.tokens[z.tokens.length - 1].type = F._enum, Zs(), !0;
	}
	return !1;
}
function xc(e) {
	let t = z.tokens.length;
	Jo([
		P._abstract,
		P._readonly,
		P._declare,
		P._static,
		P._override
	]);
	let n = z.tokens.length;
	if (us()) {
		let r = e ? t - 1 : t;
		for (let e = r; e < n; e++) z.tokens[e].isType = !0;
		return !0;
	}
	return !1;
}
function Sc(e) {
	sc(e) || Ei();
}
function Cc() {
	let e = bi(P._declare);
	e && (z.tokens[z.tokens.length - 1].type = F._declare);
	let t = !1;
	if (Y(F.name)) {
		if (e) {
			let e = K(2);
			t = oc(), q(e);
		} else t = oc();
	}
	if (!t) {
		if (e) {
			let e = K(2);
			fd(!0), q(e);
		} else fd(!0);
	}
}
function wc(e) {
	if (e && (Y(F.lessThan) || Y(F.bitShiftL)) && dc(), bi(P._implements)) {
		z.tokens[z.tokens.length - 1].type = F._implements;
		let e = K(1);
		Ks(), q(e);
	}
}
function Tc() {
	rs();
}
function Ec() {
	rs();
}
function Dc() {
	let e = K(0);
	Ci() || J(F.bang), Ls(), q(e);
}
function Oc() {
	Y(F.colon) && Bs();
}
function kc(e, t) {
	return fi ? Ac(e, t) : jc(e, t);
}
function Ac(e, t) {
	if (!Y(F.lessThan)) return el(e, t);
	let n = z.snapshot(), r = el(e, t);
	if (z.error) z.restoreFromSnapshot(n);
	else return r;
	return z.type = F.typeParameterStart, is(), r = el(e, t), r || U(), r;
}
function jc(e, t) {
	if (!Y(F.lessThan)) return el(e, t);
	let n = z.snapshot();
	is();
	let r = el(e, t);
	if (r || U(), z.error) z.restoreFromSnapshot(n);
	else return r;
	return el(e, t);
}
function Mc() {
	if (Y(F.colon)) {
		let e = z.snapshot();
		Fs(F.colon), Si() && U(), Y(F.arrow) || U(), z.error && z.restoreFromSnapshot(e);
	}
	return J(F.arrow);
}
function Nc() {
	let e = K(0);
	J(F.question), Ls(), q(e);
}
function Pc() {
	(Y(F.lessThan) || Y(F.bitShiftL)) && dc(), vd();
}
// node_modules/sucrase/dist/esm/parser/plugins/jsx/index.js
function Fc() {
	let e = !1, t = !1;
	for (;;) {
		if (z.pos >= B.length) {
			U("Unterminated JSX contents");
			return;
		}
		let n = B.charCodeAt(z.pos);
		if (n === I.lessThan || n === I.leftCurlyBrace) {
			if (z.pos === z.start) {
				if (n === I.lessThan) {
					z.pos++, X(F.jsxTagStart);
					return;
				}
				ma(n);
				return;
			}
			X(e && !t ? F.jsxEmptyText : F.jsxText);
			return;
		}
		n === I.lineFeed ? e = !0 : n !== I.space && n !== I.carriageReturn && n !== I.tab && (t = !0), z.pos++;
	}
}
function Ic(e) {
	for (z.pos++;;) {
		if (z.pos >= B.length) {
			U("Unterminated string constant");
			return;
		}
		if (B.charCodeAt(z.pos) === e) {
			z.pos++;
			break;
		}
		z.pos++;
	}
	X(F.string);
}
function Lc() {
	let e;
	do {
		if (z.pos > B.length) {
			U("Unexpectedly reached the end of input.");
			return;
		}
		e = B.charCodeAt(++z.pos);
	} while (ji[e] || e === I.dash);
	X(F.jsxName);
}
function Rc() {
	qc();
}
function zc(e) {
	Rc(), J(F.colon) ? Rc() : z.tokens[z.tokens.length - 1].identifierRole = e;
}
function Bc() {
	let e = z.tokens.length;
	zc(W.Access);
	let t = !1;
	for (; Y(F.dot);) t = !0, qc(), Rc();
	if (!t) {
		let t = z.tokens[e], n = B.charCodeAt(t.start);
		n >= I.lowercaseA && n <= I.lowercaseZ && (t.identifierRole = null);
	}
}
function Vc() {
	switch (z.type) {
		case F.braceL:
			G(), Qc(), qc();
			return;
		case F.jsxTagStart:
			Kc(), qc();
			return;
		case F.string:
			qc();
			return;
		default: U("JSX value should be either an expression or a quoted JSX text");
	}
}
function Hc() {
	H(F.ellipsis), Qc();
}
function Uc(e) {
	if (Y(F.jsxTagEnd)) return !1;
	Bc(), L && Gs();
	let t = !1;
	for (; !Y(F.slash) && !Y(F.jsxTagEnd) && !z.error;) J(F.braceL) ? (t = !0, H(F.ellipsis), $c(), qc()) : (t && z.end - z.start === 3 && B.charCodeAt(z.start) === I.lowercaseK && B.charCodeAt(z.start + 1) === I.lowercaseE && B.charCodeAt(z.start + 2) === I.lowercaseY && (z.tokens[e].jsxRole = Fi.KeyAfterPropSpread), zc(W.ObjectKey), Y(F.eq) && (qc(), Vc()));
	let n = Y(F.slash);
	return n && qc(), n;
}
function Wc() {
	Y(F.jsxTagEnd) || Bc();
}
function Gc() {
	let e = z.tokens.length - 1;
	z.tokens[e].jsxRole = Fi.NoChildren;
	let t = 0;
	if (!Uc(e)) for (Jc();;) switch (z.type) {
		case F.jsxTagStart:
			if (qc(), Y(F.slash)) {
				qc(), Wc(), z.tokens[e].jsxRole !== Fi.KeyAfterPropSpread && (t === 1 ? z.tokens[e].jsxRole = Fi.OneChild : t > 1 && (z.tokens[e].jsxRole = Fi.StaticChildren));
				return;
			}
			t++, Gc(), Jc();
			break;
		case F.jsxText:
			t++, Jc();
			break;
		case F.jsxEmptyText:
			Jc();
			break;
		case F.braceL:
			G(), Y(F.ellipsis) ? (Hc(), Jc(), t += 2) : (Y(F.braceR) || (t++, Qc()), Jc());
			break;
		// istanbul ignore next - should never happen
		default:
			U();
			return;
	}
}
function Kc() {
	qc(), Gc();
}
function qc() {
	z.tokens.push(new Hi()), na(), z.start = z.pos;
	let e = B.charCodeAt(z.pos);
	if (Mi[e]) Lc();
	else if (e === I.quotationMark || e === I.apostrophe) Ic(e);
	else switch (++z.pos, e) {
		case I.greaterThan:
			X(F.jsxTagEnd);
			break;
		case I.lessThan:
			X(F.jsxTagStart);
			break;
		case I.slash:
			X(F.slash);
			break;
		case I.equalsTo:
			X(F.eq);
			break;
		case I.leftCurlyBrace:
			X(F.braceL);
			break;
		case I.dot:
			X(F.dot);
			break;
		case I.colon:
			X(F.colon);
			break;
		default: U();
	}
}
function Jc() {
	z.tokens.push(new Hi()), z.start = z.pos, Fc();
}
// node_modules/sucrase/dist/esm/parser/plugins/types.js
function Yc(e) {
	if (Y(F.question)) {
		let e = Ki();
		if (e === F.colon || e === F.comma || e === F.parenR) return;
	}
	rl(e);
}
function Xc() {
	Gi(F.question), Y(F.colon) && (L ? Bs() : R && Fu());
}
// node_modules/sucrase/dist/esm/parser/traverser/expression.js
var Zc = class {
	constructor(e) {
		this.stop = e;
	}
};
function Qc(e = !1) {
	if ($c(e), Y(F.comma)) for (; J(F.comma);) $c(e);
}
function $c(e = !1, t = !1) {
	return L ? kc(e, t) : R ? rd(e, t) : el(e, t);
}
function el(e, t) {
	if (Y(F._yield)) return Hl(), !1;
	(Y(F.parenL) || Y(F.name) || Y(F._yield)) && (z.potentialArrowAt = z.start);
	let n = tl(e);
	return t && Tl(), z.type & F.IS_ASSIGN ? (G(), $c(e), !1) : n;
}
function tl(e) {
	return il(e) ? !0 : (nl(e), !1);
}
function nl(e) {
	L || R ? Yc(e) : rl(e);
}
function rl(e) {
	J(F.question) && ($c(), H(F.colon), $c(e));
}
function il(e) {
	let t = z.tokens.length;
	return ol() ? !0 : (al(t, -1, e), !1);
}
function al(e, t, n) {
	if (L && (F._in & F.PRECEDENCE_MASK) > t && !Ci() && (bi(P._as) || bi(P._satisfies))) {
		let r = K(1);
		Vs(), q(r), da(), al(e, t, n);
		return;
	}
	let r = z.type & F.PRECEDENCE_MASK;
	if (r > 0 && (!n || !Y(F._in)) && r > t) {
		let i = z.type;
		G(), i === F.nullishCoalescing && (z.tokens[z.tokens.length - 1].nullishStartIndex = e);
		let a = z.tokens.length;
		ol(), al(a, i & F.IS_RIGHT_ASSOCIATIVE ? r - 1 : r, n), i === F.nullishCoalescing && (z.tokens[e].numNullishCoalesceStarts++, z.tokens[z.tokens.length - 1].numNullishCoalesceEnds++), al(e, t, n);
	}
}
function ol() {
	if (L && !fi && J(F.lessThan)) return Ws(), !1;
	if (V(P._module) && Zi() === I.leftCurlyBrace && !wi()) return Ul(), !1;
	if (z.type & F.IS_PREFIX) return G(), ol(), !1;
	if (sl()) return !0;
	for (; z.type & F.IS_POSTFIX && !Si();) z.type === F.preIncDec && (z.type = F.postIncDec), G();
	return !1;
}
function sl() {
	let e = z.tokens.length;
	return _l() ? !0 : (cl(e), z.tokens.length > e && z.tokens[e].isOptionalChainStart && (z.tokens[z.tokens.length - 1].isOptionalChainEnd = !0), !1);
}
function cl(e, t = !1) {
	R ? ad(e, t) : ll(e, t);
}
function ll(e, t = !1) {
	let n = new Zc(!1);
	do
		ul(e, t, n);
	while (!n.stop && !z.error);
}
function ul(e, t, n) {
	L ? hc(e, t, n) : R ? zu(e, t, n) : dl(e, t, n);
}
function dl(e, t, n) {
	if (!t && J(F.doubleColon)) gl(), n.stop = !0, cl(e, t);
	else if (Y(F.questionDot)) {
		if (z.tokens[e].isOptionalChainStart = !0, t && Ki() === F.parenL) {
			n.stop = !0;
			return;
		}
		G(), z.tokens[z.tokens.length - 1].subscriptStartIndex = e, J(F.bracketL) ? (Qc(), H(F.bracketR)) : J(F.parenL) ? pl() : vl();
	} else if (J(F.dot)) z.tokens[z.tokens.length - 1].subscriptStartIndex = e, vl();
	else if (J(F.bracketL)) z.tokens[z.tokens.length - 1].subscriptStartIndex = e, Qc(), H(F.bracketR);
	else if (!t && Y(F.parenL)) {
		if (fl()) {
			let t = z.snapshot(), r = z.tokens.length;
			G(), z.tokens[z.tokens.length - 1].subscriptStartIndex = e;
			let i = mi();
			z.tokens[z.tokens.length - 1].contextId = i, pl(), z.tokens[z.tokens.length - 1].contextId = i, ml() && (z.restoreFromSnapshot(t), n.stop = !0, z.scopeDepth++, Wd(), hl(r));
		} else {
			G(), z.tokens[z.tokens.length - 1].subscriptStartIndex = e;
			let t = mi();
			z.tokens[z.tokens.length - 1].contextId = t, pl(), z.tokens[z.tokens.length - 1].contextId = t;
		}
	} else Y(F.backQuote) ? Ol() : n.stop = !0;
}
function fl() {
	return z.tokens[z.tokens.length - 1].contextualKeyword === P._async && !Si();
}
function pl() {
	let e = !0;
	for (; !J(F.parenR) && !z.error;) {
		if (e) e = !1;
		else if (H(F.comma), J(F.parenR)) break;
		Bl(!1);
	}
}
function ml() {
	return Y(F.colon) || Y(F.arrow);
}
function hl(e) {
	L ? Oc() : R && nd(), H(F.arrow), Il(e);
}
function gl() {
	let e = z.tokens.length;
	_l(), cl(e, !0);
}
function _l() {
	if (J(F.modulo)) return Z(), !1;
	if (Y(F.jsxText) || Y(F.jsxEmptyText)) return bl(), !1;
	if (Y(F.lessThan) && fi) return z.type = F.jsxTagStart, Kc(), G(), !1;
	let e = z.potentialArrowAt === z.start;
	switch (z.type) {
		case F.slash:
		case F.assign: Wi();
		case F._super:
		case F._this:
		case F.regexp:
		case F.num:
		case F.bigint:
		case F.decimal:
		case F.string:
		case F._null:
		case F._true:
		case F._false: return G(), !1;
		case F._import: return G(), Y(F.dot) && (z.tokens[z.tokens.length - 1].type = F.name, G(), Z()), !1;
		case F.name: {
			let t = z.tokens.length, n = z.start, r = z.contextualKeyword;
			return Z(), r === P._await ? (Vl(), !1) : r === P._async && Y(F._function) && !Si() ? (G(), Ud(n, !1), !1) : e && r === P._async && !Si() && Y(F.name) ? (z.scopeDepth++, Lo(!1), H(F.arrow), Il(t), !0) : Y(F._do) && !Si() ? (G(), Ld(), !1) : e && !Si() && Y(F.arrow) ? (z.scopeDepth++, zo(!1), H(F.arrow), Il(t), !0) : (z.tokens[z.tokens.length - 1].identifierRole = W.Access, !1);
		}
		case F._do: return G(), Ld(), !1;
		case F.parenL: return Sl(e);
		case F.bracketL: return G(), zl(F.bracketR, !0), !1;
		case F.braceL: return kl(!1, !1), !1;
		case F._function: return yl(), !1;
		case F.at: hd();
		case F._class: return Gd(!1), !1;
		case F._new: return El(), !1;
		case F.backQuote: return Ol(), !1;
		case F.doubleColon: return G(), gl(), !1;
		case F.hash: {
			let e = Zi();
			return Mi[e] || e === I.backslash ? vl() : G(), !1;
		}
		default: return U(), !1;
	}
}
function vl() {
	J(F.hash), Z();
}
function yl() {
	let e = z.start;
	Z(), J(F.dot) && Z(), Ud(e, !1);
}
function bl() {
	G();
}
function xl() {
	H(F.parenL), Qc(), H(F.parenR);
}
function Sl(e) {
	let t = z.snapshot(), n = z.tokens.length;
	H(F.parenL);
	let r = !0;
	for (; !Y(F.parenR) && !z.error;) {
		if (r) r = !1;
		else if (H(F.comma), Y(F.parenR)) break;
		if (Y(F.ellipsis)) {
			Io(!1), Tl();
			break;
		}
		$c(!1, !0);
	}
	return H(F.parenR), e && Cl() && wl() ? (z.restoreFromSnapshot(t), z.scopeDepth++, Wd(), wl(), Il(n), !z.error || (z.restoreFromSnapshot(t), Sl(!1), !1)) : !1;
}
function Cl() {
	return Y(F.colon) || !Si();
}
function wl() {
	return L ? Mc() : R ? id() : J(F.arrow);
}
function Tl() {
	(L || R) && Xc();
}
function El() {
	H(F._new), J(F.dot) ? Z() : (Dl(), R && Bu(), J(F.parenL) && zl(F.parenR));
}
function Dl() {
	gl(), J(F.questionDot);
}
function Ol() {
	for (Ui(), Ui(); !Y(F.backQuote) && !z.error;) H(F.dollarBraceL), Qc(), Ui(), Ui();
	G();
}
function kl(e, t) {
	let n = mi(), r = !0;
	for (G(), z.tokens[z.tokens.length - 1].contextId = n; !J(F.braceR) && !z.error;) {
		if (r) r = !1;
		else if (H(F.comma), J(F.braceR)) break;
		let i = !1;
		if (Y(F.ellipsis)) {
			let n = z.tokens.length;
			if (Fo(), e && (z.tokens.length === n + 2 && zo(t), J(F.braceR))) break;
		} else e || (i = J(F.star)), !e && V(P._async) ? (i && U(), Z(), Y(F.colon) || Y(F.parenL) || Y(F.braceR) || Y(F.eq) || Y(F.comma) || (Y(F.star) && (G(), i = !0), Pl(n))) : Pl(n), Nl(e, t, n);
	}
	z.tokens[z.tokens.length - 1].contextId = n;
}
function Al(e) {
	return !e && (Y(F.string) || Y(F.num) || Y(F.bracketL) || Y(F.name) || !!(z.type & F.IS_KEYWORD));
}
function jl(e, t) {
	let n = z.start;
	return Y(F.parenL) ? (e && U(), Fl(n, !1), !0) : Al(e) ? (Pl(t), Fl(n, !1), !0) : !1;
}
function Ml(e, t) {
	if (J(F.colon)) {
		e ? Wo(t) : $c(!1);
		return;
	}
	let n;
	n = e ? z.scopeDepth === 0 ? W.ObjectShorthandTopLevelDeclaration : t ? W.ObjectShorthandBlockScopedDeclaration : W.ObjectShorthandFunctionScopedDeclaration : W.ObjectShorthand, z.tokens[z.tokens.length - 1].identifierRole = n, Wo(t, !0);
}
function Nl(e, t, n) {
	L ? Tc() : R && Xu(), jl(e, n) || Ml(e, t);
}
function Pl(e) {
	R && Lu(), J(F.bracketL) ? (z.tokens[z.tokens.length - 1].contextId = e, $c(), H(F.bracketR), z.tokens[z.tokens.length - 1].contextId = e) : (Y(F.num) || Y(F.string) || Y(F.bigint) || Y(F.decimal) ? _l() : vl(), z.tokens[z.tokens.length - 1].identifierRole = W.ObjectKey, z.tokens[z.tokens.length - 1].contextId = e);
}
function Fl(e, t) {
	let n = mi();
	z.scopeDepth++;
	let r = z.tokens.length;
	Wd(t, n), Ll(e, n);
	let i = z.tokens.length;
	z.scopes.push(new li(r, i, !0)), z.scopeDepth--;
}
function Il(e) {
	Rl(!0);
	let t = z.tokens.length;
	z.scopes.push(new li(e, t, !0)), z.scopeDepth--;
}
function Ll(e, t = 0) {
	L ? mc(e, t) : R ? Ru(t) : Rl(!1, t);
}
function Rl(e, t = 0) {
	e && !Y(F.braceL) ? $c() : Ld(!0, t);
}
function zl(e, t = !1) {
	let n = !0;
	for (; !J(e) && !z.error;) {
		if (n) n = !1;
		else if (H(F.comma), J(e)) break;
		Bl(t);
	}
}
function Bl(e) {
	e && Y(F.comma) || (Y(F.ellipsis) ? (Fo(), Tl()) : Y(F.question) ? G() : $c(!1, !0));
}
function Z() {
	G(), z.tokens[z.tokens.length - 1].type = F.name;
}
function Vl() {
	ol();
}
function Hl() {
	G(), !Y(F.semi) && !Si() && (J(F.star), $c());
}
function Ul() {
	xi(P._module), H(F.braceL), Rd(F.braceR);
}
// node_modules/sucrase/dist/esm/parser/plugins/flow.js
function Wl(e) {
	return (e.type === F.name || !!(e.type & F.IS_KEYWORD)) && e.contextualKeyword !== P._from;
}
function Gl(e) {
	let t = K(0);
	H(e || F.colon), Pu(), q(t);
}
function Kl() {
	H(F.modulo), xi(P._checks), J(F.parenL) && (Qc(), H(F.parenR));
}
function ql() {
	let e = K(0);
	H(F.colon), Y(F.modulo) ? Kl() : (Pu(), Y(F.modulo) && Kl()), q(e);
}
function Jl() {
	G(), iu(!0);
}
function Yl() {
	G(), Z(), Y(F.lessThan) && du(), H(F.parenL), Du(), H(F.parenR), ql(), Ei();
}
function Xl() {
	Y(F._class) ? Jl() : Y(F._function) ? Yl() : Y(F._var) ? Zl() : bi(P._module) ? J(F.dot) ? eu() : Ql() : V(P._type) ? tu() : V(P._opaque) ? nu() : V(P._interface) ? ru() : Y(F._export) ? $l() : U();
}
function Zl() {
	G(), Iu(), Ei();
}
function Ql() {
	for (Y(F.string) ? _l() : Z(), H(F.braceL); !Y(F.braceR) && !z.error;) Y(F._import) ? (G(), yf()) : U();
	H(F.braceR);
}
function $l() {
	H(F._export), J(F._default) ? Y(F._function) || Y(F._class) ? Xl() : (Pu(), Ei()) : Y(F._var) || Y(F._function) || Y(F._class) || V(P._opaque) ? Xl() : Y(F.star) || Y(F.braceL) || V(P._interface) || V(P._type) || V(P._opaque) ? rf() : U();
}
function eu() {
	xi(P._exports), Fu(), Ei();
}
function tu() {
	G(), cu();
}
function nu() {
	G(), lu(!0);
}
function ru() {
	G(), iu();
}
function iu(e = !1) {
	if (su(), Y(F.lessThan) && du(), J(F._extends)) do
		au();
	while (!e && J(F.comma));
	if (V(P._mixins)) {
		G();
		do
			au();
		while (J(F.comma));
	}
	if (V(P._implements)) {
		G();
		do
			au();
		while (J(F.comma));
	}
	yu(e, !1, e);
}
function au() {
	Su(!1), Y(F.lessThan) && fu();
}
function ou() {
	iu();
}
function su() {
	Z();
}
function cu() {
	su(), Y(F.lessThan) && du(), Gl(F.eq), Ei();
}
function lu(e) {
	xi(P._type), su(), Y(F.lessThan) && du(), Y(F.colon) && Gl(F.colon), e || Gl(F.eq), Ei();
}
function uu() {
	Lu(), Iu(), J(F.eq) && Pu();
}
function du() {
	let e = K(0);
	// istanbul ignore else: this condition is already checked at all call sites
	Y(F.lessThan) || Y(F.typeParameterStart) ? G() : U();
	do
		uu(), Y(F.greaterThan) || H(F.comma);
	while (!Y(F.greaterThan) && !z.error);
	H(F.greaterThan), q(e);
}
function fu() {
	let e = K(0);
	for (H(F.lessThan); !Y(F.greaterThan) && !z.error;) Pu(), Y(F.greaterThan) || H(F.comma);
	H(F.greaterThan), q(e);
}
function pu() {
	if (xi(P._interface), J(F._extends)) do
		au();
	while (J(F.comma));
	yu(!1, !1, !1);
}
function mu() {
	Y(F.num) || Y(F.string) ? _l() : Z();
}
function hu() {
	Ki() === F.colon ? (mu(), Gl()) : Pu(), H(F.bracketR), Gl();
}
function gu() {
	mu(), H(F.bracketR), H(F.bracketR), Y(F.lessThan) || Y(F.parenL) ? _u() : (J(F.question), Gl());
}
function _u() {
	for (Y(F.lessThan) && du(), H(F.parenL); !Y(F.parenR) && !Y(F.ellipsis) && !z.error;) Eu(), Y(F.parenR) || H(F.comma);
	J(F.ellipsis) && Eu(), H(F.parenR), Gl();
}
function vu() {
	_u();
}
function yu(e, t, n) {
	let r;
	for (t && Y(F.braceBarL) ? (H(F.braceBarL), r = F.braceBarR) : (H(F.braceL), r = F.braceR); !Y(r) && !z.error;) {
		if (n && V(P._proto)) {
			let t = Ki();
			t !== F.colon && t !== F.question && (G(), e = !1);
		}
		if (e && V(P._static)) {
			let e = Ki();
			e !== F.colon && e !== F.question && G();
		}
		if (Lu(), J(F.bracketL)) J(F.bracketL) ? gu() : hu();
		else if (Y(F.parenL) || Y(F.lessThan)) vu();
		else {
			if (V(P._get) || V(P._set)) {
				let e = Ki();
				(e === F.name || e === F.string || e === F.num) && G();
			}
			bu();
		}
		xu();
	}
	H(r);
}
function bu() {
	if (Y(F.ellipsis)) {
		if (H(F.ellipsis), J(F.comma) || J(F.semi), Y(F.braceR)) return;
		Pu();
	} else mu(), Y(F.lessThan) || Y(F.parenL) ? _u() : (J(F.question), Gl());
}
function xu() {
	J(F.semi) || J(F.comma) || Y(F.braceR) || Y(F.braceBarR) || U();
}
function Su(e) {
	for (e || Z(); J(F.dot);) Z();
}
function Cu() {
	Su(!0), Y(F.lessThan) && fu();
}
function wu() {
	H(F._typeof), Ou();
}
function Tu() {
	for (H(F.bracketL); z.pos < B.length && !Y(F.bracketR) && (Pu(), !Y(F.bracketR));) H(F.comma);
	H(F.bracketR);
}
function Eu() {
	let e = Ki();
	e === F.colon || e === F.question ? (Z(), J(F.question), Gl()) : Pu();
}
function Du() {
	for (; !Y(F.parenR) && !Y(F.ellipsis) && !z.error;) Eu(), Y(F.parenR) || H(F.comma);
	J(F.ellipsis) && Eu();
}
function Ou() {
	let e = !1, t = z.noAnonFunctionType;
	switch (z.type) {
		case F.name:
			if (V(P._interface)) {
				pu();
				return;
			}
			Z(), Cu();
			return;
		case F.braceL:
			yu(!1, !1, !1);
			return;
		case F.braceBarL:
			yu(!1, !0, !1);
			return;
		case F.bracketL:
			Tu();
			return;
		case F.lessThan:
			du(), H(F.parenL), Du(), H(F.parenR), H(F.arrow), Pu();
			return;
		case F.parenL:
			if (G(), !Y(F.parenR) && !Y(F.ellipsis)) {
				if (Y(F.name)) {
					let t = Ki();
					e = t !== F.question && t !== F.colon;
				} else e = !0;
			}
			if (e) {
				if (z.noAnonFunctionType = !1, Pu(), z.noAnonFunctionType = t, z.noAnonFunctionType || !(Y(F.comma) || Y(F.parenR) && Ki() === F.arrow)) {
					H(F.parenR);
					return;
				}
				J(F.comma);
			}
			Du(), H(F.parenR), H(F.arrow), Pu();
			return;
		case F.minus:
			G(), bl();
			return;
		case F.string:
		case F.num:
		case F._true:
		case F._false:
		case F._null:
		case F._this:
		case F._void:
		case F.star:
			G();
			return;
		default:
			if (z.type === F._typeof) {
				wu();
				return;
			}
			if (z.type & F.IS_KEYWORD) {
				G(), z.tokens[z.tokens.length - 1].type = F.name;
				return;
			}
	}
	U();
}
function ku() {
	for (Ou(); !Si() && (Y(F.bracketL) || Y(F.questionDot));) J(F.questionDot), H(F.bracketL), J(F.bracketR) || (Pu(), H(F.bracketR));
}
function Au() {
	J(F.question) ? Au() : ku();
}
function ju() {
	Au(), !z.noAnonFunctionType && J(F.arrow) && Pu();
}
function Mu() {
	for (J(F.bitwiseAND), ju(); J(F.bitwiseAND);) ju();
}
function Nu() {
	for (J(F.bitwiseOR), Mu(); J(F.bitwiseOR);) Mu();
}
function Pu() {
	Nu();
}
function Fu() {
	Gl();
}
function Iu() {
	Z(), Y(F.colon) && Fu();
}
function Lu() {
	(Y(F.plus) || Y(F.minus)) && (G(), z.tokens[z.tokens.length - 1].isType = !0);
}
function Ru(e) {
	Y(F.colon) && ql(), Rl(!1, e);
}
function zu(e, t, n) {
	if (Y(F.questionDot) && Ki() === F.lessThan) {
		if (t) {
			n.stop = !0;
			return;
		}
		G(), fu(), H(F.parenL), pl();
	} else {
		if (!t && Y(F.lessThan)) {
			let e = z.snapshot();
			if (fu(), H(F.parenL), pl(), z.error) z.restoreFromSnapshot(e);
			else return;
		}
		dl(e, t, n);
	}
}
function Bu() {
	if (Y(F.lessThan)) {
		let e = z.snapshot();
		fu(), z.error && z.restoreFromSnapshot(e);
	}
}
function Vu() {
	if (Y(F.name) && z.contextualKeyword === P._interface) {
		let e = K(0);
		return G(), ou(), q(e), !0;
	}
	return V(P._enum) ? (sd(), !0) : !1;
}
function Hu() {
	return V(P._enum) ? (sd(), !0) : !1;
}
function Uu(e) {
	if (e === P._declare) {
		if (Y(F._class) || Y(F.name) || Y(F._function) || Y(F._var) || Y(F._export)) {
			let e = K(1);
			Xl(), q(e);
		}
	} else if (Y(F.name)) {
		if (e === P._interface) {
			let e = K(1);
			ou(), q(e);
		} else if (e === P._type) {
			let e = K(1);
			cu(), q(e);
		} else if (e === P._opaque) {
			let e = K(1);
			lu(!1), q(e);
		}
	}
	Ei();
}
function Wu() {
	return V(P._type) || V(P._interface) || V(P._opaque) || V(P._enum);
}
function Gu() {
	return Y(F.name) && (z.contextualKeyword === P._type || z.contextualKeyword === P._interface || z.contextualKeyword === P._opaque || z.contextualKeyword === P._enum);
}
function Ku() {
	if (V(P._type)) {
		let e = K(1);
		G(), Y(F.braceL) ? (hf(), lf()) : cu(), q(e);
	} else if (V(P._opaque)) {
		let e = K(1);
		G(), lu(!1), q(e);
	} else if (V(P._interface)) {
		let e = K(1);
		G(), ou(), q(e);
	} else fd(!0);
}
function qu() {
	return Y(F.star) || V(P._type) && Ki() === F.star;
}
function Ju() {
	if (bi(P._type)) {
		let e = K(2);
		ff(), q(e);
	} else ff();
}
function Yu(e) {
	if (e && Y(F.lessThan) && fu(), V(P._implements)) {
		let e = K(0);
		G(), z.tokens[z.tokens.length - 1].type = F._implements;
		do
			su(), Y(F.lessThan) && fu();
		while (J(F.comma));
		q(e);
	}
}
function Xu() {
	Y(F.lessThan) && (du(), Y(F.parenL) || U());
}
function Zu() {
	let e = K(0);
	J(F.question), Y(F.colon) && Fu(), q(e);
}
function Qu() {
	if (Y(F._typeof) || V(P._type)) {
		let e = Ji();
		(Wl(e) || e.type === F.braceL || e.type === F.star) && G();
	}
}
function $u() {
	let e = z.contextualKeyword === P._type || z.type === F._typeof;
	e ? G() : Z(), V(P._as) && !yi(P._as) ? (Z(), e && !Y(F.name) && !(z.type & F.IS_KEYWORD) || Z()) : (e && (Y(F.name) || z.type & F.IS_KEYWORD) && Z(), bi(P._as) && Z());
}
function ed() {
	if (Y(F.lessThan)) {
		let e = K(0);
		du(), q(e);
	}
}
function td() {
	Y(F.colon) && Fu();
}
function nd() {
	if (Y(F.colon)) {
		let e = z.noAnonFunctionType;
		z.noAnonFunctionType = !0, Fu(), z.noAnonFunctionType = e;
	}
}
function rd(e, t) {
	if (Y(F.lessThan)) {
		let n = z.snapshot(), r = el(e, t);
		if (z.error) z.restoreFromSnapshot(n), z.type = F.typeParameterStart;
		else return r;
		let i = K(0);
		if (du(), q(i), r = el(e, t), r) return !0;
		U();
	}
	return el(e, t);
}
function id() {
	if (Y(F.colon)) {
		let e = K(0), t = z.snapshot(), n = z.noAnonFunctionType;
		z.noAnonFunctionType = !0, ql(), z.noAnonFunctionType = n, Si() && U(), Y(F.arrow) || U(), z.error && z.restoreFromSnapshot(t), q(e);
	}
	return J(F.arrow);
}
function ad(e, t = !1) {
	if (z.tokens[z.tokens.length - 1].contextualKeyword === P._async && Y(F.lessThan)) {
		let e = z.snapshot();
		if (od() && !z.error) return;
		z.restoreFromSnapshot(e);
	}
	ll(e, t);
}
function od() {
	z.scopeDepth++;
	let e = z.tokens.length;
	return Wd(), wl() ? (Il(e), !0) : !1;
}
function sd() {
	xi(P._enum), z.tokens[z.tokens.length - 1].type = F._enum, Z(), cd();
}
function cd() {
	bi(P._of) && G(), H(F.braceL), ld(), H(F.braceR);
}
function ld() {
	for (; !Y(F.braceR) && !z.error && !J(F.ellipsis);) ud(), Y(F.braceR) || H(F.comma);
}
function ud() {
	Z(), J(F.eq) && G();
}
// node_modules/sucrase/dist/esm/parser/traverser/statement.js
function dd() {
	if (Rd(F.eof), z.scopes.push(new li(0, z.tokens.length, !0)), z.scopeDepth !== 0) throw Error(`Invalid scope depth at end of file: ${z.scopeDepth}`);
	return new Ef(z.tokens, z.scopes);
}
function fd(e) {
	R && Vu() || (Y(F.at) && hd(), pd(e));
}
function pd(e) {
	if (L && bc()) return;
	let t = z.type;
	switch (t) {
		case F._break:
		case F._continue:
			yd();
			return;
		case F._debugger:
			bd();
			return;
		case F._do:
			xd();
			return;
		case F._for:
			Sd();
			return;
		case F._function:
			if (Ki() === F.dot) break;
			e || U(), Td();
			return;
		case F._class:
			e || U(), Gd(!0);
			return;
		case F._if:
			Ed();
			return;
		case F._return:
			Dd();
			return;
		case F._switch:
			Od();
			return;
		case F._throw:
			kd();
			return;
		case F._try:
			jd();
			return;
		case F._let:
		case F._const: e || U();
		case F._var:
			Md(t !== F._var);
			return;
		case F._while:
			Nd();
			return;
		case F.braceL:
			Ld();
			return;
		case F.semi:
			Pd();
			return;
		case F._export:
		case F._import: {
			let e = Ki();
			if (e === F.parenL || e === F.dot) break;
			G(), t === F._import ? yf() : rf();
			return;
		}
		case F.name: if (z.contextualKeyword === P._async) {
			let e = z.start, t = z.snapshot();
			if (G(), Y(F._function) && !Si()) {
				H(F._function), Ud(e, !0);
				return;
			}
			z.restoreFromSnapshot(t);
		} else if (z.contextualKeyword === P._using && !wi() && Ki() === F.name) {
			Md(!0);
			return;
		} else if (md()) {
			xi(P._await), Md(!0);
			return;
		}
	}
	let n = z.tokens.length;
	Qc();
	let r = null;
	if (z.tokens.length === n + 1) {
		let e = z.tokens[z.tokens.length - 1];
		e.type === F.name && (r = e.contextualKeyword);
	}
	r == null ? Ei() : J(F.colon) ? Fd() : Id(r);
}
function md() {
	if (!V(P._await)) return !1;
	let e = z.snapshot();
	return G(), !V(P._using) || Ci() || (G(), !Y(F.name) || Ci()) ? (z.restoreFromSnapshot(e), !1) : (z.restoreFromSnapshot(e), !0);
}
function hd() {
	for (; Y(F.at);) gd();
}
function gd() {
	if (G(), J(F.parenL)) Qc(), H(F.parenR);
	else {
		for (Z(); J(F.dot);) Z();
		_d();
	}
}
function _d() {
	L ? Pc() : vd();
}
function vd() {
	J(F.parenL) && pl();
}
function yd() {
	G(), Ti() || (Z(), Ei());
}
function bd() {
	G(), Ei();
}
function xd() {
	G(), fd(!1), H(F._while), xl(), J(F.semi);
}
function Sd() {
	z.scopeDepth++;
	let e = z.tokens.length;
	wd();
	let t = z.tokens.length;
	z.scopes.push(new li(e, t, !1)), z.scopeDepth--;
}
function Cd() {
	return !(!V(P._using) || yi(P._of));
}
function wd() {
	G();
	let e = !1;
	if (V(P._await) && (e = !0, G()), H(F.parenL), Y(F.semi)) {
		e && U(), zd();
		return;
	}
	let t = md();
	if (t || Y(F._var) || Y(F._let) || Y(F._const) || Cd()) {
		if (t && xi(P._await), G(), Vd(!0, z.type !== F._var), Y(F._in) || V(P._of)) {
			Bd(e);
			return;
		}
		zd();
	} else Qc(!0), Y(F._in) || V(P._of) ? Bd(e) : (e && U(), zd());
}
function Td() {
	let e = z.start;
	G(), Ud(e, !0);
}
function Ed() {
	G(), xl(), fd(!1), J(F._else) && fd(!1);
}
function Dd() {
	G(), Ti() || (Qc(), Ei());
}
function Od() {
	G(), xl(), z.scopeDepth++;
	let e = z.tokens.length;
	for (H(F.braceL); !Y(F.braceR) && !z.error;) if (Y(F._case) || Y(F._default)) {
		let e = Y(F._case);
		G(), e && Qc(), H(F.colon);
	} else fd(!0);
	G();
	let t = z.tokens.length;
	z.scopes.push(new li(e, t, !1)), z.scopeDepth--;
}
function kd() {
	G(), Qc(), Ei();
}
function Ad() {
	Bo(!0), L && Ls();
}
function jd() {
	if (G(), Ld(), Y(F._catch)) {
		G();
		let e = null;
		if (Y(F.parenL) && (z.scopeDepth++, e = z.tokens.length, H(F.parenL), Ad(), H(F.parenR)), Ld(), e != null) {
			let t = z.tokens.length;
			z.scopes.push(new li(e, t, !1)), z.scopeDepth--;
		}
	}
	J(F._finally) && Ld();
}
function Md(e) {
	G(), Vd(!1, e), Ei();
}
function Nd() {
	G(), xl(), fd(!1);
}
function Pd() {
	G();
}
function Fd() {
	fd(!0);
}
function Id(e) {
	L ? Sc(e) : R ? Uu(e) : Ei();
}
function Ld(e = !1, t = 0) {
	let n = z.tokens.length;
	z.scopeDepth++, H(F.braceL), t && (z.tokens[z.tokens.length - 1].contextId = t), Rd(F.braceR), t && (z.tokens[z.tokens.length - 1].contextId = t);
	let r = z.tokens.length;
	z.scopes.push(new li(n, r, e)), z.scopeDepth--;
}
function Rd(e) {
	for (; !J(e) && !z.error;) fd(!0);
}
function zd() {
	H(F.semi), Y(F.semi) || Qc(), H(F.semi), Y(F.parenR) || Qc(), H(F.parenR), fd(!1);
}
function Bd(e) {
	e ? bi(P._of) : G(), Qc(), H(F.parenR), fd(!1);
}
function Vd(e, t) {
	for (;;) {
		if (Hd(t), J(F.eq)) {
			let t = z.tokens.length - 1;
			$c(e), z.tokens[t].rhsEndIndex = z.tokens.length;
		}
		if (!J(F.comma)) break;
	}
}
function Hd(e) {
	Bo(e), L ? Dc() : R && td();
}
function Ud(e, t, n = !1) {
	Y(F.star) && G(), t && !n && !Y(F.name) && !Y(F._yield) && U();
	let r = null;
	Y(F.name) && (t || (r = z.tokens.length, z.scopeDepth++), Lo(!1));
	let i = z.tokens.length;
	z.scopeDepth++, Wd(), Ll(e);
	let a = z.tokens.length;
	z.scopes.push(new li(i, a, !0)), z.scopeDepth--, r !== null && (z.scopes.push(new li(r, a, !0)), z.scopeDepth--);
}
function Wd(e = !1, t = 0) {
	L ? Ec() : R && ed(), H(F.parenL), t && (z.tokens[z.tokens.length - 1].contextId = t), Vo(F.parenR, !1, !1, e, t), t && (z.tokens[z.tokens.length - 1].contextId = t);
}
function Gd(e, t = !1) {
	let n = mi();
	G(), z.tokens[z.tokens.length - 1].contextId = n, z.tokens[z.tokens.length - 1].isExpression = !e;
	let r = null;
	e || (r = z.tokens.length, z.scopeDepth++), tf(e, t), nf();
	let i = z.tokens.length;
	if (Jd(n), !z.error && (z.tokens[i].contextId = n, z.tokens[z.tokens.length - 1].contextId = n, r !== null)) {
		let e = z.tokens.length;
		z.scopes.push(new li(r, e, !1)), z.scopeDepth--;
	}
}
function Kd() {
	return Y(F.eq) || Y(F.semi) || Y(F.braceR) || Y(F.bang) || Y(F.colon);
}
function qd() {
	return Y(F.parenL) || Y(F.lessThan);
}
function Jd(e) {
	for (H(F.braceL); !J(F.braceR) && !z.error;) {
		if (J(F.semi)) continue;
		if (Y(F.at)) {
			gd();
			continue;
		}
		let t = z.start;
		Yd(t, e);
	}
}
function Yd(e, t) {
	L && Jo([
		P._declare,
		P._public,
		P._protected,
		P._private,
		P._override
	]);
	let n = !1;
	if (Y(F.name) && z.contextualKeyword === P._static) {
		if (Z(), qd()) {
			Zd(e, !1);
			return;
		}
		if (Kd()) {
			ef();
			return;
		}
		if (z.tokens[z.tokens.length - 1].type = F._static, n = !0, Y(F.braceL)) {
			z.tokens[z.tokens.length - 1].contextId = t, Ld();
			return;
		}
	}
	Xd(e, n, t);
}
function Xd(e, t, n) {
	if (L && xc(t)) return;
	if (J(F.star)) {
		Qd(n), Zd(e, !1);
		return;
	}
	Qd(n);
	let r = !1, i = z.tokens[z.tokens.length - 1];
	i.contextualKeyword === P._constructor && (r = !0), $d(), qd() ? Zd(e, r) : Kd() ? ef() : i.contextualKeyword === P._async && !Ti() ? (z.tokens[z.tokens.length - 1].type = F._async, Y(F.star) && G(), Qd(n), $d(), Zd(e, !1)) : (i.contextualKeyword === P._get || i.contextualKeyword === P._set) && !(Ti() && Y(F.star)) ? (i.contextualKeyword === P._get ? z.tokens[z.tokens.length - 1].type = F._get : z.tokens[z.tokens.length - 1].type = F._set, Qd(n), Zd(e, !1)) : i.contextualKeyword === P._accessor && !Ti() ? (Qd(n), ef()) : Ti() ? ef() : U();
}
function Zd(e, t) {
	L ? rs() : R && Y(F.lessThan) && du(), Fl(e, t);
}
function Qd(e) {
	Pl(e);
}
function $d() {
	if (L) {
		let e = K(0);
		J(F.question), q(e);
	}
}
function ef() {
	if (L ? (Gi(F.bang), Ls()) : R && Y(F.colon) && Fu(), Y(F.eq)) {
		let e = z.tokens.length;
		G(), $c(), z.tokens[e].rhsEndIndex = z.tokens.length;
	}
	Ei();
}
function tf(e, t = !1) {
	(!L || e && !t || !V(P._implements)) && (Y(F.name) && Lo(!0), L ? rs() : R && Y(F.lessThan) && du());
}
function nf() {
	let e = !1;
	J(F._extends) ? (sl(), e = !0) : e = !1, L ? wc(e) : R && Yu(e);
}
function rf() {
	let e = z.tokens.length - 1;
	L && gc() || (uf() ? df() : sf() ? (Z(), Y(F.comma) && Ki() === F.star ? (H(F.comma), H(F.star), xi(P._as), Z()) : cf(), lf()) : J(F._default) ? af() : mf() ? of() : (hf(), lf()), z.tokens[e].rhsEndIndex = z.tokens.length);
}
function af() {
	if (L && yc() || R && Hu()) return;
	let e = z.start;
	J(F._function) ? Ud(e, !0, !0) : V(P._async) && Ki() === F._function ? (bi(P._async), J(F._function), Ud(e, !0, !0)) : Y(F._class) ? Gd(!0, !0) : Y(F.at) ? (hd(), Gd(!0, !0)) : ($c(), Ei());
}
function of() {
	L ? Cc() : R ? Ku() : fd(!0);
}
function sf() {
	if (L && pc() || R && Gu()) return !1;
	if (Y(F.name)) return z.contextualKeyword !== P._async;
	if (!Y(F._default)) return !1;
	let e = Yi(), t = Ji(), n = t.type === F.name && t.contextualKeyword === P._from;
	if (t.type === F.comma) return !0;
	if (n) {
		let t = B.charCodeAt(Xi(e + 4));
		return t === I.quotationMark || t === I.apostrophe;
	}
	return !1;
}
function cf() {
	J(F.comma) && hf();
}
function lf() {
	bi(P._from) && (_l(), wf()), Ei();
}
function uf() {
	return R ? qu() : Y(F.star);
}
function df() {
	R ? Ju() : ff();
}
function ff() {
	H(F.star), V(P._as) ? pf() : lf();
}
function pf() {
	G(), z.tokens[z.tokens.length - 1].type = F._as, Z(), cf(), lf();
}
function mf() {
	return L && pc() || R && Wu() || z.type === F._var || z.type === F._const || z.type === F._let || z.type === F._function || z.type === F._class || V(P._async) || Y(F.at);
}
function hf() {
	let e = !0;
	for (H(F.braceL); !J(F.braceR) && !z.error;) {
		if (e) e = !1;
		else if (H(F.comma), J(F.braceR)) break;
		gf();
	}
}
function gf() {
	L ? vc() : (Z(), z.tokens[z.tokens.length - 1].identifierRole = W.ExportAccess, bi(P._as) && Z());
}
function _f() {
	let e = z.snapshot();
	return xi(P._module), bi(P._from) ? V(P._from) ? (z.restoreFromSnapshot(e), !0) : (z.restoreFromSnapshot(e), !1) : Y(F.comma) ? (z.restoreFromSnapshot(e), !1) : (z.restoreFromSnapshot(e), !0);
}
function vf() {
	V(P._module) && _f() && G();
}
function yf() {
	if (L && Y(F.name) && Ki() === F.eq) tc();
	else {
		if (L && V(P._type)) {
			let e = Ji();
			if (e.type === F.name && e.contextualKeyword !== P._from) {
				if (xi(P._type), Ki() === F.eq) {
					tc();
					return;
				}
			} else (e.type === F.star || e.type === F.braceL) && xi(P._type);
		}
		Y(F.string) || (vf(), Sf(), xi(P._from)), _l(), wf(), Ei();
	}
}
function bf() {
	return Y(F.name);
}
function xf() {
	Ro();
}
function Sf() {
	R && Qu();
	let e = !0;
	if (!(bf() && (xf(), !J(F.comma)))) {
		if (Y(F.star)) G(), xi(P._as), xf();
		else for (H(F.braceL); !J(F.braceR) && !z.error;) {
			if (e) e = !1;
			else if (J(F.colon) && U("ES2015 named imports do not destructure. Use another statement for destructuring after the import."), H(F.comma), J(F.braceR)) break;
			Cf();
		}
	}
}
function Cf() {
	L ? _c() : R ? $u() : (Ro(), V(P._as) && (z.tokens[z.tokens.length - 1].identifierRole = W.ImportAccess, G(), Ro()));
}
function wf() {
	(Y(F._with) || V(P._assert) && !Ci()) && (G(), kl(!1, !1));
}
// node_modules/sucrase/dist/esm/parser/traverser/index.js
function Tf() {
	return z.pos === 0 && B.charCodeAt(0) === I.numberSign && B.charCodeAt(1) === I.exclamationMark && ta(2), Qi(), dd();
}
// node_modules/sucrase/dist/esm/parser/index.js
var Ef = class {
	constructor(e, t) {
		this.tokens = e, this.scopes = t;
	}
};
function Df(e, t, n, r) {
	if (r && n) throw Error("Cannot combine flow and typescript plugins.");
	vi(e, t, n, r);
	let i = Tf();
	if (z.error) throw hi(z.error);
	return i;
}
// node_modules/sucrase/dist/esm/util/isAsyncOperation.js
function Of(e) {
	let t = e.currentIndex(), n = 0, r = e.currentToken();
	do {
		let i = e.tokens[t];
		if (i.isOptionalChainStart && n++, i.isOptionalChainEnd && n--, n += i.numNullishCoalesceStarts, n -= i.numNullishCoalesceEnds, i.contextualKeyword === P._await && i.identifierRole == null && i.scopeDepth === r.scopeDepth) return !0;
		t += 1;
	} while (n > 0 && t < e.tokens.length);
	return !1;
}
// node_modules/sucrase/dist/esm/TokenProcessor.js
var kf = class e {
	__init() {
		this.resultCode = "";
	}
	__init2() {
		this.resultMappings = Array(this.tokens.length);
	}
	__init3() {
		this.tokenIndex = 0;
	}
	constructor(t, n, r, i, a) {
		this.code = t, this.tokens = n, this.isFlowEnabled = r, this.disableESTransforms = i, this.helperManager = a, e.prototype.__init.call(this), e.prototype.__init2.call(this), e.prototype.__init3.call(this);
	}
	snapshot() {
		return {
			resultCode: this.resultCode,
			tokenIndex: this.tokenIndex
		};
	}
	restoreToSnapshot(e) {
		this.resultCode = e.resultCode, this.tokenIndex = e.tokenIndex;
	}
	dangerouslyGetAndRemoveCodeSinceSnapshot(e) {
		let t = this.resultCode.slice(e.resultCode.length);
		return this.resultCode = e.resultCode, t;
	}
	reset() {
		this.resultCode = "", this.resultMappings = Array(this.tokens.length), this.tokenIndex = 0;
	}
	matchesContextualAtIndex(e, t) {
		return this.matches1AtIndex(e, F.name) && this.tokens[e].contextualKeyword === t;
	}
	identifierNameAtIndex(e) {
		return this.identifierNameForToken(this.tokens[e]);
	}
	identifierNameAtRelativeIndex(e) {
		return this.identifierNameForToken(this.tokenAtRelativeIndex(e));
	}
	identifierName() {
		return this.identifierNameForToken(this.currentToken());
	}
	identifierNameForToken(e) {
		return this.code.slice(e.start, e.end);
	}
	rawCodeForToken(e) {
		return this.code.slice(e.start, e.end);
	}
	stringValueAtIndex(e) {
		return this.stringValueForToken(this.tokens[e]);
	}
	stringValue() {
		return this.stringValueForToken(this.currentToken());
	}
	stringValueForToken(e) {
		return this.code.slice(e.start + 1, e.end - 1);
	}
	matches1AtIndex(e, t) {
		return this.tokens[e].type === t;
	}
	matches2AtIndex(e, t, n) {
		return this.tokens[e].type === t && this.tokens[e + 1].type === n;
	}
	matches3AtIndex(e, t, n, r) {
		return this.tokens[e].type === t && this.tokens[e + 1].type === n && this.tokens[e + 2].type === r;
	}
	matches1(e) {
		return this.tokens[this.tokenIndex].type === e;
	}
	matches2(e, t) {
		return this.tokens[this.tokenIndex].type === e && this.tokens[this.tokenIndex + 1].type === t;
	}
	matches3(e, t, n) {
		return this.tokens[this.tokenIndex].type === e && this.tokens[this.tokenIndex + 1].type === t && this.tokens[this.tokenIndex + 2].type === n;
	}
	matches4(e, t, n, r) {
		return this.tokens[this.tokenIndex].type === e && this.tokens[this.tokenIndex + 1].type === t && this.tokens[this.tokenIndex + 2].type === n && this.tokens[this.tokenIndex + 3].type === r;
	}
	matches5(e, t, n, r, i) {
		return this.tokens[this.tokenIndex].type === e && this.tokens[this.tokenIndex + 1].type === t && this.tokens[this.tokenIndex + 2].type === n && this.tokens[this.tokenIndex + 3].type === r && this.tokens[this.tokenIndex + 4].type === i;
	}
	matchesContextual(e) {
		return this.matchesContextualAtIndex(this.tokenIndex, e);
	}
	matchesContextIdAndLabel(e, t) {
		return this.matches1(e) && this.currentToken().contextId === t;
	}
	previousWhitespaceAndComments() {
		let e = this.code.slice(this.tokenIndex > 0 ? this.tokens[this.tokenIndex - 1].end : 0, this.tokenIndex < this.tokens.length ? this.tokens[this.tokenIndex].start : this.code.length);
		return this.isFlowEnabled && (e = e.replace(/@flow/g, "")), e;
	}
	replaceToken(e) {
		this.resultCode += this.previousWhitespaceAndComments(), this.appendTokenPrefix(), this.resultMappings[this.tokenIndex] = this.resultCode.length, this.resultCode += e, this.appendTokenSuffix(), this.tokenIndex++;
	}
	replaceTokenTrimmingLeftWhitespace(e) {
		this.resultCode += this.previousWhitespaceAndComments().replace(/[^\r\n]/g, ""), this.appendTokenPrefix(), this.resultMappings[this.tokenIndex] = this.resultCode.length, this.resultCode += e, this.appendTokenSuffix(), this.tokenIndex++;
	}
	removeInitialToken() {
		this.replaceToken("");
	}
	removeToken() {
		this.replaceTokenTrimmingLeftWhitespace("");
	}
	removeBalancedCode() {
		let e = 0;
		for (; !this.isAtEnd();) {
			if (this.matches1(F.braceL)) e++;
			else if (this.matches1(F.braceR)) {
				if (e === 0) return;
				e--;
			}
			this.removeToken();
		}
	}
	copyExpectedToken(e) {
		if (this.tokens[this.tokenIndex].type !== e) throw Error(`Expected token ${e}`);
		this.copyToken();
	}
	copyToken() {
		this.resultCode += this.previousWhitespaceAndComments(), this.appendTokenPrefix(), this.resultMappings[this.tokenIndex] = this.resultCode.length, this.resultCode += this.code.slice(this.tokens[this.tokenIndex].start, this.tokens[this.tokenIndex].end), this.appendTokenSuffix(), this.tokenIndex++;
	}
	copyTokenWithPrefix(e) {
		this.resultCode += this.previousWhitespaceAndComments(), this.appendTokenPrefix(), this.resultCode += e, this.resultMappings[this.tokenIndex] = this.resultCode.length, this.resultCode += this.code.slice(this.tokens[this.tokenIndex].start, this.tokens[this.tokenIndex].end), this.appendTokenSuffix(), this.tokenIndex++;
	}
	appendTokenPrefix() {
		let e = this.currentToken();
		if ((e.numNullishCoalesceStarts || e.isOptionalChainStart) && (e.isAsyncOperation = Of(this)), !this.disableESTransforms) {
			if (e.numNullishCoalesceStarts) for (let t = 0; t < e.numNullishCoalesceStarts; t++) e.isAsyncOperation ? (this.resultCode += "await ", this.resultCode += this.helperManager.getHelperName("asyncNullishCoalesce")) : this.resultCode += this.helperManager.getHelperName("nullishCoalesce"), this.resultCode += "(";
			e.isOptionalChainStart && (e.isAsyncOperation && (this.resultCode += "await "), this.tokenIndex > 0 && this.tokenAtRelativeIndex(-1).type === F._delete ? e.isAsyncOperation ? this.resultCode += this.helperManager.getHelperName("asyncOptionalChainDelete") : this.resultCode += this.helperManager.getHelperName("optionalChainDelete") : e.isAsyncOperation ? this.resultCode += this.helperManager.getHelperName("asyncOptionalChain") : this.resultCode += this.helperManager.getHelperName("optionalChain"), this.resultCode += "([");
		}
	}
	appendTokenSuffix() {
		let e = this.currentToken();
		if (e.isOptionalChainEnd && !this.disableESTransforms && (this.resultCode += "])"), e.numNullishCoalesceEnds && !this.disableESTransforms) for (let t = 0; t < e.numNullishCoalesceEnds; t++) this.resultCode += "))";
	}
	appendCode(e) {
		this.resultCode += e;
	}
	currentToken() {
		return this.tokens[this.tokenIndex];
	}
	currentTokenCode() {
		let e = this.currentToken();
		return this.code.slice(e.start, e.end);
	}
	tokenAtRelativeIndex(e) {
		return this.tokens[this.tokenIndex + e];
	}
	currentIndex() {
		return this.tokenIndex;
	}
	nextToken() {
		if (this.tokenIndex === this.tokens.length) throw Error("Unexpectedly reached end of input.");
		this.tokenIndex++;
	}
	previousToken() {
		this.tokenIndex--;
	}
	finish() {
		if (this.tokenIndex !== this.tokens.length) throw Error("Tried to finish processing tokens before reaching the end.");
		return this.resultCode += this.previousWhitespaceAndComments(), {
			code: this.resultCode,
			mappings: this.resultMappings
		};
	}
	isAtEnd() {
		return this.tokenIndex === this.tokens.length;
	}
};
// node_modules/sucrase/dist/esm/util/getClassInfo.js
function Af(e, t, n, r) {
	let i = t.snapshot(), a = Mf(t), o = [], s = [], c = [], l = null, u = [], d = [], f = t.currentToken().contextId;
	if (f == null) throw Error("Expected non-null class context ID on class open-brace.");
	for (t.nextToken(); !t.matchesContextIdAndLabel(F.braceR, f);) if (t.matchesContextual(P._constructor) && !t.currentToken().isType) ({constructorInitializerStatements: o, constructorInsertPos: l} = Nf(t));
	else if (t.matches1(F.semi)) r || d.push({
		start: t.currentIndex(),
		end: t.currentIndex() + 1
	}), t.nextToken();
	else if (t.currentToken().isType) t.nextToken();
	else {
		let i = t.currentIndex(), a = !1, p = !1, m = !1;
		for (; Pf(t.currentToken());) t.matches1(F._static) && (a = !0), t.matches1(F.hash) && (p = !0), (t.matches1(F._declare) || t.matches1(F._abstract)) && (m = !0), t.nextToken();
		if (a && t.matches1(F.braceL) || p) {
			jf(t, f);
			continue;
		}
		if (t.matchesContextual(P._constructor) && !t.currentToken().isType) {
			({constructorInitializerStatements: o, constructorInsertPos: l} = Nf(t));
			continue;
		}
		let h = t.currentIndex();
		if (Ff(t), t.matches1(F.lessThan) || t.matches1(F.parenL)) {
			jf(t, f);
			continue;
		}
		for (; t.currentToken().isType;) t.nextToken();
		if (t.matches1(F.eq)) {
			let r = t.currentIndex(), i = t.currentToken().rhsEndIndex;
			if (i == null) throw Error("Expected rhsEndIndex on class field assignment.");
			for (t.nextToken(); t.currentIndex() < i;) e.processToken();
			let o;
			a ? (o = n.claimFreeName("__initStatic"), c.push(o)) : (o = n.claimFreeName("__init"), s.push(o)), u.push({
				initializerName: o,
				equalsIndex: r,
				start: h,
				end: t.currentIndex()
			});
		} else (!r || m) && d.push({
			start: i,
			end: t.currentIndex()
		});
	}
	return t.restoreToSnapshot(i), r ? {
		headerInfo: a,
		constructorInitializerStatements: o,
		instanceInitializerNames: [],
		staticInitializerNames: [],
		constructorInsertPos: l,
		fields: [],
		rangesToRemove: d
	} : {
		headerInfo: a,
		constructorInitializerStatements: o,
		instanceInitializerNames: s,
		staticInitializerNames: c,
		constructorInsertPos: l,
		fields: u,
		rangesToRemove: d
	};
}
function jf(e, t) {
	for (e.nextToken(); e.currentToken().contextId !== t;) e.nextToken();
	for (; Pf(e.tokenAtRelativeIndex(-1));) e.previousToken();
}
function Mf(e) {
	let t = e.currentToken(), n = t.contextId;
	if (n == null) throw Error("Expected context ID on class token.");
	let r = t.isExpression;
	if (r == null) throw Error("Expected isExpression on class token.");
	let i = null, a = !1;
	for (e.nextToken(), e.matches1(F.name) && (i = e.identifierName()); !e.matchesContextIdAndLabel(F.braceL, n);) e.matches1(F._extends) && !e.currentToken().isType && (a = !0), e.nextToken();
	return {
		isExpression: r,
		className: i,
		hasSuperclass: a
	};
}
function Nf(e) {
	let t = [];
	e.nextToken();
	let n = e.currentToken().contextId;
	if (n == null) throw Error("Expected context ID on open-paren starting constructor params.");
	for (; !e.matchesContextIdAndLabel(F.parenR, n);) if (e.currentToken().contextId === n) {
		if (e.nextToken(), Pf(e.currentToken())) {
			for (e.nextToken(); Pf(e.currentToken());) e.nextToken();
			let n = e.currentToken();
			if (n.type !== F.name) throw Error("Expected identifier after access modifiers in constructor arg.");
			let r = e.identifierNameForToken(n);
			t.push(`this.${r} = ${r}`);
		}
	} else e.nextToken();
	for (e.nextToken(); e.currentToken().isType;) e.nextToken();
	let r = e.currentIndex(), i = !1;
	for (; !e.matchesContextIdAndLabel(F.braceR, n);) {
		if (!i && e.matches2(F._super, F.parenL)) {
			e.nextToken();
			let t = e.currentToken().contextId;
			if (t == null) throw Error("Expected a context ID on the super call");
			for (; !e.matchesContextIdAndLabel(F.parenR, t);) e.nextToken();
			r = e.currentIndex(), i = !0;
		}
		e.nextToken();
	}
	return e.nextToken(), {
		constructorInitializerStatements: t,
		constructorInsertPos: r
	};
}
function Pf(e) {
	return [
		F._async,
		F._get,
		F._set,
		F.plus,
		F.minus,
		F._readonly,
		F._static,
		F._public,
		F._private,
		F._protected,
		F._override,
		F._abstract,
		F.star,
		F._declare,
		F.hash
	].includes(e.type);
}
function Ff(e) {
	if (e.matches1(F.bracketL)) {
		let t = e.currentToken().contextId;
		if (t == null) throw Error("Expected class context ID on computed name open bracket.");
		for (; !e.matchesContextIdAndLabel(F.bracketR, t);) e.nextToken();
		e.nextToken();
	} else e.nextToken();
}
// node_modules/sucrase/dist/esm/util/elideImportEquals.js
function If(e) {
	if (e.removeInitialToken(), e.removeToken(), e.removeToken(), e.removeToken(), e.matches1(F.parenL)) e.removeToken(), e.removeToken(), e.removeToken();
	else for (; e.matches1(F.dot);) e.removeToken(), e.removeToken();
}
// node_modules/sucrase/dist/esm/util/getDeclarationInfo.js
var Lf = {
	typeDeclarations: /* @__PURE__ */ new Set(),
	valueDeclarations: /* @__PURE__ */ new Set()
};
function Rf(e) {
	let t = /* @__PURE__ */ new Set(), n = /* @__PURE__ */ new Set();
	for (let r = 0; r < e.tokens.length; r++) {
		let i = e.tokens[r];
		i.type === F.name && Ri(i) && (i.isType ? t.add(e.identifierNameForToken(i)) : n.add(e.identifierNameForToken(i)));
	}
	return {
		typeDeclarations: t,
		valueDeclarations: n
	};
}
// node_modules/sucrase/dist/esm/util/isExportFrom.js
function zf(e) {
	let t = e.currentIndex();
	for (; !e.matches1AtIndex(t, F.braceR);) t++;
	return e.matchesContextualAtIndex(t + 1, P._from) && e.matches1AtIndex(t + 2, F.string);
}
// node_modules/sucrase/dist/esm/util/removeMaybeImportAttributes.js
function Bf(e) {
	(e.matches2(F._with, F.braceL) || e.matches2(F.name, F.braceL) && e.matchesContextual(P._assert)) && (e.removeToken(), e.removeToken(), e.removeBalancedCode(), e.removeToken());
}
// node_modules/sucrase/dist/esm/util/shouldElideDefaultExport.js
function Vf(e, t, n, r) {
	if (!e || t) return !1;
	let i = n.currentToken();
	if (i.rhsEndIndex == null) throw Error("Expected non-null rhsEndIndex on export token.");
	let a = i.rhsEndIndex - n.currentIndex();
	if (a !== 3 && !(a === 4 && n.matches1AtIndex(i.rhsEndIndex - 1, F.semi))) return !1;
	let o = n.tokenAtRelativeIndex(2);
	if (o.type !== F.name) return !1;
	let s = n.identifierNameForToken(o);
	return r.typeDeclarations.has(s) && !r.valueDeclarations.has(s);
}
// node_modules/sucrase/dist/esm/transformers/CJSImportTransformer.js
var Hf = class e extends Oa {
	__init() {
		this.hadExport = !1;
	}
	__init2() {
		this.hadNamedExport = !1;
	}
	__init3() {
		this.hadDefaultExport = !1;
	}
	constructor(t, n, r, i, a, o, s, c, l, u, d, f) {
		super(), this.rootTransformer = t, this.tokens = n, this.importProcessor = r, this.nameManager = i, this.helperManager = a, this.reactHotLoaderTransformer = o, this.enableLegacyBabel5ModuleInterop = s, this.enableLegacyTypeScriptModuleInterop = c, this.isTypeScriptTransformEnabled = l, this.isFlowTransformEnabled = u, this.preserveDynamicImport = d, this.keepUnusedImports = f, e.prototype.__init.call(this), e.prototype.__init2.call(this), e.prototype.__init3.call(this), this.declarationInfo = l ? Rf(n) : Lf;
	}
	getPrefixCode() {
		let e = "";
		return this.hadExport && (e += "Object.defineProperty(exports, \"__esModule\", {value: true});"), e;
	}
	getSuffixCode() {
		return this.enableLegacyBabel5ModuleInterop && this.hadDefaultExport && !this.hadNamedExport ? "\nmodule.exports = exports.default;\n" : "";
	}
	process() {
		return this.tokens.matches3(F._import, F.name, F.eq) ? this.processImportEquals() : this.tokens.matches1(F._import) ? (this.processImport(), !0) : this.tokens.matches2(F._export, F.eq) ? (this.tokens.replaceToken("module.exports"), !0) : this.tokens.matches1(F._export) && !this.tokens.currentToken().isType ? (this.hadExport = !0, this.processExport()) : this.tokens.matches2(F.name, F.postIncDec) && this.processPostIncDec() ? !0 : this.tokens.matches1(F.name) || this.tokens.matches1(F.jsxName) ? this.processIdentifier() : this.tokens.matches1(F.eq) ? this.processAssignment() : this.tokens.matches1(F.assign) ? this.processComplexAssignment() : this.tokens.matches1(F.preIncDec) ? this.processPreIncDec() : !1;
	}
	processImportEquals() {
		let e = this.tokens.identifierNameAtIndex(this.tokens.currentIndex() + 1);
		return this.importProcessor.shouldAutomaticallyElideImportedName(e) ? If(this.tokens) : this.tokens.replaceToken("const"), !0;
	}
	processImport() {
		if (this.tokens.matches2(F._import, F.parenL)) {
			if (this.preserveDynamicImport) {
				this.tokens.copyToken();
				return;
			}
			let e = this.enableLegacyTypeScriptModuleInterop ? "" : `${this.helperManager.getHelperName("interopRequireWildcard")}(`;
			this.tokens.replaceToken(`Promise.resolve().then(() => ${e}require`);
			let t = this.tokens.currentToken().contextId;
			if (t == null) throw Error("Expected context ID on dynamic import invocation.");
			for (this.tokens.copyToken(); !this.tokens.matchesContextIdAndLabel(F.parenR, t);) this.rootTransformer.processToken();
			this.tokens.replaceToken(e ? ")))" : "))");
		} else {
			if (this.removeImportAndDetectIfShouldElide()) this.tokens.removeToken();
			else {
				let e = this.tokens.stringValue();
				this.tokens.replaceTokenTrimmingLeftWhitespace(this.importProcessor.claimImportCode(e)), this.tokens.appendCode(this.importProcessor.claimImportCode(e));
			}
			Bf(this.tokens), this.tokens.matches1(F.semi) && this.tokens.removeToken();
		}
	}
	removeImportAndDetectIfShouldElide() {
		if (this.tokens.removeInitialToken(), this.tokens.matchesContextual(P._type) && !this.tokens.matches1AtIndex(this.tokens.currentIndex() + 1, F.comma) && !this.tokens.matchesContextualAtIndex(this.tokens.currentIndex() + 1, P._from)) return this.removeRemainingImport(), !0;
		if (this.tokens.matches1(F.name) || this.tokens.matches1(F.star)) return this.removeRemainingImport(), !1;
		if (this.tokens.matches1(F.string)) return !1;
		let e = !1, t = !1;
		for (; !this.tokens.matches1(F.string);) (!e && this.tokens.matches1(F.braceL) || this.tokens.matches1(F.comma)) && (this.tokens.removeToken(), this.tokens.matches1(F.braceR) || (t = !0), (this.tokens.matches2(F.name, F.comma) || this.tokens.matches2(F.name, F.braceR) || this.tokens.matches4(F.name, F.name, F.name, F.comma) || this.tokens.matches4(F.name, F.name, F.name, F.braceR)) && (e = !0)), this.tokens.removeToken();
		return this.keepUnusedImports ? !1 : this.isTypeScriptTransformEnabled ? !e : this.isFlowTransformEnabled ? t && !e : !1;
	}
	removeRemainingImport() {
		for (; !this.tokens.matches1(F.string);) this.tokens.removeToken();
	}
	processIdentifier() {
		let e = this.tokens.currentToken();
		if (e.shadowsGlobal) return !1;
		if (e.identifierRole === W.ObjectShorthand) return this.processObjectShorthand();
		if (e.identifierRole !== W.Access) return !1;
		let t = this.importProcessor.getIdentifierReplacement(this.tokens.identifierNameForToken(e));
		if (!t) return !1;
		let n = this.tokens.currentIndex() + 1;
		for (; n < this.tokens.tokens.length && this.tokens.tokens[n].type === F.parenR;) n++;
		return this.tokens.tokens[n].type === F.parenL ? this.tokens.tokenAtRelativeIndex(1).type === F.parenL && this.tokens.tokenAtRelativeIndex(-1).type !== F._new ? (this.tokens.replaceToken(`${t}.call(void 0, `), this.tokens.removeToken(), this.rootTransformer.processBalancedCode(), this.tokens.copyExpectedToken(F.parenR)) : this.tokens.replaceToken(`(0, ${t})`) : this.tokens.replaceToken(t), !0;
	}
	processObjectShorthand() {
		let e = this.tokens.identifierName(), t = this.importProcessor.getIdentifierReplacement(e);
		return t ? (this.tokens.replaceToken(`${e}: ${t}`), !0) : !1;
	}
	processExport() {
		if (this.tokens.matches2(F._export, F._enum) || this.tokens.matches3(F._export, F._const, F._enum)) return this.hadNamedExport = !0, !1;
		if (this.tokens.matches2(F._export, F._default)) return this.tokens.matches3(F._export, F._default, F._enum) ? (this.hadDefaultExport = !0, !1) : (this.processExportDefault(), !0);
		if (this.tokens.matches2(F._export, F.braceL)) return this.processExportBindings(), !0;
		if (this.tokens.matches2(F._export, F.name) && this.tokens.matchesContextualAtIndex(this.tokens.currentIndex() + 1, P._type)) {
			if (this.tokens.removeInitialToken(), this.tokens.removeToken(), this.tokens.matches1(F.braceL)) {
				for (; !this.tokens.matches1(F.braceR);) this.tokens.removeToken();
				this.tokens.removeToken();
			} else this.tokens.removeToken(), this.tokens.matches1(F._as) && (this.tokens.removeToken(), this.tokens.removeToken());
			return this.tokens.matchesContextual(P._from) && this.tokens.matches1AtIndex(this.tokens.currentIndex() + 1, F.string) && (this.tokens.removeToken(), this.tokens.removeToken(), Bf(this.tokens)), !0;
		}
		if (this.hadNamedExport = !0, this.tokens.matches2(F._export, F._var) || this.tokens.matches2(F._export, F._let) || this.tokens.matches2(F._export, F._const)) return this.processExportVar(), !0;
		if (this.tokens.matches2(F._export, F._function) || this.tokens.matches3(F._export, F.name, F._function)) return this.processExportFunction(), !0;
		if (this.tokens.matches2(F._export, F._class) || this.tokens.matches3(F._export, F._abstract, F._class) || this.tokens.matches2(F._export, F.at)) return this.processExportClass(), !0;
		if (this.tokens.matches2(F._export, F.star)) return this.processExportStar(), !0;
		throw Error("Unrecognized export syntax.");
	}
	processAssignment() {
		let e = this.tokens.currentIndex(), t = this.tokens.tokens[e - 1];
		if (t.isType || t.type !== F.name || t.shadowsGlobal || e >= 2 && this.tokens.matches1AtIndex(e - 2, F.dot) || e >= 2 && [
			F._var,
			F._let,
			F._const
		].includes(this.tokens.tokens[e - 2].type)) return !1;
		let n = this.importProcessor.resolveExportBinding(this.tokens.identifierNameForToken(t));
		return n ? (this.tokens.copyToken(), this.tokens.appendCode(` ${n} =`), !0) : !1;
	}
	processComplexAssignment() {
		let e = this.tokens.currentIndex(), t = this.tokens.tokens[e - 1];
		if (t.type !== F.name || t.shadowsGlobal || e >= 2 && this.tokens.matches1AtIndex(e - 2, F.dot)) return !1;
		let n = this.importProcessor.resolveExportBinding(this.tokens.identifierNameForToken(t));
		return n ? (this.tokens.appendCode(` = ${n}`), this.tokens.copyToken(), !0) : !1;
	}
	processPreIncDec() {
		let e = this.tokens.currentIndex(), t = this.tokens.tokens[e + 1];
		if (t.type !== F.name || t.shadowsGlobal || e + 2 < this.tokens.tokens.length && (this.tokens.matches1AtIndex(e + 2, F.dot) || this.tokens.matches1AtIndex(e + 2, F.bracketL) || this.tokens.matches1AtIndex(e + 2, F.parenL))) return !1;
		let n = this.tokens.identifierNameForToken(t), r = this.importProcessor.resolveExportBinding(n);
		return r ? (this.tokens.appendCode(`${r} = `), this.tokens.copyToken(), !0) : !1;
	}
	processPostIncDec() {
		let e = this.tokens.currentIndex(), t = this.tokens.tokens[e], n = this.tokens.tokens[e + 1];
		if (t.type !== F.name || t.shadowsGlobal || e >= 1 && this.tokens.matches1AtIndex(e - 1, F.dot)) return !1;
		let r = this.tokens.identifierNameForToken(t), i = this.importProcessor.resolveExportBinding(r);
		if (!i) return !1;
		let a = this.tokens.rawCodeForToken(n), o = this.importProcessor.getIdentifierReplacement(r) || r;
		if (a === "++") this.tokens.replaceToken(`(${o} = ${i} = ${o} + 1, ${o} - 1)`);
		else if (a === "--") this.tokens.replaceToken(`(${o} = ${i} = ${o} - 1, ${o} + 1)`);
		else throw Error(`Unexpected operator: ${a}`);
		return this.tokens.removeToken(), !0;
	}
	processExportDefault() {
		let e = !0;
		if (this.tokens.matches4(F._export, F._default, F._function, F.name) || this.tokens.matches5(F._export, F._default, F.name, F._function, F.name) && this.tokens.matchesContextualAtIndex(this.tokens.currentIndex() + 2, P._async)) {
			this.tokens.removeInitialToken(), this.tokens.removeToken();
			let e = this.processNamedFunction();
			this.tokens.appendCode(` exports.default = ${e};`);
		} else if (this.tokens.matches4(F._export, F._default, F._class, F.name) || this.tokens.matches5(F._export, F._default, F._abstract, F._class, F.name) || this.tokens.matches3(F._export, F._default, F.at)) {
			this.tokens.removeInitialToken(), this.tokens.removeToken(), this.copyDecorators(), this.tokens.matches1(F._abstract) && this.tokens.removeToken();
			let e = this.rootTransformer.processNamedClass();
			this.tokens.appendCode(` exports.default = ${e};`);
		} else if (Vf(this.isTypeScriptTransformEnabled, this.keepUnusedImports, this.tokens, this.declarationInfo)) e = !1, this.tokens.removeInitialToken(), this.tokens.removeToken(), this.tokens.removeToken();
		else if (this.reactHotLoaderTransformer) {
			let e = this.nameManager.claimFreeName("_default");
			this.tokens.replaceToken(`let ${e}; exports.`), this.tokens.copyToken(), this.tokens.appendCode(` = ${e} =`), this.reactHotLoaderTransformer.setExtractedDefaultExportName(e);
		} else this.tokens.replaceToken("exports."), this.tokens.copyToken(), this.tokens.appendCode(" =");
		e && (this.hadDefaultExport = !0);
	}
	copyDecorators() {
		for (; this.tokens.matches1(F.at);) if (this.tokens.copyToken(), this.tokens.matches1(F.parenL)) this.tokens.copyExpectedToken(F.parenL), this.rootTransformer.processBalancedCode(), this.tokens.copyExpectedToken(F.parenR);
		else {
			for (this.tokens.copyExpectedToken(F.name); this.tokens.matches1(F.dot);) this.tokens.copyExpectedToken(F.dot), this.tokens.copyExpectedToken(F.name);
			this.tokens.matches1(F.parenL) && (this.tokens.copyExpectedToken(F.parenL), this.rootTransformer.processBalancedCode(), this.tokens.copyExpectedToken(F.parenR));
		}
	}
	processExportVar() {
		this.isSimpleExportVar() ? this.processSimpleExportVar() : this.processComplexExportVar();
	}
	isSimpleExportVar() {
		let e = this.tokens.currentIndex();
		if (e++, e++, !this.tokens.matches1AtIndex(e, F.name)) return !1;
		for (e++; e < this.tokens.tokens.length && this.tokens.tokens[e].isType;) e++;
		return !!this.tokens.matches1AtIndex(e, F.eq);
	}
	processSimpleExportVar() {
		this.tokens.removeInitialToken(), this.tokens.copyToken();
		let e = this.tokens.identifierName();
		for (; !this.tokens.matches1(F.eq);) this.rootTransformer.processToken();
		let t = this.tokens.currentToken().rhsEndIndex;
		if (t == null) throw Error("Expected = token with an end index.");
		for (; this.tokens.currentIndex() < t;) this.rootTransformer.processToken();
		this.tokens.appendCode(`; exports.${e} = ${e}`);
	}
	processComplexExportVar() {
		this.tokens.removeInitialToken(), this.tokens.removeToken();
		let e = this.tokens.matches1(F.braceL);
		e && this.tokens.appendCode("(");
		let t = 0;
		for (;;) if (this.tokens.matches1(F.braceL) || this.tokens.matches1(F.dollarBraceL) || this.tokens.matches1(F.bracketL)) t++, this.tokens.copyToken();
		else if (this.tokens.matches1(F.braceR) || this.tokens.matches1(F.bracketR)) t--, this.tokens.copyToken();
		else if (t === 0 && !this.tokens.matches1(F.name) && !this.tokens.currentToken().isType) break;
		else if (this.tokens.matches1(F.eq)) {
			let e = this.tokens.currentToken().rhsEndIndex;
			if (e == null) throw Error("Expected = token with an end index.");
			for (; this.tokens.currentIndex() < e;) this.rootTransformer.processToken();
		} else {
			let e = this.tokens.currentToken();
			if (Ii(e)) {
				let t = this.tokens.identifierName(), n = this.importProcessor.getIdentifierReplacement(t);
				if (n === null) throw Error(`Expected a replacement for ${t} in \`export var\` syntax.`);
				Vi(e) && (n = `${t}: ${n}`), this.tokens.replaceToken(n);
			} else this.rootTransformer.processToken();
		}
		if (e) {
			let e = this.tokens.currentToken().rhsEndIndex;
			if (e == null) throw Error("Expected = token with an end index.");
			for (; this.tokens.currentIndex() < e;) this.rootTransformer.processToken();
			this.tokens.appendCode(")");
		}
	}
	processExportFunction() {
		this.tokens.replaceToken("");
		let e = this.processNamedFunction();
		this.tokens.appendCode(` exports.${e} = ${e};`);
	}
	processNamedFunction() {
		if (this.tokens.matches1(F._function)) this.tokens.copyToken();
		else if (this.tokens.matches2(F.name, F._function)) {
			if (!this.tokens.matchesContextual(P._async)) throw Error("Expected async keyword in function export.");
			this.tokens.copyToken(), this.tokens.copyToken();
		}
		if (this.tokens.matches1(F.star) && this.tokens.copyToken(), !this.tokens.matches1(F.name)) throw Error("Expected identifier for exported function name.");
		let e = this.tokens.identifierName();
		if (this.tokens.copyToken(), this.tokens.currentToken().isType) for (this.tokens.removeInitialToken(); this.tokens.currentToken().isType;) this.tokens.removeToken();
		return this.tokens.copyExpectedToken(F.parenL), this.rootTransformer.processBalancedCode(), this.tokens.copyExpectedToken(F.parenR), this.rootTransformer.processPossibleTypeRange(), this.tokens.copyExpectedToken(F.braceL), this.rootTransformer.processBalancedCode(), this.tokens.copyExpectedToken(F.braceR), e;
	}
	processExportClass() {
		this.tokens.removeInitialToken(), this.copyDecorators(), this.tokens.matches1(F._abstract) && this.tokens.removeToken();
		let e = this.rootTransformer.processNamedClass();
		this.tokens.appendCode(` exports.${e} = ${e};`);
	}
	processExportBindings() {
		this.tokens.removeInitialToken(), this.tokens.removeToken();
		let e = zf(this.tokens), t = [];
		for (;;) {
			if (this.tokens.matches1(F.braceR)) {
				this.tokens.removeToken();
				break;
			}
			let n = Ca(this.tokens);
			for (; this.tokens.currentIndex() < n.endIndex;) this.tokens.removeToken();
			if (!(n.isType || !e && this.shouldElideExportedIdentifier(n.leftName))) {
				let e = n.rightName;
				e === "default" ? this.hadDefaultExport = !0 : this.hadNamedExport = !0;
				let r = n.leftName, i = this.importProcessor.getIdentifierReplacement(r);
				t.push(`exports.${e} = ${i || r};`);
			}
			if (this.tokens.matches1(F.braceR)) {
				this.tokens.removeToken();
				break;
			}
			if (this.tokens.matches2(F.comma, F.braceR)) {
				this.tokens.removeToken(), this.tokens.removeToken();
				break;
			}
			if (this.tokens.matches1(F.comma)) this.tokens.removeToken();
			else throw Error(`Unexpected token: ${JSON.stringify(this.tokens.currentToken())}`);
		}
		if (this.tokens.matchesContextual(P._from)) {
			this.tokens.removeToken();
			let e = this.tokens.stringValue();
			this.tokens.replaceTokenTrimmingLeftWhitespace(this.importProcessor.claimImportCode(e)), Bf(this.tokens);
		} else this.tokens.appendCode(t.join(" "));
		this.tokens.matches1(F.semi) && this.tokens.removeToken();
	}
	processExportStar() {
		for (this.tokens.removeInitialToken(); !this.tokens.matches1(F.string);) this.tokens.removeToken();
		let e = this.tokens.stringValue();
		this.tokens.replaceTokenTrimmingLeftWhitespace(this.importProcessor.claimImportCode(e)), Bf(this.tokens), this.tokens.matches1(F.semi) && this.tokens.removeToken();
	}
	shouldElideExportedIdentifier(e) {
		return this.isTypeScriptTransformEnabled && !this.keepUnusedImports && !this.declarationInfo.valueDeclarations.has(e);
	}
}, Uf = class extends Oa {
	constructor(e, t, n, r, i, a, o, s) {
		super(), this.tokens = e, this.nameManager = t, this.helperManager = n, this.reactHotLoaderTransformer = r, this.isTypeScriptTransformEnabled = i, this.isFlowTransformEnabled = a, this.keepUnusedImports = o, this.nonTypeIdentifiers = i && !o ? La(e, s) : /* @__PURE__ */ new Set(), this.declarationInfo = i && !o ? Rf(e) : Lf, this.injectCreateRequireForImportRequire = !!s.injectCreateRequireForImportRequire;
	}
	process() {
		if (this.tokens.matches3(F._import, F.name, F.eq)) return this.processImportEquals();
		if (this.tokens.matches4(F._import, F.name, F.name, F.eq) && this.tokens.matchesContextualAtIndex(this.tokens.currentIndex() + 1, P._type)) {
			this.tokens.removeInitialToken();
			for (let e = 0; e < 7; e++) this.tokens.removeToken();
			return !0;
		}
		if (this.tokens.matches2(F._export, F.eq)) return this.tokens.replaceToken("module.exports"), !0;
		if (this.tokens.matches5(F._export, F._import, F.name, F.name, F.eq) && this.tokens.matchesContextualAtIndex(this.tokens.currentIndex() + 2, P._type)) {
			this.tokens.removeInitialToken();
			for (let e = 0; e < 8; e++) this.tokens.removeToken();
			return !0;
		}
		if (this.tokens.matches1(F._import)) return this.processImport();
		if (this.tokens.matches2(F._export, F._default)) return this.processExportDefault();
		if (this.tokens.matches2(F._export, F.braceL)) return this.processNamedExports();
		if (this.tokens.matches2(F._export, F.name) && this.tokens.matchesContextualAtIndex(this.tokens.currentIndex() + 1, P._type)) {
			if (this.tokens.removeInitialToken(), this.tokens.removeToken(), this.tokens.matches1(F.braceL)) {
				for (; !this.tokens.matches1(F.braceR);) this.tokens.removeToken();
				this.tokens.removeToken();
			} else this.tokens.removeToken(), this.tokens.matches1(F._as) && (this.tokens.removeToken(), this.tokens.removeToken());
			return this.tokens.matchesContextual(P._from) && this.tokens.matches1AtIndex(this.tokens.currentIndex() + 1, F.string) && (this.tokens.removeToken(), this.tokens.removeToken(), Bf(this.tokens)), !0;
		}
		return !1;
	}
	processImportEquals() {
		let e = this.tokens.identifierNameAtIndex(this.tokens.currentIndex() + 1);
		return this.shouldAutomaticallyElideImportedName(e) ? If(this.tokens) : this.injectCreateRequireForImportRequire ? (this.tokens.replaceToken("const"), this.tokens.copyToken(), this.tokens.copyToken(), this.tokens.replaceToken(this.helperManager.getHelperName("require"))) : this.tokens.replaceToken("const"), !0;
	}
	processImport() {
		if (this.tokens.matches2(F._import, F.parenL)) return !1;
		let e = this.tokens.snapshot();
		if (this.removeImportTypeBindings()) {
			for (this.tokens.restoreToSnapshot(e); !this.tokens.matches1(F.string);) this.tokens.removeToken();
			this.tokens.removeToken(), Bf(this.tokens), this.tokens.matches1(F.semi) && this.tokens.removeToken();
		}
		return !0;
	}
	removeImportTypeBindings() {
		if (this.tokens.copyExpectedToken(F._import), this.tokens.matchesContextual(P._type) && !this.tokens.matches1AtIndex(this.tokens.currentIndex() + 1, F.comma) && !this.tokens.matchesContextualAtIndex(this.tokens.currentIndex() + 1, P._from)) return !0;
		if (this.tokens.matches1(F.string)) return this.tokens.copyToken(), !1;
		this.tokens.matchesContextual(P._module) && this.tokens.matchesContextualAtIndex(this.tokens.currentIndex() + 2, P._from) && this.tokens.copyToken();
		let e = !1, t = !1, n = !1;
		if (this.tokens.matches1(F.name) && (this.shouldAutomaticallyElideImportedName(this.tokens.identifierName()) ? (this.tokens.removeToken(), this.tokens.matches1(F.comma) && this.tokens.removeToken()) : (e = !0, this.tokens.copyToken(), this.tokens.matches1(F.comma) && (n = !0, this.tokens.removeToken()))), this.tokens.matches1(F.star)) this.shouldAutomaticallyElideImportedName(this.tokens.identifierNameAtRelativeIndex(2)) ? (this.tokens.removeToken(), this.tokens.removeToken(), this.tokens.removeToken()) : (n && this.tokens.appendCode(","), e = !0, this.tokens.copyExpectedToken(F.star), this.tokens.copyExpectedToken(F.name), this.tokens.copyExpectedToken(F.name));
		else if (this.tokens.matches1(F.braceL)) {
			for (n && this.tokens.appendCode(","), this.tokens.copyToken(); !this.tokens.matches1(F.braceR);) {
				t = !0;
				let n = Ca(this.tokens);
				if (n.isType || this.shouldAutomaticallyElideImportedName(n.rightName)) {
					for (; this.tokens.currentIndex() < n.endIndex;) this.tokens.removeToken();
					this.tokens.matches1(F.comma) && this.tokens.removeToken();
				} else {
					for (e = !0; this.tokens.currentIndex() < n.endIndex;) this.tokens.copyToken();
					this.tokens.matches1(F.comma) && this.tokens.copyToken();
				}
			}
			this.tokens.copyExpectedToken(F.braceR);
		}
		return this.keepUnusedImports ? !1 : this.isTypeScriptTransformEnabled ? !e : this.isFlowTransformEnabled ? t && !e : !1;
	}
	shouldAutomaticallyElideImportedName(e) {
		return this.isTypeScriptTransformEnabled && !this.keepUnusedImports && !this.nonTypeIdentifiers.has(e);
	}
	processExportDefault() {
		if (Vf(this.isTypeScriptTransformEnabled, this.keepUnusedImports, this.tokens, this.declarationInfo)) return this.tokens.removeInitialToken(), this.tokens.removeToken(), this.tokens.removeToken(), !0;
		if (!(this.tokens.matches4(F._export, F._default, F._function, F.name) || this.tokens.matches5(F._export, F._default, F.name, F._function, F.name) && this.tokens.matchesContextualAtIndex(this.tokens.currentIndex() + 2, P._async) || this.tokens.matches4(F._export, F._default, F._class, F.name) || this.tokens.matches5(F._export, F._default, F._abstract, F._class, F.name)) && this.reactHotLoaderTransformer) {
			let e = this.nameManager.claimFreeName("_default");
			return this.tokens.replaceToken(`let ${e}; export`), this.tokens.copyToken(), this.tokens.appendCode(` ${e} =`), this.reactHotLoaderTransformer.setExtractedDefaultExportName(e), !0;
		}
		return !1;
	}
	processNamedExports() {
		if (!this.isTypeScriptTransformEnabled) return !1;
		this.tokens.copyExpectedToken(F._export), this.tokens.copyExpectedToken(F.braceL);
		let e = zf(this.tokens), t = !1;
		for (; !this.tokens.matches1(F.braceR);) {
			let n = Ca(this.tokens);
			if (n.isType || !e && this.shouldElideExportedName(n.leftName)) {
				for (; this.tokens.currentIndex() < n.endIndex;) this.tokens.removeToken();
				this.tokens.matches1(F.comma) && this.tokens.removeToken();
			} else {
				for (t = !0; this.tokens.currentIndex() < n.endIndex;) this.tokens.copyToken();
				this.tokens.matches1(F.comma) && this.tokens.copyToken();
			}
		}
		return this.tokens.copyExpectedToken(F.braceR), !this.keepUnusedImports && e && !t && (this.tokens.removeToken(), this.tokens.removeToken(), Bf(this.tokens)), !0;
	}
	shouldElideExportedName(e) {
		return this.isTypeScriptTransformEnabled && !this.keepUnusedImports && this.declarationInfo.typeDeclarations.has(e) && !this.declarationInfo.valueDeclarations.has(e);
	}
}, Wf = class extends Oa {
	constructor(e, t, n) {
		super(), this.rootTransformer = e, this.tokens = t, this.isImportsTransformEnabled = n;
	}
	process() {
		return this.rootTransformer.processPossibleArrowParamEnd() || this.rootTransformer.processPossibleAsyncArrowWithTypeParams() || this.rootTransformer.processPossibleTypeRange() ? !0 : this.tokens.matches1(F._enum) ? (this.processEnum(), !0) : this.tokens.matches2(F._export, F._enum) ? (this.processNamedExportEnum(), !0) : this.tokens.matches3(F._export, F._default, F._enum) ? (this.processDefaultExportEnum(), !0) : !1;
	}
	processNamedExportEnum() {
		if (this.isImportsTransformEnabled) {
			this.tokens.removeInitialToken();
			let e = this.tokens.identifierNameAtRelativeIndex(1);
			this.processEnum(), this.tokens.appendCode(` exports.${e} = ${e};`);
		} else this.tokens.copyToken(), this.processEnum();
	}
	processDefaultExportEnum() {
		this.tokens.removeInitialToken(), this.tokens.removeToken();
		let e = this.tokens.identifierNameAtRelativeIndex(1);
		this.processEnum(), this.isImportsTransformEnabled ? this.tokens.appendCode(` exports.default = ${e};`) : this.tokens.appendCode(` export default ${e};`);
	}
	processEnum() {
		this.tokens.replaceToken("const"), this.tokens.copyExpectedToken(F.name);
		let e = !1;
		this.tokens.matchesContextual(P._of) && (this.tokens.removeToken(), e = this.tokens.matchesContextual(P._symbol), this.tokens.removeToken());
		let t = this.tokens.matches3(F.braceL, F.name, F.eq);
		this.tokens.appendCode(" = require(\"flow-enums-runtime\")");
		let n = !e && !t;
		for (this.tokens.replaceTokenTrimmingLeftWhitespace(n ? ".Mirrored([" : "({"); !this.tokens.matches1(F.braceR);) {
			if (this.tokens.matches1(F.ellipsis)) {
				this.tokens.removeToken();
				break;
			}
			this.processEnumElement(e, t), this.tokens.matches1(F.comma) && this.tokens.copyToken();
		}
		this.tokens.replaceToken(n ? "]);" : "});");
	}
	processEnumElement(e, t) {
		if (e) {
			let e = this.tokens.identifierName();
			this.tokens.copyToken(), this.tokens.appendCode(`: Symbol("${e}")`);
		} else t ? (this.tokens.copyToken(), this.tokens.replaceTokenTrimmingLeftWhitespace(":"), this.tokens.copyToken()) : this.tokens.replaceToken(`"${this.tokens.identifierName()}"`);
	}
};
// node_modules/sucrase/dist/esm/transformers/JestHoistTransformer.js
function Gf(e) {
	let t, n = e[0], r = 1;
	for (; r < e.length;) {
		let i = e[r], a = e[r + 1];
		if (r += 2, (i === "optionalAccess" || i === "optionalCall") && n == null) return;
		i === "access" || i === "optionalAccess" ? (t = n, n = a(n)) : (i === "call" || i === "optionalCall") && (n = a((...e) => n.call(t, ...e)), t = void 0);
	}
	return n;
}
var Kf = "jest", qf = [
	"mock",
	"unmock",
	"enableAutomock",
	"disableAutomock"
], Jf = class e extends Oa {
	__init() {
		this.hoistedFunctionNames = [];
	}
	constructor(t, n, r, i) {
		super(), this.rootTransformer = t, this.tokens = n, this.nameManager = r, this.importProcessor = i, e.prototype.__init.call(this);
	}
	process() {
		return this.tokens.currentToken().scopeDepth === 0 && this.tokens.matches4(F.name, F.dot, F.name, F.parenL) && this.tokens.identifierName() === Kf ? !Gf([
			this,
			"access",
			(e) => e.importProcessor,
			"optionalAccess",
			(e) => e.getGlobalNames,
			"call",
			(e) => e(),
			"optionalAccess",
			(e) => e.has,
			"call",
			(e) => e(Kf)
		]) && this.extractHoistedCalls() : !1;
	}
	getHoistedCode() {
		return this.hoistedFunctionNames.length > 0 ? this.hoistedFunctionNames.map((e) => `${e}();`).join("") : "";
	}
	extractHoistedCalls() {
		this.tokens.removeToken();
		let e = !1;
		for (; this.tokens.matches3(F.dot, F.name, F.parenL);) {
			let t = this.tokens.identifierNameAtIndex(this.tokens.currentIndex() + 1);
			if (qf.includes(t)) {
				let t = this.nameManager.claimFreeName("__jestHoist");
				this.hoistedFunctionNames.push(t), this.tokens.replaceToken(`function ${t}(){${Kf}.`), this.tokens.copyToken(), this.tokens.copyToken(), this.rootTransformer.processBalancedCode(), this.tokens.copyExpectedToken(F.parenR), this.tokens.appendCode(";}"), e = !1;
			} else e ? this.tokens.copyToken() : this.tokens.replaceToken(`${Kf}.`), this.tokens.copyToken(), this.tokens.copyToken(), this.rootTransformer.processBalancedCode(), this.tokens.copyExpectedToken(F.parenR), e = !0;
		}
		return !0;
	}
}, Yf = class extends Oa {
	constructor(e) {
		super(), this.tokens = e;
	}
	process() {
		if (this.tokens.matches1(F.num)) {
			let e = this.tokens.currentTokenCode();
			if (e.includes("_")) return this.tokens.replaceToken(e.replace(/_/g, "")), !0;
		}
		return !1;
	}
}, Xf = class extends Oa {
	constructor(e, t) {
		super(), this.tokens = e, this.nameManager = t;
	}
	process() {
		return this.tokens.matches2(F._catch, F.braceL) ? (this.tokens.copyToken(), this.tokens.appendCode(` (${this.nameManager.claimFreeName("e")})`), !0) : !1;
	}
}, Zf = class extends Oa {
	constructor(e, t) {
		super(), this.tokens = e, this.nameManager = t;
	}
	process() {
		if (this.tokens.matches1(F.nullishCoalescing)) {
			let e = this.tokens.currentToken();
			return this.tokens.tokens[e.nullishStartIndex].isAsyncOperation ? this.tokens.replaceTokenTrimmingLeftWhitespace(", async () => (") : this.tokens.replaceTokenTrimmingLeftWhitespace(", () => ("), !0;
		}
		if (this.tokens.matches1(F._delete) && this.tokens.tokenAtRelativeIndex(1).isOptionalChainStart) return this.tokens.removeInitialToken(), !0;
		let e = this.tokens.currentToken().subscriptStartIndex;
		if (e != null && this.tokens.tokens[e].isOptionalChainStart && this.tokens.tokenAtRelativeIndex(-1).type !== F._super) {
			let t = this.nameManager.claimFreeName("_"), n;
			if (n = e > 0 && this.tokens.matches1AtIndex(e - 1, F._delete) && this.isLastSubscriptInChain() ? `${t} => delete ${t}` : `${t} => ${t}`, this.tokens.tokens[e].isAsyncOperation && (n = `async ${n}`), this.tokens.matches2(F.questionDot, F.parenL) || this.tokens.matches2(F.questionDot, F.lessThan)) this.justSkippedSuper() && this.tokens.appendCode(".bind(this)"), this.tokens.replaceTokenTrimmingLeftWhitespace(`, 'optionalCall', ${n}`);
			else if (this.tokens.matches2(F.questionDot, F.bracketL)) this.tokens.replaceTokenTrimmingLeftWhitespace(`, 'optionalAccess', ${n}`);
			else if (this.tokens.matches1(F.questionDot)) this.tokens.replaceTokenTrimmingLeftWhitespace(`, 'optionalAccess', ${n}.`);
			else if (this.tokens.matches1(F.dot)) this.tokens.replaceTokenTrimmingLeftWhitespace(`, 'access', ${n}.`);
			else if (this.tokens.matches1(F.bracketL)) this.tokens.replaceTokenTrimmingLeftWhitespace(`, 'access', ${n}[`);
			else if (this.tokens.matches1(F.parenL)) this.justSkippedSuper() && this.tokens.appendCode(".bind(this)"), this.tokens.replaceTokenTrimmingLeftWhitespace(`, 'call', ${n}(`);
			else throw Error("Unexpected subscript operator in optional chain.");
			return !0;
		}
		return !1;
	}
	isLastSubscriptInChain() {
		let e = 0;
		for (let t = this.tokens.currentIndex() + 1;; t++) {
			if (t >= this.tokens.tokens.length) throw Error("Reached the end of the code while finding the end of the access chain.");
			if (this.tokens.tokens[t].isOptionalChainStart ? e++ : this.tokens.tokens[t].isOptionalChainEnd && e--, e < 0) return !0;
			if (e === 0 && this.tokens.tokens[t].subscriptStartIndex != null) return !1;
		}
	}
	justSkippedSuper() {
		let e = 0, t = this.tokens.currentIndex() - 1;
		for (;;) {
			if (t < 0) throw Error("Reached the start of the code while finding the start of the access chain.");
			if (this.tokens.tokens[t].isOptionalChainStart ? e-- : this.tokens.tokens[t].isOptionalChainEnd && e++, e < 0) return !1;
			if (e === 0 && this.tokens.tokens[t].subscriptStartIndex != null) return this.tokens.tokens[t - 1].type === F._super;
			t--;
		}
	}
}, Qf = class extends Oa {
	constructor(e, t, n, r) {
		super(), this.rootTransformer = e, this.tokens = t, this.importProcessor = n, this.options = r;
	}
	process() {
		let e = this.tokens.currentIndex();
		if (this.tokens.identifierName() === "createReactClass") {
			let t = this.importProcessor && this.importProcessor.getIdentifierReplacement("createReactClass");
			return t ? this.tokens.replaceToken(`(0, ${t})`) : this.tokens.copyToken(), this.tryProcessCreateClassCall(e), !0;
		}
		if (this.tokens.matches3(F.name, F.dot, F.name) && this.tokens.identifierName() === "React" && this.tokens.identifierNameAtIndex(this.tokens.currentIndex() + 2) === "createClass") {
			let t = this.importProcessor && this.importProcessor.getIdentifierReplacement("React") || "React";
			return t ? (this.tokens.replaceToken(t), this.tokens.copyToken(), this.tokens.copyToken()) : (this.tokens.copyToken(), this.tokens.copyToken(), this.tokens.copyToken()), this.tryProcessCreateClassCall(e), !0;
		}
		return !1;
	}
	tryProcessCreateClassCall(e) {
		let t = this.findDisplayName(e);
		t && this.classNeedsDisplayName() && (this.tokens.copyExpectedToken(F.parenL), this.tokens.copyExpectedToken(F.braceL), this.tokens.appendCode(`displayName: '${t}',`), this.rootTransformer.processBalancedCode(), this.tokens.copyExpectedToken(F.braceR), this.tokens.copyExpectedToken(F.parenR));
	}
	findDisplayName(e) {
		return e < 2 ? null : this.tokens.matches2AtIndex(e - 2, F.name, F.eq) || e >= 2 && this.tokens.tokens[e - 2].identifierRole === W.ObjectKey ? this.tokens.identifierNameAtIndex(e - 2) : this.tokens.matches2AtIndex(e - 2, F._export, F._default) ? this.getDisplayNameFromFilename() : null;
	}
	getDisplayNameFromFilename() {
		let e = (this.options.filePath || "unknown").split("/"), t = e[e.length - 1], n = t.lastIndexOf("."), r = n === -1 ? t : t.slice(0, n);
		return r === "index" && e[e.length - 2] ? e[e.length - 2] : r;
	}
	classNeedsDisplayName() {
		let e = this.tokens.currentIndex();
		if (!this.tokens.matches2(F.parenL, F.braceL)) return !1;
		let t = e + 1, n = this.tokens.tokens[t].contextId;
		if (n == null) throw Error("Expected non-null context ID on object open-brace.");
		for (; e < this.tokens.tokens.length; e++) {
			let t = this.tokens.tokens[e];
			if (t.type === F.braceR && t.contextId === n) {
				e++;
				break;
			}
			if (this.tokens.identifierNameAtIndex(e) === "displayName" && this.tokens.tokens[e].identifierRole === W.ObjectKey && t.contextId === n) return !1;
		}
		if (e === this.tokens.tokens.length) throw Error("Unexpected end of input when processing React class.");
		return this.tokens.matches1AtIndex(e, F.parenR) || this.tokens.matches2AtIndex(e, F.comma, F.parenR);
	}
}, $f = class e extends Oa {
	__init() {
		this.extractedDefaultExportName = null;
	}
	constructor(t, n) {
		super(), this.tokens = t, this.filePath = n, e.prototype.__init.call(this);
	}
	setExtractedDefaultExportName(e) {
		this.extractedDefaultExportName = e;
	}
	getPrefixCode() {
		return "\n      (function () {\n        var enterModule = require('react-hot-loader').enterModule;\n        enterModule && enterModule(module);\n      })();".replace(/\s+/g, " ").trim();
	}
	getSuffixCode() {
		let e = /* @__PURE__ */ new Set();
		for (let t of this.tokens.tokens) !t.isType && Ri(t) && t.identifierRole !== W.ImportDeclaration && e.add(this.tokens.identifierNameForToken(t));
		let t = Array.from(e).map((e) => ({
			variableName: e,
			uniqueLocalName: e
		}));
		return this.extractedDefaultExportName && t.push({
			variableName: this.extractedDefaultExportName,
			uniqueLocalName: "default"
		}), `
;(function () {
  var reactHotLoader = require('react-hot-loader').default;
  var leaveModule = require('react-hot-loader').leaveModule;
  if (!reactHotLoader) {
    return;
  }
${t.map(({ variableName: e, uniqueLocalName: t }) => `  reactHotLoader.register(${e}, "${t}", ${JSON.stringify(this.filePath || "")});`).join("\n")}
  leaveModule(module);
})();`;
	}
	process() {
		return !1;
	}
}, ep = /* @__PURE__ */ new Set(/* @__PURE__ */ "break.case.catch.class.const.continue.debugger.default.delete.do.else.export.extends.finally.for.function.if.import.in.instanceof.new.return.super.switch.this.throw.try.typeof.var.void.while.with.yield.enum.implements.interface.let.package.private.protected.public.static.await.false.null.true".split("."));
function tp(e) {
	if (e.length === 0 || !Mi[e.charCodeAt(0)]) return !1;
	for (let t = 1; t < e.length; t++) if (!ji[e.charCodeAt(t)]) return !1;
	return !ep.has(e);
}
// node_modules/sucrase/dist/esm/transformers/TypeScriptTransformer.js
var np = class extends Oa {
	constructor(e, t, n) {
		super(), this.rootTransformer = e, this.tokens = t, this.isImportsTransformEnabled = n;
	}
	process() {
		return this.rootTransformer.processPossibleArrowParamEnd() || this.rootTransformer.processPossibleAsyncArrowWithTypeParams() || this.rootTransformer.processPossibleTypeRange() ? !0 : this.tokens.matches1(F._public) || this.tokens.matches1(F._protected) || this.tokens.matches1(F._private) || this.tokens.matches1(F._abstract) || this.tokens.matches1(F._readonly) || this.tokens.matches1(F._override) || this.tokens.matches1(F.nonNullAssertion) ? (this.tokens.removeInitialToken(), !0) : this.tokens.matches1(F._enum) || this.tokens.matches2(F._const, F._enum) ? (this.processEnum(), !0) : this.tokens.matches2(F._export, F._enum) || this.tokens.matches3(F._export, F._const, F._enum) ? (this.processEnum(!0), !0) : !1;
	}
	processEnum(e = !1) {
		for (this.tokens.removeInitialToken(); this.tokens.matches1(F._const) || this.tokens.matches1(F._enum);) this.tokens.removeToken();
		let t = this.tokens.identifierName();
		this.tokens.removeToken(), e && !this.isImportsTransformEnabled && this.tokens.appendCode("export "), this.tokens.appendCode(`var ${t}; (function (${t})`), this.tokens.copyExpectedToken(F.braceL), this.processEnumBody(t), this.tokens.copyExpectedToken(F.braceR), e && this.isImportsTransformEnabled ? this.tokens.appendCode(`)(${t} || (exports.${t} = ${t} = {}));`) : this.tokens.appendCode(`)(${t} || (${t} = {}));`);
	}
	processEnumBody(e) {
		let t = null;
		for (; !this.tokens.matches1(F.braceR);) {
			let { nameStringCode: n, variableName: r } = this.extractEnumKeyInfo(this.tokens.currentToken());
			this.tokens.removeInitialToken(), this.tokens.matches3(F.eq, F.string, F.comma) || this.tokens.matches3(F.eq, F.string, F.braceR) ? this.processStringLiteralEnumMember(e, n, r) : this.tokens.matches1(F.eq) ? this.processExplicitValueEnumMember(e, n, r) : this.processImplicitValueEnumMember(e, n, r, t), this.tokens.matches1(F.comma) && this.tokens.removeToken(), t = r ?? `${e}[${n}]`;
		}
	}
	extractEnumKeyInfo(e) {
		if (e.type === F.name) {
			let t = this.tokens.identifierNameForToken(e);
			return {
				nameStringCode: `"${t}"`,
				variableName: tp(t) ? t : null
			};
		}
		if (e.type === F.string) {
			let t = this.tokens.stringValueForToken(e);
			return {
				nameStringCode: this.tokens.code.slice(e.start, e.end),
				variableName: tp(t) ? t : null
			};
		}
		throw Error("Expected name or string at beginning of enum element.");
	}
	processStringLiteralEnumMember(e, t, n) {
		n == null ? (this.tokens.appendCode(`${e}[${t}]`), this.tokens.copyToken(), this.tokens.copyToken(), this.tokens.appendCode(";")) : (this.tokens.appendCode(`const ${n}`), this.tokens.copyToken(), this.tokens.copyToken(), this.tokens.appendCode(`; ${e}[${t}] = ${n};`));
	}
	processExplicitValueEnumMember(e, t, n) {
		let r = this.tokens.currentToken().rhsEndIndex;
		if (r == null) throw Error("Expected rhsEndIndex on enum assign.");
		if (n != null) {
			for (this.tokens.appendCode(`const ${n}`), this.tokens.copyToken(); this.tokens.currentIndex() < r;) this.rootTransformer.processToken();
			this.tokens.appendCode(`; ${e}[${e}[${t}] = ${n}] = ${t};`);
		} else {
			for (this.tokens.appendCode(`${e}[${e}[${t}]`), this.tokens.copyToken(); this.tokens.currentIndex() < r;) this.rootTransformer.processToken();
			this.tokens.appendCode(`] = ${t};`);
		}
	}
	processImplicitValueEnumMember(e, t, n, r) {
		let i = r == null ? "0" : `${r} + 1`;
		n != null && (this.tokens.appendCode(`const ${n} = ${i}; `), i = n), this.tokens.appendCode(`${e}[${e}[${t}] = ${i}] = ${t};`);
	}
}, rp = class e {
	__init() {
		this.transformers = [];
	}
	__init2() {
		this.generatedVariables = [];
	}
	constructor(t, n, r, i) {
		e.prototype.__init.call(this), e.prototype.__init2.call(this), this.nameManager = t.nameManager, this.helperManager = t.helperManager;
		let { tokenProcessor: a, importProcessor: o } = t;
		this.tokens = a, this.isImportsTransformEnabled = n.includes("imports"), this.isReactHotLoaderTransformEnabled = n.includes("react-hot-loader"), this.disableESTransforms = !!i.disableESTransforms, i.disableESTransforms || (this.transformers.push(new Zf(a, this.nameManager)), this.transformers.push(new Yf(a)), this.transformers.push(new Xf(a, this.nameManager))), n.includes("jsx") && (i.jsxRuntime !== "preserve" && this.transformers.push(new ka(this, a, o, this.nameManager, i)), this.transformers.push(new Qf(this, a, o, i)));
		let s = null;
		if (n.includes("react-hot-loader")) {
			if (!i.filePath) throw Error("filePath is required when using the react-hot-loader transform.");
			s = new $f(a, i.filePath), this.transformers.push(s);
		}
		if (n.includes("imports")) {
			if (o === null) throw Error("Expected non-null importProcessor with imports transform enabled.");
			this.transformers.push(new Hf(this, a, o, this.nameManager, this.helperManager, s, r, !!i.enableLegacyTypeScriptModuleInterop, n.includes("typescript"), n.includes("flow"), !!i.preserveDynamicImport, !!i.keepUnusedImports));
		} else this.transformers.push(new Uf(a, this.nameManager, this.helperManager, s, n.includes("typescript"), n.includes("flow"), !!i.keepUnusedImports, i));
		n.includes("flow") && this.transformers.push(new Wf(this, a, n.includes("imports"))), n.includes("typescript") && this.transformers.push(new np(this, a, n.includes("imports"))), n.includes("jest") && this.transformers.push(new Jf(this, a, this.nameManager, o));
	}
	transform() {
		this.tokens.reset(), this.processBalancedCode();
		let e = this.isImportsTransformEnabled ? "\"use strict\";" : "";
		for (let t of this.transformers) e += t.getPrefixCode();
		e += this.helperManager.emitHelpers(), e += this.generatedVariables.map((e) => ` var ${e};`).join("");
		for (let t of this.transformers) e += t.getHoistedCode();
		let t = "";
		for (let e of this.transformers) t += e.getSuffixCode();
		let n = this.tokens.finish(), { code: r } = n;
		if (r.startsWith("#!")) {
			let i = r.indexOf("\n");
			return i === -1 && (i = r.length, r += "\n"), {
				code: r.slice(0, i + 1) + e + r.slice(i + 1) + t,
				mappings: this.shiftMappings(n.mappings, e.length)
			};
		}
		return {
			code: e + r + t,
			mappings: this.shiftMappings(n.mappings, e.length)
		};
	}
	processBalancedCode() {
		let e = 0, t = 0;
		for (; !this.tokens.isAtEnd();) {
			if (this.tokens.matches1(F.braceL) || this.tokens.matches1(F.dollarBraceL)) e++;
			else if (this.tokens.matches1(F.braceR)) {
				if (e === 0) return;
				e--;
			}
			if (this.tokens.matches1(F.parenL)) t++;
			else if (this.tokens.matches1(F.parenR)) {
				if (t === 0) return;
				t--;
			}
			this.processToken();
		}
	}
	processToken() {
		if (this.tokens.matches1(F._class)) this.processClass();
		else {
			for (let e of this.transformers) if (e.process()) return;
			this.tokens.copyToken();
		}
	}
	processNamedClass() {
		if (!this.tokens.matches2(F._class, F.name)) throw Error("Expected identifier for exported class name.");
		let e = this.tokens.identifierNameAtIndex(this.tokens.currentIndex() + 1);
		return this.processClass(), e;
	}
	processClass() {
		let e = Af(this, this.tokens, this.nameManager, this.disableESTransforms), t = (e.headerInfo.isExpression || !e.headerInfo.className) && e.staticInitializerNames.length + e.instanceInitializerNames.length > 0, n = e.headerInfo.className;
		t && (n = this.nameManager.claimFreeName("_class"), this.generatedVariables.push(n), this.tokens.appendCode(` (${n} =`));
		let r = this.tokens.currentToken().contextId;
		if (r == null) throw Error("Expected class to have a context ID.");
		for (this.tokens.copyExpectedToken(F._class); !this.tokens.matchesContextIdAndLabel(F.braceL, r);) this.processToken();
		this.processClassBody(e, n);
		let i = e.staticInitializerNames.map((e) => `${n}.${e}()`);
		t ? this.tokens.appendCode(`, ${i.map((e) => `${e}, `).join("")}${n})`) : e.staticInitializerNames.length > 0 && this.tokens.appendCode(` ${i.map((e) => `${e};`).join(" ")}`);
	}
	processClassBody(e, t) {
		let { headerInfo: n, constructorInsertPos: r, constructorInitializerStatements: i, fields: a, instanceInitializerNames: o, rangesToRemove: s } = e, c = 0, l = 0, u = this.tokens.currentToken().contextId;
		if (u == null) throw Error("Expected non-null context ID on class.");
		this.tokens.copyExpectedToken(F.braceL), this.isReactHotLoaderTransformEnabled && this.tokens.appendCode("__reactstandin__regenerateByEval(key, code) {this[key] = eval(code);}");
		let d = i.length + o.length > 0;
		if (r === null && d) {
			let e = this.makeConstructorInitCode(i, o, t);
			if (n.hasSuperclass) {
				let t = this.nameManager.claimFreeName("args");
				this.tokens.appendCode(`constructor(...${t}) { super(...${t}); ${e}; }`);
			} else this.tokens.appendCode(`constructor() { ${e}; }`);
		}
		for (; !this.tokens.matchesContextIdAndLabel(F.braceR, u);) if (c < a.length && this.tokens.currentIndex() === a[c].start) {
			let e = !1;
			for (this.tokens.matches1(F.bracketL) ? this.tokens.copyTokenWithPrefix(`${a[c].initializerName}() {this`) : this.tokens.matches1(F.string) || this.tokens.matches1(F.num) ? (this.tokens.copyTokenWithPrefix(`${a[c].initializerName}() {this[`), e = !0) : this.tokens.copyTokenWithPrefix(`${a[c].initializerName}() {this.`); this.tokens.currentIndex() < a[c].end;) e && this.tokens.currentIndex() === a[c].equalsIndex && this.tokens.appendCode("]"), this.processToken();
			this.tokens.appendCode("}"), c++;
		} else if (l < s.length && this.tokens.currentIndex() >= s[l].start) {
			for (this.tokens.currentIndex() < s[l].end && this.tokens.removeInitialToken(); this.tokens.currentIndex() < s[l].end;) this.tokens.removeToken();
			l++;
		} else this.tokens.currentIndex() === r && (this.tokens.copyToken(), d && this.tokens.appendCode(`;${this.makeConstructorInitCode(i, o, t)};`)), this.processToken();
		this.tokens.copyExpectedToken(F.braceR);
	}
	makeConstructorInitCode(e, t, n) {
		return [...e, ...t.map((e) => `${n}.prototype.${e}.call(this)`)].join(";");
	}
	processPossibleArrowParamEnd() {
		if (this.tokens.matches2(F.parenR, F.colon) && this.tokens.tokenAtRelativeIndex(1).isType) {
			let e = this.tokens.currentIndex() + 1;
			for (; this.tokens.tokens[e].isType;) e++;
			if (this.tokens.matches1AtIndex(e, F.arrow)) {
				for (this.tokens.removeInitialToken(); this.tokens.currentIndex() < e;) this.tokens.removeToken();
				return this.tokens.replaceTokenTrimmingLeftWhitespace(") =>"), !0;
			}
		}
		return !1;
	}
	processPossibleAsyncArrowWithTypeParams() {
		if (!this.tokens.matchesContextual(P._async) && !this.tokens.matches1(F._async)) return !1;
		let e = this.tokens.tokenAtRelativeIndex(1);
		if (e.type !== F.lessThan || !e.isType) return !1;
		let t = this.tokens.currentIndex() + 1;
		for (; this.tokens.tokens[t].isType;) t++;
		if (this.tokens.matches1AtIndex(t, F.parenL)) {
			for (this.tokens.replaceToken("async ("), this.tokens.removeInitialToken(); this.tokens.currentIndex() < t;) this.tokens.removeToken();
			return this.tokens.removeToken(), this.processBalancedCode(), this.processToken(), !0;
		}
		return !1;
	}
	processPossibleTypeRange() {
		if (this.tokens.currentToken().isType) {
			for (this.tokens.removeInitialToken(); this.tokens.currentToken().isType;) this.tokens.removeToken();
			return !0;
		}
		return !1;
	}
	shiftMappings(e, t) {
		for (let n = 0; n < e.length; n++) {
			let r = e[n];
			r !== void 0 && (e[n] = r + t);
		}
		return e;
	}
};
(/* @__PURE__ */ t(((e) => {
	e.__esModule = !0, e.LinesAndColumns = void 0;
	var t = "\n", n = "\r";
	e.LinesAndColumns = function() {
		function e(e) {
			this.string = e;
			for (var r = [0], i = 0; i < e.length;) switch (e[i]) {
				case t:
					i += t.length, r.push(i);
					break;
				case n:
					i += n.length, e[i] === t && (i += t.length), r.push(i);
					break;
				default: i++;
			}
			this.offsets = r;
		}
		return e.prototype.locationForIndex = function(e) {
			if (e < 0 || e > this.string.length) return null;
			for (var t = 0, n = this.offsets; n[t + 1] <= e;) t++;
			var r = e - n[t];
			return {
				line: t,
				column: r
			};
		}, e.prototype.indexForLocation = function(e) {
			var t = e.line, n = e.column;
			return t < 0 || t >= this.offsets.length || n < 0 || n > this.lengthOfLine(t) ? null : this.offsets[t] + n;
		}, e.prototype.lengthOfLine = function(e) {
			var t = this.offsets[e];
			return (e === this.offsets.length - 1 ? this.string.length : this.offsets[e + 1]) - t;
		}, e;
	}();
})))();
// node_modules/sucrase/dist/esm/util/getTSImportedNames.js
function ip(e) {
	let t = /* @__PURE__ */ new Set();
	for (let n = 0; n < e.tokens.length; n++) e.matches1AtIndex(n, F._import) && !e.matches3AtIndex(n, F._import, F.name, F.eq) && ap(e, n, t);
	return t;
}
function ap(e, t, n) {
	t++, !e.matches1AtIndex(t, F.parenL) && (e.matches1AtIndex(t, F.name) && (n.add(e.identifierNameAtIndex(t)), t++, e.matches1AtIndex(t, F.comma) && t++), e.matches1AtIndex(t, F.star) && (t += 2, n.add(e.identifierNameAtIndex(t)), t++), e.matches1AtIndex(t, F.braceL) && (t++, op(e, t, n)));
}
function op(e, t, n) {
	for (;;) {
		if (e.matches1AtIndex(t, F.braceR)) return;
		let r = Ca(e, t);
		if (t = r.endIndex, r.isType || n.add(r.rightName), e.matches2AtIndex(t, F.comma, F.braceR) || e.matches1AtIndex(t, F.braceR)) return;
		if (e.matches1AtIndex(t, F.comma)) t++;
		else throw Error(`Unexpected token: ${JSON.stringify(e.tokens[t])}`);
	}
}
// node_modules/sucrase/dist/esm/index.js
function sp(e, t) {
	Po(t);
	try {
		let n = cp(e, t), r = new rp(n, t.transforms, !!t.enableLegacyBabel5ModuleInterop, t).transform(), i = { code: r.code };
		if (t.sourceMapOptions) {
			if (!t.filePath) throw Error("filePath must be specified when generating a source map.");
			i = {
				...i,
				sourceMap: yo(r, t.filePath, t.sourceMapOptions, e, n.tokenProcessor.tokens)
			};
		}
		return i;
	} catch (e) {
		throw t.filePath && (e.message = `Error transforming ${t.filePath}: ${e.message}`), e;
	}
}
function cp(e, t) {
	let n = t.transforms.includes("jsx"), r = t.transforms.includes("typescript"), i = t.transforms.includes("flow"), a = t.disableESTransforms === !0, o = Df(e, n, r, i), s = o.tokens, c = o.scopes, l = new Oo(e, s), u = new So(l), d = new kf(e, s, i, a, u), f = !!t.enableLegacyTypeScriptModuleInterop, p = null;
	return t.transforms.includes("imports") ? (p = new Ra(l, d, f, t, t.transforms.includes("typescript"), !!t.keepUnusedImports, u), p.preprocessTokens(), Co(d, c, p.getGlobalNames()), t.transforms.includes("typescript") && !t.keepUnusedImports && p.pruneTypeOnlyImports()) : t.transforms.includes("typescript") && !t.keepUnusedImports && Co(d, c, ip(d)), {
		tokenProcessor: d,
		scopes: c,
		nameManager: l,
		importProcessor: p,
		helperManager: u
	};
}
// node_modules/stylis/src/Enum.js
var lp = "comm", up = "rule", dp = "decl", fp = "@media", pp = "@import", mp = "@supports", hp = "@namespace", gp = "@keyframes", _p = "@font-face", vp = "@layer", yp = Math.abs, bp = String.fromCharCode;
function xp(e) {
	return e.trim();
}
function Sp(e, t, n) {
	return e.replace(t, n);
}
function Cp(e, t) {
	return e.charCodeAt(t) | 0;
}
function wp(e, t, n) {
	return e.slice(t, n);
}
function Tp(e) {
	return e.length;
}
function Ep(e) {
	return e.length;
}
function Dp(e, t) {
	return t.push(e), e;
}
// node_modules/stylis/src/Tokenizer.js
var Op = 1, kp = 1, Ap = 0, jp = 0, Mp = 0, Np = "";
function Pp(e, t, n, r, i, a, o, s) {
	return {
		value: e,
		root: t,
		parent: n,
		type: r,
		props: i,
		children: a,
		line: Op,
		column: kp,
		length: o,
		return: "",
		siblings: s
	};
}
function Fp() {
	return Mp;
}
function Ip() {
	return Mp = jp > 0 ? Cp(Np, --jp) : 0, kp--, Mp === 10 && (kp = 1, Op--), Mp;
}
function Lp() {
	return Mp = jp < Ap ? Cp(Np, jp++) : 0, kp++, Mp === 10 && (kp = 1, Op++), Mp;
}
function Rp() {
	return Cp(Np, jp);
}
function zp() {
	return jp;
}
function Bp(e, t) {
	return wp(Np, e, t);
}
function Vp(e) {
	switch (e) {
		case 0:
		case 9:
		case 10:
		case 13:
		case 32: return 5;
		case 33:
		case 43:
		case 44:
		case 47:
		case 62:
		case 64:
		case 126:
		case 59:
		case 123:
		case 125: return 4;
		case 58: return 3;
		case 34:
		case 39:
		case 40:
		case 91: return 2;
		case 41:
		case 93: return 1;
	}
	return 0;
}
function Hp(e) {
	return Op = kp = 1, Ap = Tp(Np = e), jp = 0, [];
}
function Up(e) {
	return Np = "", e;
}
function Wp(e) {
	return xp(Bp(jp - 1, qp(e === 91 ? e + 2 : e === 40 ? e + 1 : e)));
}
function Gp(e) {
	for (; (Mp = Rp()) && Mp < 33;) Lp();
	return Vp(e) > 2 || Vp(Mp) > 3 ? "" : " ";
}
function Kp(e, t) {
	for (; --t && Lp() && !(Mp < 48 || Mp > 102 || Mp > 57 && Mp < 65 || Mp > 70 && Mp < 97););
	return Bp(e, zp() + (t < 6 && Rp() == 32 && Lp() == 32));
}
function qp(e) {
	for (; Lp();) switch (Mp) {
		case e: return jp;
		case 34:
		case 39:
			e !== 34 && e !== 39 && qp(Mp);
			break;
		case 40:
			e === 41 && qp(e);
			break;
		case 92: Lp();
	}
	return jp;
}
function Jp(e, t) {
	for (; Lp() && e + Mp !== 57 && (e + Mp !== 84 || Rp() !== 47););
	return "/*" + Bp(t, jp - 1) + "*" + bp(e === 47 ? e : Lp());
}
function Yp(e) {
	for (; !Vp(Rp());) Lp();
	return Bp(e, jp);
}
// node_modules/stylis/src/Parser.js
function Xp(e) {
	return Up(Zp("", null, null, null, [""], e = Hp(e), 0, [0], e));
}
function Zp(e, t, n, r, i, a, o, s, c) {
	for (var l = 0, u = 0, d = o, f = 0, p = 0, m = 0, h = 1, g = 1, _ = 1, v = 0, y = 0, b = "", x = i, S = a, C = r, w = b; g;) switch (m = y, y = Lp()) {
		case 40:
			m != 108 && Cp(w, d - 1) == 58 ? (v++, w += "(") : w += Wp(y);
			break;
		case 41:
			v--, w += ")";
			break;
		case 34:
		case 39:
		case 91:
			w += Wp(y);
			break;
		case 9:
		case 10:
		case 13:
		case 32:
			if (v > 0) {
				w += bp(y);
				break;
			}
			w += Gp(m);
			break;
		case 92:
			w += Kp(zp() - 1, 7);
			continue;
		case 47:
			switch (Rp()) {
				case 42:
				case 47:
					Dp($p(Jp(Lp(), zp()), t, n, c), c), (Vp(m || 1) == 5 || Vp(Rp() || 1) == 5) && Tp(w) && wp(w, -1, void 0) !== " " && (w += " ");
					break;
				default: w += "/";
			}
			break;
		case 123 * h: s[l++] = Tp(w) * _;
		case 125 * h:
		case 59:
		case 0:
			if (v > 0 && y) {
				w += bp(y);
				break;
			}
			switch (y) {
				case 0:
				case 125: g = 0;
				case 59 + u:
					_ == -1 && (w = Sp(w, /\f/g, "")), p > 0 && (Tp(w) - d || h === 0) && Dp(p > 32 ? em(w + ";", r, n, d - 1, c) : em(Sp(w, " ", "") + ";", r, n, d - 2, c), c);
					break;
				case 59: w += ";";
				default: if (Dp(C = Qp(w, t, n, l, u, i, s, b, x = [], S = [], d, a), a), y === 123) {
					if (u === 0) Zp(w, t, C, C, x, a, d, s, S);
					else {
						switch (f) {
							case 99: if (Cp(w, 3) === 110) break;
							case 108: if (Cp(w, 2) === 97) break;
							default: u = 0;
							case 100:
							case 109:
							case 115:
						}
						u ? Zp(e, C, C, r && Dp(Qp(e, C, C, 0, 0, i, s, b, i, x = [], d, S), S), i, S, d, s, r ? x : S) : Zp(w, C, C, C, [""], S, 0, s, S);
					}
				}
			}
			l = u = p = 0, h = _ = 1, b = w = "", d = o;
			break;
		case 58: d = 1 + Tp(w), p = m;
		default:
			if (h < 1) {
				if (y == 123) --h;
				else if (y == 125 && h++ == 0 && Ip() == 125) continue;
			}
			switch (w += bp(y), y * h) {
				case 38:
					_ = u > 0 ? 1 : (w += "\f", -1);
					break;
				case 44:
					if (v > 0) break;
					s[l++] = (Tp(w) - 1) * _, _ = 1;
					break;
				case 64:
					Rp() === 45 && (w += Wp(Lp())), f = Rp(), u = d = Tp(b = w += Yp(zp())), y++;
					break;
				case 45: m === 45 && Tp(w) == 2 && (h = 0);
			}
	}
	return a;
}
function Qp(e, t, n, r, i, a, o, s, c, l, u, d) {
	for (var f = i - 1, p = i === 0 ? a : [""], m = Ep(p), h = 0, g = 0, _ = 0; h < r; ++h) for (var v = 0, y = wp(e, f + 1, f = yp(g = o[h])), b = e; v < m; ++v) (b = xp(g > 0 ? p[v] + " " + y : Sp(y, /&\f/g, p[v]))) && (c[_++] = b);
	return Pp(e, t, n, i === 0 ? up : s, c, l, u, d);
}
function $p(e, t, n, r) {
	return Pp(e, t, n, lp, bp(Fp()), wp(e, 2, -2), 0, r);
}
function em(e, t, n, r, i) {
	return Pp(e, t, n, dp, wp(e, 0, r), wp(e, r + 1, -1), r, i);
}
// node_modules/stylis/src/Serializer.js
function tm(e, t) {
	for (var n = "", r = 0; r < e.length; r++) n += t(e[r], r, e, t) || "";
	return n;
}
function nm(e, t, n, r) {
	switch (e.type) {
		case vp: if (e.children.length) break;
		case pp:
		case hp:
		case dp: return e.return = e.return || e.value;
		case lp: return "";
		case gp: return e.return = e.value + "{" + tm(e.children, r) + "}";
		case up: if (!Tp(e.value = e.props.join(","))) return "";
	}
	return Tp(n = tm(e.children, r)) ? e.return = e.value + "{" + n + "}" : "";
}
// libs/sdk/react/src/lib/custom-component-runtime/utils.ts
function rm(e) {
	let t = 5381;
	for (let n = 0; n < e.length; n++) t = (t << 5) + t + e.charCodeAt(n) >>> 0;
	return t;
}
function im(e) {
	return rm(e).toString(16).padStart(8, "0").slice(0, 6);
}
function am(e) {
	return rm(e).toString(16).padStart(8, "0");
}
// libs/sdk/react/src/lib/custom-component-runtime/css-scoper.ts
function om(e) {
	return `flx-cc-${im(e)}`;
}
function sm(e, t) {
	if (!e || !e.trim()) return "";
	let n = `.${t}`, r = Xp(e), i = [], a = /* @__PURE__ */ new Map();
	cm(r, t, a);
	let o = lm(r, n, t, a, i);
	return i.length > 0 ? i.join("") + o : o;
}
function cm(e, t, n) {
	for (let r of e) if (r.type === "@keyframes") {
		let e = r.props[0];
		e && n.set(e, `${t}-${e}`);
	} else (r.type === "@media" || r.type === "@supports") && Array.isArray(r.children) && cm(r.children, t, n);
}
function lm(e, t, n, r, i) {
	let a = "";
	for (let o of e) switch (o.type) {
		case lp: break;
		case pp:
			i.push(o.value + "");
			break;
		case _p:
			a += tm([o], nm);
			break;
		case gp: {
			let e = o.props[0], t = r.get(e) ?? e;
			a += `@keyframes ${t}{`, a += tm(o.children, nm), a += "}";
			break;
		}
		case fp:
		case mp: {
			let e = [], s = lm(o.children, t, n, r, e);
			i.push(...e), a += `${o.value}{${s}}`;
			break;
		}
		case up: {
			let e = o.props.map((e) => `${t} ${e}`).join(","), n = um(o.children, r);
			a += `${e}{${n}}`;
			break;
		}
		default: a += tm([o], nm);
	}
	return a;
}
function um(e, t) {
	let n = "";
	for (let r of e) if (r.type === "decl") {
		let e = r.props;
		t.size > 0 && (e === "animation" || e === "animation-name") ? n += dm(r.value, t) : n += r.value;
	}
	return n;
}
function dm(e, t) {
	let n = e.indexOf(":");
	if (n === -1) return e;
	let r = e.slice(0, n + 1), i = e.slice(n + 1);
	for (let [e, n] of t) {
		let t = RegExp(`\\b${fm(e)}\\b`, "g");
		i = i.replace(t, n);
	}
	return r + i;
}
function fm(e) {
	return e.replace(/[.*+?^${}()|[\]\\]/g, "\\$&");
}
var pm = /* @__PURE__ */ new Map();
function mm(e, t) {
	let n = A(t);
	n.current = t, Vn(() => {
		if (!e) return;
		let t = n.current, r = pm.get(t);
		if (r) r.count++, r.element.textContent = e;
		else {
			let n = document.createElement("style");
			n.setAttribute("data-flx-cc", t), n.textContent = e, document.head.appendChild(n), pm.set(t, {
				element: n,
				count: 1
			});
		}
		return () => {
			let e = pm.get(t);
			e && (e.count--, e.count <= 0 && (e.element.remove(), pm.delete(t)));
		};
	}, [e, t]);
}
// node_modules/@emotion/sheet/dist/emotion-sheet.esm.js
function hm(e) {
	if (e.sheet) return e.sheet;
	/* istanbul ignore next */
	for (var t = 0; t < document.styleSheets.length; t++) if (document.styleSheets[t].ownerNode === e) return document.styleSheets[t];
}
function gm(e) {
	var t = document.createElement("style");
	return t.setAttribute("data-emotion", e.key), e.nonce !== void 0 && t.setAttribute("nonce", e.nonce), t.appendChild(document.createTextNode("")), t.setAttribute("data-s", ""), t;
}
var _m = /*#__PURE__*/ function() {
	function e(e) {
		var t = this;
		this._insertTag = function(e) {
			var n = t.tags.length === 0 ? t.insertionPoint ? t.insertionPoint.nextSibling : t.prepend ? t.container.firstChild : t.before : t.tags[t.tags.length - 1].nextSibling;
			t.container.insertBefore(e, n), t.tags.push(e);
		}, this.isSpeedy = e.speedy === void 0 || e.speedy, this.tags = [], this.ctr = 0, this.nonce = e.nonce, this.key = e.key, this.container = e.container, this.prepend = e.prepend, this.insertionPoint = e.insertionPoint, this.before = null;
	}
	var t = e.prototype;
	return t.hydrate = function(e) {
		e.forEach(this._insertTag);
	}, t.insert = function(e) {
		this.ctr % (this.isSpeedy ? 65e3 : 1) == 0 && this._insertTag(gm(this));
		var t = this.tags[this.tags.length - 1];
		if (this.isSpeedy) {
			var n = hm(t);
			try {
				n.insertRule(e, n.cssRules.length);
			} catch {}
		} else t.appendChild(document.createTextNode(e));
		this.ctr++;
	}, t.flush = function() {
		this.tags.forEach(function(e) {
			return e.parentNode?.removeChild(e);
		}), this.tags = [], this.ctr = 0;
	}, e;
}(), vm = "-ms-", ym = "-moz-", bm = "-webkit-", xm = "comm", Sm = "rule", Cm = "decl", wm = "@import", Tm = "@keyframes", Em = "@layer", Dm = Math.abs, Om = String.fromCharCode, km = Object.assign;
function Am(e, t) {
	return Fm(e, 0) ^ 45 ? (((t << 2 ^ Fm(e, 0)) << 2 ^ Fm(e, 1)) << 2 ^ Fm(e, 2)) << 2 ^ Fm(e, 3) : 0;
}
function jm(e) {
	return e.trim();
}
function Mm(e, t) {
	return (e = t.exec(e)) ? e[0] : e;
}
function Nm(e, t, n) {
	return e.replace(t, n);
}
function Pm(e, t) {
	return e.indexOf(t);
}
function Fm(e, t) {
	return e.charCodeAt(t) | 0;
}
function Im(e, t, n) {
	return e.slice(t, n);
}
function Lm(e) {
	return e.length;
}
function Rm(e) {
	return e.length;
}
function zm(e, t) {
	return t.push(e), e;
}
function Bm(e, t) {
	return e.map(t).join("");
}
// node_modules/@emotion/cache/node_modules/stylis/src/Tokenizer.js
var Vm = 1, Hm = 1, Um = 0, Wm = 0, Gm = 0, Km = "";
function qm(e, t, n, r, i, a, o) {
	return {
		value: e,
		root: t,
		parent: n,
		type: r,
		props: i,
		children: a,
		line: Vm,
		column: Hm,
		length: o,
		return: ""
	};
}
function Jm(e, t) {
	return km(qm("", null, null, "", null, null, 0), e, { length: -e.length }, t);
}
function Ym() {
	return Gm;
}
function Xm() {
	return Gm = Wm > 0 ? Fm(Km, --Wm) : 0, Hm--, Gm === 10 && (Hm = 1, Vm--), Gm;
}
function Zm() {
	return Gm = Wm < Um ? Fm(Km, Wm++) : 0, Hm++, Gm === 10 && (Hm = 1, Vm++), Gm;
}
function Qm() {
	return Fm(Km, Wm);
}
function $m() {
	return Wm;
}
function eh(e, t) {
	return Im(Km, e, t);
}
function th(e) {
	switch (e) {
		case 0:
		case 9:
		case 10:
		case 13:
		case 32: return 5;
		case 33:
		case 43:
		case 44:
		case 47:
		case 62:
		case 64:
		case 126:
		case 59:
		case 123:
		case 125: return 4;
		case 58: return 3;
		case 34:
		case 39:
		case 40:
		case 91: return 2;
		case 41:
		case 93: return 1;
	}
	return 0;
}
function nh(e) {
	return Vm = Hm = 1, Um = Lm(Km = e), Wm = 0, [];
}
function rh(e) {
	return Km = "", e;
}
function ih(e) {
	return jm(eh(Wm - 1, sh(e === 91 ? e + 2 : e === 40 ? e + 1 : e)));
}
function ah(e) {
	for (; (Gm = Qm()) && Gm < 33;) Zm();
	return th(e) > 2 || th(Gm) > 3 ? "" : " ";
}
function oh(e, t) {
	for (; --t && Zm() && !(Gm < 48 || Gm > 102 || Gm > 57 && Gm < 65 || Gm > 70 && Gm < 97););
	return eh(e, $m() + (t < 6 && Qm() == 32 && Zm() == 32));
}
function sh(e) {
	for (; Zm();) switch (Gm) {
		case e: return Wm;
		case 34:
		case 39:
			e !== 34 && e !== 39 && sh(Gm);
			break;
		case 40:
			e === 41 && sh(e);
			break;
		case 92: Zm();
	}
	return Wm;
}
function ch(e, t) {
	for (; Zm() && e + Gm !== 57 && (e + Gm !== 84 || Qm() !== 47););
	return "/*" + eh(t, Wm - 1) + "*" + Om(e === 47 ? e : Zm());
}
function lh(e) {
	for (; !th(Qm());) Zm();
	return eh(e, Wm);
}
// node_modules/@emotion/cache/node_modules/stylis/src/Parser.js
function uh(e) {
	return rh(dh("", null, null, null, [""], e = nh(e), 0, [0], e));
}
function dh(e, t, n, r, i, a, o, s, c) {
	for (var l = 0, u = 0, d = o, f = 0, p = 0, m = 0, h = 1, g = 1, _ = 1, v = 0, y = "", b = i, x = a, S = r, C = y; g;) switch (m = v, v = Zm()) {
		case 40: if (m != 108 && Fm(C, d - 1) == 58) {
			Pm(C += Nm(ih(v), "&", "&\f"), "&\f") != -1 && (_ = -1);
			break;
		}
		case 34:
		case 39:
		case 91:
			C += ih(v);
			break;
		case 9:
		case 10:
		case 13:
		case 32:
			C += ah(m);
			break;
		case 92:
			C += oh($m() - 1, 7);
			continue;
		case 47:
			switch (Qm()) {
				case 42:
				case 47:
					zm(ph(ch(Zm(), $m()), t, n), c);
					break;
				default: C += "/";
			}
			break;
		case 123 * h: s[l++] = Lm(C) * _;
		case 125 * h:
		case 59:
		case 0:
			switch (v) {
				case 0:
				case 125: g = 0;
				case 59 + u:
					_ == -1 && (C = Nm(C, /\f/g, "")), p > 0 && Lm(C) - d && zm(p > 32 ? mh(C + ";", r, n, d - 1) : mh(Nm(C, " ", "") + ";", r, n, d - 2), c);
					break;
				case 59: C += ";";
				default: if (zm(S = fh(C, t, n, l, u, i, s, y, b = [], x = [], d), a), v === 123) {
					if (u === 0) dh(C, t, S, S, b, a, d, s, x);
					else switch (f === 99 && Fm(C, 3) === 110 ? 100 : f) {
						case 100:
						case 108:
						case 109:
						case 115:
							dh(e, S, S, r && zm(fh(e, S, S, 0, 0, i, s, y, i, b = [], d), x), i, x, d, s, r ? b : x);
							break;
						default: dh(C, S, S, S, [""], x, 0, s, x);
					}
				}
			}
			l = u = p = 0, h = _ = 1, y = C = "", d = o;
			break;
		case 58: d = 1 + Lm(C), p = m;
		default:
			if (h < 1) {
				if (v == 123) --h;
				else if (v == 125 && h++ == 0 && Xm() == 125) continue;
			}
			switch (C += Om(v), v * h) {
				case 38:
					_ = u > 0 ? 1 : (C += "\f", -1);
					break;
				case 44:
					s[l++] = (Lm(C) - 1) * _, _ = 1;
					break;
				case 64:
					Qm() === 45 && (C += ih(Zm())), f = Qm(), u = d = Lm(y = C += lh($m())), v++;
					break;
				case 45: m === 45 && Lm(C) == 2 && (h = 0);
			}
	}
	return a;
}
function fh(e, t, n, r, i, a, o, s, c, l, u) {
	for (var d = i - 1, f = i === 0 ? a : [""], p = Rm(f), m = 0, h = 0, g = 0; m < r; ++m) for (var _ = 0, v = Im(e, d + 1, d = Dm(h = o[m])), y = e; _ < p; ++_) (y = jm(h > 0 ? f[_] + " " + v : Nm(v, /&\f/g, f[_]))) && (c[g++] = y);
	return qm(e, t, n, i === 0 ? Sm : s, c, l, u);
}
function ph(e, t, n) {
	return qm(e, t, n, xm, Om(Ym()), Im(e, 2, -2), 0);
}
function mh(e, t, n, r) {
	return qm(e, t, n, Cm, Im(e, 0, r), Im(e, r + 1, -1), r);
}
// node_modules/@emotion/cache/node_modules/stylis/src/Serializer.js
function hh(e, t) {
	for (var n = "", r = Rm(e), i = 0; i < r; i++) n += t(e[i], i, e, t) || "";
	return n;
}
function gh(e, t, n, r) {
	switch (e.type) {
		case Em: if (e.children.length) break;
		case wm:
		case Cm: return e.return = e.return || e.value;
		case xm: return "";
		case Tm: return e.return = e.value + "{" + hh(e.children, r) + "}";
		case Sm: e.value = e.props.join(",");
	}
	return Lm(n = hh(e.children, r)) ? e.return = e.value + "{" + n + "}" : "";
}
// node_modules/@emotion/cache/node_modules/stylis/src/Middleware.js
function _h(e) {
	var t = Rm(e);
	return function(n, r, i, a) {
		for (var o = "", s = 0; s < t; s++) o += e[s](n, r, i, a) || "";
		return o;
	};
}
function vh(e) {
	return function(t) {
		t.root || (t = t.return) && e(t);
	};
}
// node_modules/@emotion/memoize/dist/emotion-memoize.esm.js
function yh(e) {
	var t = Object.create(null);
	return function(n) {
		return t[n] === void 0 && (t[n] = e(n)), t[n];
	};
}
// node_modules/@emotion/cache/dist/emotion-cache.browser.esm.js
var bh = function(e, t, n) {
	for (var r = 0, i = 0; r = i, i = Qm(), r === 38 && i === 12 && (t[n] = 1), !th(i);) Zm();
	return eh(e, Wm);
}, xh = function(e, t) {
	var n = -1, r = 44;
	do
		switch (th(r)) {
			case 0:
				r === 38 && Qm() === 12 && (t[n] = 1), e[n] += bh(Wm - 1, t, n);
				break;
			case 2:
				e[n] += ih(r);
				break;
			case 4: if (r === 44) {
				e[++n] = Qm() === 58 ? "&\f" : "", t[n] = e[n].length;
				break;
			}
			default: e[n] += Om(r);
		}
	while (r = Zm());
	return e;
}, Sh = function(e, t) {
	return rh(xh(nh(e), t));
}, Ch = /* #__PURE__ */ new WeakMap(), wh = function(e) {
	if (!(e.type !== "rule" || !e.parent || e.length < 1)) {
		for (var t = e.value, n = e.parent, r = e.column === n.column && e.line === n.line; n.type !== "rule";) if (n = n.parent, !n) return;
		if ((e.props.length !== 1 || t.charCodeAt(0) === 58 || Ch.get(n)) && !r) {
			Ch.set(e, !0);
			for (var i = [], a = Sh(t, i), o = n.props, s = 0, c = 0; s < a.length; s++) for (var l = 0; l < o.length; l++, c++) e.props[c] = i[s] ? a[s].replace(/&\f/g, o[l]) : o[l] + " " + a[s];
		}
	}
}, Th = function(e) {
	if (e.type === "decl") {
		var t = e.value;
		t.charCodeAt(0) === 108 && t.charCodeAt(2) === 98 && (e.return = "", e.value = "");
	}
};
function Eh(e, t) {
	switch (Am(e, t)) {
		case 5103: return bm + "print-" + e + e;
		case 5737:
		case 4201:
		case 3177:
		case 3433:
		case 1641:
		case 4457:
		case 2921:
		case 5572:
		case 6356:
		case 5844:
		case 3191:
		case 6645:
		case 3005:
		case 6391:
		case 5879:
		case 5623:
		case 6135:
		case 4599:
		case 4855:
		case 4215:
		case 6389:
		case 5109:
		case 5365:
		case 5621:
		case 3829: return bm + e + e;
		case 5349:
		case 4246:
		case 4810:
		case 6968:
		case 2756: return bm + e + ym + e + vm + e + e;
		case 6828:
		case 4268: return bm + e + vm + e + e;
		case 6165: return bm + e + vm + "flex-" + e + e;
		case 5187: return bm + e + Nm(e, /(\w+).+(:[^]+)/, bm + "box-$1$2" + vm + "flex-$1$2") + e;
		case 5443: return bm + e + vm + "flex-item-" + Nm(e, /flex-|-self/, "") + e;
		case 4675: return bm + e + vm + "flex-line-pack" + Nm(e, /align-content|flex-|-self/, "") + e;
		case 5548: return bm + e + vm + Nm(e, "shrink", "negative") + e;
		case 5292: return bm + e + vm + Nm(e, "basis", "preferred-size") + e;
		case 6060: return bm + "box-" + Nm(e, "-grow", "") + bm + e + vm + Nm(e, "grow", "positive") + e;
		case 4554: return bm + Nm(e, /([^-])(transform)/g, "$1" + bm + "$2") + e;
		case 6187: return Nm(Nm(Nm(e, /(zoom-|grab)/, bm + "$1"), /(image-set)/, bm + "$1"), e, "") + e;
		case 5495:
		case 3959: return Nm(e, /(image-set\([^]*)/, bm + "$1$`$1");
		case 4968: return Nm(Nm(e, /(.+:)(flex-)?(.*)/, bm + "box-pack:$3" + vm + "flex-pack:$3"), /s.+-b[^;]+/, "justify") + bm + e + e;
		case 4095:
		case 3583:
		case 4068:
		case 2532: return Nm(e, /(.+)-inline(.+)/, bm + "$1$2") + e;
		case 8116:
		case 7059:
		case 5753:
		case 5535:
		case 5445:
		case 5701:
		case 4933:
		case 4677:
		case 5533:
		case 5789:
		case 5021:
		case 4765:
			if (Lm(e) - 1 - t > 6) switch (Fm(e, t + 1)) {
				case 109: if (Fm(e, t + 4) !== 45) break;
				case 102: return Nm(e, /(.+:)(.+)-([^]+)/, "$1" + bm + "$2-$3$1" + ym + (Fm(e, t + 3) == 108 ? "$3" : "$2-$3")) + e;
				case 115: return ~Pm(e, "stretch") ? Eh(Nm(e, "stretch", "fill-available"), t) + e : e;
			}
			break;
		case 4949: if (Fm(e, t + 1) !== 115) break;
		case 6444:
			switch (Fm(e, Lm(e) - 3 - (~Pm(e, "!important") && 10))) {
				case 107: return Nm(e, ":", ":" + bm) + e;
				case 101: return Nm(e, /(.+:)([^;!]+)(;|!.+)?/, "$1" + bm + (Fm(e, 14) === 45 ? "inline-" : "") + "box$3$1" + bm + "$2$3$1" + vm + "$2box$3") + e;
			}
			break;
		case 5936:
			switch (Fm(e, t + 11)) {
				case 114: return bm + e + vm + Nm(e, /[svh]\w+-[tblr]{2}/, "tb") + e;
				case 108: return bm + e + vm + Nm(e, /[svh]\w+-[tblr]{2}/, "tb-rl") + e;
				case 45: return bm + e + vm + Nm(e, /[svh]\w+-[tblr]{2}/, "lr") + e;
			}
			return bm + e + vm + e + e;
	}
	return e;
}
var Dh = [function(e, t, n, r) {
	if (e.length > -1 && !e.return) switch (e.type) {
		case Cm:
			e.return = Eh(e.value, e.length);
			break;
		case Tm: return hh([Jm(e, { value: Nm(e.value, "@", "@" + bm) })], r);
		case Sm: if (e.length) return Bm(e.props, function(t) {
			switch (Mm(t, /(::plac\w+|:read-\w+)/)) {
				case ":read-only":
				case ":read-write": return hh([Jm(e, { props: [Nm(t, /:(read-\w+)/, ":" + ym + "$1")] })], r);
				case "::placeholder": return hh([
					Jm(e, { props: [Nm(t, /:(plac\w+)/, ":" + bm + "input-$1")] }),
					Jm(e, { props: [Nm(t, /:(plac\w+)/, ":" + ym + "$1")] }),
					Jm(e, { props: [Nm(t, /:(plac\w+)/, vm + "input-$1")] })
				], r);
			}
			return "";
		});
	}
}], Oh = function(e) {
	var t = e.key;
	if (t === "css") {
		var n = document.querySelectorAll("style[data-emotion]:not([data-s])");
		Array.prototype.forEach.call(n, function(e) {
			e.getAttribute("data-emotion").indexOf(" ") !== -1 && (document.head.appendChild(e), e.setAttribute("data-s", ""));
		});
	}
	var r = e.stylisPlugins || Dh, i = {}, a, o = [];
	a = e.container || document.head, Array.prototype.forEach.call(document.querySelectorAll("style[data-emotion^=\"" + t + " \"]"), function(e) {
		for (var t = e.getAttribute("data-emotion").split(" "), n = 1; n < t.length; n++) i[t[n]] = !0;
		o.push(e);
	});
	var s, c = [wh, Th], l, u = [gh, vh(function(e) {
		l.insert(e);
	})], d = _h(c.concat(r, u)), f = function(e) {
		return hh(uh(e), d);
	};
	s = function(e, t, n, r) {
		l = n, f(e ? e + "{" + t.styles + "}" : t.styles), r && (p.inserted[t.name] = !0);
	};
	var p = {
		key: t,
		sheet: new _m({
			key: t,
			container: a,
			nonce: e.nonce,
			speedy: e.speedy,
			prepend: e.prepend,
			insertionPoint: e.insertionPoint
		}),
		nonce: e.nonce,
		inserted: i,
		registered: {},
		insert: s
	};
	return p.sheet.hydrate(o), p;
};
// node_modules/@emotion/hash/dist/emotion-hash.esm.js
function kh(e) {
	for (var t = 0, n, r = 0, i = e.length; i >= 4; ++r, i -= 4) n = e.charCodeAt(r) & 255 | (e.charCodeAt(++r) & 255) << 8 | (e.charCodeAt(++r) & 255) << 16 | (e.charCodeAt(++r) & 255) << 24, n = (n & 65535) * 1540483477 + ((n >>> 16) * 59797 << 16), n ^= n >>> 24, t = (n & 65535) * 1540483477 + ((n >>> 16) * 59797 << 16) ^ (t & 65535) * 1540483477 + ((t >>> 16) * 59797 << 16);
	switch (i) {
		case 3: t ^= (e.charCodeAt(r + 2) & 255) << 16;
		case 2: t ^= (e.charCodeAt(r + 1) & 255) << 8;
		case 1: t ^= e.charCodeAt(r) & 255, t = (t & 65535) * 1540483477 + ((t >>> 16) * 59797 << 16);
	}
	return t ^= t >>> 13, t = (t & 65535) * 1540483477 + ((t >>> 16) * 59797 << 16), ((t ^ t >>> 15) >>> 0).toString(36);
}
// node_modules/@emotion/unitless/dist/emotion-unitless.esm.js
var Ah = {
	animationIterationCount: 1,
	aspectRatio: 1,
	borderImageOutset: 1,
	borderImageSlice: 1,
	borderImageWidth: 1,
	boxFlex: 1,
	boxFlexGroup: 1,
	boxOrdinalGroup: 1,
	columnCount: 1,
	columns: 1,
	flex: 1,
	flexGrow: 1,
	flexPositive: 1,
	flexShrink: 1,
	flexNegative: 1,
	flexOrder: 1,
	gridRow: 1,
	gridRowEnd: 1,
	gridRowSpan: 1,
	gridRowStart: 1,
	gridColumn: 1,
	gridColumnEnd: 1,
	gridColumnSpan: 1,
	gridColumnStart: 1,
	msGridRow: 1,
	msGridRowSpan: 1,
	msGridColumn: 1,
	msGridColumnSpan: 1,
	fontWeight: 1,
	lineHeight: 1,
	opacity: 1,
	order: 1,
	orphans: 1,
	scale: 1,
	tabSize: 1,
	widows: 1,
	zIndex: 1,
	zoom: 1,
	WebkitLineClamp: 1,
	fillOpacity: 1,
	floodOpacity: 1,
	stopOpacity: 1,
	strokeDasharray: 1,
	strokeDashoffset: 1,
	strokeMiterlimit: 1,
	strokeOpacity: 1,
	strokeWidth: 1
}, jh = /[A-Z]|^ms/g, Mh = /_EMO_([^_]+?)_([^]*?)_EMO_/g, Nh = function(e) {
	return e.charCodeAt(1) === 45;
}, Ph = function(e) {
	return e != null && typeof e != "boolean";
}, Fh = /* #__PURE__ */ yh(function(e) {
	return Nh(e) ? e : e.replace(jh, "-$&").toLowerCase();
}), Ih = function(e, t) {
	switch (e) {
		case "animation":
		case "animationName": if (typeof t == "string") return t.replace(Mh, function(e, t, n) {
			return Bh = {
				name: t,
				styles: n,
				next: Bh
			}, t;
		});
	}
	return Ah[e] !== 1 && !Nh(e) && typeof t == "number" && t !== 0 ? t + "px" : t;
};
function Lh(e, t, n) {
	if (n == null) return "";
	var r = n;
	if (r.__emotion_styles !== void 0) return r;
	switch (typeof n) {
		case "boolean": return "";
		case "object":
			var i = n;
			if (i.anim === 1) return Bh = {
				name: i.name,
				styles: i.styles,
				next: Bh
			}, i.name;
			var a = n;
			if (a.styles !== void 0) {
				var o = a.next;
				if (o !== void 0) for (; o !== void 0;) Bh = {
					name: o.name,
					styles: o.styles,
					next: Bh
				}, o = o.next;
				return a.styles + ";";
			}
			return Rh(e, t, n);
		case "function": if (e !== void 0) {
			var s = Bh, c = n(e);
			return Bh = s, Lh(e, t, c);
		}
	}
	var l = n;
	if (t == null) return l;
	var u = t[l];
	return u === void 0 ? l : u;
}
function Rh(e, t, n) {
	var r = "";
	if (Array.isArray(n)) for (var i = 0; i < n.length; i++) r += Lh(e, t, n[i]) + ";";
	else for (var a in n) {
		var o = n[a];
		if (typeof o != "object") {
			var s = o;
			t != null && t[s] !== void 0 ? r += a + "{" + t[s] + "}" : Ph(s) && (r += Fh(a) + ":" + Ih(a, s) + ";");
		} else if (Array.isArray(o) && typeof o[0] == "string" && (t == null || t[o[0]] === void 0)) for (var c = 0; c < o.length; c++) Ph(o[c]) && (r += Fh(a) + ":" + Ih(a, o[c]) + ";");
		else {
			var l = Lh(e, t, o);
			switch (a) {
				case "animation":
				case "animationName":
					r += Fh(a) + ":" + l + ";";
					break;
				default: r += a + "{" + l + "}";
			}
		}
	}
	return r;
}
var zh = /label:\s*([^\s;{]+)\s*(;|$)/g, Bh;
function Vh(e, t, n) {
	if (e.length === 1 && typeof e[0] == "object" && e[0] !== null && e[0].styles !== void 0) return e[0];
	var r = !0, i = "";
	Bh = void 0;
	var a = e[0];
	a == null || a.raw === void 0 ? (r = !1, i += Lh(n, t, a)) : i += a[0];
	for (var o = 1; o < e.length; o++) i += Lh(n, t, e[o]), r && (i += a[o]);
	zh.lastIndex = 0;
	for (var s = "", c; (c = zh.exec(i)) !== null;) s += "-" + c[1];
	return {
		name: kh(i) + s,
		styles: i,
		next: Bh
	};
}
// node_modules/@emotion/utils/dist/emotion-utils.browser.esm.js
function Hh(e, t, n) {
	var r = "";
	return n.split(" ").forEach(function(n) {
		e[n] === void 0 ? n && (r += n + " ") : t.push(e[n] + ";");
	}), r;
}
var Uh = function(e, t, n) {
	var r = e.key + "-" + t.name;
	n === !1 && e.registered[r] === void 0 && (e.registered[r] = t.styles);
}, Wh = function(e, t, n) {
	Uh(e, t, n);
	var r = e.key + "-" + t.name;
	if (e.inserted[t.name] === void 0) {
		var i = t;
		do
			e.insert(t === i ? "." + r : "", i, e.sheet, !0), i = i.next;
		while (i !== void 0);
	}
};
// node_modules/@emotion/css/create-instance/dist/emotion-css-create-instance.esm.js
function Gh(e, t) {
	if (e.inserted[t.name] === void 0) return e.insert("", t, e.sheet, !0);
}
function Kh(e, t, n) {
	var r = [], i = Hh(e, r, n);
	return r.length < 2 ? n : i + t(r);
}
var qh = function(e) {
	var t = Oh(e);
	t.sheet.speedy = function(e) {
		this.isSpeedy = e;
	}, t.compat = !0;
	var n = function() {
		var e = Vh([...arguments], t.registered, void 0);
		return Wh(t, e, !1), t.key + "-" + e.name;
	};
	return {
		css: n,
		cx: function() {
			var e = [...arguments];
			return Kh(t.registered, n, Jh(e));
		},
		injectGlobal: function() {
			Gh(t, Vh([...arguments], t.registered));
		},
		keyframes: function() {
			var e = Vh([...arguments], t.registered), n = "animation-" + e.name;
			return Gh(t, {
				name: e.name,
				styles: "@keyframes " + n + "{" + e.styles + "}"
			}), n;
		},
		hydrate: function(e) {
			e.forEach(function(e) {
				t.inserted[e] = !0;
			});
		},
		flush: function() {
			t.registered = {}, t.inserted = {}, t.sheet.flush();
		},
		sheet: t.sheet,
		cache: t,
		getRegisteredStyles: Hh.bind(null, t.registered),
		merge: Kh.bind(null, t.registered, n)
	};
}, Jh = function e(t) {
	for (var n = "", r = 0; r < t.length; r++) {
		var i = t[r];
		if (i != null) {
			var a = void 0;
			switch (typeof i) {
				case "boolean": break;
				case "object":
					if (Array.isArray(i)) a = e(i);
					else for (var o in a = "", i) i[o] && o && (a && (a += " "), a += o);
					break;
				default: a = i;
			}
			a && (n && (n += " "), n += a);
		}
	}
	return n;
}, Yh = /* @__PURE__ */ r({
	cache: () => og,
	css: () => ig,
	cx: () => $h,
	flush: () => Zh,
	getRegisteredStyles: () => tg,
	hydrate: () => Qh,
	injectGlobal: () => ng,
	keyframes: () => rg,
	merge: () => eg,
	sheet: () => ag
}), Xh = qh({ key: "css" }), Zh = Xh.flush, Qh = Xh.hydrate, $h = Xh.cx, eg = Xh.merge, tg = Xh.getRegisteredStyles, ng = Xh.injectGlobal, rg = Xh.keyframes, ig = Xh.css, ag = Xh.sheet, og = Xh.cache, sg = /* @__PURE__ */ new Map(), cg = !1;
try {
	cg = new Intl.NumberFormat("de-DE", { signDisplay: "exceptZero" }).resolvedOptions().signDisplay === "exceptZero";
} catch {}
var lg = !1;
try {
	lg = new Intl.NumberFormat("de-DE", {
		style: "unit",
		unit: "degree"
	}).resolvedOptions().style === "unit";
} catch {}
var ug = { degree: { narrow: {
	default: "°",
	"ja-JP": " 度",
	"zh-TW": "度",
	"sl-SI": " °"
} } }, dg = class {
	constructor(e, t = {}) {
		this.numberFormatter = fg(e, t), this.options = t;
	}
	format(e) {
		let t = "";
		if (t = !cg && this.options.signDisplay != null ? pg(this.numberFormatter, this.options.signDisplay, e) : this.numberFormatter.format(e), this.options.style === "unit" && !lg) {
			let { unit: e, unitDisplay: n = "short", locale: r } = this.resolvedOptions();
			if (!e) return t;
			let i = ug[e]?.[n];
			t += i[r] || i.default;
		}
		return t;
	}
	formatToParts(e) {
		return this.numberFormatter.formatToParts(e);
	}
	formatRange(e, t) {
		if (typeof this.numberFormatter.formatRange == "function") return this.numberFormatter.formatRange(e, t);
		if (t < e) throw RangeError("End date must be >= start date");
		return `${this.format(e)} \u{2013} ${this.format(t)}`;
	}
	formatRangeToParts(e, t) {
		if (typeof this.numberFormatter.formatRangeToParts == "function") return this.numberFormatter.formatRangeToParts(e, t);
		if (t < e) throw RangeError("End date must be >= start date");
		let n = this.numberFormatter.formatToParts(e), r = this.numberFormatter.formatToParts(t);
		return [
			...n.map((e) => ({
				...e,
				source: "startRange"
			})),
			{
				type: "literal",
				value: " – ",
				source: "shared"
			},
			...r.map((e) => ({
				...e,
				source: "endRange"
			}))
		];
	}
	resolvedOptions() {
		let e = this.numberFormatter.resolvedOptions();
		return !cg && this.options.signDisplay != null && (e = {
			...e,
			signDisplay: this.options.signDisplay
		}), !lg && this.options.style === "unit" && (e = {
			...e,
			style: "unit",
			unit: this.options.unit,
			unitDisplay: this.options.unitDisplay
		}), e;
	}
};
function fg(e, t = {}) {
	let { numberingSystem: n } = t;
	if (n && e.includes("-nu-") && (e.includes("-u-") || (e += "-u-"), e += `-nu-${n}`), t.style === "unit" && !lg) {
		let { unit: e, unitDisplay: n = "short" } = t;
		if (!e) throw Error("unit option must be provided with style: \"unit\"");
		if (!ug[e]?.[n]) throw Error(`Unsupported unit ${e} with unitDisplay = ${n}`);
		t = {
			...t,
			style: "decimal"
		};
	}
	let r = e + (t ? Object.entries(t).sort((e, t) => e[0] < t[0] ? -1 : 1).join() : "");
	if (sg.has(r)) return sg.get(r);
	let i = new Intl.NumberFormat(e, t);
	return sg.set(r, i), i;
}
function pg(e, t, n) {
	if (t === "auto") return e.format(n);
	if (t === "never") return e.format(Math.abs(n));
	{
		let r = !1;
		if (t === "always" ? r = n > 0 || Object.is(n, 0) : t === "exceptZero" && (Object.is(n, -0) || Object.is(n, 0) ? n = Math.abs(n) : r = n > 0), r) {
			let t = e.format(-n), r = e.format(n), i = t.replace(r, "").replace(/\u200e|\u061C/, "");
			return [...i].length !== 1 && console.warn("@react-aria/i18n polyfill for NumberFormat signDisplay: Unsupported case"), t.replace(r, "!!!").replace(i, "+").replace("!!!", r);
		}
		return e.format(n);
	}
}
// node_modules/@internationalized/number/dist/private/NumberParser.mjs
var mg = /* @__PURE__ */ RegExp("^.*\\(.*\\).*$"), hg = [
	"latn",
	"arab",
	"hanidec",
	"deva",
	"beng",
	"fullwide"
], gg = class {
	constructor(e, t = {}) {
		this.locale = e, this.options = t;
	}
	parse(e) {
		return vg(this.locale, this.options, e).parse(e);
	}
	isValidPartialNumber(e, t, n) {
		return vg(this.locale, this.options, e).isValidPartialNumber(e, t, n);
	}
	getNumberingSystem(e) {
		return vg(this.locale, this.options, e).options.numberingSystem;
	}
}, _g = /* @__PURE__ */ new Map();
function vg(e, t, n) {
	let r = yg(e, t);
	if (!e.includes("-nu-") && !r.isValidPartialNumber(n)) {
		for (let i of hg) if (i !== r.options.numberingSystem) {
			let r = yg(e + (e.includes("-u-") ? "-nu-" : "-u-nu-") + i, t);
			if (r.isValidPartialNumber(n)) return r;
		}
	}
	return r;
}
function yg(e, t) {
	let n = e + (t ? Object.entries(t).sort((e, t) => e[0] < t[0] ? -1 : 1).join() : ""), r = _g.get(n);
	return r || (r = new bg(e, t), _g.set(n, r)), r;
}
var bg = class {
	constructor(e, t = {}) {
		this.locale = e, t.roundingIncrement !== 1 && t.roundingIncrement != null && (t.maximumFractionDigits == null && t.minimumFractionDigits == null ? (t.maximumFractionDigits = 0, t.minimumFractionDigits = 0) : t.maximumFractionDigits == null ? t.maximumFractionDigits = t.minimumFractionDigits : t.minimumFractionDigits ??= t.maximumFractionDigits), this.formatter = new Intl.NumberFormat(e, t), this.options = this.formatter.resolvedOptions(), this.symbols = Cg(e, this.formatter, this.options, t), this.options.style === "percent" && ((this.options.minimumFractionDigits ?? 0) > 18 || (this.options.maximumFractionDigits ?? 0) > 18) && console.warn("NumberParser cannot handle percentages with greater than 18 decimal places, please reduce the number in your options.");
	}
	parse(e) {
		let t = this.formatter.resolvedOptions().useGrouping, n = this.sanitize(e);
		if (!t && this.symbols.group && n.includes(this.symbols.group)) return NaN;
		if (this.symbols.group && (n = n.replaceAll(this.symbols.group, "")), this.symbols.decimal && (n = n.replace(this.symbols.decimal, ".")), this.symbols.minusSign && (n = n.replace(this.symbols.minusSign, "-")), n = n.replace(this.symbols.numeral, this.symbols.index), this.options.style === "percent") {
			let e = n.indexOf("-");
			n = n.replace("-", ""), n = n.replace("+", "");
			let t = n.indexOf(".");
			t === -1 && (t = n.length), n = n.replace(".", ""), n = t - 2 == 0 ? `0.${n}` : t - 2 == -1 ? `0.0${n}` : t - 2 == -2 ? "0.00" : `${n.slice(0, t - 2)}.${n.slice(t - 2)}`, e > -1 && (n = `-${n}`);
		}
		let r = n ? +n : NaN;
		if (isNaN(r)) return NaN;
		if (this.options.style === "percent") {
			let e = {
				...this.options,
				style: "decimal",
				minimumFractionDigits: Math.min((this.options.minimumFractionDigits ?? 0) + 2, 20),
				maximumFractionDigits: Math.min((this.options.maximumFractionDigits ?? 0) + 2, 20)
			};
			return new gg(this.locale, e).parse(new dg(this.locale, e).format(r));
		}
		return this.options.currencySign === "accounting" && mg.test(e) && (r = -1 * r), r;
	}
	sanitize(e) {
		let t = this.formatter.resolvedOptions().useGrouping;
		return this.symbols.noNumeralUnits.length > 0 && this.symbols.noNumeralUnits.find((t) => t.unit === e) ? this.symbols.noNumeralUnits.find((t) => t.unit === e).value.toString() : (e = e.replace(this.symbols.literals, ""), this.symbols.minusSign && (e = e.replace("-", this.symbols.minusSign)), this.options.numberingSystem === "arab" && (this.symbols.decimal && (e = wg(e, ",", this.symbols.decimal), e = wg(e, "،", this.symbols.decimal)), this.symbols.group && t && (e = wg(e, ".", this.symbols.group))), this.symbols.group === "’" && e.includes("'") && t && (e = wg(e, "'", this.symbols.group)), this.symbols.group === "'" && e.includes("’") && t && (e = wg(e, "’", this.symbols.group)), this.options.locale === "fr-FR" && this.symbols.group && t && (e = wg(e, " ", this.symbols.group), e = wg(e, /\u00A0/g, this.symbols.group)), e);
	}
	isValidPartialNumber(e, t = -Infinity, n = Infinity) {
		let r = this.formatter.resolvedOptions().useGrouping;
		return e = this.sanitize(e), this.symbols.minusSign && e.startsWith(this.symbols.minusSign) && t < 0 ? e = e.slice(this.symbols.minusSign.length) : this.symbols.plusSign && e.startsWith(this.symbols.plusSign) && n > 0 && (e = e.slice(this.symbols.plusSign.length)), this.symbols.decimal && e.indexOf(this.symbols.decimal) > -1 && this.options.maximumFractionDigits === 0 ? !1 : (this.symbols.group && r && (e = wg(e, this.symbols.group, "")), e = e.replace(this.symbols.numeral, ""), this.symbols.decimal && (e = e.replace(this.symbols.decimal, "")), e.length === 0);
	}
}, xg = /* @__PURE__ */ new Set([
	"decimal",
	"fraction",
	"integer",
	"minusSign",
	"plusSign",
	"group"
]), Sg = [
	0,
	4,
	2,
	1,
	11,
	20,
	3,
	7,
	100,
	21,
	.1,
	1.1
];
function Cg(e, t, n, r) {
	let i = new Intl.NumberFormat(e, {
		...n,
		minimumSignificantDigits: 1,
		maximumSignificantDigits: 21,
		roundingIncrement: 1,
		roundingPriority: "auto",
		roundingMode: "halfExpand",
		useGrouping: !0
	}), a = i.formatToParts(-10000.111), o = i.formatToParts(10000.111), s = Sg.map((e) => i.formatToParts(e)), c = s.map((e, t) => {
		let n = e.find((e) => e.type === "unit");
		return n && !e.some((e) => e.type === "integer" || e.type === "fraction") ? {
			unit: n.value,
			value: Sg[t]
		} : null;
	}).filter((e) => !!e), l = a.find((e) => e.type === "minusSign")?.value ?? "-", u = o.find((e) => e.type === "plusSign")?.value;
	u || r?.signDisplay !== "exceptZero" && r?.signDisplay !== "always" || (u = "+");
	let d = new Intl.NumberFormat(e, {
		...n,
		minimumFractionDigits: 2,
		maximumFractionDigits: 2
	}).formatToParts(.001).find((e) => e.type === "decimal")?.value, f = a.find((e) => e.type === "group")?.value, p = a.filter((e) => !xg.has(e.type)).map((e) => Tg(e.value)), m = s.flatMap((e) => e.filter((e) => !xg.has(e.type)).map((e) => Tg(e.value))), h = [.../* @__PURE__ */ new Set([...p, ...m])].sort((e, t) => t.length - e.length), g = h.length === 0 ? /* @__PURE__ */ RegExp("\\p{White_Space}|\\p{Cf}", "gu") : RegExp(`${h.join("|")}|\\p{White_Space}|\\p{Cf}`, "gu"), _ = [...new Intl.NumberFormat(n.locale, { useGrouping: !1 }).format(9876543210)].reverse(), v = new Map(_.map((e, t) => [e, t])), y = RegExp(`[${_.join("")}]`, "g");
	return {
		minusSign: l,
		plusSign: u,
		decimal: d,
		group: f,
		literals: g,
		numeral: y,
		numerals: _,
		index: (e) => String(v.get(e)),
		noNumeralUnits: c
	};
}
function wg(e, t, n) {
	return e.replaceAll ? e.replaceAll(t, n) : e.split(t).join(n);
}
function Tg(e) {
	return e.replace(/[.*+?^${}()|[\]\\]/g, "\\$&");
}
// node_modules/@internationalized/number/dist/index.mjs
var Eg = /* @__PURE__ */ r({
	NumberFormatter: () => dg,
	NumberParser: () => gg
});
// node_modules/axios/lib/helpers/bind.js
function Dg(e, t) {
	return function() {
		return e.apply(t, arguments);
	};
}
// node_modules/axios/lib/utils.js
var { toString: Og } = Object.prototype, { getPrototypeOf: kg } = Object, { iterator: Ag, toStringTag: jg } = Symbol, Mg = (({ hasOwnProperty: e }) => (t, n) => e.call(t, n))(Object.prototype), Ng = (e) => typeof e == "string" && (e === "__proto__" || e === "constructor" || e === "prototype"), Pg = (e, t, n) => e === Object.prototype || !n && t === null, Fg = (e) => {
	if (!Object.isExtensible(e)) return !1;
	let t = Object.getOwnPropertyNames(e);
	return Object.getOwnPropertySymbols && t.push(...Object.getOwnPropertySymbols(e)), t.every((t) => {
		if (Ng(t)) return !1;
		let n = Object.getOwnPropertyDescriptor(e, t);
		return !!n && n.configurable && n.writable === !0;
	});
}, Ig = (e, t) => {
	let n = e, r = [];
	for (; n != null;) {
		if (r.indexOf(n) !== -1) return !1;
		r.push(n);
		let i = kg(n);
		if (Pg(n, i, n === e)) return !1;
		if (Mg(n, t)) return !0;
		n = i;
	}
	return !1;
}, Lg = (e, t) => e != null && Ig(e, t) ? e[t] : void 0, Rg = (e) => {
	if (e == null || typeof e != "object" && typeof e != "function") return e;
	let t = kg(e);
	if (t === null && Fg(e)) return e;
	let n = Object.create(null), r = Object.create(null), i = [], a = e;
	for (; a != null && i.indexOf(a) === -1;) {
		i.push(a);
		let o = a === e ? t : kg(a);
		if (Pg(a, o, a === e)) break;
		let s = Object.getOwnPropertyNames(a);
		Object.getOwnPropertySymbols && s.push(...Object.getOwnPropertySymbols(a));
		for (let t of s) Ng(t) || Mg(r, t) || (n[t] = e[t], r[t] = !0);
		a = o;
	}
	return n;
}, zg = ((e) => (t) => {
	let n = Og.call(t);
	return e[n] || (e[n] = n.slice(8, -1).toLowerCase());
})(Object.create(null)), Bg = (e) => (e = e.toLowerCase(), (t) => zg(t) === e), Vg = (e) => (t) => typeof t === e, { isArray: Hg } = Array, Ug = Vg("undefined");
function Wg(e) {
	return e !== null && !Ug(e) && e.constructor !== null && !Ug(e.constructor) && Jg(e.constructor.isBuffer) && e.constructor.isBuffer(e);
}
var Gg = Bg("ArrayBuffer");
function Kg(e) {
	let t;
	return t = typeof ArrayBuffer < "u" && ArrayBuffer.isView ? ArrayBuffer.isView(e) : e && e.buffer && Gg(e.buffer), t;
}
var qg = Vg("string"), Jg = Vg("function"), Yg = Vg("number"), Xg = (e) => typeof e == "object" && !!e, Zg = (e) => e === !0 || e === !1, Qg = (e) => {
	if (!Xg(e)) return !1;
	let t = kg(e);
	return (t === null || t === Object.prototype || kg(t) === null) && !Ig(e, jg) && !Ig(e, Ag);
}, $g = (e) => {
	if (!Xg(e) || Wg(e)) return !1;
	try {
		return Object.keys(e).length === 0 && Object.getPrototypeOf(e) === Object.prototype;
	} catch {
		return !1;
	}
}, e_ = Bg("Date"), t_ = Bg("File"), n_ = (e) => !!(e && e.uri !== void 0), r_ = (e) => e && e.getParts !== void 0, i_ = Bg("Blob"), a_ = Bg("FileList"), o_ = Bg("Set"), s_ = (e) => Xg(e) && Jg(e.pipe);
function c_() {
	return typeof globalThis < "u" ? globalThis : typeof self < "u" ? self : typeof window < "u" ? window : typeof global < "u" ? global : {};
}
var l_ = c_(), u_ = l_.FormData === void 0 ? void 0 : l_.FormData, d_ = (e) => {
	if (!e) return !1;
	if (u_ && e instanceof u_) return !0;
	let t = kg(e);
	if (!t || t === Object.prototype || !Jg(e.append)) return !1;
	let n = zg(e);
	return n === "formdata" || n === "object" && Jg(e.toString) && e.toString() === "[object FormData]";
}, f_ = Bg("URLSearchParams"), [p_, m_, h_, g_] = [
	"ReadableStream",
	"Request",
	"Response",
	"Headers"
].map(Bg), __ = (e) => e.trim ? e.trim() : e.replace(/^[\s\uFEFF\xA0]+|[\s\uFEFF\xA0]+$/g, "");
function v_(e, t, { allOwnKeys: n = !1 } = {}) {
	if (e == null) return;
	let r, i;
	if (typeof e != "object" && (e = [e]), Hg(e)) for (r = 0, i = e.length; r < i; r++) t.call(null, e[r], r, e);
	else {
		if (Wg(e)) return;
		let i = n ? Object.getOwnPropertyNames(e) : Object.keys(e), a = i.length, o;
		for (r = 0; r < a; r++) o = i[r], t.call(null, e[o], o, e);
	}
}
function y_(e, t) {
	if (Wg(e)) return null;
	t = t.toLowerCase();
	let n = Object.keys(e), r = n.length, i;
	for (; r-- > 0;) if (i = n[r], t === i.toLowerCase()) return i;
	return null;
}
var b_ = typeof globalThis < "u" ? globalThis : typeof self < "u" ? self : typeof window < "u" ? window : global, x_ = (e) => !Ug(e) && e !== b_;
function S_(...e) {
	let { caseless: t, skipUndefined: n } = x_(this) && this || {}, r = {}, i = (e, i) => {
		if (i === "__proto__" || i === "constructor" || i === "prototype") return;
		let a = t && typeof i == "string" && y_(r, i) || i, o = Mg(r, a) ? r[a] : void 0;
		Qg(o) && Qg(e) ? r[a] = S_(o, e) : Qg(e) ? r[a] = S_({}, e) : Hg(e) ? r[a] = e.slice() : n && Ug(e) || (r[a] = e);
	};
	for (let t = 0, n = e.length; t < n; t++) {
		let n = e[t];
		if (!n || Wg(n) || (v_(n, i), typeof n != "object" || Hg(n))) continue;
		let r = Object.getOwnPropertySymbols(n);
		for (let e = 0; e < r.length; e++) {
			let t = r[e];
			P_.call(n, t) && i(n[t], t);
		}
	}
	return r;
}
var C_ = (e, t, n, { allOwnKeys: r } = {}) => (v_(t, (t, r) => {
	n && Jg(t) ? Object.defineProperty(e, r, {
		__proto__: null,
		value: Dg(t, n),
		writable: !0,
		enumerable: !0,
		configurable: !0
	}) : Object.defineProperty(e, r, {
		__proto__: null,
		value: t,
		writable: !0,
		enumerable: !0,
		configurable: !0
	});
}, { allOwnKeys: r }), e), w_ = (e) => (e.charCodeAt(0) === 65279 && (e = e.slice(1)), e), T_ = (e, t, n, r) => {
	e.prototype = Object.create(t.prototype, r), Object.defineProperty(e.prototype, "constructor", {
		__proto__: null,
		value: e,
		writable: !0,
		enumerable: !1,
		configurable: !0
	}), Object.defineProperty(e, "super", {
		__proto__: null,
		value: t.prototype
	}), n && Object.assign(e.prototype, n);
}, E_ = (e, t, n, r) => {
	let i, a, o, s = {};
	if (t ||= {}, e == null) return t;
	do {
		for (i = Object.getOwnPropertyNames(e), a = i.length; a-- > 0;) o = i[a], r && !r(o, e, t) || s[o] || (t[o] = e[o], s[o] = !0);
		e = n !== !1 && kg(e);
	} while (e && (!n || n(e, t)) && e !== Object.prototype);
	return t;
}, D_ = (e, t, n) => {
	e = String(e), (n === void 0 || n > e.length) && (n = e.length), n -= t.length;
	let r = e.indexOf(t, n);
	return r !== -1 && r === n;
}, O_ = (e) => {
	if (!e) return null;
	if (Hg(e)) return e;
	let t = e.length;
	if (!Yg(t)) return null;
	let n = Array(t);
	for (; t-- > 0;) n[t] = e[t];
	return n;
}, k_ = ((e) => (t) => e && t instanceof e)(typeof Uint8Array < "u" && kg(Uint8Array)), A_ = (e, t) => {
	let n = (e && e[Ag]).call(e), r;
	for (; (r = n.next()) && !r.done;) {
		let n = r.value;
		t.call(e, n[0], n[1]);
	}
}, j_ = (e, t) => {
	let n, r = [];
	for (; (n = e.exec(t)) !== null;) r.push(n);
	return r;
}, M_ = Bg("HTMLFormElement"), N_ = (e) => e.toLowerCase().replace(/[-_\s]([a-z\d])(\w*)/g, function(e, t, n) {
	return t.toUpperCase() + n;
}), { propertyIsEnumerable: P_ } = Object.prototype, F_ = Bg("RegExp"), I_ = (e, t) => {
	let n = Object.getOwnPropertyDescriptors(e), r = {};
	v_(n, (n, i) => {
		let a;
		(a = t(n, i, e)) !== !1 && (r[i] = a || n);
	}), Object.defineProperties(e, r);
}, L_ = (e) => {
	I_(e, (t, n) => {
		if (Jg(e) && [
			"arguments",
			"caller",
			"callee"
		].includes(n)) return !1;
		let r = e[n];
		Jg(r) && (t.enumerable = !1, "writable" in t ? t.writable = !1 : t.set ||= () => {
			throw Error("Can not rewrite read-only method '" + n + "'");
		});
	});
}, R_ = (e, t) => {
	let n = {}, r = (e) => {
		e.forEach((e) => {
			n[e] = !0;
		});
	};
	return Hg(e) ? r(e) : r(String(e).split(t)), n;
}, z_ = () => {}, B_ = (e, t) => e != null && Number.isFinite(e = +e) ? e : t;
function V_(e) {
	return !!(e && Jg(e.append) && e[jg] === "FormData" && e[Ag]);
}
var H_ = (e) => {
	let t = /* @__PURE__ */ new WeakSet(), n = (e) => {
		if (Xg(e)) {
			if (t.has(e)) return;
			if (Wg(e)) return e;
			if (!("toJSON" in e)) {
				t.add(e);
				let r;
				if (o_(e)) {
					r = [];
					for (let t of e) {
						let e = n(t);
						!Ug(e) && r.push(e);
					}
				} else r = Hg(e) ? [] : {}, v_(e, (e, t) => {
					let i = n(e);
					!Ug(i) && (r[t] = i);
				});
				return t.delete(e), r;
			}
		}
		return e;
	};
	return n(e);
}, U_ = Bg("AsyncFunction"), W_ = (e) => e && (Xg(e) || Jg(e)) && Jg(e.then) && Jg(e.catch), G_ = ((e, t) => e ? setImmediate : t ? ((e, t) => (b_.addEventListener("message", ({ source: n, data: r }) => {
	n === b_ && r === e && t.length && t.shift()();
}, !1), (n) => {
	t.push(n), b_.postMessage(e, "*");
}))(`axios@${Math.random()}`, []) : (e) => setTimeout(e))(typeof setImmediate == "function", Jg(b_.postMessage)), K_ = typeof queueMicrotask < "u" ? queueMicrotask.bind(b_) : typeof process < "u" && process.nextTick || G_, q_ = (e) => e != null && Jg(e[Ag]), Q = {
	isArray: Hg,
	isArrayBuffer: Gg,
	isBuffer: Wg,
	isFormData: d_,
	isArrayBufferView: Kg,
	isString: qg,
	isNumber: Yg,
	isBoolean: Zg,
	isObject: Xg,
	isPlainObject: Qg,
	isEmptyObject: $g,
	isReadableStream: p_,
	isRequest: m_,
	isResponse: h_,
	isHeaders: g_,
	isUndefined: Ug,
	isDate: e_,
	isFile: t_,
	isReactNativeBlob: n_,
	isReactNative: r_,
	isBlob: i_,
	isRegExp: F_,
	isFunction: Jg,
	isStream: s_,
	isURLSearchParams: f_,
	isTypedArray: k_,
	isFileList: a_,
	forEach: v_,
	merge: S_,
	extend: C_,
	trim: __,
	stripBOM: w_,
	inherits: T_,
	toFlatObject: E_,
	kindOf: zg,
	kindOfTest: Bg,
	endsWith: D_,
	toArray: O_,
	forEachEntry: A_,
	matchAll: j_,
	isHTMLForm: M_,
	hasOwnProperty: Mg,
	hasOwnProp: Mg,
	hasOwnInPrototypeChain: Ig,
	getSafeProp: Lg,
	toSafeFlatObject: Rg,
	reduceDescriptors: I_,
	freezeMethods: L_,
	toObjectSet: R_,
	toCamelCase: N_,
	noop: z_,
	toFiniteNumber: B_,
	findKey: y_,
	global: b_,
	isContextDefined: x_,
	isSpecCompliantForm: V_,
	toJSONObject: H_,
	isAsyncFn: U_,
	isThenable: W_,
	setImmediate: G_,
	asap: K_,
	isIterable: q_,
	isSafeIterable: (e) => e != null && Ig(e, Ag) && q_(e)
}, J_ = Q.toObjectSet([
	"age",
	"authorization",
	"content-length",
	"content-type",
	"etag",
	"expires",
	"from",
	"host",
	"if-modified-since",
	"if-unmodified-since",
	"last-modified",
	"location",
	"max-forwards",
	"proxy-authorization",
	"referer",
	"retry-after",
	"user-agent"
]), Y_ = (e) => {
	let t = {}, n, r, i;
	return e && e.split("\n").forEach(function(e) {
		i = e.indexOf(":"), n = e.substring(0, i).trim().toLowerCase(), r = e.substring(i + 1).trim();
		let a = Q.hasOwnProp(t, n);
		!n || a && Q.hasOwnProp(J_, n) || (n === "set-cookie" ? a ? t[n].push(r) : t[n] = [r] : t[n] = a ? t[n] + ", " + r : r);
	}), t;
};
// node_modules/axios/lib/helpers/sanitizeHeaderValue.js
function X_(e) {
	let t = 0, n = e.length;
	for (; t < n;) {
		let n = e.charCodeAt(t);
		if (n !== 9 && n !== 32) break;
		t += 1;
	}
	for (; n > t;) {
		let t = e.charCodeAt(n - 1);
		if (t !== 9 && t !== 32) break;
		--n;
	}
	return t === 0 && n === e.length ? e : e.slice(t, n);
}
var Z_ = /* @__PURE__ */ RegExp("[\\u0000-\\u0008\\u000a-\\u001f\\u007f]+", "g"), Q_ = /* @__PURE__ */ RegExp("[^\\u0009\\u0020-\\u007e\\u0080-\\u00ff]+", "g");
function $_(e, t) {
	return Q.isArray(e) ? e.map((e) => $_(e, t)) : X_(String(e).replace(t, ""));
}
var ev = (e) => $_(e, Z_), tv = (e) => $_(e, Q_);
function nv(e) {
	let t = Object.create(null);
	return Q.forEach(e.toJSON(), (e, n) => {
		t[n] = tv(e);
	}), t;
}
// node_modules/axios/lib/core/AxiosHeaders.js
var rv = Symbol("internals");
function iv(e) {
	return e && String(e).trim().toLowerCase();
}
function av(e) {
	return e === !1 || e == null ? e : Q.isArray(e) ? e.map(av) : ev(String(e));
}
function ov(e) {
	let t = Object.create(null), n = /([^\s,;=]+)\s*(?:=\s*([^,;]+))?/g, r;
	for (; r = n.exec(e);) t[r[1]] = r[2];
	return t;
}
var sv = /^[!#$%&'*+\-.^_`|~0-9A-Za-z]+$/;
function cv(e) {
	let t = 0, n = e.length;
	for (; t < n;) {
		let n = e.charCodeAt(t);
		if (n !== 9 && n !== 32) break;
		t += 1;
	}
	for (; n > t;) {
		let t = e.charCodeAt(n - 1);
		if (t !== 9 && t !== 32) break;
		--n;
	}
	return t === 0 && n === e.length ? e : e.slice(t, n);
}
function lv(e) {
	let t = e.length - 1;
	if (t < 1 || e.charCodeAt(0) !== 34 || e.charCodeAt(t) !== 34) return e;
	let n = "";
	for (let r = 1; r < t; r++) {
		let i = e.charCodeAt(r);
		if (i === 34 || i === 92 && (r += 1, r >= t)) return e;
		n += e[r];
	}
	return n;
}
function uv(e) {
	let t = Object.create(null), n = String(e), r = 0, i = !1, a = !1;
	function o(e) {
		let i = cv(n.slice(r, e)), a = i.indexOf("=");
		if (a < 1) return;
		let o = cv(i.slice(0, a));
		if (!sv.test(o)) return;
		let s = o.toLowerCase();
		if (s === "__proto__" || s === "constructor" || s === "prototype") return;
		let c = cv(i.slice(a + 1));
		t[s] = lv(c);
	}
	for (let e = 0; e < n.length; e++) {
		let t = n.charCodeAt(e);
		i ? a ? a = !1 : t === 92 ? a = !0 : t === 34 && (i = !1) : t === 34 ? i = !0 : (t === 44 || t === 59) && (o(e), r = e + 1);
	}
	return o(n.length), t;
}
var dv = (e) => /^[-_a-zA-Z0-9^`|~,!#$%&'*+.]+$/.test(e.trim());
function fv(e, t, n, r, i) {
	if (Q.isFunction(r)) return r.call(this, t, n);
	if (i && (t = n), Q.isString(t)) {
		if (Q.isString(r)) return t.indexOf(r) !== -1;
		if (Q.isRegExp(r)) return r.test(t);
	}
}
function pv(e) {
	return e.trim().toLowerCase().replace(/([a-z\d])(\w*)/g, (e, t, n) => t.toUpperCase() + n);
}
function mv(e, t) {
	let n = Q.toCamelCase(" " + t);
	[
		"get",
		"set",
		"has"
	].forEach((r) => {
		Object.defineProperty(e, r + n, {
			__proto__: null,
			value: function(e, n, i) {
				return this[r].call(this, t, e, n, i);
			},
			configurable: !0
		});
	});
}
var hv = class {
	constructor(e) {
		e && this.set(e);
	}
	set(e, t, n) {
		let r = this;
		function i(e, t, n) {
			let i = iv(t);
			if (!i) return;
			let a = Q.findKey(r, i);
			(!a || r[a] === void 0 || n === !0 || n === void 0 && r[a] !== !1) && (r[a || t] = av(e));
		}
		let a = (e, t) => Q.forEach(e, (e, n) => i(e, n, t));
		if (Q.isPlainObject(e) || e instanceof this.constructor) a(e, t);
		else if (Q.isString(e) && (e = e.trim()) && !dv(e)) a(Y_(e), t);
		else if (Q.isObject(e) && Q.isSafeIterable(e)) {
			let n = Object.create(null), r, i;
			for (let t of e) {
				if (!Q.isArray(t)) throw TypeError("Object iterator must return a key-value pair");
				i = t[0], Q.hasOwnProp(n, i) ? (r = n[i], n[i] = Q.isArray(r) ? [...r, t[1]] : [r, t[1]]) : n[i] = t[1];
			}
			a(n, t);
		} else e != null && i(t, e, n);
		return this;
	}
	get(e, t) {
		if (e = iv(e), e) {
			let n = Q.findKey(this, e);
			if (n) {
				let e = this[n];
				if (!t) return e;
				if (t === !0) return ov(e);
				if (Q.isFunction(t)) return t.call(this, e, n);
				if (Q.isRegExp(t)) return t.exec(e);
				throw TypeError("parser must be boolean|regexp|function");
			}
		}
	}
	has(e, t) {
		if (e = iv(e), e) {
			let n = Q.findKey(this, e);
			return !(!n || this[n] === void 0 || t && !fv(this, this[n], n, t));
		}
		return !1;
	}
	delete(e, t) {
		let n = this, r = !1;
		function i(e) {
			if (e = iv(e), e) {
				let i = Q.findKey(n, e);
				i && (!t || fv(n, n[i], i, t)) && (delete n[i], r = !0);
			}
		}
		return Q.isArray(e) ? e.forEach(i) : i(e), r;
	}
	clear(e) {
		let t = Object.keys(this), n = t.length, r = !1;
		for (; n--;) {
			let i = t[n];
			(!e || fv(this, this[i], i, e, !0)) && (delete this[i], r = !0);
		}
		return r;
	}
	normalize(e) {
		let t = this, n = {};
		return Q.forEach(this, (r, i) => {
			let a = Q.findKey(n, i);
			if (a) {
				t[a] = av(r), delete t[i];
				return;
			}
			let o = e ? pv(i) : String(i).trim();
			o !== i && delete t[i], t[o] = av(r), n[o] = !0;
		}), this;
	}
	concat(...e) {
		return this.constructor.concat(this, ...e);
	}
	toJSON(e) {
		let t = Object.create(null);
		return Q.forEach(this, (n, r) => {
			n != null && n !== !1 && (t[r] = e && Q.isArray(n) ? n.join(", ") : n);
		}), t;
	}
	[Symbol.iterator]() {
		return Object.entries(this.toJSON())[Symbol.iterator]();
	}
	toString() {
		return Object.entries(this.toJSON()).map(([e, t]) => e + ": " + t).join("\n");
	}
	getSetCookie() {
		let e = this.get("set-cookie");
		return Q.isArray(e) ? e : e == null || e === !1 ? [] : [e];
	}
	get [Symbol.toStringTag]() {
		return "AxiosHeaders";
	}
	static from(e) {
		return e instanceof this ? e : new this(e);
	}
	static parseParameters(e) {
		return uv(e);
	}
	static concat(e, ...t) {
		let n = new this(e);
		return t.forEach((e) => n.set(e)), n;
	}
	static accessor(e) {
		let t = (this[rv] = this[rv] = { accessors: {} }).accessors, n = this.prototype;
		function r(e) {
			let r = iv(e);
			t[r] || (mv(n, e), t[r] = !0);
		}
		return Q.isArray(e) ? e.forEach(r) : r(e), this;
	}
};
hv.accessor([
	"Content-Type",
	"Content-Length",
	"Accept",
	"Accept-Encoding",
	"User-Agent",
	"Authorization"
]), Q.reduceDescriptors(hv.prototype, ({ value: e }, t) => {
	let n = t[0].toUpperCase() + t.slice(1);
	return {
		get: () => e,
		set(e) {
			this[n] = e;
		}
	};
}), Q.freezeMethods(hv);
// node_modules/axios/lib/core/AxiosError.js
var gv = "[REDACTED ****]";
function _v(e) {
	if (Q.hasOwnProp(e, "toJSON")) return !0;
	let t = Object.getPrototypeOf(e);
	for (; t && t !== Object.prototype;) {
		if (Q.hasOwnProp(t, "toJSON")) return !0;
		t = Object.getPrototypeOf(t);
	}
	return !1;
}
function vv(e, t) {
	let n = new Set(t.map((e) => String(e).toLowerCase())), r = [], i = (e) => {
		if (typeof e != "object" || !e || Q.isBuffer(e)) return e;
		if (r.indexOf(e) !== -1) return;
		e instanceof hv && (e = e.toJSON()), r.push(e);
		let t;
		if (Q.isArray(e)) t = [], e.forEach((e, n) => {
			let r = i(e);
			Q.isUndefined(r) || (t[n] = r);
		});
		else {
			if (!Q.isPlainObject(e) && _v(e)) return r.pop(), e;
			t = Object.create(null);
			for (let [r, a] of Object.entries(e)) {
				let e = n.has(r.toLowerCase()) ? gv : i(a);
				Q.isUndefined(e) || (t[r] = e);
			}
		}
		return r.pop(), t;
	};
	return i(e);
}
function yv(e) {
	try {
		return String(e);
	} catch {
		return "";
	}
}
function bv(e) {
	return e.errors.map((e) => {
		try {
			return e && e.message ? yv(e.message) : yv(e);
		} catch {
			return "";
		}
	}).filter(Boolean).join("; ") || e.name || "AggregateError";
}
var $ = class e extends Error {
	static from(t, n, r, i, a, o) {
		let s = t.message;
		!s && Q.isArray(t.errors) && t.errors.length && (s = bv(t));
		let c = new e(s, n || t.code, r, i, a);
		return Object.defineProperty(c, "cause", {
			__proto__: null,
			value: t,
			writable: !0,
			enumerable: !1,
			configurable: !0
		}), c.name = t.name, t.status != null && c.status == null && (c.status = t.status), o && Object.assign(c, o), c;
	}
	constructor(e, t, n, r, i) {
		super(e), Object.defineProperty(this, "message", {
			__proto__: null,
			value: e,
			enumerable: !0,
			writable: !0,
			configurable: !0
		}), this.name = "AxiosError", this.isAxiosError = !0, t && (this.code = t), n && (this.config = n), r && (this.request = r), i && (this.response = i, this.status = i.status);
	}
	toJSON() {
		let e = this.config, t = e && Q.hasOwnProp(e, "redact") ? e.redact : void 0, n = Q.isArray(t) && t.length > 0 ? vv(e, t) : Q.toJSONObject(e);
		return {
			message: this.message,
			name: this.name,
			description: this.description,
			number: this.number,
			fileName: this.fileName,
			lineNumber: this.lineNumber,
			columnNumber: this.columnNumber,
			stack: this.stack,
			config: n,
			code: this.code,
			status: this.status
		};
	}
};
$.ERR_BAD_OPTION_VALUE = "ERR_BAD_OPTION_VALUE", $.ERR_BAD_OPTION = "ERR_BAD_OPTION", $.ECONNABORTED = "ECONNABORTED", $.ETIMEDOUT = "ETIMEDOUT", $.ECONNREFUSED = "ECONNREFUSED", $.ERR_NETWORK = "ERR_NETWORK", $.ERR_FR_TOO_MANY_REDIRECTS = "ERR_FR_TOO_MANY_REDIRECTS", $.ERR_DEPRECATED = "ERR_DEPRECATED", $.ERR_BAD_RESPONSE = "ERR_BAD_RESPONSE", $.ERR_BAD_REQUEST = "ERR_BAD_REQUEST", $.ERR_CANCELED = "ERR_CANCELED", $.ERR_NOT_SUPPORT = "ERR_NOT_SUPPORT", $.ERR_INVALID_URL = "ERR_INVALID_URL", $.ERR_FORM_DATA_DEPTH_EXCEEDED = "ERR_FORM_DATA_DEPTH_EXCEEDED";
function xv(e) {
	return Q.isPlainObject(e) || Q.isArray(e);
}
function Sv(e) {
	return Q.endsWith(e, "[]") ? e.slice(0, -2) : e;
}
function Cv(e, t, n) {
	return e ? e.concat(t).map(function(e, t) {
		return e = Sv(e), !n && t ? "[" + e + "]" : e;
	}).join(n ? "." : "") : t;
}
function wv(e) {
	return Q.isArray(e) && !e.some(xv);
}
var Tv = Q.toFlatObject(Q, {}, null, function(e) {
	return /^is[A-Z]/.test(e);
});
function Ev(e, t, n) {
	if (!Q.isObject(e)) throw TypeError("target must be an object");
	t ||= new FormData();
	let r = (e, t) => {
		let r = Q.getSafeProp(n, e);
		return Q.isUndefined(r) ? t : r;
	}, i = r("metaTokens", !0), a = r("visitor") || h, o = r("dots", !1), s = r("indexes", !1), c = r("Blob") || typeof Blob < "u" && Blob, l = r("maxDepth", 100), u = c && Q.isSpecCompliantForm(t), d = [];
	if (!Q.isFunction(a)) throw TypeError("visitor must be a function");
	function f(e) {
		if (e === null) return "";
		if (Q.isDate(e)) return e.toISOString();
		if (Q.isBoolean(e)) return e.toString();
		if (!u && Q.isBlob(e)) throw new $("Blob is not supported. Use a Buffer instead.");
		if (Q.isArrayBuffer(e) || Q.isTypedArray(e)) {
			if (u && typeof c == "function") return new c([e]);
			throw new $("Blob is not supported. Use a Buffer instead.", $.ERR_NOT_SUPPORT);
		}
		return e;
	}
	function p(e) {
		if (e > l) throw new $("Object is too deeply nested (" + e + " levels). Max depth: " + l, $.ERR_FORM_DATA_DEPTH_EXCEEDED);
	}
	function m(e, t) {
		if (l === Infinity) return JSON.stringify(e);
		let n = [];
		return JSON.stringify(e, function(e, r) {
			if (!Q.isObject(r)) return r;
			for (; n.length && n[n.length - 1] !== this;) n.pop();
			return n.push(r), p(t + n.length - 1), r;
		});
	}
	function h(e, n, r) {
		let a = e;
		if (Q.isReactNative(t) && Q.isReactNativeBlob(e)) return t.append(Cv(r, n, o), f(e)), !1;
		if (e && !r && typeof e == "object") {
			if (Q.endsWith(n, "{}")) n = i ? n : n.slice(0, -2), e = m(e, 1);
			else if (Q.isArray(e) && wv(e) || (Q.isFileList(e) || Q.endsWith(n, "[]")) && (a = Q.toArray(e))) return n = Sv(n), a.forEach(function(e, r) {
				!(Q.isUndefined(e) || e === null) && t.append(s === !0 ? Cv([n], r, o) : s === null ? n : n + "[]", f(e));
			}), !1;
		}
		return xv(e) ? !0 : (t.append(Cv(r, n, o), f(e)), !1);
	}
	let g = Object.assign(Tv, {
		defaultVisitor: h,
		convertValue: f,
		isVisitable: xv
	});
	function _(e, n, r = 0) {
		if (!Q.isUndefined(e)) {
			if (p(r), d.indexOf(e) !== -1) throw Error("Circular reference detected in " + n.join("."));
			d.push(e), Q.forEach(e, function(e, i) {
				(!(Q.isUndefined(e) || e === null) && a.call(t, e, Q.isString(i) ? i.trim() : i, n, g)) === !0 && _(e, n ? n.concat(i) : [i], r + 1);
			}), d.pop();
		}
	}
	if (!Q.isObject(e)) throw TypeError("data must be an object");
	return _(e), t;
}
// node_modules/axios/lib/helpers/AxiosURLSearchParams.js
function Dv(e) {
	let t = {
		"!": "%21",
		"'": "%27",
		"(": "%28",
		")": "%29",
		"~": "%7E",
		"%20": "+"
	};
	return encodeURIComponent(e).replace(/[!'()~]|%20/g, function(e) {
		return t[e];
	});
}
function Ov(e, t) {
	this._pairs = [], e && Ev(e, this, t);
}
var kv = Ov.prototype;
kv.append = function(e, t) {
	this._pairs.push([e, t]);
}, kv.toString = function(e) {
	let t = e ? (t) => e.call(this, t, Dv) : Dv;
	return this._pairs.map(function(e) {
		return t(e[0]) + "=" + t(e[1]);
	}, "").join("&");
};
// node_modules/axios/lib/helpers/buildURL.js
function Av(e) {
	return encodeURIComponent(e).replace(/%3A/gi, ":").replace(/%24/g, "$").replace(/%2C/gi, ",").replace(/%20/g, "+");
}
function jv(e, t, n) {
	if (!t) return e;
	e ||= "";
	let r = Q.isFunction(n) ? { serialize: n } : n, i = Q.getSafeProp(r, "encode") || Av, a = Q.getSafeProp(r, "serialize"), o;
	if (o = a ? a(t, r) : Q.isURLSearchParams(t) ? t.toString() : new Ov(t, r).toString(i), o) {
		let t = e.indexOf("#");
		t !== -1 && (e = e.slice(0, t)), e += (e.indexOf("?") === -1 ? "?" : "&") + o;
	}
	return e;
}
// node_modules/axios/lib/core/InterceptorManager.js
var Mv = Symbol("internals");
function Nv(e) {
	return e ? e.length : 0;
}
function Pv(e) {
	if (e) for (; e.length && e[e.length - 1] === null;) e.pop();
}
function Fv(e, t) {
	let n = e.handlers, r = Nv(n);
	n === t.handlersRef ? r !== t.handlersLength && (r ? t.handlerEntries.forEach(function(e, r) {
		n[e.index] !== e.handler && t.handlerEntries.delete(r);
	}) : t.handlerEntries.clear()) : (t.handlersRef = n, t.handlerEntries.clear()), t.handlersLength = r;
}
var Iv = class {
	constructor() {
		this.handlers = [], this[Mv] = {
			handlersRef: this.handlers,
			handlersLength: this.handlers.length,
			handlerEntries: /* @__PURE__ */ new Map(),
			iterationDepth: 0,
			nextId: 0
		};
	}
	use(e, t, n) {
		let r = {
			fulfilled: e,
			rejected: t,
			synchronous: n ? n.synchronous : !1,
			runWhen: n ? n.runWhen : null
		}, i = this[Mv];
		this.handlers ??= [], Fv(this, i);
		let a = i.nextId++;
		return this.handlers.push(r), i.handlerEntries.set(a, {
			handler: r,
			index: this.handlers.length - 1
		}), i.handlersLength = this.handlers.length, a;
	}
	eject(e) {
		let t = this[Mv];
		Fv(this, t);
		let n = t.handlerEntries.get(e);
		if (n) {
			if (t.handlerEntries.delete(e), this.handlers[n.index] !== n.handler) return;
			this.handlers[n.index] = null, t.iterationDepth || (Pv(this.handlers), t.handlersLength = this.handlers.length);
		}
	}
	clear() {
		this.handlers && (this.handlers = [], Fv(this, this[Mv]));
	}
	forEach(e) {
		let t = this[Mv];
		Fv(this, t), t.iterationDepth++;
		try {
			Q.forEach(this.handlers, function(t) {
				t !== null && e(t);
			});
		} finally {
			--t.iterationDepth || (Fv(this, t), Pv(this.handlers), t.handlersLength = Nv(this.handlers));
		}
	}
}, Lv = {
	silentJSONParsing: !0,
	forcedJSONParsing: !0,
	clarifyTimeoutError: !1,
	legacyInterceptorReqResOrdering: !0,
	advertiseZstdAcceptEncoding: !1,
	validateStatusUndefinedResolves: !0
}, Rv = {
	isBrowser: !0,
	classes: {
		URLSearchParams: typeof URLSearchParams < "u" ? URLSearchParams : Ov,
		FormData: typeof FormData < "u" ? FormData : null,
		Blob: typeof Blob < "u" ? Blob : null
	},
	protocols: [
		"http",
		"https",
		"file",
		"blob",
		"url",
		"data"
	]
}, zv = /* @__PURE__ */ r({
	hasBrowserEnv: () => Bv,
	hasStandardBrowserEnv: () => Hv,
	hasStandardBrowserWebWorkerEnv: () => Uv,
	navigator: () => Vv,
	origin: () => Wv
}), Bv = typeof window < "u" && typeof document < "u", Vv = typeof navigator == "object" && navigator || void 0, Hv = Bv && (!Vv || [
	"ReactNative",
	"NativeScript",
	"NS"
].indexOf(Vv.product) < 0), Uv = typeof WorkerGlobalScope < "u" && self instanceof WorkerGlobalScope && typeof self.importScripts == "function", Wv = Bv && window.location.href || "http://localhost", Gv = {
	...zv,
	...Rv
};
// node_modules/axios/lib/helpers/toURLEncodedForm.js
function Kv(e, t) {
	return Ev(e, new Gv.classes.URLSearchParams(), {
		visitor: function(e, t, n, r) {
			return Gv.isNode && Q.isBuffer(e) ? (this.append(t, e.toString("base64")), !1) : r.defaultVisitor.apply(this, arguments);
		},
		...t
	});
}
// node_modules/axios/lib/helpers/formDataToJSON.js
var qv = 100;
function Jv(e) {
	if (e > qv) throw new $("FormData field is too deeply nested (" + e + " levels). Max depth: " + qv, $.ERR_FORM_DATA_DEPTH_EXCEEDED);
}
function Yv(e) {
	let t = [], n = /[^.[\]]+|\[([^.[\]]*)]/g, r;
	for (; (r = n.exec(e)) !== null;) Jv(t.length), t.push(r[0] === "[]" ? "" : r[1] || r[0]);
	return t;
}
function Xv(e) {
	let t = {}, n = Object.keys(e), r, i = n.length, a;
	for (r = 0; r < i; r++) a = n[r], t[a] = e[a];
	return t;
}
function Zv(e) {
	function t(e, n, r, i) {
		Jv(i);
		let a = e[i++];
		if (a === "__proto__") return !0;
		let o = Number.isFinite(+a), s = i >= e.length;
		return a = !a && Q.isArray(r) ? r.length : a, s ? (Q.hasOwnProp(r, a) ? r[a] = Q.isArray(r[a]) ? r[a].concat(n) : [r[a], n] : r[a] = n, !o) : (Q.hasOwnProp(r, a) && Q.isObject(r[a]) || (r[a] = []), t(e, n, r[a], i) && Q.isArray(r[a]) && (r[a] = Xv(r[a])), !o);
	}
	if (Q.isFormData(e) && Q.isFunction(e.entries)) {
		let n = {};
		return Q.forEachEntry(e, (e, r) => {
			t(Yv(e), r, n, 0);
		}), n;
	}
	return null;
}
// node_modules/axios/lib/core/methodList.js
var Qv = Object.freeze([
	"get",
	"delete",
	"head",
	"options",
	"post",
	"put",
	"patch",
	"purge",
	"link",
	"unlink",
	"query"
]), $v = (e, t) => e != null && Q.hasOwnProp(e, t) ? e[t] : void 0;
function ey(e, t, n) {
	if (Q.isString(e)) try {
		return (t || JSON.parse)(e), Q.trim(e);
	} catch (e) {
		if (e.name !== "SyntaxError") throw e;
	}
	return (n || JSON.stringify)(e);
}
var ty = {
	transitional: Lv,
	adapter: [
		"xhr",
		"http",
		"fetch"
	],
	transformRequest: [function(e, t) {
		let n = t.getContentType() || "", r = n.indexOf("application/json") > -1, i = Q.isObject(e);
		if (i && Q.isHTMLForm(e) && (e = new FormData(e)), Q.isFormData(e)) return r ? JSON.stringify(Zv(e)) : e;
		if (Q.isArrayBuffer(e) || Q.isBuffer(e) || Q.isStream(e) || Q.isFile(e) || Q.isBlob(e) || Q.isReadableStream(e)) return e;
		if (Q.isArrayBufferView(e)) return e.buffer;
		if (Q.isURLSearchParams(e)) return t.setContentType("application/x-www-form-urlencoded;charset=utf-8", !1), e.toString();
		let a;
		if (i) {
			let t = $v(this, "formSerializer");
			if (n.indexOf("application/x-www-form-urlencoded") > -1) return Kv(e, t).toString();
			if ((a = Q.isFileList(e)) || n.indexOf("multipart/form-data") > -1) {
				let n = $v(this, "env"), r = n && n.FormData;
				return Ev(a ? { "files[]": e } : e, r && new r(), t);
			}
		}
		return i || r ? (t.setContentType("application/json", !1), ey(e)) : e;
	}],
	transformResponse: [function(e) {
		let t = $v(this, "transitional") || ty.transitional, n = t && t.forcedJSONParsing, r = $v(this, "responseType"), i = r === "json";
		if (Q.isResponse(e) || Q.isReadableStream(e)) return e;
		if (e && Q.isString(e) && (n && !r || i)) {
			let n = !(t && t.silentJSONParsing) && i;
			try {
				return JSON.parse(e, $v(this, "parseReviver"));
			} catch (e) {
				if (n) throw e.name === "SyntaxError" ? $.from(e, $.ERR_BAD_RESPONSE, this, null, $v(this, "response")) : e;
			}
		}
		return e;
	}],
	timeout: 0,
	xsrfCookieName: "XSRF-TOKEN",
	xsrfHeaderName: "X-XSRF-TOKEN",
	maxContentLength: -1,
	maxBodyLength: -1,
	env: {
		FormData: Gv.classes.FormData,
		Blob: Gv.classes.Blob
	},
	validateStatus: function(e) {
		return e >= 200 && e < 300;
	},
	headers: { common: {
		Accept: "application/json, text/plain, */*",
		"Content-Type": void 0
	} }
};
Q.forEach(Qv, (e) => {
	ty.headers[e] = {};
});
// node_modules/axios/lib/core/transformData.js
function ny(e, t) {
	let n = this || ty, r = t || n, i = hv.from(r.headers), a = r.data;
	return Q.forEach(e, function(e) {
		a = e.call(n, a, i.normalize(), t ? t.status : void 0);
	}), i.normalize(), a;
}
// node_modules/axios/lib/cancel/isCancel.js
function ry(e) {
	return !!(e && e.__CANCEL__);
}
// node_modules/axios/lib/cancel/CanceledError.js
var iy = class extends $ {
	constructor(e, t, n) {
		super(e ?? "canceled", $.ERR_CANCELED, t, n), this.name = "CanceledError", this.__CANCEL__ = !0;
	}
};
// node_modules/axios/lib/core/settle.js
function ay(e, t, n) {
	let r = n.config.validateStatus;
	!n.status || !r || r(n.status) ? e(n) : t(new $("Request failed with status code " + n.status, n.status >= 400 && n.status < 500 ? $.ERR_BAD_REQUEST : $.ERR_BAD_RESPONSE, n.config, n.request, n));
}
// node_modules/axios/lib/helpers/normalizeURLForProtocolCheck.js
var oy = /[\t\n\r]/g;
function sy(e) {
	if (typeof e != "string") return e;
	let t = 0;
	for (; t < e.length && e.charCodeAt(t) <= 32;) t++;
	return e.slice(t).replace(oy, "");
}
// node_modules/axios/lib/helpers/parseProtocol.js
function cy(e) {
	let t = /^([-+\w]{1,25}):(?:\/\/)?/.exec(e);
	return t && t[1] || "";
}
// node_modules/axios/lib/helpers/speedometer.js
function ly(e, t) {
	e ||= 10;
	let n = Array(e), r = Array(e), i = 0, a = 0, o;
	return t = t === void 0 ? 1e3 : t, function(s) {
		let c = Date.now(), l = r[a];
		o ||= c, n[i] = s, r[i] = c;
		let u = a, d = 0;
		for (; u !== i;) d += n[u++], u %= e;
		if (i = (i + 1) % e, i === a && (a = (a + 1) % e), c - o < t) return;
		let f = l && c - l;
		return f ? Math.round(d * 1e3 / f) : void 0;
	};
}
// node_modules/axios/lib/helpers/throttle.js
function uy(e, t) {
	let n = 0, r = 1e3 / t, i, a, o = (t, r = Date.now()) => {
		n = r, i = null, a &&= (clearTimeout(a), null), e(...t);
	};
	return [
		(...e) => {
			let t = Date.now(), s = t - n;
			s >= r ? o(e, t) : (i = e, a ||= setTimeout(() => {
				a = null, o(i);
			}, r - s));
		},
		() => i && o(i),
		(...e) => o(e)
	];
}
// node_modules/axios/lib/helpers/progressEventReducer.js
var dy = (e, t, n = 3) => {
	let r = 0, i = ly(50, 250);
	return uy((n) => {
		if (!n || !Q.isNumber(n.loaded)) return;
		let a = n.loaded, o = n.lengthComputable ? n.total : void 0, s = Math.max(0, o == null ? a : Math.min(a, o)), c = Math.max(0, s - r), l = i(c);
		r = Math.max(r, s), e({
			loaded: s,
			total: o,
			progress: o ? s / o : void 0,
			bytes: c,
			rate: l || void 0,
			estimated: l && o ? (o - s) / l : void 0,
			event: n,
			lengthComputable: o != null,
			[t ? "download" : "upload"]: !0
		});
	}, n);
}, fy = (e, t) => {
	let n = e != null;
	return [(r) => t[0]({
		lengthComputable: n,
		total: e,
		loaded: r
	}), t[1]];
}, py = (e, t = Q.asap) => (...n) => t(() => e(...n)), my = Gv.hasStandardBrowserEnv ? ((e, t) => (n) => (n = new URL(n, Gv.origin), e.protocol === n.protocol && e.host === n.host && (t || e.port === n.port)))(new URL(Gv.origin), Gv.navigator && /(msie|trident)/i.test(Gv.navigator.userAgent)) : () => !0, hy = Gv.hasStandardBrowserEnv ? {
	write(e, t, n, r, i, a, o) {
		if (typeof document > "u") return;
		let s = [`${e}=${encodeURIComponent(t)}`];
		Q.isNumber(n) && s.push(`expires=${new Date(n).toUTCString()}`), Q.isString(r) && s.push(`path=${r}`), Q.isString(i) && s.push(`domain=${i}`), a === !0 && s.push("secure"), Q.isString(o) && s.push(`SameSite=${o}`), document.cookie = s.join("; ");
	},
	read(e) {
		if (typeof document > "u") return null;
		let t = document.cookie.split(";");
		for (let n = 0; n < t.length; n++) {
			let r = t[n].replace(/^\s+/, ""), i = r.indexOf("=");
			if (i !== -1 && r.slice(0, i) === e) try {
				return decodeURIComponent(r.slice(i + 1));
			} catch {
				return r.slice(i + 1);
			}
		}
		return null;
	},
	remove(e) {
		this.write(e, "", Date.now() - 864e5, "/");
	}
} : {
	write() {},
	read() {
		return null;
	},
	remove() {}
};
// node_modules/axios/lib/helpers/isAbsoluteURL.js
function gy(e) {
	return typeof e == "string" && /^([a-z][a-z\d+\-.]*:)?\/\//i.test(e);
}
// node_modules/axios/lib/helpers/combineURLs.js
function _y(e, t) {
	if (!t) return e;
	let n = e.length;
	for (; n > 0 && e.charCodeAt(n - 1) === 47;) n--;
	return e.slice(0, n) + "/" + t.replace(/^\/+/, "");
}
// node_modules/axios/lib/core/buildFullPath.js
var vy = /^https?:(?!\/\/)/i;
function yy(e) {
	return e && e.replace(/(^|&)([^=&]*=)?[^&]+/g, (e, t, n = "") => `${t}${n}${gv}`);
}
function by(e) {
	let t = e.replace(/^(https?:\/{0,2})[^/?#]*@/i, `$1${gv}@`), n = t.indexOf("#"), r = (n === -1 ? t : t.slice(0, n)).replace(/([?&][^=&#]*=)[^&#]*/g, `$1${gv}`);
	return n === -1 ? r : `${r}#${yy(t.slice(n + 1))}`;
}
function xy(e, t) {
	if (typeof e == "string") {
		let n = sy(e);
		if (vy.test(n)) throw new $(`Invalid URL ${JSON.stringify(by(n))}: missing "//" after protocol`, $.ERR_INVALID_URL, t);
	}
}
function Sy(e, t, n, r) {
	xy(t, r);
	let i = !gy(t);
	return e && (i || n === !1) ? (xy(e, r), _y(e, t)) : t;
}
// node_modules/axios/lib/core/mergeConfig.js
var Cy = (e) => e instanceof hv ? { ...e } : e, wy = (e) => Object.getOwnPropertySymbols && Object.getOwnPropertyDescriptor ? Object.keys(e).concat(Object.getOwnPropertySymbols(e).filter((t) => Object.getOwnPropertyDescriptor(e, t).enumerable)) : Object.keys(e);
function Ty(e, t) {
	e ||= {}, t ||= {};
	let n = Object.create(null);
	Object.defineProperty(n, "hasOwnProperty", {
		__proto__: null,
		value: Object.prototype.hasOwnProperty,
		enumerable: !1,
		writable: !0,
		configurable: !0
	});
	function r(e, t, n, r) {
		return Q.isPlainObject(e) && Q.isPlainObject(t) ? Q.merge.call({ caseless: r }, e, t) : Q.isPlainObject(t) ? Q.merge({}, t) : Q.isArray(t) ? t.slice() : t;
	}
	function i(e, t, n, i) {
		if (!Q.isUndefined(t)) return r(e, t, n, i);
		if (!Q.isUndefined(e)) return r(void 0, e, n, i);
	}
	function a(e, t) {
		if (!Q.isUndefined(t)) return r(void 0, t);
	}
	function o(e, t) {
		if (!Q.isUndefined(t)) return r(void 0, t);
		if (!Q.isUndefined(e)) return r(void 0, e);
	}
	function s(n) {
		let r = Q.hasOwnProp(t, "transitional") ? t.transitional : void 0;
		if (!Q.isUndefined(r)) {
			if (Q.isPlainObject(r)) {
				if (Q.hasOwnProp(r, n)) return r[n];
			} else return;
		}
		let i = Q.hasOwnProp(e, "transitional") ? e.transitional : void 0;
		if (Q.isPlainObject(i) && Q.hasOwnProp(i, n)) return i[n];
	}
	function c(n, i, a) {
		if (Q.hasOwnProp(t, a)) return r(n, i);
		if (Q.hasOwnProp(e, a)) return r(void 0, n);
	}
	let l = {
		url: a,
		method: a,
		data: a,
		baseURL: o,
		transformRequest: o,
		transformResponse: o,
		paramsSerializer: o,
		timeout: o,
		timeoutErrorMessage: o,
		withCredentials: o,
		withXSRFToken: o,
		adapter: o,
		responseType: o,
		xsrfCookieName: o,
		xsrfHeaderName: o,
		onUploadProgress: o,
		onDownloadProgress: o,
		decompress: o,
		maxContentLength: o,
		maxBodyLength: o,
		beforeRedirect: o,
		transport: o,
		httpAgent: o,
		httpsAgent: o,
		cancelToken: o,
		socketPath: o,
		allowedSocketPaths: o,
		responseEncoding: o,
		validateStatus: c,
		headers: (e, t, n) => i(Cy(e), Cy(t), n, !0)
	};
	return Q.forEach(wy({
		...e,
		...t
	}), function(r) {
		if (r === "__proto__" || r === "constructor" || r === "prototype") return;
		let a = Q.hasOwnProp(l, r) ? l[r] : i, o = a(Q.hasOwnProp(e, r) ? e[r] : void 0, Q.hasOwnProp(t, r) ? t[r] : void 0, r);
		Q.isUndefined(o) && a !== c || (n[r] = o);
	}), Q.hasOwnProp(t, "validateStatus") && Q.isUndefined(t.validateStatus) && s("validateStatusUndefinedResolves") === !1 && (Q.hasOwnProp(e, "validateStatus") ? n.validateStatus = r(void 0, e.validateStatus) : delete n.validateStatus), n;
}
// node_modules/axios/lib/core/setFormDataHeaders.js
var Ey = ["content-type", "content-length"];
function Dy(e, t, n) {
	n === "content-only" ? Object.entries(t || {}).forEach(([t, n]) => {
		Ey.includes(t.toLowerCase()) && e.set(t, n);
	}) : e.set(t);
}
// node_modules/axios/lib/helpers/resolveConfig.js
var Oy = (e) => encodeURIComponent(e).replace(/%([0-9A-F]{2})/gi, (e, t) => String.fromCharCode(parseInt(t, 16)));
function ky(e) {
	let t = Ty({}, e), n = (e) => Q.hasOwnProp(t, e) ? t[e] : void 0, r = n("data"), i = n("withXSRFToken"), a = n("xsrfHeaderName"), o = n("xsrfCookieName"), s = n("headers"), c = n("auth"), l = n("baseURL"), u = n("allowAbsoluteUrls"), d = n("url");
	if (t.headers = s = hv.from(s), t.url = jv(Sy(l, d, u, t), n("params"), n("paramsSerializer")), c) {
		let t = Q.getSafeProp(c, "username") || "", n = Q.getSafeProp(c, "password") || "";
		try {
			s.set("Authorization", "Basic " + btoa(t + ":" + (n ? Oy(n) : "")));
		} catch (t) {
			throw $.from(t, $.ERR_BAD_OPTION_VALUE, e);
		}
	}
	if (Q.isFormData(r)) {
		let e = Q.getSafeProp(r, "getHeaders");
		Gv.hasStandardBrowserEnv || Gv.hasStandardBrowserWebWorkerEnv || Q.isReactNative(r) ? s.setContentType(void 0) : Q.isFunction(e) && Dy(s, e.call(r), n("formDataHeaderPolicy"));
	}
	if (Gv.hasStandardBrowserEnv && (Q.isFunction(i) && (i = i(t)), i === !0 || i == null && my(t.url))) {
		let e = a && o && hy.read(o);
		e && s.set(a, e);
	}
	return t;
}
var Ay = typeof XMLHttpRequest < "u" && function(e) {
	return new Promise(function(t, n) {
		let r = ky(e), i = r.data, a = hv.from(r.headers).normalize(), { responseType: o, onUploadProgress: s, onDownloadProgress: c } = r, l, u, d, f, p, m;
		function h() {
			f && f(), p && p(), r.cancelToken && r.cancelToken.unsubscribe(l), r.signal && r.signal.removeEventListener("abort", l);
		}
		let g = new XMLHttpRequest();
		g.open(r.method.toUpperCase(), r.url, !0), g.timeout = r.timeout;
		function _(i) {
			if (!g) return;
			if (g.status === 0 && (cy(sy(r.url)) || cy(Gv.origin)) !== "file" && !(g.responseURL && g.responseURL.startsWith("file:"))) {
				n(new $("Request aborted", $.ECONNABORTED, e, g)), h(), g = null;
				return;
			}
			try {
				i ? m && m(i) : p && p();
			} catch (e) {
				setTimeout(() => {
					throw e;
				});
			}
			if (!g) return;
			let a = hv.from("getAllResponseHeaders" in g && g.getAllResponseHeaders());
			ay(function(e) {
				t(e), h();
			}, function(e) {
				n(e), h();
			}, {
				data: !o || o === "text" || o === "json" ? g.responseText : g.response,
				status: g.status,
				statusText: g.statusText,
				headers: a,
				config: e,
				request: g
			}), g = null;
		}
		"onloadend" in g ? g.onloadend = _ : g.onreadystatechange = function() {
			g && g.readyState === 4 && (g.status !== 0 || g.responseURL && g.responseURL.startsWith("file:")) && setTimeout(_);
		}, g.onabort = function() {
			g &&= (n(new $("Request aborted", $.ECONNABORTED, e, g)), h(), null);
		}, g.onerror = function(t) {
			let r = new $(t && t.message ? t.message : "Network Error", $.ERR_NETWORK, e, g);
			r.event = t || null, n(r), h(), g = null;
		}, g.ontimeout = function() {
			let t = r.timeout ? "timeout of " + r.timeout + "ms exceeded" : "timeout exceeded", i = r.transitional || Lv;
			r.timeoutErrorMessage && (t = r.timeoutErrorMessage), n(new $(t, i.clarifyTimeoutError ? $.ETIMEDOUT : $.ECONNABORTED, e, g)), h(), g = null;
		}, i === void 0 && a.setContentType(null), "setRequestHeader" in g && Q.forEach(nv(a), function(e, t) {
			g.setRequestHeader(t, e);
		}), Q.isUndefined(r.withCredentials) || (g.withCredentials = !!r.withCredentials), o && o !== "json" && (g.responseType = r.responseType), c && ([d, p, m] = dy(c, !0), g.addEventListener("progress", d)), s && g.upload && ([u, f] = dy(s), g.upload.addEventListener("progress", u), g.upload.addEventListener("loadend", f)), (r.cancelToken || r.signal) && (l = (t) => {
			g &&= (n(!t || t.type ? new iy(null, e, g) : t), g.abort(), h(), null);
		}, r.cancelToken && r.cancelToken.subscribe(l), r.signal && (r.signal.aborted ? l() : r.signal.addEventListener("abort", l)));
		let v = cy(r.url);
		v && !Gv.protocols.includes(v) ? (n(new $("Unsupported protocol " + v + ":", $.ERR_BAD_REQUEST, e)), h()) : g.send(i || null);
	});
}, jy = (e, t) => {
	if (e = e ? e.filter(Boolean) : [], !t && !e.length) return;
	let n = new AbortController(), r = !1, i = function(e) {
		if (!r) {
			r = !0, o();
			let t = e instanceof Error ? e : this.reason;
			n.abort(t instanceof $ ? t : new iy(t instanceof Error ? t.message : t));
		}
	}, a = t && setTimeout(() => {
		a = null, i(new $(`timeout of ${t}ms exceeded`, $.ETIMEDOUT));
	}, t), o = () => {
		e &&= (a && clearTimeout(a), a = null, e.forEach((e) => {
			e.unsubscribe ? e.unsubscribe(i) : e.removeEventListener("abort", i);
		}), null);
	};
	e.forEach((e) => {
		r || (e.aborted ? i.call(e) : e.addEventListener("abort", i, { once: !0 }));
	});
	let { signal: s } = n;
	return s.unsubscribe = () => Q.asap(o), s;
}, My = function* (e, t) {
	let n = e.byteLength;
	if (!t || n < t) {
		yield e;
		return;
	}
	let r = 0, i;
	for (; r < n;) i = r + t, yield e.slice(r, i), r = i;
}, Ny = async function* (e, t) {
	for await (let n of Py(e)) yield* My(n, t);
}, Py = async function* (e) {
	if (e[Symbol.asyncIterator]) {
		yield* e;
		return;
	}
	let t = e.getReader();
	try {
		for (;;) {
			let { done: e, value: n } = await t.read();
			if (e) break;
			yield n;
		}
	} finally {
		await t.cancel();
	}
}, Fy = (e, t, n, r) => {
	let i = Ny(e, t), a = 0, o, s = (e) => {
		o || (o = !0, r && r(e));
	};
	return new ReadableStream({
		async pull(e) {
			try {
				let { done: t, value: r } = await i.next();
				if (t) {
					s(), e.close();
					return;
				}
				let o = r.byteLength;
				n && n(a += o), e.enqueue(new Uint8Array(r));
			} catch (e) {
				throw s(e), e;
			}
		},
		cancel(e) {
			return s(e), i.return();
		}
	}, { highWaterMark: 2 });
}, Iy = (e) => e >= 48 && e <= 57 || e >= 65 && e <= 70 || e >= 97 && e <= 102, Ly = (e, t, n) => t + 2 < n && Iy(e.charCodeAt(t + 1)) && Iy(e.charCodeAt(t + 2)), Ry = (e) => e <= 57 ? e - 48 : (e & 223) - 55, zy = (e) => e >= 65 && e <= 90 || e >= 97 && e <= 122 || e >= 48 && e <= 57 || e === 43 || e === 47 || e === 45 || e === 95, By = (e) => e === 9 || e === 10 || e === 12 || e === 13 || e === 32, Vy = (e) => {
	let t = Math.floor(e / 4), n = e % 4;
	return t * 3 + (n === 2 ? 1 : n === 3 ? 2 : 0);
}, Hy = (e) => {
	let t = e.length, n = 0;
	return t > 0 && e.charCodeAt(t - 1) === 61 && (n++, t > 1 && e.charCodeAt(t - 2) === 61 && n++), Math.floor((t - n) * 3 / 4);
}, Uy = (e) => {
	let t = e.length, n = 0, r = 0, i = !1;
	for (let a = 0; a < t; a++) {
		let o = e.charCodeAt(a);
		o === 37 && Ly(e, a, t) && (o = Ry(e.charCodeAt(a + 1)) * 16 + Ry(e.charCodeAt(a + 2)), a += 2), !By(o) && (o === 61 ? r++ : !zy(o) || r > 0 ? i = !0 : n++);
	}
	return i || r > 2 || r > 0 && (n + r) % 4 != 0 || n % 4 == 1 ? Hy(e) : Vy(n);
}, Wy = (e, t) => {
	if (!e || typeof e != "string" || !e.startsWith("data:")) return 0;
	let n = e.indexOf(",");
	if (n < 0) return 0;
	let r = e.slice(5, n), i = e.slice(n + 1);
	if (/;base64/i.test(r)) return t(i);
	let a = 0;
	for (let e = 0, t = i.length; e < t; e++) {
		let n = i.charCodeAt(e);
		if (n === 37 && Ly(i, e, t)) a += 1, e += 2;
		else if (n < 128) a += 1;
		else if (n < 2048) a += 2;
		else if (n >= 55296 && n <= 56319 && e + 1 < t) {
			let t = i.charCodeAt(e + 1);
			t >= 56320 && t <= 57343 ? (a += 4, e++) : a += 3;
		} else a += 3;
	}
	return a;
};
function Gy(e) {
	let t = typeof e == "string" ? e.indexOf("#") : -1;
	return Wy(t === -1 ? e : e.slice(0, t), Uy);
}
// node_modules/axios/lib/env/data.js
var Ky = "1.20.0", qy = 65536, Jy = {
	cache: "default",
	redirect: "follow",
	referrer: "about:client",
	referrerPolicy: "",
	mode: "cors",
	integrity: "",
	keepalive: !1,
	priority: "auto",
	window: null
}, { isFunction: Yy } = Q, Xy = (e) => encodeURIComponent(e).replace(/%([0-9A-F]{2})/gi, (e, t) => String.fromCharCode(parseInt(t, 16))), Zy = (e) => {
	if (!Q.isString(e)) return e;
	try {
		return decodeURIComponent(e);
	} catch {
		return e;
	}
}, Qy = (e, ...t) => {
	try {
		return !!e(...t);
	} catch {
		return !1;
	}
}, $y = (e) => {
	let t = e.indexOf("://"), n = e;
	return t !== -1 && (n = n.slice(t + 3)), n.includes("@") || n.includes(":");
}, eb = (e) => {
	let t = Q.global !== void 0 && Q.global !== null ? Q.global : globalThis, { ReadableStream: n, TextEncoder: r } = t;
	e = Q.merge.call({ skipUndefined: !0 }, {
		Request: t.Request,
		Response: t.Response
	}, e);
	let { fetch: i, Request: a, Response: o } = e, s = i ? Yy(i) : typeof fetch == "function", c = Yy(a), l = Yy(o);
	if (!s) return !1;
	let u = s && Yy(n), d = s && (typeof r == "function" ? ((e) => (t) => e.encode(t))(new r()) : async (e) => new Uint8Array(await new a(e).arrayBuffer())), f = c && u && Qy(() => {
		let e = !1, t = new a(Gv.origin, {
			body: new n(),
			method: "POST",
			get duplex() {
				return e = !0, "half";
			}
		}), r = t.headers.has("Content-Type");
		return t.body != null && t.body.cancel(), e && !r;
	}), p = l && u && Qy(() => Q.isReadableStream(new o("").body)), m = { stream: p && ((e) => e.body) };
	s && [
		"text",
		"arrayBuffer",
		"blob",
		"formData",
		"stream"
	].forEach((e) => {
		!m[e] && (m[e] = (t, n) => {
			let r = t && t[e];
			if (r) return r.call(t);
			throw new $(`Response type '${e}' is not supported`, $.ERR_NOT_SUPPORT, n);
		});
	});
	let h = async (e) => {
		if (e == null) return 0;
		if (Q.isBlob(e)) return e.size;
		if (Q.isSpecCompliantForm(e)) return (await new a(Gv.origin, {
			method: "POST",
			body: e
		}).arrayBuffer()).byteLength;
		if (Q.isArrayBufferView(e) || Q.isArrayBuffer(e)) return e.byteLength;
		if (Q.isURLSearchParams(e) && (e += ""), Q.isString(e)) return (await d(e)).byteLength;
	}, g = async (e, t) => Q.toFiniteNumber(e.getContentLength()) ?? h(t);
	return async (e) => {
		let { url: t, method: n, data: s, signal: l, cancelToken: d, timeout: _, onDownloadProgress: v, onUploadProgress: y, responseType: b, headers: x, withCredentials: S = "same-origin", fetchOptions: C, maxContentLength: w, maxBodyLength: ee, maxRedirects: te } = ky(e), ne = Q.isNumber(w) && w > -1, re = Q.isNumber(ee) && ee > -1, ie = (t) => Q.hasOwnProp(e, t) ? e[t] : void 0, ae = i || fetch;
		b = b ? (b + "").toLowerCase() : "text";
		let oe = jy([l, d && d.toAbortSignal()], _), se = null, ce = oe && oe.unsubscribe && (() => {
			oe.unsubscribe();
		}), le, ue = null, de = () => new $("Request body larger than maxBodyLength limit", $.ERR_BAD_REQUEST, e, se);
		try {
			let i, l = ie("auth");
			if (l && (i = {
				username: Q.getSafeProp(l, "username") || "",
				password: Q.getSafeProp(l, "password") || ""
			}), $y(t)) {
				let e = new URL(t, Gv.origin);
				!i && (e.username || e.password) && (i = {
					username: Zy(e.username),
					password: Zy(e.password)
				}), (e.username || e.password) && (e.username = "", e.password = "", t = e.href);
			}
			if (i && (x.delete("authorization"), x.set("Authorization", "Basic " + btoa(Xy((i.username || "") + ":" + (i.password || ""))))), ne && typeof t == "string" && t.startsWith("data:") && Gy(t) > w) throw new $("maxContentLength size of " + w + " exceeded", $.ERR_BAD_RESPONSE, e, se);
			if (re && n !== "get" && n !== "head") {
				let e = await h(s);
				if (typeof e == "number" && isFinite(e) && (le = e, e > ee)) throw de();
			}
			let d = re && (Q.isReadableStream(s) || Q.isStream(s)), _ = (e, t, n) => Fy(e, qy, (e) => {
				if (re && e > ee) throw ue = de();
				t && t(e);
			}, n);
			if (f && n !== "get" && n !== "head" && (y || d)) {
				if (le ??= await g(x, s), le !== 0 || d) {
					let e = new a(t, {
						method: "POST",
						body: s,
						duplex: "half"
					}), n;
					if (Q.isFormData(s) && (n = e.headers.get("content-type")) && x.setContentType(n), e.body) {
						let [t, n] = y && fy(le, dy(py(y))) || [];
						s = _(e.body, t, n);
					}
				}
			} else if (d && !c && u && n !== "get" && n !== "head") s = _(s);
			else if (d && c && !f && n !== "get" && n !== "head") throw new $("Stream request bodies are not supported by the current fetch implementation", $.ERR_NOT_SUPPORT, e, se);
			Q.isString(S) || (S = S ? "include" : "omit");
			let fe = c && "credentials" in a.prototype;
			if (Q.isFormData(s)) {
				let e = x.getContentType();
				e && /^multipart\/form-data/i.test(e) && !/boundary=/i.test(e) && x.delete("content-type");
			}
			x.set("User-Agent", "axios/" + Ky, !1);
			let T = C == null ? C : Object.assign(Object.create(null), C);
			T && (delete T.body, delete T.headers, delete T.method, delete T.signal, delete T.duplex, delete T.credentials);
			let pe = Object.assign(Object.create(null), T, {
				signal: oe,
				method: n.toUpperCase(),
				headers: nv(x.normalize()),
				body: s,
				duplex: "half",
				credentials: fe ? S : void 0
			});
			c && (Q.forEach(Jy, (e, t) => {
				pe[t] === void 0 && (pe[t] = e);
			}), pe.signal === void 0 && (pe.signal = null), pe.body === void 0 && (pe.body = null)), te === 0 && (pe.redirect = "manual", T && (T.redirect = "manual")), se = c && new a(t, pe);
			let E = await (c ? ae(se, T) : ae(t, pe)), me = hv.from(E.headers);
			if (ne) {
				let t = Q.toFiniteNumber(me.getContentLength());
				if (t != null && t > w) throw new $("maxContentLength size of " + w + " exceeded", $.ERR_BAD_RESPONSE, e, se);
			}
			let he = p && (b === "stream" || b === "response");
			if (p && E.body && (v || ne || he && ce)) {
				let t = {};
				[
					"status",
					"statusText",
					"headers"
				].forEach((e) => {
					t[e] = E[e];
				});
				let n = Q.toFiniteNumber(me.getContentLength()), [r, i] = v && fy(n, dy(py(v), !0)) || [], a = 0;
				E = new o(Fy(E.body, qy, (t) => {
					if (ne && (a = t, a > w)) throw new $("maxContentLength size of " + w + " exceeded", $.ERR_BAD_RESPONSE, e, se);
					r && r(t);
				}, () => {
					i && i(), ce && ce();
				}), t);
			}
			b ||= "text";
			let ge = await m[Q.findKey(m, b) || "text"](E, e);
			if (ne && !p && !he) {
				let t;
				if (ge != null && (typeof ge.byteLength == "number" ? t = ge.byteLength : typeof ge.size == "number" ? t = ge.size : typeof ge == "string" && (t = typeof r == "function" ? new r().encode(ge).byteLength : ge.length)), typeof t == "number" && t > w) throw new $("maxContentLength size of " + w + " exceeded", $.ERR_BAD_RESPONSE, e, se);
			}
			return !he && ce && ce(), await new Promise((t, n) => {
				ay(t, n, {
					data: ge,
					headers: hv.from(E.headers),
					status: E.status,
					statusText: E.statusText,
					config: e,
					request: se
				});
			});
		} catch (t) {
			if (ce && ce(), oe && oe.aborted && oe.reason instanceof $) {
				let n = oe.reason;
				throw n.config = e, se && (n.request = se), t !== n && Object.defineProperty(n, "cause", {
					__proto__: null,
					value: t,
					writable: !0,
					enumerable: !1,
					configurable: !0
				}), n;
			}
			if (ue) throw se && !ue.request && (ue.request = se), ue;
			if (t instanceof $) throw se && !t.request && (t.request = se), t;
			if (t && t.name === "TypeError" && /Load failed|fetch/i.test(t.message)) {
				let n = new $("Network Error", $.ERR_NETWORK, e, se, t && t.response);
				throw Object.defineProperty(n, "cause", {
					__proto__: null,
					value: t.cause || t,
					writable: !0,
					enumerable: !1,
					configurable: !0
				}), n;
			}
			throw $.from(t, t && t.code, e, se, t && t.response);
		}
	};
}, tb = /* @__PURE__ */ new Map(), nb = (e) => {
	let t = e && e.env || {}, { fetch: n, Request: r, Response: i } = t, a = [
		r,
		i,
		n
	], o = a.length, s, c, l = tb;
	for (; o--;) s = a[o], c = l.get(s), c === void 0 && l.set(s, c = o ? /* @__PURE__ */ new Map() : eb(t)), l = c;
	return c;
};
nb();
// node_modules/axios/lib/adapters/adapters.js
var rb = {
	http: null,
	xhr: Ay,
	fetch: { get: nb }
};
Q.forEach(rb, (e, t) => {
	if (e) {
		try {
			Object.defineProperty(e, "name", {
				__proto__: null,
				value: t
			});
		} catch {}
		Object.defineProperty(e, "adapterName", {
			__proto__: null,
			value: t
		});
	}
});
var ib = (e) => `- ${e}`, ab = (e) => Q.isFunction(e) || e === null || e === !1;
function ob(e, t) {
	e = Q.isArray(e) ? e : [e];
	let { length: n } = e, r, i, a = {};
	for (let o = 0; o < n; o++) {
		r = e[o];
		let n;
		if (i = r, !ab(r) && (i = rb[(n = String(r)).toLowerCase()], i === void 0)) throw new $(`Unknown adapter '${n}'`);
		if (i && (Q.isFunction(i) || (i = i.get(t)))) break;
		a[n || "#" + o] = i;
	}
	if (!i) {
		let e = Object.entries(a).map(([e, t]) => `adapter ${e} ` + (t === !1 ? "is not supported by the environment" : "is not available in the build"));
		throw new $("There is no suitable adapter to dispatch the request " + (n ? e.length > 1 ? "since :\n" + e.map(ib).join("\n") : " " + ib(e[0]) : "as no adapter specified"), $.ERR_NOT_SUPPORT);
	}
	return i;
}
var sb = {
	getAdapter: ob,
	adapters: rb
};
// node_modules/axios/lib/core/dispatchRequest.js
function cb(e) {
	if (e.cancelToken && e.cancelToken.throwIfRequested(), e.signal && e.signal.aborted) throw new iy(null, e);
}
function lb(e) {
	let t = Q.toSafeFlatObject(e);
	return cb(t), t.headers = hv.from(Q.getSafeProp(t, "headers")), t.data = ny.call(t, t.transformRequest), [
		"post",
		"put",
		"patch"
	].indexOf(t.method) !== -1 && t.headers.setContentType("application/x-www-form-urlencoded", !1), sb.getAdapter(t.adapter || ty.adapter, t)(t).then(function(e) {
		cb(t), t.response = e;
		try {
			e.data = ny.call(t, t.transformResponse, e);
		} finally {
			delete t.response;
		}
		return e.headers = hv.from(e.headers), e;
	}, function(e) {
		if (!ry(e) && (cb(t), e && e.response)) {
			t.response = e.response;
			try {
				e.response.data = ny.call(t, t.transformResponse, e.response);
			} finally {
				delete t.response;
			}
			e.response.headers = hv.from(e.response.headers);
		}
		return Promise.reject(e);
	});
}
// node_modules/axios/lib/helpers/validator.js
var ub = {};
[
	"object",
	"boolean",
	"number",
	"function",
	"string",
	"symbol"
].forEach((e, t) => {
	ub[e] = function(n) {
		return typeof n === e || "a" + (t < 1 ? "n " : " ") + e;
	};
});
var db = {};
ub.transitional = function(e, t, n) {
	function r(e, t) {
		return "[Axios v" + Ky + "] Transitional option '" + e + "'" + t + (n ? ". " + n : "");
	}
	return (n, i, a) => {
		if (e === !1) throw new $(r(i, " has been removed" + (t ? " in " + t : "")), $.ERR_DEPRECATED);
		return t && !db[i] && (db[i] = !0, console.warn(r(i, " has been deprecated since v" + t + " and will be removed in the near future"))), !e || e(n, i, a);
	};
}, ub.spelling = function(e) {
	return (t, n) => (console.warn(`${n} is likely a misspelling of ${e}`), !0);
};
function fb(e, t, n) {
	if (typeof e != "object" || !e) throw new $("options must be an object", $.ERR_BAD_OPTION_VALUE);
	let r = Object.keys(e), i = r.length;
	for (; i-- > 0;) {
		let a = r[i], o = Object.prototype.hasOwnProperty.call(t, a) ? t[a] : void 0;
		if (o) {
			let t = e[a], n = t === void 0 || o(t, a, e);
			if (n !== !0) throw new $("option " + a + " must be " + n, $.ERR_BAD_OPTION_VALUE);
		} else if (n !== !0) throw new $("Unknown option " + a, $.ERR_BAD_OPTION);
	}
}
var pb = {
	assertOptions: fb,
	validators: ub
}, mb = pb.validators, hb = class {
	constructor(e) {
		this.defaults = e || {}, this.interceptors = {
			request: new Iv(),
			response: new Iv()
		};
	}
	async request(e, t) {
		try {
			return await this._request(e, t);
		} catch (e) {
			if (e instanceof Error) try {
				let t = {};
				Error.captureStackTrace ? Error.captureStackTrace(t) : t = /* @__PURE__ */ Error();
				let n = t.stack, r = "";
				if (typeof n == "string") {
					let e = n.indexOf("\n");
					r = e === -1 ? "" : n.slice(e + 1);
				}
				if (!e.stack) e.stack = r;
				else if (r) {
					let t = r.indexOf("\n"), n = t === -1 ? -1 : r.indexOf("\n", t + 1), i = n === -1 ? "" : r.slice(n + 1);
					String(e.stack).endsWith(i) || (e.stack += "\n" + r);
				}
			} catch {}
			throw e;
		}
	}
	_request(e, t) {
		typeof e == "string" ? (t ||= {}, t.url = e) : t = e || {}, t = Ty(this.defaults, t);
		let { transitional: n, paramsSerializer: r, headers: i } = t;
		n !== void 0 && pb.assertOptions(n, {
			silentJSONParsing: mb.transitional(mb.boolean),
			forcedJSONParsing: mb.transitional(mb.boolean),
			clarifyTimeoutError: mb.transitional(mb.boolean),
			legacyInterceptorReqResOrdering: mb.transitional(mb.boolean),
			advertiseZstdAcceptEncoding: mb.transitional(mb.boolean),
			validateStatusUndefinedResolves: mb.transitional(mb.boolean)
		}, !1), r != null && (Q.isFunction(r) ? t.paramsSerializer = { serialize: r } : pb.assertOptions(r, {
			encode: mb.function,
			serialize: mb.function
		}, !0)), t.allowAbsoluteUrls !== void 0 || (this.defaults.allowAbsoluteUrls === void 0 ? t.allowAbsoluteUrls = !0 : t.allowAbsoluteUrls = this.defaults.allowAbsoluteUrls), pb.assertOptions(t, {
			baseUrl: mb.spelling("baseURL"),
			withXsrfToken: mb.spelling("withXSRFToken")
		}, !0), t.method = (Q.getSafeProp(t, "method") || Q.getSafeProp(this.defaults, "method") || "get").toLowerCase();
		let a = i && Q.merge(i.common, i[t.method]);
		i && Q.forEach(Qv.concat("common"), (e) => {
			delete i[e];
		}), t.headers = hv.concat(a, i);
		let o = [], s = !0;
		this.interceptors.request.forEach(function(e) {
			if (typeof e.runWhen == "function" && e.runWhen(t) === !1) return;
			s &&= e.synchronous;
			let n = t.transitional || Lv;
			n && n.legacyInterceptorReqResOrdering ? o.unshift(e.fulfilled, e.rejected) : o.push(e.fulfilled, e.rejected);
		});
		let c = [];
		this.interceptors.response.forEach(function(e) {
			c.push(e.fulfilled, e.rejected);
		});
		let l, u = 0, d;
		if (!s) {
			let e = [lb.bind(this), void 0];
			for (e.unshift(...o), e.push(...c), d = e.length, l = Promise.resolve(t); u < d;) l = l.then(e[u++], e[u++]);
			return l;
		}
		d = o.length;
		let f = t;
		for (; u < d;) {
			let e = o[u++], t = o[u++];
			try {
				f = e ? e(f) : f;
			} catch (e) {
				if (!t) {
					l = Promise.reject(e);
					break;
				}
				try {
					let n = t.call(this, e);
					Q.isThenable(n) && (l = Promise.resolve(n).then(() => lb.call(this, f)));
				} catch (e) {
					l = Promise.reject(e);
				}
				break;
			}
		}
		if (!l) try {
			l = lb.call(this, f);
		} catch (e) {
			l = Promise.reject(e);
		}
		for (u = 0, d = c.length; u < d;) l = l.then(c[u++], c[u++]);
		return l;
	}
	getUri(e) {
		return e = Ty(this.defaults, e), jv(Sy(e.baseURL, e.url, e.allowAbsoluteUrls, e), e.params, e.paramsSerializer);
	}
};
Q.forEach([
	"delete",
	"get",
	"head",
	"options"
], function(e) {
	hb.prototype[e] = function(t, n) {
		return this.request(Ty(n || {}, {
			method: e,
			url: t,
			data: n && Q.hasOwnProp(n, "data") ? n.data : void 0
		}));
	};
}), Q.forEach([
	"post",
	"put",
	"patch",
	"query"
], function(e) {
	function t(t) {
		return function(n, r, i) {
			return this.request(Ty(i || {}, {
				method: e,
				headers: t ? { "Content-Type": "multipart/form-data" } : {},
				url: n,
				data: r
			}));
		};
	}
	hb.prototype[e] = t(), e !== "query" && (hb.prototype[e + "Form"] = t(!0));
});
// node_modules/axios/lib/cancel/CancelToken.js
var gb = class e {
	constructor(e) {
		if (typeof e != "function") throw TypeError("executor must be a function.");
		let t;
		this.promise = new Promise(function(e) {
			t = e;
		});
		let n = this;
		this.promise.then((e) => {
			if (!n._listeners) return;
			let t = n._listeners.length;
			for (; t-- > 0;) n._listeners[t](e);
			n._listeners = null;
		}), this.promise.then = (e) => {
			let t, r = new Promise((e) => {
				n.subscribe(e), t = e;
			}).then(e);
			return r.cancel = function() {
				n.unsubscribe(t);
			}, r;
		}, e(function(e, r, i) {
			n.reason || (n.reason = new iy(e, r, i), t(n.reason));
		});
	}
	throwIfRequested() {
		if (this.reason) throw this.reason;
	}
	subscribe(e) {
		this.reason ? e(this.reason) : this._listeners ? this._listeners.push(e) : this._listeners = [e];
	}
	unsubscribe(e) {
		if (!this._listeners) return;
		let t = this._listeners.indexOf(e);
		t !== -1 && this._listeners.splice(t, 1);
	}
	toAbortSignal() {
		let e = new AbortController(), t = (t) => {
			e.abort(t);
		};
		return this.subscribe(t), e.signal.unsubscribe = () => this.unsubscribe(t), e.signal;
	}
	static source() {
		let t;
		return {
			token: new e(function(e) {
				t = e;
			}),
			cancel: t
		};
	}
};
// node_modules/axios/lib/helpers/spread.js
function _b(e) {
	return function(t) {
		return e.apply(null, t);
	};
}
// node_modules/axios/lib/helpers/isAxiosError.js
function vb(e) {
	return Q.isObject(e) && e.isAxiosError === !0;
}
// node_modules/axios/lib/helpers/HttpStatusCode.js
var yb = {
	Continue: 100,
	SwitchingProtocols: 101,
	Processing: 102,
	EarlyHints: 103,
	Ok: 200,
	Created: 201,
	Accepted: 202,
	NonAuthoritativeInformation: 203,
	NoContent: 204,
	ResetContent: 205,
	PartialContent: 206,
	MultiStatus: 207,
	AlreadyReported: 208,
	ImUsed: 226,
	MultipleChoices: 300,
	MovedPermanently: 301,
	Found: 302,
	SeeOther: 303,
	NotModified: 304,
	UseProxy: 305,
	Unused: 306,
	TemporaryRedirect: 307,
	PermanentRedirect: 308,
	BadRequest: 400,
	Unauthorized: 401,
	PaymentRequired: 402,
	Forbidden: 403,
	NotFound: 404,
	MethodNotAllowed: 405,
	NotAcceptable: 406,
	ProxyAuthenticationRequired: 407,
	RequestTimeout: 408,
	Conflict: 409,
	Gone: 410,
	LengthRequired: 411,
	PreconditionFailed: 412,
	PayloadTooLarge: 413,
	ContentTooLarge: 413,
	UriTooLong: 414,
	UnsupportedMediaType: 415,
	RangeNotSatisfiable: 416,
	ExpectationFailed: 417,
	ImATeapot: 418,
	MisdirectedRequest: 421,
	UnprocessableEntity: 422,
	UnprocessableContent: 422,
	Locked: 423,
	FailedDependency: 424,
	TooEarly: 425,
	UpgradeRequired: 426,
	PreconditionRequired: 428,
	TooManyRequests: 429,
	RequestHeaderFieldsTooLarge: 431,
	UnavailableForLegalReasons: 451,
	InternalServerError: 500,
	NotImplemented: 501,
	BadGateway: 502,
	ServiceUnavailable: 503,
	GatewayTimeout: 504,
	HttpVersionNotSupported: 505,
	VariantAlsoNegotiates: 506,
	InsufficientStorage: 507,
	LoopDetected: 508,
	NotExtended: 510,
	NetworkAuthenticationRequired: 511,
	WebServerReturnsAnUnknownError: 520,
	WebServerIsDown: 521,
	ConnectionTimedOut: 522,
	OriginIsUnreachable: 523,
	TimeoutOccurred: 524,
	SslHandshakeFailed: 525,
	InvalidSslCertificate: 526
};
Object.entries(yb).forEach(([e, t]) => {
	yb[t] === void 0 && (yb[t] = e);
});
// node_modules/axios/lib/axios.js
function bb(e) {
	let t = new hb(e), n = Dg(hb.prototype.request, t);
	return Q.extend(n, hb.prototype, t, { allOwnKeys: !0 }), Q.extend(n, t, null, { allOwnKeys: !0 }), n.create = function(t) {
		return bb(Ty(e, t));
	}, n;
}
var xb = bb(ty);
xb.Axios = hb, xb.CanceledError = iy, xb.CancelToken = gb, xb.isCancel = ry, xb.VERSION = Ky, xb.toFormData = Ev, xb.AxiosError = $, xb.Cancel = xb.CanceledError, xb.all = function(e) {
	return Promise.all(e);
}, xb.spread = _b, xb.isAxiosError = vb, xb.mergeConfig = Ty, xb.AxiosHeaders = hv, xb.formToJSON = (e) => Zv(Q.isHTMLForm(e) ? new FormData(e) : e), xb.getAdapter = sb.getAdapter, xb.HttpStatusCode = yb, xb.default = xb;
// node_modules/axios/index.js
var Sb = /* @__PURE__ */ r({
	Axios: () => Cb,
	AxiosError: () => wb,
	AxiosHeaders: () => Pb,
	Cancel: () => Ab,
	CancelToken: () => Db,
	CanceledError: () => Tb,
	HttpStatusCode: () => Fb,
	VERSION: () => Ob,
	all: () => kb,
	create: () => zb,
	default: () => xb,
	formToJSON: () => Ib,
	getAdapter: () => Lb,
	isAxiosError: () => jb,
	isCancel: () => Eb,
	mergeConfig: () => Rb,
	spread: () => Mb,
	toFormData: () => Nb
}), { Axios: Cb, AxiosError: wb, CanceledError: Tb, isCancel: Eb, CancelToken: Db, VERSION: Ob, all: kb, Cancel: Ab, isAxiosError: jb, spread: Mb, toFormData: Nb, AxiosHeaders: Pb, HttpStatusCode: Fb, formToJSON: Ib, getAdapter: Lb, mergeConfig: Rb, create: zb } = xb, Bb = /* @__PURE__ */ r({
	Hooks: () => rS,
	Lexer: () => $x,
	Marked: () => iS,
	Parser: () => nS,
	Renderer: () => eS,
	TextRenderer: () => tS,
	Tokenizer: () => cx,
	defaults: () => Hb,
	getDefaults: () => Vb,
	lexer: () => mS,
	marked: () => oS,
	options: () => sS,
	parse: () => fS,
	parseInline: () => dS,
	parser: () => pS,
	setOptions: () => cS,
	use: () => lS,
	walkTokens: () => uS
});
function Vb() {
	return {
		async: !1,
		breaks: !1,
		extensions: null,
		gfm: !0,
		hooks: null,
		pedantic: !1,
		renderer: null,
		silent: !1,
		tokenizer: null,
		walkTokens: null
	};
}
var Hb = Vb();
function Ub(e) {
	Hb = e;
}
var Wb = /[&<>"']/, Gb = new RegExp(Wb.source, "g"), Kb = /[<>"']|&(?!(#\d{1,7}|#[Xx][a-fA-F0-9]{1,6}|\w+);)/, qb = new RegExp(Kb.source, "g"), Jb = {
	"&": "&amp;",
	"<": "&lt;",
	">": "&gt;",
	"\"": "&quot;",
	"'": "&#39;"
}, Yb = (e) => Jb[e];
function Xb(e, t) {
	if (t) {
		if (Wb.test(e)) return e.replace(Gb, Yb);
	} else if (Kb.test(e)) return e.replace(qb, Yb);
	return e;
}
var Zb = /&(#(?:\d+)|(?:#x[0-9A-Fa-f]+)|(?:\w+));?/gi;
function Qb(e) {
	return e.replace(Zb, (e, t) => (t = t.toLowerCase(), t === "colon" ? ":" : t.charAt(0) === "#" ? t.charAt(1) === "x" ? String.fromCharCode(parseInt(t.substring(2), 16)) : String.fromCharCode(+t.substring(1)) : ""));
}
var $b = /(^|[^\[])\^/g;
function ex(e, t) {
	let n = typeof e == "string" ? e : e.source;
	t ||= "";
	let r = {
		replace: (e, t) => {
			let i = typeof t == "string" ? t : t.source;
			return i = i.replace($b, "$1"), n = n.replace(e, i), r;
		},
		getRegex: () => new RegExp(n, t)
	};
	return r;
}
function tx(e) {
	try {
		e = encodeURI(e).replace(/%25/g, "%");
	} catch {
		return null;
	}
	return e;
}
var nx = { exec: () => null };
function rx(e, t) {
	let n = e.replace(/\|/g, (e, t, n) => {
		let r = !1, i = t;
		for (; --i >= 0 && n[i] === "\\";) r = !r;
		return r ? "|" : " |";
	}).split(/ \|/), r = 0;
	if (n[0].trim() || n.shift(), n.length > 0 && !n[n.length - 1].trim() && n.pop(), t) {
		if (n.length > t) n.splice(t);
		else for (; n.length < t;) n.push("");
	}
	for (; r < n.length; r++) n[r] = n[r].trim().replace(/\\\|/g, "|");
	return n;
}
function ix(e, t, n) {
	let r = e.length;
	if (r === 0) return "";
	let i = 0;
	for (; i < r;) {
		let a = e.charAt(r - i - 1);
		if (a === t && !n) i++;
		else if (a !== t && n) i++;
		else break;
	}
	return e.slice(0, r - i);
}
function ax(e, t) {
	if (e.indexOf(t[1]) === -1) return -1;
	let n = 0;
	for (let r = 0; r < e.length; r++) if (e[r] === "\\") r++;
	else if (e[r] === t[0]) n++;
	else if (e[r] === t[1] && (n--, n < 0)) return r;
	return -1;
}
function ox(e, t, n, r) {
	let i = t.href, a = t.title ? Xb(t.title) : null, o = e[1].replace(/\\([\[\]])/g, "$1");
	if (e[0].charAt(0) !== "!") {
		r.state.inLink = !0;
		let e = {
			type: "link",
			raw: n,
			href: i,
			title: a,
			text: o,
			tokens: r.inlineTokens(o)
		};
		return r.state.inLink = !1, e;
	}
	return {
		type: "image",
		raw: n,
		href: i,
		title: a,
		text: Xb(o)
	};
}
function sx(e, t) {
	let n = e.match(/^(\s+)(?:```)/);
	if (n === null) return t;
	let r = n[1];
	return t.split("\n").map((e) => {
		let t = e.match(/^\s+/);
		if (t === null) return e;
		let [n] = t;
		return n.length >= r.length ? e.slice(r.length) : e;
	}).join("\n");
}
var cx = class {
	options;
	rules;
	lexer;
	constructor(e) {
		this.options = e || Hb;
	}
	space(e) {
		let t = this.rules.block.newline.exec(e);
		if (t && t[0].length > 0) return {
			type: "space",
			raw: t[0]
		};
	}
	code(e) {
		let t = this.rules.block.code.exec(e);
		if (t) {
			let e = t[0].replace(/^ {1,4}/gm, "");
			return {
				type: "code",
				raw: t[0],
				codeBlockStyle: "indented",
				text: this.options.pedantic ? e : ix(e, "\n")
			};
		}
	}
	fences(e) {
		let t = this.rules.block.fences.exec(e);
		if (t) {
			let e = t[0], n = sx(e, t[3] || "");
			return {
				type: "code",
				raw: e,
				lang: t[2] ? t[2].trim().replace(this.rules.inline.anyPunctuation, "$1") : t[2],
				text: n
			};
		}
	}
	heading(e) {
		let t = this.rules.block.heading.exec(e);
		if (t) {
			let e = t[2].trim();
			if (/#$/.test(e)) {
				let t = ix(e, "#");
				(this.options.pedantic || !t || / $/.test(t)) && (e = t.trim());
			}
			return {
				type: "heading",
				raw: t[0],
				depth: t[1].length,
				text: e,
				tokens: this.lexer.inline(e)
			};
		}
	}
	hr(e) {
		let t = this.rules.block.hr.exec(e);
		if (t) return {
			type: "hr",
			raw: t[0]
		};
	}
	blockquote(e) {
		let t = this.rules.block.blockquote.exec(e);
		if (t) {
			let e = t[0].replace(/\n {0,3}((?:=+|-+) *)(?=\n|$)/g, "\n    $1");
			e = ix(e.replace(/^ *>[ \t]?/gm, ""), "\n");
			let n = this.lexer.state.top;
			this.lexer.state.top = !0;
			let r = this.lexer.blockTokens(e);
			return this.lexer.state.top = n, {
				type: "blockquote",
				raw: t[0],
				tokens: r,
				text: e
			};
		}
	}
	list(e) {
		let t = this.rules.block.list.exec(e);
		if (t) {
			let n = t[1].trim(), r = n.length > 1, i = {
				type: "list",
				raw: "",
				ordered: r,
				start: r ? +n.slice(0, -1) : "",
				loose: !1,
				items: []
			};
			n = r ? `\\d{1,9}\\${n.slice(-1)}` : `\\${n}`, this.options.pedantic && (n = r ? n : "[*+-]");
			let a = RegExp(`^( {0,3}${n})((?:[\t ][^\\n]*)?(?:\\n|$))`), o = "", s = "", c = !1;
			for (; e;) {
				let n = !1;
				if (!(t = a.exec(e)) || this.rules.block.hr.test(e)) break;
				o = t[0], e = e.substring(o.length);
				let r = t[2].split("\n", 1)[0].replace(/^\t+/, (e) => " ".repeat(3 * e.length)), l = e.split("\n", 1)[0], u = 0;
				this.options.pedantic ? (u = 2, s = r.trimStart()) : (u = t[2].search(/[^ ]/), u = u > 4 ? 1 : u, s = r.slice(u), u += t[1].length);
				let d = !1;
				if (!r && /^ *$/.test(l) && (o += l + "\n", e = e.substring(l.length + 1), n = !0), !n) {
					let t = RegExp(`^ {0,${Math.min(3, u - 1)}}(?:[*+-]|\\d{1,9}[.)])((?:[ \t][^\\n]*)?(?:\\n|$))`), n = RegExp(`^ {0,${Math.min(3, u - 1)}}((?:- *){3,}|(?:_ *){3,}|(?:\\* *){3,})(?:\\n+|$)`), i = RegExp(`^ {0,${Math.min(3, u - 1)}}(?:\`\`\`|~~~)`), a = RegExp(`^ {0,${Math.min(3, u - 1)}}#`);
					for (; e;) {
						let c = e.split("\n", 1)[0];
						if (l = c, this.options.pedantic && (l = l.replace(/^ {1,4}(?=( {4})*[^ ])/g, "  ")), i.test(l) || a.test(l) || t.test(l) || n.test(e)) break;
						if (l.search(/[^ ]/) >= u || !l.trim()) s += "\n" + l.slice(u);
						else {
							if (d || r.search(/[^ ]/) >= 4 || i.test(r) || a.test(r) || n.test(r)) break;
							s += "\n" + l;
						}
						!d && !l.trim() && (d = !0), o += c + "\n", e = e.substring(c.length + 1), r = l.slice(u);
					}
				}
				i.loose || (c ? i.loose = !0 : /\n *\n *$/.test(o) && (c = !0));
				let f = null, p;
				this.options.gfm && (f = /^\[[ xX]\] /.exec(s), f && (p = f[0] !== "[ ] ", s = s.replace(/^\[[ xX]\] +/, ""))), i.items.push({
					type: "list_item",
					raw: o,
					task: !!f,
					checked: p,
					loose: !1,
					text: s,
					tokens: []
				}), i.raw += o;
			}
			i.items[i.items.length - 1].raw = o.trimEnd(), i.items[i.items.length - 1].text = s.trimEnd(), i.raw = i.raw.trimEnd();
			for (let e = 0; e < i.items.length; e++) if (this.lexer.state.top = !1, i.items[e].tokens = this.lexer.blockTokens(i.items[e].text, []), !i.loose) {
				let t = i.items[e].tokens.filter((e) => e.type === "space");
				i.loose = t.length > 0 && t.some((e) => /\n.*\n/.test(e.raw));
			}
			if (i.loose) for (let e = 0; e < i.items.length; e++) i.items[e].loose = !0;
			return i;
		}
	}
	html(e) {
		let t = this.rules.block.html.exec(e);
		if (t) return {
			type: "html",
			block: !0,
			raw: t[0],
			pre: t[1] === "pre" || t[1] === "script" || t[1] === "style",
			text: t[0]
		};
	}
	def(e) {
		let t = this.rules.block.def.exec(e);
		if (t) {
			let e = t[1].toLowerCase().replace(/\s+/g, " "), n = t[2] ? t[2].replace(/^<(.*)>$/, "$1").replace(this.rules.inline.anyPunctuation, "$1") : "", r = t[3] ? t[3].substring(1, t[3].length - 1).replace(this.rules.inline.anyPunctuation, "$1") : t[3];
			return {
				type: "def",
				tag: e,
				raw: t[0],
				href: n,
				title: r
			};
		}
	}
	table(e) {
		let t = this.rules.block.table.exec(e);
		if (!t || !/[:|]/.test(t[2])) return;
		let n = rx(t[1]), r = t[2].replace(/^\||\| *$/g, "").split("|"), i = t[3] && t[3].trim() ? t[3].replace(/\n[ \t]*$/, "").split("\n") : [], a = {
			type: "table",
			raw: t[0],
			header: [],
			align: [],
			rows: []
		};
		if (n.length === r.length) {
			for (let e of r) /^ *-+: *$/.test(e) ? a.align.push("right") : /^ *:-+: *$/.test(e) ? a.align.push("center") : /^ *:-+ *$/.test(e) ? a.align.push("left") : a.align.push(null);
			for (let e of n) a.header.push({
				text: e,
				tokens: this.lexer.inline(e)
			});
			for (let e of i) a.rows.push(rx(e, a.header.length).map((e) => ({
				text: e,
				tokens: this.lexer.inline(e)
			})));
			return a;
		}
	}
	lheading(e) {
		let t = this.rules.block.lheading.exec(e);
		if (t) return {
			type: "heading",
			raw: t[0],
			depth: t[2].charAt(0) === "=" ? 1 : 2,
			text: t[1],
			tokens: this.lexer.inline(t[1])
		};
	}
	paragraph(e) {
		let t = this.rules.block.paragraph.exec(e);
		if (t) {
			let e = t[1].charAt(t[1].length - 1) === "\n" ? t[1].slice(0, -1) : t[1];
			return {
				type: "paragraph",
				raw: t[0],
				text: e,
				tokens: this.lexer.inline(e)
			};
		}
	}
	text(e) {
		let t = this.rules.block.text.exec(e);
		if (t) return {
			type: "text",
			raw: t[0],
			text: t[0],
			tokens: this.lexer.inline(t[0])
		};
	}
	escape(e) {
		let t = this.rules.inline.escape.exec(e);
		if (t) return {
			type: "escape",
			raw: t[0],
			text: Xb(t[1])
		};
	}
	tag(e) {
		let t = this.rules.inline.tag.exec(e);
		if (t) return !this.lexer.state.inLink && /^<a /i.test(t[0]) ? this.lexer.state.inLink = !0 : this.lexer.state.inLink && /^<\/a>/i.test(t[0]) && (this.lexer.state.inLink = !1), !this.lexer.state.inRawBlock && /^<(pre|code|kbd|script)(\s|>)/i.test(t[0]) ? this.lexer.state.inRawBlock = !0 : this.lexer.state.inRawBlock && /^<\/(pre|code|kbd|script)(\s|>)/i.test(t[0]) && (this.lexer.state.inRawBlock = !1), {
			type: "html",
			raw: t[0],
			inLink: this.lexer.state.inLink,
			inRawBlock: this.lexer.state.inRawBlock,
			block: !1,
			text: t[0]
		};
	}
	link(e) {
		let t = this.rules.inline.link.exec(e);
		if (t) {
			let e = t[2].trim();
			if (!this.options.pedantic && /^</.test(e)) {
				if (!/>$/.test(e)) return;
				let t = ix(e.slice(0, -1), "\\");
				if ((e.length - t.length) % 2 == 0) return;
			} else {
				let e = ax(t[2], "()");
				if (e > -1) {
					let n = (t[0].indexOf("!") === 0 ? 5 : 4) + t[1].length + e;
					t[2] = t[2].substring(0, e), t[0] = t[0].substring(0, n).trim(), t[3] = "";
				}
			}
			let n = t[2], r = "";
			if (this.options.pedantic) {
				let e = /^([^'"]*[^\s])\s+(['"])(.*)\2/.exec(n);
				e && (n = e[1], r = e[3]);
			} else r = t[3] ? t[3].slice(1, -1) : "";
			return n = n.trim(), /^</.test(n) && (n = this.options.pedantic && !/>$/.test(e) ? n.slice(1) : n.slice(1, -1)), ox(t, {
				href: n && n.replace(this.rules.inline.anyPunctuation, "$1"),
				title: r && r.replace(this.rules.inline.anyPunctuation, "$1")
			}, t[0], this.lexer);
		}
	}
	reflink(e, t) {
		let n;
		if ((n = this.rules.inline.reflink.exec(e)) || (n = this.rules.inline.nolink.exec(e))) {
			let e = t[(n[2] || n[1]).replace(/\s+/g, " ").toLowerCase()];
			if (!e) {
				let e = n[0].charAt(0);
				return {
					type: "text",
					raw: e,
					text: e
				};
			}
			return ox(n, e, n[0], this.lexer);
		}
	}
	emStrong(e, t, n = "") {
		let r = this.rules.inline.emStrongLDelim.exec(e);
		if (r && !(r[3] && n.match(/[\p{L}\p{N}]/u)) && (!(r[1] || r[2]) || !n || this.rules.inline.punctuation.exec(n))) {
			let n = [...r[0]].length - 1, i, a, o = n, s = 0, c = r[0][0] === "*" ? this.rules.inline.emStrongRDelimAst : this.rules.inline.emStrongRDelimUnd;
			for (c.lastIndex = 0, t = t.slice(-1 * e.length + n); (r = c.exec(t)) != null;) {
				if (i = r[1] || r[2] || r[3] || r[4] || r[5] || r[6], !i) continue;
				if (a = [...i].length, r[3] || r[4]) {
					o += a;
					continue;
				}
				if ((r[5] || r[6]) && n % 3 && !((n + a) % 3)) {
					s += a;
					continue;
				}
				if (o -= a, o > 0) continue;
				a = Math.min(a, a + o + s);
				let t = [...r[0]][0].length, c = e.slice(0, n + r.index + t + a);
				if (Math.min(n, a) % 2) {
					let e = c.slice(1, -1);
					return {
						type: "em",
						raw: c,
						text: e,
						tokens: this.lexer.inlineTokens(e)
					};
				}
				let l = c.slice(2, -2);
				return {
					type: "strong",
					raw: c,
					text: l,
					tokens: this.lexer.inlineTokens(l)
				};
			}
		}
	}
	codespan(e) {
		let t = this.rules.inline.code.exec(e);
		if (t) {
			let e = t[2].replace(/\n/g, " "), n = /[^ ]/.test(e), r = /^ /.test(e) && / $/.test(e);
			return n && r && (e = e.substring(1, e.length - 1)), e = Xb(e, !0), {
				type: "codespan",
				raw: t[0],
				text: e
			};
		}
	}
	br(e) {
		let t = this.rules.inline.br.exec(e);
		if (t) return {
			type: "br",
			raw: t[0]
		};
	}
	del(e) {
		let t = this.rules.inline.del.exec(e);
		if (t) return {
			type: "del",
			raw: t[0],
			text: t[2],
			tokens: this.lexer.inlineTokens(t[2])
		};
	}
	autolink(e) {
		let t = this.rules.inline.autolink.exec(e);
		if (t) {
			let e, n;
			return t[2] === "@" ? (e = Xb(t[1]), n = "mailto:" + e) : (e = Xb(t[1]), n = e), {
				type: "link",
				raw: t[0],
				text: e,
				href: n,
				tokens: [{
					type: "text",
					raw: e,
					text: e
				}]
			};
		}
	}
	url(e) {
		let t;
		if (t = this.rules.inline.url.exec(e)) {
			let e, n;
			if (t[2] === "@") e = Xb(t[0]), n = "mailto:" + e;
			else {
				let r;
				do
					r = t[0], t[0] = this.rules.inline._backpedal.exec(t[0])?.[0] ?? "";
				while (r !== t[0]);
				e = Xb(t[0]), n = t[1] === "www." ? "http://" + t[0] : t[0];
			}
			return {
				type: "link",
				raw: t[0],
				text: e,
				href: n,
				tokens: [{
					type: "text",
					raw: e,
					text: e
				}]
			};
		}
	}
	inlineText(e) {
		let t = this.rules.inline.text.exec(e);
		if (t) {
			let e;
			return e = this.lexer.state.inRawBlock ? t[0] : Xb(t[0]), {
				type: "text",
				raw: t[0],
				text: e
			};
		}
	}
}, lx = /^(?: *(?:\n|$))+/, ux = /^( {4}[^\n]+(?:\n(?: *(?:\n|$))*)?)+/, dx = /^ {0,3}(`{3,}(?=[^`\n]*(?:\n|$))|~{3,})([^\n]*)(?:\n|$)(?:|([\s\S]*?)(?:\n|$))(?: {0,3}\1[~`]* *(?=\n|$)|$)/, fx = /^ {0,3}((?:-[\t ]*){3,}|(?:_[ \t]*){3,}|(?:\*[ \t]*){3,})(?:\n+|$)/, px = /^ {0,3}(#{1,6})(?=\s|$)(.*)(?:\n+|$)/, mx = /(?:[*+-]|\d{1,9}[.)])/, hx = ex(/^(?!bull |blockCode|fences|blockquote|heading|html)((?:.|\n(?!\s*?\n|bull |blockCode|fences|blockquote|heading|html))+?)\n {0,3}(=+|-+) *(?:\n+|$)/).replace(/bull/g, mx).replace(/blockCode/g, / {4}/).replace(/fences/g, / {0,3}(?:`{3,}|~{3,})/).replace(/blockquote/g, / {0,3}>/).replace(/heading/g, / {0,3}#{1,6}/).replace(/html/g, / {0,3}<[^\n>]+>\n/).getRegex(), gx = /^([^\n]+(?:\n(?!hr|heading|lheading|blockquote|fences|list|html|table| +\n)[^\n]+)*)/, _x = /^[^\n]+/, vx = /(?!\s*\])(?:\\.|[^\[\]\\])+/, yx = ex(/^ {0,3}\[(label)\]: *(?:\n *)?([^<\s][^\s]*|<.*?>)(?:(?: +(?:\n *)?| *\n *)(title))? *(?:\n+|$)/).replace("label", vx).replace("title", /(?:"(?:\\"?|[^"\\])*"|'[^'\n]*(?:\n[^'\n]+)*\n?'|\([^()]*\))/).getRegex(), bx = ex(/^( {0,3}bull)([ \t][^\n]+?)?(?:\n|$)/).replace(/bull/g, mx).getRegex(), xx = "address|article|aside|base|basefont|blockquote|body|caption|center|col|colgroup|dd|details|dialog|dir|div|dl|dt|fieldset|figcaption|figure|footer|form|frame|frameset|h[1-6]|head|header|hr|html|iframe|legend|li|link|main|menu|menuitem|meta|nav|noframes|ol|optgroup|option|p|param|search|section|summary|table|tbody|td|tfoot|th|thead|title|tr|track|ul", Sx = /<!--(?:-?>|[\s\S]*?(?:-->|$))/, Cx = ex("^ {0,3}(?:<(script|pre|style|textarea)[\\s>][\\s\\S]*?(?:</\\1>[^\\n]*\\n+|$)|comment[^\\n]*(\\n+|$)|<\\?[\\s\\S]*?(?:\\?>\\n*|$)|<![A-Z][\\s\\S]*?(?:>\\n*|$)|<!\\[CDATA\\[[\\s\\S]*?(?:\\]\\]>\\n*|$)|</?(tag)(?: +|\\n|/?>)[\\s\\S]*?(?:(?:\\n *)+\\n|$)|<(?!script|pre|style|textarea)([a-z][\\w-]*)(?:attribute)*? */?>(?=[ \\t]*(?:\\n|$))[\\s\\S]*?(?:(?:\\n *)+\\n|$)|</(?!script|pre|style|textarea)[a-z][\\w-]*\\s*>(?=[ \\t]*(?:\\n|$))[\\s\\S]*?(?:(?:\\n *)+\\n|$))", "i").replace("comment", Sx).replace("tag", xx).replace("attribute", / +[a-zA-Z:_][\w.:-]*(?: *= *"[^"\n]*"| *= *'[^'\n]*'| *= *[^\s"'=<>`]+)?/).getRegex(), wx = ex(gx).replace("hr", fx).replace("heading", " {0,3}#{1,6}(?:\\s|$)").replace("|lheading", "").replace("|table", "").replace("blockquote", " {0,3}>").replace("fences", " {0,3}(?:`{3,}(?=[^`\\n]*\\n)|~{3,})[^\\n]*\\n").replace("list", " {0,3}(?:[*+-]|1[.)]) ").replace("html", "</?(?:tag)(?: +|\\n|/?>)|<(?:script|pre|style|textarea|!--)").replace("tag", xx).getRegex(), Tx = {
	blockquote: ex(/^( {0,3}> ?(paragraph|[^\n]*)(?:\n|$))+/).replace("paragraph", wx).getRegex(),
	code: ux,
	def: yx,
	fences: dx,
	heading: px,
	hr: fx,
	html: Cx,
	lheading: hx,
	list: bx,
	newline: lx,
	paragraph: wx,
	table: nx,
	text: _x
}, Ex = ex("^ *([^\\n ].*)\\n {0,3}((?:\\| *)?:?-+:? *(?:\\| *:?-+:? *)*(?:\\| *)?)(?:\\n((?:(?! *\\n|hr|heading|blockquote|code|fences|list|html).*(?:\\n|$))*)\\n*|$)").replace("hr", fx).replace("heading", " {0,3}#{1,6}(?:\\s|$)").replace("blockquote", " {0,3}>").replace("code", " {4}[^\\n]").replace("fences", " {0,3}(?:`{3,}(?=[^`\\n]*\\n)|~{3,})[^\\n]*\\n").replace("list", " {0,3}(?:[*+-]|1[.)]) ").replace("html", "</?(?:tag)(?: +|\\n|/?>)|<(?:script|pre|style|textarea|!--)").replace("tag", xx).getRegex(), Dx = {
	...Tx,
	table: Ex,
	paragraph: ex(gx).replace("hr", fx).replace("heading", " {0,3}#{1,6}(?:\\s|$)").replace("|lheading", "").replace("table", Ex).replace("blockquote", " {0,3}>").replace("fences", " {0,3}(?:`{3,}(?=[^`\\n]*\\n)|~{3,})[^\\n]*\\n").replace("list", " {0,3}(?:[*+-]|1[.)]) ").replace("html", "</?(?:tag)(?: +|\\n|/?>)|<(?:script|pre|style|textarea|!--)").replace("tag", xx).getRegex()
}, Ox = {
	...Tx,
	html: ex("^ *(?:comment *(?:\\n|\\s*$)|<(tag)[\\s\\S]+?</\\1> *(?:\\n{2,}|\\s*$)|<tag(?:\"[^\"]*\"|'[^']*'|\\s[^'\"/>\\s]*)*?/?> *(?:\\n{2,}|\\s*$))").replace("comment", Sx).replace(/tag/g, "(?!(?:a|em|strong|small|s|cite|q|dfn|abbr|data|time|code|var|samp|kbd|sub|sup|i|b|u|mark|ruby|rt|rp|bdi|bdo|span|br|wbr|ins|del|img)\\b)\\w+(?!:|[^\\w\\s@]*@)\\b").getRegex(),
	def: /^ *\[([^\]]+)\]: *<?([^\s>]+)>?(?: +(["(][^\n]+[")]))? *(?:\n+|$)/,
	heading: /^(#{1,6})(.*)(?:\n+|$)/,
	fences: nx,
	lheading: /^(.+?)\n {0,3}(=+|-+) *(?:\n+|$)/,
	paragraph: ex(gx).replace("hr", fx).replace("heading", " *#{1,6} *[^\n]").replace("lheading", hx).replace("|table", "").replace("blockquote", " {0,3}>").replace("|fences", "").replace("|list", "").replace("|html", "").replace("|tag", "").getRegex()
}, kx = /^\\([!"#$%&'()*+,\-./:;<=>?@\[\]\\^_`{|}~])/, Ax = /^(`+)([^`]|[^`][\s\S]*?[^`])\1(?!`)/, jx = /^( {2,}|\\)\n(?!\s*$)/, Mx = /^(`+|[^`])(?:(?= {2,}\n)|[\s\S]*?(?:(?=[\\<!\[`*_]|\b_|$)|[^ ](?= {2,}\n)))/, Nx = "\\p{P}\\p{S}", Px = ex(/^((?![*_])[\spunctuation])/, "u").replace(/punctuation/g, Nx).getRegex(), Fx = /\[[^[\]]*?\]\([^\(\)]*?\)|`[^`]*?`|<[^<>]*?>/g, Ix = ex(/^(?:\*+(?:((?!\*)[punct])|[^\s*]))|^_+(?:((?!_)[punct])|([^\s_]))/, "u").replace(/punct/g, Nx).getRegex(), Lx = ex("^[^_*]*?__[^_*]*?\\*[^_*]*?(?=__)|[^*]+(?=[^*])|(?!\\*)[punct](\\*+)(?=[\\s]|$)|[^punct\\s](\\*+)(?!\\*)(?=[punct\\s]|$)|(?!\\*)[punct\\s](\\*+)(?=[^punct\\s])|[\\s](\\*+)(?!\\*)(?=[punct])|(?!\\*)[punct](\\*+)(?!\\*)(?=[punct])|[^punct\\s](\\*+)(?=[^punct\\s])", "gu").replace(/punct/g, Nx).getRegex(), Rx = ex("^[^_*]*?\\*\\*[^_*]*?_[^_*]*?(?=\\*\\*)|[^_]+(?=[^_])|(?!_)[punct](_+)(?=[\\s]|$)|[^punct\\s](_+)(?!_)(?=[punct\\s]|$)|(?!_)[punct\\s](_+)(?=[^punct\\s])|[\\s](_+)(?!_)(?=[punct])|(?!_)[punct](_+)(?!_)(?=[punct])", "gu").replace(/punct/g, Nx).getRegex(), zx = ex(/\\([punct])/, "gu").replace(/punct/g, Nx).getRegex(), Bx = ex(/^<(scheme:[^\s\x00-\x1f<>]*|email)>/).replace("scheme", /[a-zA-Z][a-zA-Z0-9+.-]{1,31}/).replace("email", /[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+(@)[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(?:\.[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?)+(?![-_])/).getRegex(), Vx = ex(Sx).replace("(?:-->|$)", "-->").getRegex(), Hx = ex("^comment|^</[a-zA-Z][\\w:-]*\\s*>|^<[a-zA-Z][\\w-]*(?:attribute)*?\\s*/?>|^<\\?[\\s\\S]*?\\?>|^<![a-zA-Z]+\\s[\\s\\S]*?>|^<!\\[CDATA\\[[\\s\\S]*?\\]\\]>").replace("comment", Vx).replace("attribute", /\s+[a-zA-Z:_][\w.:-]*(?:\s*=\s*"[^"]*"|\s*=\s*'[^']*'|\s*=\s*[^\s"'=<>`]+)?/).getRegex(), Ux = /(?:\[(?:\\.|[^\[\]\\])*\]|\\.|`[^`]*`|[^\[\]\\`])*?/, Wx = ex(/^!?\[(label)\]\(\s*(href)(?:\s+(title))?\s*\)/).replace("label", Ux).replace("href", /<(?:\\.|[^\n<>\\])+>|[^\s\x00-\x1f]*/).replace("title", /"(?:\\"?|[^"\\])*"|'(?:\\'?|[^'\\])*'|\((?:\\\)?|[^)\\])*\)/).getRegex(), Gx = ex(/^!?\[(label)\]\[(ref)\]/).replace("label", Ux).replace("ref", vx).getRegex(), Kx = ex(/^!?\[(ref)\](?:\[\])?/).replace("ref", vx).getRegex(), qx = {
	_backpedal: nx,
	anyPunctuation: zx,
	autolink: Bx,
	blockSkip: Fx,
	br: jx,
	code: Ax,
	del: nx,
	emStrongLDelim: Ix,
	emStrongRDelimAst: Lx,
	emStrongRDelimUnd: Rx,
	escape: kx,
	link: Wx,
	nolink: Kx,
	punctuation: Px,
	reflink: Gx,
	reflinkSearch: ex("reflink|nolink(?!\\()", "g").replace("reflink", Gx).replace("nolink", Kx).getRegex(),
	tag: Hx,
	text: Mx,
	url: nx
}, Jx = {
	...qx,
	link: ex(/^!?\[(label)\]\((.*?)\)/).replace("label", Ux).getRegex(),
	reflink: ex(/^!?\[(label)\]\s*\[([^\]]*)\]/).replace("label", Ux).getRegex()
}, Yx = {
	...qx,
	escape: ex(kx).replace("])", "~|])").getRegex(),
	url: ex(/^((?:ftp|https?):\/\/|www\.)(?:[a-zA-Z0-9\-]+\.?)+[^\s<]*|^email/, "i").replace("email", /[A-Za-z0-9._+-]+(@)[a-zA-Z0-9-_]+(?:\.[a-zA-Z0-9-_]*[a-zA-Z0-9])+(?![-_])/).getRegex(),
	_backpedal: /(?:[^?!.,:;*_'"~()&]+|\([^)]*\)|&(?![a-zA-Z0-9]+;$)|[?!.,:;*_'"~)]+(?!$))+/,
	del: /^(~~?)(?=[^\s~])([\s\S]*?[^\s~])\1(?=[^~]|$)/,
	text: /^([`~]+|[^`~])(?:(?= {2,}\n)|(?=[a-zA-Z0-9.!#$%&'*+\/=?_`{\|}~-]+@)|[\s\S]*?(?:(?=[\\<!\[`*~_]|\b_|https?:\/\/|ftp:\/\/|www\.|$)|[^ ](?= {2,}\n)|[^a-zA-Z0-9.!#$%&'*+\/=?_`{\|}~-](?=[a-zA-Z0-9.!#$%&'*+\/=?_`{\|}~-]+@)))/
}, Xx = {
	...Yx,
	br: ex(jx).replace("{2,}", "*").getRegex(),
	text: ex(Yx.text).replace("\\b_", "\\b_| {2,}\\n").replace(/\{2,\}/g, "*").getRegex()
}, Zx = {
	normal: Tx,
	gfm: Dx,
	pedantic: Ox
}, Qx = {
	normal: qx,
	gfm: Yx,
	breaks: Xx,
	pedantic: Jx
}, $x = class e {
	tokens;
	options;
	state;
	tokenizer;
	inlineQueue;
	constructor(e) {
		this.tokens = [], this.tokens.links = Object.create(null), this.options = e || Hb, this.options.tokenizer = this.options.tokenizer || new cx(), this.tokenizer = this.options.tokenizer, this.tokenizer.options = this.options, this.tokenizer.lexer = this, this.inlineQueue = [], this.state = {
			inLink: !1,
			inRawBlock: !1,
			top: !0
		};
		let t = {
			block: Zx.normal,
			inline: Qx.normal
		};
		this.options.pedantic ? (t.block = Zx.pedantic, t.inline = Qx.pedantic) : this.options.gfm && (t.block = Zx.gfm, t.inline = this.options.breaks ? Qx.breaks : Qx.gfm), this.tokenizer.rules = t;
	}
	static get rules() {
		return {
			block: Zx,
			inline: Qx
		};
	}
	static lex(t, n) {
		return new e(n).lex(t);
	}
	static lexInline(t, n) {
		return new e(n).inlineTokens(t);
	}
	lex(e) {
		e = e.replace(/\r\n|\r/g, "\n"), this.blockTokens(e, this.tokens);
		for (let e = 0; e < this.inlineQueue.length; e++) {
			let t = this.inlineQueue[e];
			this.inlineTokens(t.src, t.tokens);
		}
		return this.inlineQueue = [], this.tokens;
	}
	blockTokens(e, t = []) {
		e = this.options.pedantic ? e.replace(/\t/g, "    ").replace(/^ +$/gm, "") : e.replace(/^( *)(\t+)/gm, (e, t, n) => t + "    ".repeat(n.length));
		let n, r, i, a;
		for (; e;) if (!(this.options.extensions && this.options.extensions.block && this.options.extensions.block.some((r) => (n = r.call({ lexer: this }, e, t)) ? (e = e.substring(n.raw.length), t.push(n), !0) : !1))) {
			if (n = this.tokenizer.space(e)) e = e.substring(n.raw.length), n.raw.length === 1 && t.length > 0 ? t[t.length - 1].raw += "\n" : t.push(n);
			else if (n = this.tokenizer.code(e)) e = e.substring(n.raw.length), r = t[t.length - 1], r && (r.type === "paragraph" || r.type === "text") ? (r.raw += "\n" + n.raw, r.text += "\n" + n.text, this.inlineQueue[this.inlineQueue.length - 1].src = r.text) : t.push(n);
			else if (n = this.tokenizer.fences(e)) e = e.substring(n.raw.length), t.push(n);
			else if (n = this.tokenizer.heading(e)) e = e.substring(n.raw.length), t.push(n);
			else if (n = this.tokenizer.hr(e)) e = e.substring(n.raw.length), t.push(n);
			else if (n = this.tokenizer.blockquote(e)) e = e.substring(n.raw.length), t.push(n);
			else if (n = this.tokenizer.list(e)) e = e.substring(n.raw.length), t.push(n);
			else if (n = this.tokenizer.html(e)) e = e.substring(n.raw.length), t.push(n);
			else if (n = this.tokenizer.def(e)) e = e.substring(n.raw.length), r = t[t.length - 1], r && (r.type === "paragraph" || r.type === "text") ? (r.raw += "\n" + n.raw, r.text += "\n" + n.raw, this.inlineQueue[this.inlineQueue.length - 1].src = r.text) : this.tokens.links[n.tag] || (this.tokens.links[n.tag] = {
				href: n.href,
				title: n.title
			});
			else if (n = this.tokenizer.table(e)) e = e.substring(n.raw.length), t.push(n);
			else if (n = this.tokenizer.lheading(e)) e = e.substring(n.raw.length), t.push(n);
			else {
				if (i = e, this.options.extensions && this.options.extensions.startBlock) {
					let t = Infinity, n = e.slice(1), r;
					this.options.extensions.startBlock.forEach((e) => {
						r = e.call({ lexer: this }, n), typeof r == "number" && r >= 0 && (t = Math.min(t, r));
					}), t < Infinity && t >= 0 && (i = e.substring(0, t + 1));
				}
				if (this.state.top && (n = this.tokenizer.paragraph(i))) r = t[t.length - 1], a && r.type === "paragraph" ? (r.raw += "\n" + n.raw, r.text += "\n" + n.text, this.inlineQueue.pop(), this.inlineQueue[this.inlineQueue.length - 1].src = r.text) : t.push(n), a = i.length !== e.length, e = e.substring(n.raw.length);
				else if (n = this.tokenizer.text(e)) e = e.substring(n.raw.length), r = t[t.length - 1], r && r.type === "text" ? (r.raw += "\n" + n.raw, r.text += "\n" + n.text, this.inlineQueue.pop(), this.inlineQueue[this.inlineQueue.length - 1].src = r.text) : t.push(n);
				else if (e) {
					let t = "Infinite loop on byte: " + e.charCodeAt(0);
					if (this.options.silent) {
						console.error(t);
						break;
					}
					throw Error(t);
				}
			}
		}
		return this.state.top = !0, t;
	}
	inline(e, t = []) {
		return this.inlineQueue.push({
			src: e,
			tokens: t
		}), t;
	}
	inlineTokens(e, t = []) {
		let n, r, i, a = e, o, s, c;
		if (this.tokens.links) {
			let e = Object.keys(this.tokens.links);
			if (e.length > 0) for (; (o = this.tokenizer.rules.inline.reflinkSearch.exec(a)) != null;) e.includes(o[0].slice(o[0].lastIndexOf("[") + 1, -1)) && (a = a.slice(0, o.index) + "[" + "a".repeat(o[0].length - 2) + "]" + a.slice(this.tokenizer.rules.inline.reflinkSearch.lastIndex));
		}
		for (; (o = this.tokenizer.rules.inline.blockSkip.exec(a)) != null;) a = a.slice(0, o.index) + "[" + "a".repeat(o[0].length - 2) + "]" + a.slice(this.tokenizer.rules.inline.blockSkip.lastIndex);
		for (; (o = this.tokenizer.rules.inline.anyPunctuation.exec(a)) != null;) a = a.slice(0, o.index) + "++" + a.slice(this.tokenizer.rules.inline.anyPunctuation.lastIndex);
		for (; e;) if (s || (c = ""), s = !1, !(this.options.extensions && this.options.extensions.inline && this.options.extensions.inline.some((r) => (n = r.call({ lexer: this }, e, t)) ? (e = e.substring(n.raw.length), t.push(n), !0) : !1))) {
			if (n = this.tokenizer.escape(e)) e = e.substring(n.raw.length), t.push(n);
			else if (n = this.tokenizer.tag(e)) e = e.substring(n.raw.length), r = t[t.length - 1], r && n.type === "text" && r.type === "text" ? (r.raw += n.raw, r.text += n.text) : t.push(n);
			else if (n = this.tokenizer.link(e)) e = e.substring(n.raw.length), t.push(n);
			else if (n = this.tokenizer.reflink(e, this.tokens.links)) e = e.substring(n.raw.length), r = t[t.length - 1], r && n.type === "text" && r.type === "text" ? (r.raw += n.raw, r.text += n.text) : t.push(n);
			else if (n = this.tokenizer.emStrong(e, a, c)) e = e.substring(n.raw.length), t.push(n);
			else if (n = this.tokenizer.codespan(e)) e = e.substring(n.raw.length), t.push(n);
			else if (n = this.tokenizer.br(e)) e = e.substring(n.raw.length), t.push(n);
			else if (n = this.tokenizer.del(e)) e = e.substring(n.raw.length), t.push(n);
			else if (n = this.tokenizer.autolink(e)) e = e.substring(n.raw.length), t.push(n);
			else if (!this.state.inLink && (n = this.tokenizer.url(e))) e = e.substring(n.raw.length), t.push(n);
			else {
				if (i = e, this.options.extensions && this.options.extensions.startInline) {
					let t = Infinity, n = e.slice(1), r;
					this.options.extensions.startInline.forEach((e) => {
						r = e.call({ lexer: this }, n), typeof r == "number" && r >= 0 && (t = Math.min(t, r));
					}), t < Infinity && t >= 0 && (i = e.substring(0, t + 1));
				}
				if (n = this.tokenizer.inlineText(i)) e = e.substring(n.raw.length), n.raw.slice(-1) !== "_" && (c = n.raw.slice(-1)), s = !0, r = t[t.length - 1], r && r.type === "text" ? (r.raw += n.raw, r.text += n.text) : t.push(n);
				else if (e) {
					let t = "Infinite loop on byte: " + e.charCodeAt(0);
					if (this.options.silent) {
						console.error(t);
						break;
					}
					throw Error(t);
				}
			}
		}
		return t;
	}
}, eS = class {
	options;
	constructor(e) {
		this.options = e || Hb;
	}
	code(e, t, n) {
		let r = (t || "").match(/^\S*/)?.[0];
		return e = e.replace(/\n$/, "") + "\n", r ? "<pre><code class=\"language-" + Xb(r) + "\">" + (n ? e : Xb(e, !0)) + "</code></pre>\n" : "<pre><code>" + (n ? e : Xb(e, !0)) + "</code></pre>\n";
	}
	blockquote(e) {
		return `<blockquote>\n${e}</blockquote>\n`;
	}
	html(e, t) {
		return e;
	}
	heading(e, t, n) {
		return `<h${t}>${e}</h${t}>\n`;
	}
	hr() {
		return "<hr>\n";
	}
	list(e, t, n) {
		let r = t ? "ol" : "ul", i = t && n !== 1 ? " start=\"" + n + "\"" : "";
		return "<" + r + i + ">\n" + e + "</" + r + ">\n";
	}
	listitem(e, t, n) {
		return `<li>${e}</li>\n`;
	}
	checkbox(e) {
		return "<input " + (e ? "checked=\"\" " : "") + "disabled=\"\" type=\"checkbox\">";
	}
	paragraph(e) {
		return `<p>${e}</p>\n`;
	}
	table(e, t) {
		return t &&= `<tbody>${t}</tbody>`, "<table>\n<thead>\n" + e + "</thead>\n" + t + "</table>\n";
	}
	tablerow(e) {
		return `<tr>\n${e}</tr>\n`;
	}
	tablecell(e, t) {
		let n = t.header ? "th" : "td";
		return (t.align ? `<${n} align="${t.align}">` : `<${n}>`) + e + `</${n}>\n`;
	}
	strong(e) {
		return `<strong>${e}</strong>`;
	}
	em(e) {
		return `<em>${e}</em>`;
	}
	codespan(e) {
		return `<code>${e}</code>`;
	}
	br() {
		return "<br>";
	}
	del(e) {
		return `<del>${e}</del>`;
	}
	link(e, t, n) {
		let r = tx(e);
		if (r === null) return n;
		e = r;
		let i = "<a href=\"" + e + "\"";
		return t && (i += " title=\"" + t + "\""), i += ">" + n + "</a>", i;
	}
	image(e, t, n) {
		let r = tx(e);
		if (r === null) return n;
		e = r;
		let i = `<img src="${e}" alt="${n}"`;
		return t && (i += ` title="${t}"`), i += ">", i;
	}
	text(e) {
		return e;
	}
}, tS = class {
	strong(e) {
		return e;
	}
	em(e) {
		return e;
	}
	codespan(e) {
		return e;
	}
	del(e) {
		return e;
	}
	html(e) {
		return e;
	}
	text(e) {
		return e;
	}
	link(e, t, n) {
		return "" + n;
	}
	image(e, t, n) {
		return "" + n;
	}
	br() {
		return "";
	}
}, nS = class e {
	options;
	renderer;
	textRenderer;
	constructor(e) {
		this.options = e || Hb, this.options.renderer = this.options.renderer || new eS(), this.renderer = this.options.renderer, this.renderer.options = this.options, this.textRenderer = new tS();
	}
	static parse(t, n) {
		return new e(n).parse(t);
	}
	static parseInline(t, n) {
		return new e(n).parseInline(t);
	}
	parse(e, t = !0) {
		let n = "";
		for (let r = 0; r < e.length; r++) {
			let i = e[r];
			if (this.options.extensions && this.options.extensions.renderers && this.options.extensions.renderers[i.type]) {
				let e = i, t = this.options.extensions.renderers[e.type].call({ parser: this }, e);
				if (t !== !1 || ![
					"space",
					"hr",
					"heading",
					"code",
					"table",
					"blockquote",
					"list",
					"html",
					"paragraph",
					"text"
				].includes(e.type)) {
					n += t || "";
					continue;
				}
			}
			switch (i.type) {
				case "space": continue;
				case "hr":
					n += this.renderer.hr();
					continue;
				case "heading": {
					let e = i;
					n += this.renderer.heading(this.parseInline(e.tokens), e.depth, Qb(this.parseInline(e.tokens, this.textRenderer)));
					continue;
				}
				case "code": {
					let e = i;
					n += this.renderer.code(e.text, e.lang, !!e.escaped);
					continue;
				}
				case "table": {
					let e = i, t = "", r = "";
					for (let t = 0; t < e.header.length; t++) r += this.renderer.tablecell(this.parseInline(e.header[t].tokens), {
						header: !0,
						align: e.align[t]
					});
					t += this.renderer.tablerow(r);
					let a = "";
					for (let t = 0; t < e.rows.length; t++) {
						let n = e.rows[t];
						r = "";
						for (let t = 0; t < n.length; t++) r += this.renderer.tablecell(this.parseInline(n[t].tokens), {
							header: !1,
							align: e.align[t]
						});
						a += this.renderer.tablerow(r);
					}
					n += this.renderer.table(t, a);
					continue;
				}
				case "blockquote": {
					let e = i, t = this.parse(e.tokens);
					n += this.renderer.blockquote(t);
					continue;
				}
				case "list": {
					let e = i, t = e.ordered, r = e.start, a = e.loose, o = "";
					for (let t = 0; t < e.items.length; t++) {
						let n = e.items[t], r = n.checked, i = n.task, s = "";
						if (n.task) {
							let e = this.renderer.checkbox(!!r);
							a ? n.tokens.length > 0 && n.tokens[0].type === "paragraph" ? (n.tokens[0].text = e + " " + n.tokens[0].text, n.tokens[0].tokens && n.tokens[0].tokens.length > 0 && n.tokens[0].tokens[0].type === "text" && (n.tokens[0].tokens[0].text = e + " " + n.tokens[0].tokens[0].text)) : n.tokens.unshift({
								type: "text",
								text: e + " "
							}) : s += e + " ";
						}
						s += this.parse(n.tokens, a), o += this.renderer.listitem(s, i, !!r);
					}
					n += this.renderer.list(o, t, r);
					continue;
				}
				case "html": {
					let e = i;
					n += this.renderer.html(e.text, e.block);
					continue;
				}
				case "paragraph": {
					let e = i;
					n += this.renderer.paragraph(this.parseInline(e.tokens));
					continue;
				}
				case "text": {
					let a = i, o = a.tokens ? this.parseInline(a.tokens) : a.text;
					for (; r + 1 < e.length && e[r + 1].type === "text";) a = e[++r], o += "\n" + (a.tokens ? this.parseInline(a.tokens) : a.text);
					n += t ? this.renderer.paragraph(o) : o;
					continue;
				}
				default: {
					let e = "Token with \"" + i.type + "\" type was not found.";
					if (this.options.silent) return console.error(e), "";
					throw Error(e);
				}
			}
		}
		return n;
	}
	parseInline(e, t) {
		t ||= this.renderer;
		let n = "";
		for (let r = 0; r < e.length; r++) {
			let i = e[r];
			if (this.options.extensions && this.options.extensions.renderers && this.options.extensions.renderers[i.type]) {
				let e = this.options.extensions.renderers[i.type].call({ parser: this }, i);
				if (e !== !1 || ![
					"escape",
					"html",
					"link",
					"image",
					"strong",
					"em",
					"codespan",
					"br",
					"del",
					"text"
				].includes(i.type)) {
					n += e || "";
					continue;
				}
			}
			switch (i.type) {
				case "escape": {
					let e = i;
					n += t.text(e.text);
					break;
				}
				case "html": {
					let e = i;
					n += t.html(e.text);
					break;
				}
				case "link": {
					let e = i;
					n += t.link(e.href, e.title, this.parseInline(e.tokens, t));
					break;
				}
				case "image": {
					let e = i;
					n += t.image(e.href, e.title, e.text);
					break;
				}
				case "strong": {
					let e = i;
					n += t.strong(this.parseInline(e.tokens, t));
					break;
				}
				case "em": {
					let e = i;
					n += t.em(this.parseInline(e.tokens, t));
					break;
				}
				case "codespan": {
					let e = i;
					n += t.codespan(e.text);
					break;
				}
				case "br":
					n += t.br();
					break;
				case "del": {
					let e = i;
					n += t.del(this.parseInline(e.tokens, t));
					break;
				}
				case "text": {
					let e = i;
					n += t.text(e.text);
					break;
				}
				default: {
					let e = "Token with \"" + i.type + "\" type was not found.";
					if (this.options.silent) return console.error(e), "";
					throw Error(e);
				}
			}
		}
		return n;
	}
}, rS = class {
	options;
	constructor(e) {
		this.options = e || Hb;
	}
	static passThroughHooks = /* @__PURE__ */ new Set([
		"preprocess",
		"postprocess",
		"processAllTokens"
	]);
	preprocess(e) {
		return e;
	}
	postprocess(e) {
		return e;
	}
	processAllTokens(e) {
		return e;
	}
}, iS = class {
	defaults = Vb();
	options = this.setOptions;
	parse = this.#e($x.lex, nS.parse);
	parseInline = this.#e($x.lexInline, nS.parseInline);
	Parser = nS;
	Renderer = eS;
	TextRenderer = tS;
	Lexer = $x;
	Tokenizer = cx;
	Hooks = rS;
	constructor(...e) {
		this.use(...e);
	}
	walkTokens(e, t) {
		let n = [];
		for (let r of e) switch (n = n.concat(t.call(this, r)), r.type) {
			case "table": {
				let e = r;
				for (let r of e.header) n = n.concat(this.walkTokens(r.tokens, t));
				for (let r of e.rows) for (let e of r) n = n.concat(this.walkTokens(e.tokens, t));
				break;
			}
			case "list": {
				let e = r;
				n = n.concat(this.walkTokens(e.items, t));
				break;
			}
			default: {
				let e = r;
				this.defaults.extensions?.childTokens?.[e.type] ? this.defaults.extensions.childTokens[e.type].forEach((r) => {
					let i = e[r].flat(Infinity);
					n = n.concat(this.walkTokens(i, t));
				}) : e.tokens && (n = n.concat(this.walkTokens(e.tokens, t)));
			}
		}
		return n;
	}
	use(...e) {
		let t = this.defaults.extensions || {
			renderers: {},
			childTokens: {}
		};
		return e.forEach((e) => {
			let n = { ...e };
			if (n.async = this.defaults.async || n.async || !1, e.extensions && (e.extensions.forEach((e) => {
				if (!e.name) throw Error("extension name required");
				if ("renderer" in e) {
					let n = t.renderers[e.name];
					n ? t.renderers[e.name] = function(...t) {
						let r = e.renderer.apply(this, t);
						return r === !1 && (r = n.apply(this, t)), r;
					} : t.renderers[e.name] = e.renderer;
				}
				if ("tokenizer" in e) {
					if (!e.level || e.level !== "block" && e.level !== "inline") throw Error("extension level must be 'block' or 'inline'");
					let n = t[e.level];
					n ? n.unshift(e.tokenizer) : t[e.level] = [e.tokenizer], e.start && (e.level === "block" ? t.startBlock ? t.startBlock.push(e.start) : t.startBlock = [e.start] : e.level === "inline" && (t.startInline ? t.startInline.push(e.start) : t.startInline = [e.start]));
				}
				"childTokens" in e && e.childTokens && (t.childTokens[e.name] = e.childTokens);
			}), n.extensions = t), e.renderer) {
				let t = this.defaults.renderer || new eS(this.defaults);
				for (let n in e.renderer) {
					if (!(n in t)) throw Error(`renderer '${n}' does not exist`);
					if (n === "options") continue;
					let r = n, i = e.renderer[r], a = t[r];
					t[r] = (...e) => {
						let n = i.apply(t, e);
						return n === !1 && (n = a.apply(t, e)), n || "";
					};
				}
				n.renderer = t;
			}
			if (e.tokenizer) {
				let t = this.defaults.tokenizer || new cx(this.defaults);
				for (let n in e.tokenizer) {
					if (!(n in t)) throw Error(`tokenizer '${n}' does not exist`);
					if ([
						"options",
						"rules",
						"lexer"
					].includes(n)) continue;
					let r = n, i = e.tokenizer[r], a = t[r];
					t[r] = (...e) => {
						let n = i.apply(t, e);
						return n === !1 && (n = a.apply(t, e)), n;
					};
				}
				n.tokenizer = t;
			}
			if (e.hooks) {
				let t = this.defaults.hooks || new rS();
				for (let n in e.hooks) {
					if (!(n in t)) throw Error(`hook '${n}' does not exist`);
					if (n === "options") continue;
					let r = n, i = e.hooks[r], a = t[r];
					t[r] = rS.passThroughHooks.has(n) ? (e) => {
						if (this.defaults.async) return Promise.resolve(i.call(t, e)).then((e) => a.call(t, e));
						let n = i.call(t, e);
						return a.call(t, n);
					} : (...e) => {
						let n = i.apply(t, e);
						return n === !1 && (n = a.apply(t, e)), n;
					};
				}
				n.hooks = t;
			}
			if (e.walkTokens) {
				let t = this.defaults.walkTokens, r = e.walkTokens;
				n.walkTokens = function(e) {
					let n = [];
					return n.push(r.call(this, e)), t && (n = n.concat(t.call(this, e))), n;
				};
			}
			this.defaults = {
				...this.defaults,
				...n
			};
		}), this;
	}
	setOptions(e) {
		return this.defaults = {
			...this.defaults,
			...e
		}, this;
	}
	lexer(e, t) {
		return $x.lex(e, t ?? this.defaults);
	}
	parser(e, t) {
		return nS.parse(e, t ?? this.defaults);
	}
	#e(e, t) {
		return (n, r) => {
			let i = { ...r }, a = {
				...this.defaults,
				...i
			};
			this.defaults.async === !0 && i.async === !1 && (a.silent || console.warn("marked(): The async option was set to true by an extension. The async: false option sent to parse will be ignored."), a.async = !0);
			let o = this.#t(!!a.silent, !!a.async);
			if (n == null) return o(/* @__PURE__ */ Error("marked(): input parameter is undefined or null"));
			if (typeof n != "string") return o(/* @__PURE__ */ Error("marked(): input parameter is of type " + Object.prototype.toString.call(n) + ", string expected"));
			if (a.hooks && (a.hooks.options = a), a.async) return Promise.resolve(a.hooks ? a.hooks.preprocess(n) : n).then((t) => e(t, a)).then((e) => a.hooks ? a.hooks.processAllTokens(e) : e).then((e) => a.walkTokens ? Promise.all(this.walkTokens(e, a.walkTokens)).then(() => e) : e).then((e) => t(e, a)).then((e) => a.hooks ? a.hooks.postprocess(e) : e).catch(o);
			try {
				a.hooks && (n = a.hooks.preprocess(n));
				let r = e(n, a);
				a.hooks && (r = a.hooks.processAllTokens(r)), a.walkTokens && this.walkTokens(r, a.walkTokens);
				let i = t(r, a);
				return a.hooks && (i = a.hooks.postprocess(i)), i;
			} catch (e) {
				return o(e);
			}
		};
	}
	#t(e, t) {
		return (n) => {
			if (n.message += "\nPlease report this to https://github.com/markedjs/marked.", e) {
				let e = "<p>An error occurred:</p><pre>" + Xb(n.message + "", !0) + "</pre>";
				return t ? Promise.resolve(e) : e;
			}
			if (t) return Promise.reject(n);
			throw n;
		};
	}
}, aS = new iS();
function oS(e, t) {
	return aS.parse(e, t);
}
oS.options = oS.setOptions = function(e) {
	return aS.setOptions(e), oS.defaults = aS.defaults, Ub(oS.defaults), oS;
}, oS.getDefaults = Vb, oS.defaults = Hb, oS.use = function(...e) {
	return aS.use(...e), oS.defaults = aS.defaults, Ub(oS.defaults), oS;
}, oS.walkTokens = function(e, t) {
	return aS.walkTokens(e, t);
}, oS.parseInline = aS.parseInline, oS.Parser = nS, oS.parser = nS.parse, oS.Renderer = eS, oS.TextRenderer = tS, oS.Lexer = $x, oS.lexer = $x.lex, oS.Tokenizer = cx, oS.Hooks = rS, oS.parse = oS;
var sS = oS.options, cS = oS.setOptions, lS = oS.use, uS = oS.walkTokens, dS = oS.parseInline, fS = oS, pS = nS.parse, mS = $x.lex, hS = {
	react: Pn,
	"react-dom": Wr,
	"react-dom/client": ni,
	rxjs: Qn,
	"observable-hooks": Wn,
	clsx: Jn,
	valtio: Jr,
	lodash: Yr,
	"date-fns": ti,
	axios: Sb,
	marked: Bb,
	"ag-grid-community": $r,
	"ag-grid-react": ei,
	"@emotion/css": Yh,
	"@internationalized/date": Qr,
	"@internationalized/number": Eg,
	"@flowx/core-sdk": oe,
	"@flowx/react-sdk": iT,
	"@flowx/core-theme": pr,
	"@flowx/react-theme": hr,
	"@flowx/react-ui-toolkit": yr
};
function gS(e) {
	if (e.startsWith("@")) {
		let t = e.split("/");
		return t.length < 2 ? [e, void 0] : [`${t[0]}/${t[1]}`, t.length > 2 ? t.slice(2).join("/") : void 0];
	}
	let t = e.indexOf("/");
	return t === -1 ? [e, void 0] : [e.substring(0, t), e.substring(t + 1)];
}
function _S(e) {
	if (e in hS) {
		let [t] = gS(e);
		return {
			module: hS[e],
			packageName: t,
			subPath: void 0
		};
	}
	let [t, n] = gS(e);
	if (t in hS) {
		let e = hS[t];
		return !n || e != null && n in e ? {
			module: e,
			packageName: t,
			subPath: n
		} : {
			module: void 0,
			packageName: t,
			subPath: n
		};
	}
	return {
		module: void 0,
		packageName: t,
		subPath: n
	};
}
// libs/sdk/react/src/lib/custom-component-runtime/import-rewriter.ts
function vS(e) {
	return typeof e == "object" && e && "default" in e && typeof e.default == "function" ? Object.assign(e.default, e) : e;
}
function yS(e) {
	let t = /* @__PURE__ */ new Set(), n = [], r = e.replace(bS, (e) => {
		let t = n.length;
		return n.push(e), `\0PLACEHOLDER_${t}\0`;
	});
	return r = r.replace(xS, ""), r = r.replace(SS, (e, n, r) => {
		let i = _S(r), a = i.module !== void 0;
		a || t.add(r);
		let o = kS(n);
		return !o.defaultImport && !o.namedImports?.length && !o.namespaceImport ? "" : a ? PS(o, r, i) : FS(o, r);
	}), r = r.replace(CS, (e, n) => _S(n).module === void 0 ? (t.add(n), `await __import('${n}');`) : ""), r = r.replace(wS, (e, n, r) => {
		let i = _S(r), a = i.module !== void 0;
		if (a || t.add(r), n.trim().startsWith("*")) return `/* unsupported: export ${n.trim()} from '${r}' */`;
		let o = n.match(/\{([\s\S]*)\}/);
		if (o) {
			let e = AS(o[1]), t = a ? jS(r, i) : `await __import('${r}')`;
			return `const { ${MS(e)} } = ${t};`;
		}
		return "";
	}), r = r.replace(ES, "__defaultExport = "), r = r.replace(DS, (e, t) => {
		let n = t.split(",").map((e) => e.trim()).filter(Boolean).find((e) => /\bas\s+default\b/.test(e));
		return n ? `__defaultExport = ${n.split(/\s+as\s+/)[0].trim()};` : "";
	}), r = r.replace(OS, (e, t) => t), r = r.replace(TS, (e, n) => {
		let r = _S(n);
		return r.module === void 0 ? (t.add(n), `__import('${n}')`) : `Promise.resolve(${jS(n, r)})`;
	}), r = r.replace(/\0PLACEHOLDER_(\d+)\0/g, (e, t) => n[Number(t)]), {
		code: r,
		externalSpecifiers: t
	};
}
var bS = /\/\/[^\n]*|\/\*[\s\S]*?\*\/|`(?:[^`\\]|\\.)*`|"(?:[^"\\\n]|\\.)*(?:import|export)(?:[^"\\\n]|\\.)*"|'(?:[^'\\\n]|\\.)*(?:import|export)(?:[^'\\\n]|\\.)*'/g, xS = /\bimport\s+type\s+[\s\S]*?\s+from\s+['"][^'"]+['"]\s*;?/g, SS = /\bimport\s+([\s\S]*?)\s+from\s+['"]([^'"]+)['"]\s*;?/g, CS = /\bimport\s+['"]([^'"]+)['"]\s*;?/g, wS = /\bexport\s+([\s\S]*?)\s+from\s+['"]([^'"]+)['"]\s*;?/g, TS = /\bimport\s*\(\s*['"]([^'"]+)['"]\s*\)/g, ES = /\bexport\s+default\s+/g, DS = /\bexport\s+\{([^}]+)\}\s*;?/g, OS = /\bexport\s+((?:const|let|var|function\s*\*?|class)\s+)/g;
function kS(e) {
	let t = e.trim(), n = {}, r = t.match(/^\*\s+as\s+([\w$]+)$/);
	if (r) return n.namespaceImport = r[1], n;
	let i = t.match(/^([\w$]+)\s*,\s*\*\s+as\s+([\w$]+)$/);
	if (i) return n.defaultImport = i[1], n.namespaceImport = i[2], n;
	let a = t.match(/^([\w$]+)\s*,\s*\{([\s\S]*)\}$/);
	if (a) return n.defaultImport = a[1], n.namedImports = AS(a[2]), n;
	let o = t.match(/^\{([\s\S]*)\}$/);
	if (o) return n.namedImports = AS(o[1]), n;
	let s = t.match(/^([\w$]+)$/);
	return s && (n.defaultImport = s[1]), n;
}
function AS(e) {
	return e.split(",").map((e) => e.trim()).filter(Boolean).filter((e) => !e.startsWith("type ")).map((e) => {
		let t = e.split(/\s+as\s+/);
		return {
			imported: t[0].trim(),
			local: (t[1] ?? t[0]).trim()
		};
	});
}
function jS(e, t) {
	return t.subPath ? `__modules['${t.packageName}']['${t.subPath}']` : `__modules['${e}']`;
}
function MS(e) {
	return e.map((e) => e.imported === e.local ? e.local : `${e.imported}: ${e.local}`).join(", ");
}
function NS(e) {
	return "__" + e.replace(/[^a-zA-Z0-9_$]/g, "_");
}
function PS(e, t, n) {
	let r = jS(t, n), i = [], a = n.subPath ? `__modules['${n.packageName}']` : r;
	return e.namespaceImport && i.push(`const ${e.namespaceImport} = __resolveNamespace(${r});`), e.defaultImport && i.push(n.subPath ? `const ${e.defaultImport} = ${r};` : `const ${e.defaultImport} = ${r}.default;`), e.namedImports?.length && i.push(`const { ${MS(e.namedImports)} } = ${a};`), i.join("\n");
}
function FS(e, t) {
	let n = [];
	if ([
		e.defaultImport,
		e.namedImports?.length,
		e.namespaceImport
	].filter(Boolean).length > 1) {
		let r = NS(t);
		n.push(`const ${r} = await __import('${t}');`), e.namespaceImport && n.push(`const ${e.namespaceImport} = ${r};`), e.defaultImport && n.push(`const ${e.defaultImport} = ${r}.default;`), e.namedImports?.length && n.push(`const { ${MS(e.namedImports)} } = ${r};`);
	} else e.namespaceImport && n.push(`const ${e.namespaceImport} = await __import('${t}');`), e.defaultImport && n.push(`const ${e.defaultImport} = (await __import('${t}')).default;`), e.namedImports?.length && n.push(`const { ${MS(e.namedImports)} } = await __import('${t}');`);
	return n.join("\n");
}
// libs/sdk/react/src/lib/custom-component-runtime/component-loader.ts
var IS = /* @__PURE__ */ new Map();
function LS(e) {
	let t = [...e.dependencies].sort((e, t) => e.name.localeCompare(t.name)), n = JSON.stringify(t);
	return am(`${e.sourceCode}\0${e.styles}\0${n}`);
}
function RS() {
	IS.clear(), zS.clear(), VS(), JS();
}
var zS = /* @__PURE__ */ new Map(), BS = /* @__PURE__ */ new Map();
function VS() {
	for (let e of BS.values()) e.remove();
	BS.clear();
}
var HS = "https://esm.sh", US = 15e3, WS = [
	"react",
	"react-dom",
	"@emotion/css",
	"lodash",
	"axios",
	"date-fns"
], GS = !1, KS = null, qS = [];
function JS() {
	KS &&= (KS.remove(), null);
	for (let e of qS) URL.revokeObjectURL(e);
	qS.length = 0, delete window.__FLOWX_MODULES__, GS = !1;
}
function YS(e) {
	let t = hS[e];
	if (!t) return "";
	let n = Object.keys(t).filter((e) => e !== "default" && e !== "__esModule" && /^[a-zA-Z_$][\w$]*$/.test(e)), r = [
		`const __m = window.__FLOWX_MODULES__['${e}'];`,
		"export default __m.default ?? __m;",
		...n.map((e) => `export const ${e} = __m['${e}'];`)
	].join("\n"), i = URL.createObjectURL(new Blob([r], { type: "application/javascript" }));
	return qS.push(i), i;
}
function XS() {
	let e = URL.createObjectURL(new Blob(["const React = window.__FLOWX_MODULES__['react'];\nconst R = React.default ?? React;\nexport const jsx = R.createElement;\nexport const jsxs = R.createElement;\nexport const jsxDEV = R.createElement;\nexport const Fragment = R.Fragment;"], { type: "application/javascript" }));
	return qS.push(e), e;
}
function ZS(e, t) {
	if (GS) return;
	GS = !0, window.__FLOWX_MODULES__ = hS;
	let n = {};
	for (let e of WS) {
		let t = YS(e);
		t && (n[e] = t);
	}
	let r = XS();
	n["react/jsx-runtime"] = r, n["react/jsx-dev-runtime"] = r;
	let i = YS("react-dom/client");
	i && (n["react-dom/client"] = i), e && t && t.map((e) => gS(e)[0]).filter((e) => !(e in n) && !(e in hS)).forEach((r) => {
		n[r] = QS(r, e, t);
	});
	let a = document.createElement("script");
	a.type = "importmap", a.textContent = JSON.stringify({ imports: n }), document.head.appendChild(a), KS = a;
}
function QS(e, t, n) {
	let [r, i] = gS(e), a = t.get(r);
	return `${HS}/${r}${a ? `@${a}` : ""}${i ? `/${i}` : ""}?external=${(n ?? WS).filter((e) => e !== r).join(",")}`;
}
function $S(e) {
	return fetch(e).then((e) => {
		if (!e.ok) throw Error(`HTTP ${e.status}`);
		return e.text();
	}).then((t) => {
		let n = document.createElement("style");
		return n.setAttribute("data-flx-cc-css", e), n.textContent = t, document.head.appendChild(n), BS.set(e, n), {};
	});
}
function eC(e, t) {
	return ZS(e, t), (n) => {
		let r = QS(n, e, t), i = zS.get(r);
		if (i) return i;
		let a = n.endsWith(".css") ? $S(r) : import(
			/* webpackIgnore: true */
			/* @vite-ignore */
			r
), o, s = new Promise((e, t) => {
			o = setTimeout(() => t(/* @__PURE__ */ Error(`Timed out after ${US / 1e3}s`)), US);
		}), c = Promise.race([a, s]).then((e) => (clearTimeout(o), e), (e) => {
			throw clearTimeout(o), e;
		}).catch((e) => {
			throw zS.delete(r), Error(`[FlowX] Failed to load external dependency "${n}" from ${r}: ${e.message}`);
		});
		return zS.set(r, c), c;
	};
}
function tC(e) {
	return [
		"export default (async function(__modules, __import, __resolveNamespace) {",
		"  let __defaultExport;",
		e,
		"  return __defaultExport;",
		"})"
	].join("\n");
}
async function nC(e) {
	let t = new Blob([e], { type: "application/javascript" }), n = URL.createObjectURL(t);
	try {
		return (await import(
			/* webpackIgnore: true */
			/* @vite-ignore */
			n
)).default;
	} finally {
		URL.revokeObjectURL(n);
	}
}
function rC(e) {
	let t = {
		...e,
		dependencies: e.dependencies ?? []
	}, n;
	try {
		n = LS(t);
	} catch (e) {
		return Promise.reject(e);
	}
	let r = IS.get(n);
	if (r) return r;
	let i = iC(t);
	return IS.set(n, i), i.catch(() => IS.delete(n)), i;
}
async function iC(e) {
	let { sourceCode: t, uniqueIdentifier: n, styles: r, dependencies: i } = e, a = new Map(i.map((e) => [e.name, e.version])), { code: o, externalSpecifiers: s } = yS(t), { code: c } = sp(tC((/\bconst\s+React\s*=/.test(o) ? "" : "const React = __modules['react'].default ?? __modules['react'];\n") + o), {
		transforms: ["typescript", "jsx"],
		jsxRuntime: "classic",
		jsxPragma: "React.createElement",
		jsxFragmentPragma: "React.Fragment",
		production: !1
	}), l = om(n), u = r ? sm(r, l) : "", d = Array.from(s).map((e) => gS(e)[0]), f = eC(a, [...WS, ...d.filter((e) => !WS.includes(e) && !(e in hS))]);
	s.size > 0 && await Promise.all(Array.from(s).map((e) => f(e)));
	let p = await nC(c), m;
	try {
		m = await p(hS, f, vS);
	} catch (e) {
		let t = e instanceof Error ? e.message : String(e);
		throw Error(`[FlowX] Custom component "${n}" threw during initialization: ${t}`);
	}
	let h = typeof m == "function", g = typeof m == "object" && !!m && !!m.prototype && m.prototype?.isReactComponent != null;
	if (!h && !g) throw Error(`[FlowX] Custom component "${n}" did not export a default React component. Got: ${m === null ? "null" : typeof m}`);
	return {
		Component: m,
		scopeId: l,
		scopedCss: u
	};
}
function aC(e) {
	let { Component: t, scopeId: n, scopedCss: r } = e, i = Fn.memo(({ flowxUuid: e, ...i }) => (mm(r, n), Fn.createElement("div", {
		className: n,
		style: { display: "contents" },
		"data-uniqueid": e
	}, Fn.createElement(t, i))));
	return i.displayName = `Scoped(${t.displayName || t.name || "Component"})`, i;
}
// libs/sdk/react/src/components/sdk/custom-component/FlxRuntimeCustomComponent.tsx
var oC = /* @__PURE__ */ r({
	FlxRuntimeCustomComponent: () => dC,
	clearPendingCompilations: () => uC
}), sC = Rn(function() {
	return /* @__PURE__ */ N("div", {
		className: "flx-cc-skeleton",
		"data-flx-cc": "skeleton"
	});
}), cC = /* @__PURE__ */ new Map(), lC = 0;
function uC() {
	cC.clear(), lC++;
}
function dC({ config: e }) {
	let t = Ge(e.displayOptions.flowxProps.appId, e.displayOptions.flowxProps.resDefId);
	return t ? /* @__PURE__ */ N(fC, {
		config: e,
		definition: t
	}) : null;
}
var fC = Rn(function({ config: e, definition: t }) {
	let [n, r] = Un(!1), [i, a] = Un(null), o = `${t.appId}_${t.resourceDefinitionId}`;
	Vn(() => {
		let e = !1, n = cC.get(o);
		if (!n) {
			let e = lC;
			n = rC(t).then((t) => {
				if (lC !== e) return;
				let n = aC(t);
				me({ [o]: n });
			}).finally(() => {
				cC.delete(o);
			}), cC.set(o, n);
		}
		return n.then(() => {
			e || r(!0);
		}, (t) => {
			e || a(t.message);
		}), () => {
			e = !0;
		};
	}, [t, o]);
	let s = n ? Je()[o] : null, c = Gn((e) => e.pipe(dr(([e]) => b(e))), [e]), l = O((t, n, r, i, a) => s ? /* @__PURE__ */ N(s, {
		input: t,
		validate: a,
		registerValidation: n,
		saveData: r,
		isSubmitted: i,
		flowxUuid: e.flowxUuid
	}) : null, [s, e.flowxUuid]);
	return i ? /* @__PURE__ */ qr("div", {
		className: "flx-cc-error",
		children: [
			"Failed to load component: ",
			i,
			" with identifier: ",
			t.uniqueIdentifier
		]
	}) : n ? s ? /* @__PURE__ */ N(si, {
		componentIdentifier: o,
		children: /* @__PURE__ */ N(y, {
			uuid: e.reusableUiTemplateContext ? `${e.reusableUiTemplateContext}_${e.flowxUuid}` : e.flowxUuid,
			viewUuid: e.flowxUuid,
			data$: c,
			children: l
		})
	}) : null : /* @__PURE__ */ N(sC, {});
}), pC = (e, t) => {
	let n = A(e);
	n.current = e;
	let r = A(t);
	r.current = t;
	let i = Gn(() => cn(n.current));
	qn(i, () => Pe(n.current, r.current));
}, mC = { display: "contents" }, hC = (e) => ({
	...p,
	...g
})[e], gC = Rn(({ config: e, collectionPrototypeInstanceMeta: t, ref: n }) => {
	let r = k(() => t || void 0, [t]), i = Kn(gn.stream$, []), a = k(() => {
		let e = i[i.length - 1];
		return new Set(e?.map((e) => `${e.id}_${e.context}`) ?? []);
	}, [i]), o = A(Ae()).current, s = k(() => je({
		templateConfig: e?.templateConfig,
		parentFlowxUuid: e?.flowxUuid,
		prototypeInstanceMeta: r,
		cache: o
	}), [
		e?.templateConfig,
		e?.flowxUuid,
		r,
		o
	]), c = k(() => Ke() ? s?.filter((e) => {
		if (Dt(e) && (e.componentIdentifier === le.CARD || e.componentIdentifier === le.CONTAINER)) {
			let t = `${e.id}_${e.context}`;
			return a.has(t);
		}
		return !0;
	}) : s, [s, a]);
	return /* @__PURE__ */ N(In, {
		fallback: /* @__PURE__ */ N(_, {}),
		children: c && c.length > 0 ? c.map((e) => {
			if (e.type === "CUSTOM") {
				if (e.displayOptions.flowxProps.type === "BUNDLED") return /* @__PURE__ */ N(dC, { config: e }, e.id);
				let t = Je()[e.componentIdentifier];
				if (t) {
					let n = b(e);
					return /* @__PURE__ */ N("div", {
						style: mC,
						"data-uniqueid": e.flowxUuid,
						"data-flowx-component": e.componentIdentifier,
						children: /* @__PURE__ */ N(si, {
							componentIdentifier: e.componentIdentifier,
							children: /* @__PURE__ */ N(y, {
								uuid: e.flowxUuid,
								data$: n,
								children: (e, n, r, i, a) => /* @__PURE__ */ N(t, {
									input: e,
									validate: a,
									registerValidation: n,
									saveData: r,
									isSubmitted: i
								})
							})
						})
					}, e.id);
				}
				return null;
			}
			let t = hC(e.componentIdentifier), r = [
				e.id,
				e?.reusableUiTemplateContext,
				e.context
			].filter(Boolean).join("_");
			return t ? /* @__PURE__ */ N(m, {
				config: e,
				ref: n,
				children: /* @__PURE__ */ N(t, { config: e })
			}, r) : null;
		}) : null
	});
});
gC.displayName = "FlxTreeNode";
// libs/sdk/react/src/lib/utils/stableProjection.ts
var _C = (e, t) => {
	let n = Object.keys(e);
	return n.length === Object.keys(t).length && n.every((n) => e[n] === t[n]);
}, vC = (e) => (t) => {
	let n;
	return t.pipe(sr((t) => {
		let r = e(t);
		return n = n && _C(n, r) ? n : r, n;
	}));
}, yC = (e) => {
	if (e?.url) window.open(e.url, "_blank");
	else if (e?.src) {
		let t = Oe();
		window.open(`${t.apiUrl}/documents/${e.src}`, "_blank");
	}
}, bC = () => {
	let e = Gn(() => zt()), t = Kn(e, []), n = M(j.Message);
	return t.map((e) => {
		let t = e.displayOptions?.flowxProps, r = e.action;
		return /* @__PURE__ */ qr(Vr, {
			className: n,
			type: t?.messageType,
			display: t?.displayType || "fill",
			layout: t?.layoutType || "row",
			style: { width: "100%" },
			children: [D(t?.text || ""), r && /* @__PURE__ */ N("button", {
				name: r.label,
				onClick: () => yC(r),
				children: D(r.label)
			})]
		}, e.identifier);
	});
}, xC = { templateConfig: [] }, SC = (e) => rr(() => {
	let t = !1;
	return e.pipe(tr((e) => {
		let n = [...e?.rootTemplates?.templateConfig ?? [], ...e?.modalTemplates?.templateConfig ?? []];
		return t || n.length === 0 ? cr(e) : (t = !0, or(h(n)).pipe(sr(() => e)));
	}));
}), CC = (e, t, n) => e?.actions?.[t] || (n === "upload" ? e?.defaultUpload : void 0) || (n === "action" ? e?.defaultAction : void 0) || e?.[t], wC = Rn(({ customLoader: e }) => {
	let t = Gn(() => (Ke() ? Ut : ln).pipe(SC, lr({
		bufferSize: 1,
		refCount: !0
	}))), n = Gn(() => t.pipe(sr((e) => e?.rootTemplates ?? xC), ir((e, t) => Zn(e, t)), lr({
		bufferSize: 1,
		refCount: !0
	}))), r = Gn(() => t.pipe(sr((e) => e?.modalTemplates ?? xC), ir((e, t) => Zn(e, t)), lr({
		bufferSize: 1,
		refCount: !0
	}))), i = Kn(n, xC), a = Kn(r, xC), o = Gn(() => Cn.pipe(vC(({ showLoader: e, loaderType: t, loaderText: n }) => ({
		showLoader: e,
		loaderType: t,
		loaderText: n
	})), ir())), { showLoader: s, loaderType: c, loaderText: l } = Kn(o, {
		showLoader: void 0,
		loaderType: void 0,
		loaderText: void 0
	}), u = M(j.Button), f = M(j.Card), p = M(j.Spinner), m = d(), h = k(() => /* @__PURE__ */ N(Ir, {
		backgroundColor: "var(--flxTheme-spinner-backgroundColor, #ffffff)",
		borderColor: "var(--flxTheme-spinner-accentColor, transparent)",
		visualType: "custom",
		size: "small",
		type: "indeterminate",
		className: p ?? "",
		text: l
	}), [l, p]), g = k(() => {
		if (s === void 0) return null;
		let t = CC(e, s, c);
		return /* @__PURE__ */ N(Fr, {
			open: !0,
			container: m,
			className: Xn("flx-loader-modal", [`flx-loader-overlay ${s}`]),
			children: t ?? h
		});
	}, [
		s,
		c,
		e,
		h,
		m
	]), v = Kn(Se(1), !1), y = Kn(Se(-1), !1), b = Kn(Ce, !1), x = D("@@sys_close");
	return /* @__PURE__ */ N(Hr.Provider, { children: /* @__PURE__ */ qr("div", {
		className: Xn("flx-process-renderer", { readonly: Ke() }),
		children: [
			/* @__PURE__ */ N(bC, {}),
			/* @__PURE__ */ N(ai, {}),
			g || null,
			/* @__PURE__ */ qr(In, {
				fallback: /* @__PURE__ */ N(_, { children: g }),
				children: [/* @__PURE__ */ N(gC, { config: i }), /* @__PURE__ */ N(gC, { config: a })]
			}),
			Ke() && (y || v || b) ? /* @__PURE__ */ N("div", {
				className: "flx-template-navigation-buttons",
				children: /* @__PURE__ */ N(Rr, {
					className: f,
					children: /* @__PURE__ */ N(zr, { children: /* @__PURE__ */ qr("div", {
						className: "flx-template-navigation-actions",
						children: [b ? /* @__PURE__ */ N(xr, {
							className: u,
							variant: "text",
							icon: "left",
							iconComponent: /* @__PURE__ */ N(Pr, { name: "caretLeft" }),
							onClick: () => Rt(),
							children: x
						}) : null, /* @__PURE__ */ qr("div", {
							className: "flx-template-navigation-actions-buttons",
							children: [y ? /* @__PURE__ */ N(xr, {
								className: u,
								variant: "fill",
								icon: "center",
								iconComponent: /* @__PURE__ */ N(Pr, { name: "arrowLeft" }),
								onClick: () => Nt(-1),
								children: "Previous"
							}) : null, v ? /* @__PURE__ */ N(xr, {
								className: u,
								variant: "fill",
								icon: "center",
								iconComponent: /* @__PURE__ */ N(Pr, { name: "arrowRight" }),
								onClick: () => Nt(1),
								children: "Next"
							}) : null]
						})]
					}) })
				})
			}) : null
		]
	}) });
});
wC.displayName = "App";
// libs/sdk/react/src/components/sdk/process-renderer/FlxProcessRendererBase.tsx
function TC({ apiUrl: e, authToken: t, anonymousSessionId: n, language: r, themeId: i, processName: a, resourceId: o, processStartData: s, processApiPath: c, isDraft: l, trigger: u, staticAssetsPath: d, validators: f, components: p, projectInfo: m, buildId: h, workspaceId: g, organizationId: _, locale: v, cache: y, legacyHttpVersion: b, legacyFileSources: x, startMode: S, requestInterceptors: C, responseInterceptors: w, onProcessEnded: ee, onProcessStarted: te, customLoader: ne }) {
	let re = A(t);
	re.current = t;
	let ie = A(s);
	ie.current = s;
	let oe = A(f);
	oe.current = f;
	let se = A(p);
	se.current = p, Hn(() => {
		t && (Oe()?.isAnonymousMode || un(t));
	}, [t]), Vn(() => {
		ee && ge(ee);
	}, [ee]), Vn(() => {
		te && _e(te);
	}, [te]), Vn(() => {
		he({
			requestInterceptors: C,
			responseInterceptors: w
		});
	}, [C, w]), Vn(() => {
		bt({
			apiUrl: e,
			authToken: re.current,
			anonymousSessionId: n,
			language: r,
			themeId: i,
			processName: a,
			processStartData: ie.current,
			processApiPath: c,
			isDraft: l,
			staticAssetsPath: d,
			appInfo: {
				appId: m?.projectId,
				appVersionId: m?.appVersionId,
				selectedProcessResourceId: m?.selectedProcessResourceId
			},
			buildId: h,
			workspaceId: g,
			organizationId: _,
			locale: v,
			cache: y,
			legacyHttpVersion: b,
			legacyFileSources: x,
			resourceId: o,
			startMode: S,
			trigger: u,
			fw: "react"
		});
		let t = We() === null;
		return t && ae.initCustomValidators({ ...oe.current }), me(se.current ?? {}), () => {
			t && ae.clearCustomValidators(), Xt();
		};
	}, [
		n,
		b,
		x,
		S,
		m?.projectId,
		m?.appVersionId,
		m?.selectedProcessResourceId,
		h,
		g,
		_,
		e,
		r,
		i,
		a,
		c,
		l,
		d,
		v,
		y,
		o,
		u
	]);
	let ce = Kn(Bt.stream$, 0);
	return /* @__PURE__ */ N(wC, { customLoader: ne }, ce);
}
// libs/sdk/react/src/components/sdk/process-renderer/ProcessRenderer.tsx
function EC({ baseUrl: e, apiUrl: t, enginePath: n, processApiPath: r, assetsBaseUrl: i, staticAssetsPath: a, accessToken: o, authToken: s, customLoaderProvider: c, customLoader: u, legacyHttpVersion: d, ...f }) {
	return /* @__PURE__ */ N(TC, {
		...f,
		...l({
			baseUrl: e,
			apiUrl: t,
			enginePath: n,
			processApiPath: r,
			assetsBaseUrl: i,
			staticAssetsPath: a,
			accessToken: o,
			authToken: s
		}),
		customLoader: $t({
			customLoader: u,
			customLoaderProvider: c
		}),
		legacyHttpVersion: jn("legacyHttpVersion", d)
	});
}
var DC = (e) => ({
	top: e.top,
	left: e.left,
	width: e.width,
	height: e.height
}), OC = (e) => getComputedStyle(e).display === "contents" ? [...e.children].flatMap(OC) : [e], kC = (e) => {
	let t = e.flatMap(OC).map((e) => e.getBoundingClientRect()).filter((e) => e.width > 0 && e.height > 0);
	if (t.length === 0) return null;
	let n = Math.min(...t.map((e) => e.top)), r = Math.min(...t.map((e) => e.left));
	return {
		top: n,
		left: r,
		width: Math.max(...t.map((e) => e.right)) - r,
		height: Math.max(...t.map((e) => e.bottom)) - n
	};
}, AC = (e) => kC([e]), jC = (e) => e.replace(/["\\]/gu, "\\$&"), MC = (e, t) => {
	let n = e.getAttribute("data-uniqueid");
	return n && t ? [...t.querySelectorAll(`[data-uniqueid="${jC(n)}"]`)].filter((t) => t !== e && !t.contains(e) && !e.contains(t)) : [];
}, NC = (e, t) => {
	let n = MC(e, t);
	return n.length === 0 ? AC(e) : kC([e, ...n]);
}, PC = (e, t) => e.length === t.length && e.every((e, n) => {
	let r = t[n];
	return e === r || !!e && !!r && e.top === r.top && e.left === r.left && e.width === r.width && e.height === r.height;
}), FC = () => ({
	top: 0,
	left: 0,
	width: window.innerWidth,
	height: window.innerHeight
}), IC = (e, t) => {
	let n = Math.max(e.top, t.top), r = Math.max(e.left, t.left);
	return {
		top: n,
		left: r,
		width: Math.max(0, Math.min(e.left + e.width, t.left + t.width) - r),
		height: Math.max(0, Math.min(e.top + e.height, t.top + t.height) - n)
	};
}, LC = /auto|scroll|overlay/u, RC = (e) => {
	let t = (e) => !e || e === document.body || e === document.documentElement ? null : LC.test(getComputedStyle(e).overflowY) ? e : t(e.parentElement);
	return t(e);
}, zC = (e) => {
	let t = RC(e);
	return IC(DC(t ? t.getBoundingClientRect() : e.getBoundingClientRect()), FC());
}, BC = (e, t) => {
	let n = IC(e, t);
	return n.width > 0 && n.height > 0;
}, VC = (e, { x: t, y: n }) => t >= e.left && t <= e.left + e.width && n >= e.top && n <= e.top + e.height, HC = (e, t) => e.top - t.top < 20;
// libs/sdk/react/src/components/comment-mode/CommentHighlight.tsx
function UC({ kind: e, box: t, scroller: n, label: r, following: i }) {
	if (!t || n && !BC(t, n)) return null;
	let a = n ? HC(t, n) : !1;
	return /* @__PURE__ */ N("div", {
		className: `flx-comment-highlight flx-comment-highlight--${e}`,
		style: {
			top: t.top,
			left: t.left,
			width: t.width,
			height: t.height
		},
		"data-following": i || void 0,
		children: /* @__PURE__ */ N("span", {
			className: "flx-comment-tag",
			"aria-hidden": "true",
			"data-inside": a || void 0,
			children: r
		})
	});
}
function WC({ point: e, scroller: t }) {
	return !e || t && !BC({
		top: e.y,
		left: e.x,
		width: 1,
		height: 1
	}, t) ? null : /* @__PURE__ */ N("div", {
		className: "flx-comment-pin",
		style: {
			top: e.y,
			left: e.x
		},
		"aria-hidden": "true"
	});
}
// libs/sdk/react/src/components/comment-mode/comment-address.ts
var GC = (e, t) => {
	let n = e?.closest("[data-uniqueid]") ?? null;
	return n && t.contains(n) ? [n, ...GC(n.parentElement, t)] : [];
}, KC = (e) => {
	let t = (e.hasAttribute("data-prototypeid") ? e : e.querySelector("[data-prototypeid]"))?.getAttribute("data-prototypeid");
	return t ? Number(t) : null;
}, qC = (e) => {
	let t = e.getAttribute("data-flowx-component");
	return {
		element: e,
		marker: e.getAttribute("data-uniqueid") ?? "",
		identifier: t,
		box: AC(e),
		prototypeId: t === le.COLLECTION_PROTOTYPE ? KC(e) : null
	};
}, JC = `.flx-comment-layer, [${se}]`, YC = (e) => e instanceof Element && e.closest(JC) !== null, XC = (e, t) => {
	let { lookup: n, parentOf: r } = jt();
	return be(GC(e, t).map(qC), (e) => tn(e, r, n));
}, ZC = (e) => [...e.querySelectorAll(`[data-flowx-component="${le.MODAL}"]`)].at(-1) ?? e, QC = (e) => e.getAttribute("data-flowx-component") === le.MODAL, $C = (e, t) => {
	let n = ZC(e);
	return VC(e.getBoundingClientRect(), t) || QC(n) && VC(n.getBoundingClientRect(), t);
}, ew = (e, t, n) => {
	e.inert = !1;
	let r = document.elementFromPoint(t, n);
	return e.inert = !0, r;
}, tw = (e, t) => {
	let n = ZC(e);
	return n.contains(t) ? XC(t, n) : [];
}, nw = (e, t, n) => {
	let r = ew(e, t, n);
	return r && e.contains(r) ? tw(e, r) : [];
}, rw = [
	"pointerdown",
	"pointerup",
	"pointerover",
	"pointerout",
	"pointermove",
	"mousedown",
	"mouseup",
	"mouseover",
	"mouseout",
	"mousemove",
	"mouseenter",
	"mouseleave",
	"click",
	"dblclick",
	"auxclick",
	"touchstart",
	"touchend",
	"keydown",
	"keyup",
	"keypress",
	"beforeinput",
	"input",
	"change",
	"focusin"
], iw = "data-flowx-comment-mode";
function aw(e) {
	Vn(() => {
		if (!e) return;
		let t = (e) => {
			e.preventDefault(), e.stopPropagation(), e.type === "focusin" && e.target?.blur?.();
		}, n = { capture: !0 };
		return document.activeElement?.blur?.(), e.inert = !0, e.setAttribute(iw, ""), rw.forEach((r) => e.addEventListener(r, t, n)), () => {
			e.inert = !1, e.removeAttribute(iw), rw.forEach((r) => e.removeEventListener(r, t, n));
		};
	}, [e]);
}
// libs/sdk/react/src/components/comment-mode/useHoveredComponent.ts
var ow = (e, t) => e === t || !!e && !!t && e.x === t.x && e.y === t.y, sw = (e, t) => e === t || !!e && !!t && e.following === t.following && e.entry.element === t.entry.element && e.entry.marker === t.entry.marker && (e.entry.box === t.entry.box || on(e.entry.box, t.entry.box));
function cw(e) {
	let [t, n] = Un(null);
	return Vn(() => {
		if (!e) return;
		let t = 0, r = null, i, a = !1, o = () => {
			if (t = 0, i !== void 0 && ow(r, i) && !a) return;
			let o = a;
			a = !1, i = r;
			let s = (r ? nw(e, r.x, r.y) : [])[0] ?? null, c = s && {
				...s,
				box: NC(s.element, e)
			}, l = c && {
				entry: c,
				following: o
			};
			n((e) => sw(e, l) ? e : l);
		}, s = () => {
			t ||= requestAnimationFrame(o);
		}, c = () => {
			a = !0, s();
		}, l = (t) => {
			let n = {
				x: t.clientX,
				y: t.clientY
			};
			r = YC(t.target) || !$C(e, n) ? null : n, s();
		}, u = () => {
			r = null, s();
		}, d = (e) => {
			YC(e.target) || c();
		};
		return document.addEventListener("pointermove", l, { capture: !0 }), document.addEventListener("scroll", d, {
			capture: !0,
			passive: !0
		}), window.addEventListener("resize", c), document.documentElement.addEventListener("pointerleave", u), () => {
			cancelAnimationFrame(t), n(null), document.removeEventListener("pointermove", l, { capture: !0 }), document.removeEventListener("scroll", d, { capture: !0 }), window.removeEventListener("resize", c), document.documentElement.removeEventListener("pointerleave", u);
		};
	}, [e]), t;
}
// libs/sdk/react/src/components/comment-mode/useTrackedBoxes.ts
var lw = {
	boxes: [],
	scroller: null,
	following: !1
}, uw = (e, t) => e.following === t.following && PC(e.boxes, t.boxes) && PC([e.scroller], [t.scroller]);
function dw(e, t) {
	let [n, r] = Un(lw), i = O((n) => {
		let i = {
			boxes: e.map((e) => e?.isConnected ? NC(e, t) : null),
			scroller: t ? zC(t) : null,
			following: n
		};
		r((e) => uw(e, i) ? e : i);
	}, [e, t]);
	return Hn(() => {
		i(!1);
	}, [i]), Vn(() => {
		if (!t) return;
		let n = 0, r = () => {
			n ||= requestAnimationFrame(() => {
				n = 0, i(!0);
			});
		}, a = (e) => {
			YC(e.target) || r();
		};
		document.addEventListener("scroll", a, {
			capture: !0,
			passive: !0
		}), window.addEventListener("resize", r);
		let o = typeof ResizeObserver > "u" ? null : new ResizeObserver(r);
		return [
			t,
			RC(t),
			...e.flatMap((e) => e ? [e, ...MC(e, t)].flatMap(OC) : [])
		].forEach((e) => e && o?.observe(e)), () => {
			cancelAnimationFrame(n), document.removeEventListener("scroll", a, { capture: !0 }), window.removeEventListener("resize", r), o?.disconnect();
		};
	}, [
		i,
		t,
		e
	]), n;
}
// libs/sdk/react/src/components/comment-mode/CommentLayer.tsx
var fw = ({ marker: e, componentIdentifier: t, label: n, originalFlowxUuid: r, rowIndex: i, templateParentFlowxUuid: a, reusableTemplateContext: o, reusableTemplateDefinitionId: s, process: c, parentInOtherResource: l }) => ({
	flowxUuid: Nn(e),
	componentIdentifier: t,
	label: n,
	originalFlowxUuid: r,
	rowIndex: i,
	templateParentFlowxUuid: a,
	reusableTemplateContext: o,
	reusableTemplateDefinitionId: s,
	process: c,
	parentInOtherResource: l
}), pw = (e, t, n) => {
	let { element: r, marker: i } = e[0], a = NC(r, n), o = [...e].reverse();
	return {
		chain: o,
		at: o.length - 1,
		anchor: {
			element: r,
			marker: i,
			dx: a ? t.x - a.left : 0,
			dy: a ? t.y - a.top : 0,
			point: t
		},
		targetGone: !1
	};
}, mw = (e, t, n) => [...e.querySelectorAll("[data-uniqueid]")].find((e) => e.getAttribute("data-uniqueid") === t && (!n || AC(e) !== null)) ?? null, hw = ({ element: e, box: t }) => e.isConnected && (t === null || AC(e) !== null), gw = (e, t) => {
	if (hw(t)) return t;
	let n = mw(e, t.marker, t.box !== null);
	return n && {
		...t,
		element: n
	};
}, _w = (e, t) => {
	if (t.targetGone) return t;
	let n = t.chain.map((t) => gw(e, t) ?? t), r = gw(e, t.chain[t.at]), i = t.anchor.element.isConnected ? t.anchor.element : mw(e, t.anchor.marker, !1) ?? t.anchor.element;
	return r === t.chain[t.at] && n.every((e, n) => e === t.chain[n]) && i === t.anchor.element ? t : {
		...t,
		chain: n,
		targetGone: r === null,
		anchor: {
			...t.anchor,
			element: i
		}
	};
};
function vw({ rootRef: e }) {
	let t = d(), [n, r] = Un(null);
	Hn(() => {
		r(t ?? e.current);
	}, [t, e]), aw(n);
	let i = A(null), a = A(null), [o, s] = Un(null), [c, l] = Un(null), [u, f] = Un(null), [p, m] = Un(0), h = O((e) => {
		i.current = e, s(e);
	}, []), g = O((e) => {
		a.current = e, l(e);
	}, []), _ = cw(n), v = o?.chain[o.at] ?? null, y = o !== null, b = o?.targetGone ?? !1, x = O(() => m((e) => e + 1), []), S = O((e) => {
		h({
			...e,
			draftNumber: Ft()
		}), g(null), f(null), Kt(!1), x();
	}, [
		h,
		g,
		x
	]), C = O(() => {
		h(null), g(null), f(null), Kt(!1);
	}, [h, g]), w = O((e, t) => {
		h({
			...e,
			draftNumber: t
		}), g(null), f(null), x();
	}, [
		h,
		g,
		x
	]);
	Vn(() => {
		if (!n) return;
		let e = Wt({
			preview: (e) => f(e !== null && i.current?.chain[e]?.element.isConnected ? e : null),
			select: (e) => {
				let t = i.current, r = t?.chain[e] && gw(n, t.chain[e]);
				return !t || !r ? !1 : (h({
					...t,
					chain: t.chain.map((t, n) => n === e ? r : t),
					at: e,
					targetGone: !1
				}), f(null), x(), !0);
			},
			resolvePendingPick: (e) => {
				let t = a.current;
				t && (e === "openPick" ? S(_w(n, t)) : (g(null), x()));
			},
			close: C,
			targetIfOnScreen: () => {
				let e = i.current;
				if (!e) return null;
				let t = _w(n, e);
				return h(t), t.targetGone ? null : {
					target: fw(t.chain[t.at]),
					hierarchy: [...t.chain].reverse().map(fw)
				};
			}
		});
		return () => {
			let t = e();
			h(null), g(null), f(null), t && (Vt(null), Ht(null), Kt(!1));
		};
	}, [
		n,
		S,
		C,
		h,
		g,
		x
	]), Vn(() => {
		if (!n) return;
		let e = (e) => {
			let t = {
				x: e.clientX,
				y: e.clientY
			};
			if (YC(e.target) || !$C(n, t)) return;
			let r = ew(n, t.x, t.y);
			if (!r || !n.contains(r)) return;
			e.preventDefault(), e.stopPropagation();
			let a = i.current, o = a?.chain[a.at].marker ?? null, s = tw(n, r), c = s[0];
			if (!c || c.marker === o && !a?.targetGone) {
				g(null), o !== null && x();
				return;
			}
			let l = pw(s, t, n);
			a?.targetGone ? w(l, a.draftNumber) : o !== null && De() ? g(l) : S(l);
		};
		return document.addEventListener("click", e, { capture: !0 }), () => document.removeEventListener("click", e, { capture: !0 });
	}, [
		n,
		S,
		w,
		g,
		x
	]), Vn(() => {
		if (!n || !y) return;
		let e = 0, t = new MutationObserver(() => {
			e ||= requestAnimationFrame(() => {
				e = 0;
				let t = i.current;
				t && h(_w(n, t));
			});
		});
		return t.observe(n, {
			childList: !0,
			subtree: !0
		}), () => {
			cancelAnimationFrame(e), t.disconnect();
		};
	}, [
		n,
		y,
		h
	]), Vn(() => {
		if (!n) return;
		let e = (e) => {
			if (e.key !== "Escape") return;
			let t = e.target instanceof Node ? e.target : null;
			t && QC(ZC(n)) && (t === document.body || n.contains(t)) && (e.preventDefault(), e.stopPropagation());
		};
		return window.addEventListener("keydown", e, { capture: !0 }), () => window.removeEventListener("keydown", e, { capture: !0 });
	}, [n]);
	let ee = o && u !== null ? o.chain[u] ?? null : null, te = _ && _.entry.element !== v?.element ? _.entry : null, ne = ee ?? te, re = b ? null : v?.element ?? null, ie = ee?.element ?? null, ae = o?.anchor.element ?? null, oe = dw(k(() => [
		re,
		ie,
		ae
	], [
		re,
		ie,
		ae
	]), n), [se = null, ce = null, le = null] = oe.boxes, ue = ee ? ce : te?.box ?? null, de = ee ? oe.following : _?.following ?? !1, fe = o && (le ? {
		x: le.left + o.anchor.dx,
		y: le.top + o.anchor.dy
	} : o.anchor.point), T = k(() => o?.chain.map(({ label: e, name: t, crumbName: n }) => ({
		typeLabel: e,
		displayName: t,
		crumbText: n
	})) ?? [], [o?.chain]), pe = o?.draftNumber ?? null, E = o?.at ?? 0, me = c?.anchor.point ?? null;
	Hn(() => {
		Vt(pe === null ? null : {
			draftNumber: pe,
			crumbs: T,
			selectedIndex: E,
			targetGone: b,
			pendingPickAt: me,
			focusRequestCount: p
		});
	}, [
		pe,
		T,
		E,
		b,
		me,
		p
	]);
	let he = fe?.x, ge = fe?.y, _e = oe.scroller;
	return Hn(() => {
		Ht(he === void 0 || ge === void 0 ? null : {
			pin: {
				x: he,
				y: ge
			},
			bounds: _e
		});
	}, [
		he,
		ge,
		_e
	]), Gr(/* @__PURE__ */ qr("div", {
		className: "flx-comment-layer",
		children: [
			/* @__PURE__ */ N(UC, {
				kind: "hover",
				box: ue,
				scroller: oe.scroller,
				label: ne?.label ?? "",
				following: de
			}),
			/* @__PURE__ */ N(UC, {
				kind: "selected",
				box: se,
				scroller: oe.scroller,
				label: v?.label ?? "",
				following: oe.following
			}),
			o ? /* @__PURE__ */ N(WC, {
				point: fe,
				scroller: oe.scroller
			}) : null
		]
	}), n?.parentElement ?? document.body);
}
// libs/sdk/react/src/components/sdk/process-renderer/FlxProcessRendererPortal.tsx
function yw({ commentMode: e, ...t }) {
	let [n, r] = Un(void 0), i = A(null), a = O((e) => {
		i.current = e, r(e ?? void 0);
	}, []);
	return /* @__PURE__ */ N("div", {
		ref: a,
		style: { position: "relative" },
		children: /* @__PURE__ */ qr(f.Provider, {
			value: n,
			children: [e ? /* @__PURE__ */ N(vw, { rootRef: i }) : null, /* @__PURE__ */ N(EC, { ...t })]
		})
	});
}
// libs/sdk/react/src/lib/contexts/ScrollRegistryContext.tsx
var bw = Ln({ register: () => {} }), xw = () => Bn(bw), Sw = /* @__PURE__ */ r({
	FlxModalWrapper: () => Cw,
	default: () => Cw
}), Cw = ({ config: e, modalDismissed: t }) => {
	let { displayOptions: { flowxProps: n, style: r } } = e, i = M(j.Button), a = M(j.Modal), o = M(j.ModalHeader), s = _r({
		styles: r,
		component: j.Modal,
		flowxProps: n
	}), c = _r({
		styles: r,
		component: j.ModalHeader,
		flowxProps: n
	}), l = ee({
		prop: n?.title || "",
		config: e
	}), u = ee({
		prop: n?.subtitle || "",
		config: e
	}), f = ee({
		prop: n?.modalDismissAlert?.title || "",
		config: e
	}), p = ee({
		prop: n?.modalDismissAlert?.message || "",
		config: e
	}), m = ee({
		prop: n?.modalDismissAlert?.cancelLabel || "",
		config: e
	}), h = ee({
		prop: n?.modalDismissAlert?.confirmLabel || "",
		config: e
	});
	x(e, !0), S(e, !0), pC(e, n);
	let [g, _] = Un(!1), [y, b] = Un(!0), C = A(null), w = A(null), te = Gn((e) => e.pipe(nr(0), dr(([e, t]) => er([ye(e).pipe(fr(hn(e, t))), qe]))), [e.processInstanceUuid, e.id]);
	qn(te, ([[t, n], r]) => {
		b(r?.id === e.id && r?.context === e.context || n?.some((e) => t.some((t) => t.currentNodeId === e.nodeDefinitionId && t.currentContext === e.context)));
	});
	let ne = O(async () => {
		if (_(!1), b(!1), Et(e)) try {
			await Ne(e.processInstanceUuid);
		} catch {}
		We() !== null && Pt.currentEntry?.ephemeral?.modalId && Pt.pop(), Ee(), t?.();
	}, [e, t]), re = O(() => {
		n?.showDismissConfirmationAlert ? _(!0) : ne();
	}, [ne, n?.showDismissConfirmationAlert]), ie = O((e) => {
		e ? ne() : _(!1);
	}, [ne]), ae = O((e) => {
		e && w.current?.focus();
	}, []), oe = O(() => {
		n?.canDismissModal && re();
	}, [re, n?.canDismissModal]), se = O(() => {
		n?.canDismissModal && n?.closeOnBackdropClick && re();
	}, [
		re,
		n?.canDismissModal,
		n?.closeOnBackdropClick
	]), ce = v("@@sys_a11y_modal_close"), le = gr(j.ModalHeader, "closeIcon"), ue = (le ? at(le) : void 0) ?? void 0, de = d();
	return /* @__PURE__ */ N(Fr, {
		ref: C,
		container: de,
		closeIconAriaLabel: ce || "Close",
		closeIconPath: ue,
		open: y,
		dismissible: n?.canDismissModal,
		onOpenChange: (e) => !e && oe(),
		onBackdropClick: () => se(),
		"data-testid": n?.dataTestId,
		"data-uniqueid": e.flowxUuid,
		"data-flowx-component": e.componentIdentifier,
		className: Xn(a, o, ...s),
		headerClassName: Xn(o, ...c),
		panelClass: n?.panelClass,
		backdropClass: n?.backdropClass,
		title: l,
		subTitle: u,
		alertDialog: /* @__PURE__ */ N(ri.Root, {
			open: g,
			onOpenChangeComplete: ae,
			children: /* @__PURE__ */ N(ri.Portal, {
				container: C,
				children: /* @__PURE__ */ qr(ri.Popup, {
					initialFocus: !1,
					className: "flx-modal-wrapper-dismiss-sheet",
					children: [
						/* @__PURE__ */ N(ri.Title, {
							className: "title",
							children: f
						}),
						/* @__PURE__ */ N(ri.Description, {
							className: "message",
							children: p
						}),
						/* @__PURE__ */ qr("div", {
							className: "buttons",
							children: [/* @__PURE__ */ N(ri.Close, {
								onClick: () => ie(!1),
								render: /* @__PURE__ */ N(xr, {
									ref: w,
									variant: "ghost",
									className: i,
									children: m
								})
							}), /* @__PURE__ */ N(ri.Close, {
								onClick: () => ie(!0),
								render: /* @__PURE__ */ N(xr, {
									className: i,
									children: h
								})
							})]
						})
					]
				})
			})
		}),
		children: /* @__PURE__ */ N(gC, {
			config: e,
			collectionPrototypeInstanceMeta: e.prototypeInstanceMeta
		})
	});
}, ww = () => {
	let e = Kn(Lt, null), t = k(() => e ? ut(e) : null, [e]), n = Gn(() => kn.pipe(sr((e) => e.searchParams.get("modalId")), ir(), ar((e) => !e)));
	qn(n, () => {
		Ee();
	});
	let r = Gn(() => Lt.pipe(ir(), ur(1), ar((e) => e === null)));
	return qn(r, () => {
		_n("modal-dismiss");
	}), t ? /* @__PURE__ */ N(Cw, { config: t }) : null;
};
// libs/sdk/react/src/components/sdk/header/FlxHeader.tsx
function Tw(e) {
	return e?.positionType === "fixed" ? {
		position: "sticky",
		top: 0,
		zIndex: 3
	} : mr(e ?? {});
}
var Ew = ({ config: e }) => {
	let { displayOptions: { flowxProps: t, style: n }, flowxUuid: r } = e, i = M(j.Container), a = _r({
		styles: {
			widthType: "fill",
			...n
		},
		component: j.Container,
		flowxProps: t
	}), o = vr({
		styles: n,
		className: "&.flx-header"
	}), s = ig(Tw(n?.position));
	return /* @__PURE__ */ N("header", {
		"data-uniqueid": r,
		"data-flowx-component": e.componentIdentifier,
		"data-testid": t?.dataTestId,
		className: Xn(i, o, ...a, s, "flx-container", "flx-header"),
		children: /* @__PURE__ */ N(gC, { config: e })
	});
};
Ew.displayName = "FlxHeader";
// libs/sdk/react/src/components/sdk/footer/FlxFooter.tsx
function Dw(e) {
	return e?.positionType === "fixed" ? {
		position: "sticky",
		bottom: 0,
		marginTop: "auto",
		zIndex: 3
	} : mr(e ?? {});
}
var Ow = ({ config: e }) => {
	let { displayOptions: { flowxProps: t, style: n }, flowxUuid: r } = e, i = M(j.Container), a = _r({
		styles: {
			widthType: "fill",
			...n
		},
		component: j.Container,
		flowxProps: t
	}), o = vr({
		styles: n,
		className: "&.flx-footer"
	}), s = ig(Dw(n?.position));
	return /* @__PURE__ */ N("div", {
		className: Xn(s),
		children: /* @__PURE__ */ N("footer", {
			"data-uniqueid": r,
			"data-flowx-component": e.componentIdentifier,
			"data-testid": t?.dataTestId,
			className: Xn(i, o, ...a, "flx-container", "flx-footer"),
			children: /* @__PURE__ */ N(gC, { config: e })
		})
	});
};
Ow.displayName = "FlxFooter";
// libs/sdk/react/src/components/ui-flow-renderer/UiFlowAccessDenied.tsx
function kw({ reason: e = "access-denied", onStartNewSession: t }) {
	let n = M(j.AccessDenied), r = M(j.Button), i = dt(e);
	return /* @__PURE__ */ qr("div", {
		className: `flx-ui-flow-access-denied ${n ?? ""}`,
		"data-testid": "ui-flow-access-denied",
		children: [
			/* @__PURE__ */ N("h1", {
				"data-testid": "ui-flow-access-denied-title",
				children: i.title
			}),
			/* @__PURE__ */ N("p", {
				"data-testid": "ui-flow-access-denied-description",
				children: i.description
			}),
			/* @__PURE__ */ N(xr, {
				variant: "fill",
				className: r ?? "",
				onClick: t,
				"data-testid": "ui-flow-access-denied-cta",
				children: i.cta
			})
		]
	});
}
// libs/sdk/react/src/components/ui-flow-renderer/UiFlowRenderer.tsx
var Aw = () => {
	let e = rt(ht("viewId")) ?? mt()[0];
	return h(e ? [e, ...ft().filter((t) => Tt(t, e.flowxUuid))] : []);
};
function jw({ item: e }) {
	let t = e.config, n = e.label, r = ee({
		prop: n,
		config: t
	});
	return /* @__PURE__ */ N(Kr, { children: r });
}
function Mw({ enginePath: e, processApiPath: t, baseUrl: n, apiUrl: r, accessToken: a, authToken: o, anonymousSessionId: c, customLoaderProvider: u, customLoader: f, language: p, themeId: m, uiFlowName: h, appInfo: g, isDraft: v, assetsBaseUrl: y, staticAssetsPath: b, buildId: x, workspaceId: S, organizationId: C, locale: w, cache: ee, legacyFileSources: te, resourceId: ne, startParams: re, components: ie, validators: oe, resourceDefinitionId: se, onSteady: ce, commentMode: ue }) {
	let { apiUrl: de, processApiPath: fe, staticAssetsPath: T, authToken: pe } = l({
		baseUrl: n,
		apiUrl: r,
		enginePath: e,
		processApiPath: t,
		assetsBaseUrl: y,
		staticAssetsPath: b,
		accessToken: a,
		authToken: o
	}), E = $t({
		customLoader: f,
		customLoaderProvider: u
	}), he = en("appInfo.selectedProcessResourceId", g.selectedProcessResourceId, "resourceId", ne), [ge, _e] = Un(null), [ye, be] = Un(!1), xe = A(ye);
	xe.current = ye;
	let [Se, Ce] = Un(null), we = A(null), Te = A(pe);
	Te.current = pe;
	let Ee = A(oe);
	Ee.current = oe;
	let De = A(ie);
	De.current = ie;
	let ke = A(re);
	ke.current = re;
	let Ae = A(ce);
	Ae.current = ce, Hn(() => {
		pe && (Oe()?.isAnonymousMode || un(pe));
	}, [pe]);
	let je = Gn(() => Pt.currentState$), Me = Kn(je, null), Ne = Kn(An, []), Pe = Kn(yn, []), Fe = Gn(() => Cn.pipe(vC(({ showLoader: e, loaderType: t, loaderText: n }) => ({
		showLoader: e,
		loaderType: t,
		loaderText: n
	})), ir())), { showLoader: Ie, loaderType: Le, loaderText: Re } = Kn(Fe, {
		showLoader: void 0,
		loaderType: void 0,
		loaderText: void 0
	}), ze = Kn(vn, null), Be = k(() => {
		let e = Pe?.find((e) => e.componentIdentifier === le.BREADCRUMBS);
		return e ? {
			flowxUuid: e.flowxUuid,
			dataTestId: e.displayOptions.flowxProps.dataTestId,
			showHomeIcon: e.displayOptions.flowxProps.showHomeIcon,
			maxItems: e.displayOptions.flowxProps.collapseMode === "NONE" ? null : e.displayOptions.flowxProps.maxVisibleItems,
			style: e.displayOptions.style
		} : null;
	}, [Pe]), Ve = k(() => Pe?.find((e) => e.componentIdentifier === le.CHAT) || null, [Pe]), He = k(() => Pe?.find((e) => e.componentIdentifier === le.HEADER) ?? null, [Pe]), Ue = k(() => Pe?.find((e) => e.componentIdentifier === le.FOOTER) ?? null, [Pe]), We = !!Ue && Ue.displayOptions?.style?.position?.positionType === "fixed", Ge = M(j.Breadcrumbs), Ke = M(j.BreadcrumbItem), qe = _r({
		styles: Be?.style ?? {},
		component: j.Breadcrumbs
	}), Je = M(j.Spinner), Ye = Gn(() => Pt.navigation$);
	qn(Ye, (e) => {
		if (e.type === "pop" || e.type === "reset") {
			let t = e.previousEntry?.ephemeral;
			xe.current && !t?.modalId && (fn(null), xe.current = !1, be(!1), Ce(null));
			let n = e.entry?.route?.viewId;
			if (n && !xe.current) {
				let e = ut(n);
				ve(e ?? null);
			}
		}
	}), Vn(() => {
		let e = !1, t = pn(), n = tt(), r = !!t?.ephemeral?.processUuid && !!n;
		(t?.ephemeral?.modalId || r) && Pt.seed(t.route, t.ephemeral), be(!1), Ce(null);
		async function i() {
			let t = await wt({
				authToken: Te.current,
				anonymousSessionId: c,
				apiUrl: de,
				staticAssetsPath: T,
				workspaceId: S,
				organizationId: C,
				appInfo: {
					appId: g.appId,
					appVersionId: g.appVersionId,
					selectedProcessResourceId: he
				},
				buildId: x,
				uiFlowName: h,
				themeId: m,
				language: p,
				locale: w,
				isDraft: v,
				cache: ee,
				legacyFileSources: te,
				startParams: ke.current,
				processApiPath: fe,
				resourceDefinitionId: se,
				fw: "react"
			}), n = pt();
			if (r && n === !1) Ce({
				processResourceId: "",
				processStartData: {}
			}), be(!0);
			else if (await Aw(), e) return;
			_e(t), Ae.current && (await Mn(), e || Ae.current?.());
		}
		return i(), ae.initCustomValidators({ ...Ee.current }), me(De.current ?? {}), () => {
			e = !0, ae.clearCustomValidators(), Jt(), RS(), uC(), qt(), Zt(), Yt();
		};
	}, [
		de,
		p,
		m,
		h,
		v,
		T,
		S,
		g.appId,
		g.appVersionId,
		he,
		x,
		C,
		w,
		ee,
		te,
		c,
		fe,
		se
	]);
	let Xe = Gn(() => xn);
	qn(Xe, (e) => {
		let t = tt();
		e === !1 && t && !xe.current ? (xe.current = !0, Ce({
			processResourceId: "",
			processStartData: {}
		}), be(!0)) : e === !0 && xe.current && (xe.current = !1, be(!1), Ce(null));
	});
	let Ze = O((e, t, n, r) => {
		let i = ht("viewId") ?? "";
		Pt.push({ viewId: i }, { processUuid: "pending" }), zn(() => {
			Ce({
				processResourceId: e,
				processStartData: t,
				...n && { appId: n },
				...r && { buildId: r }
			}), be(!0);
		});
	}, []), Qe = Kn(Sn, null), $e = A(/* @__PURE__ */ new Map()), nt = O((e) => {
		let t = $e.current.get(e) || document.getElementById(e);
		return t ? (t.scrollIntoView({ behavior: "smooth" }), !0) : !1;
	}, []), rt = O((e, t) => {
		if (t) {
			$e.current.set(e, t);
			let n = Me?.route?.viewId, r = ht("viewId");
			(n || r) === e && setTimeout(() => nt(e), 100);
		} else $e.current.delete(e);
	}, [Me, nt]), it = O(({ flowxUuid: e }) => {
		if (!e) return;
		let t = ht("viewId"), n = Object.fromEntries(new URLSearchParams(window.location.search)), { urlUpdateParams: r } = an(t, e, n), i = new URL(window.location.href);
		for (let [e, t] of Object.entries(r)) t == null ? i.searchParams.delete(e) : i.searchParams.set(e, t);
		Pt.push({ viewId: e }, {}, i.toString()), On(r), nt(e) || setTimeout(() => nt(e), 100), _n("navigation", e);
	}, [nt]);
	Vn(() => {
		if (ye) return;
		let e = Me?.route?.viewId, t = ht("viewId"), n = e || t;
		n && nt(n);
	}, [
		Me,
		ye,
		nt
	]);
	let at = Gn(() => kn.pipe(sr((e) => e.searchParams.get("viewId")), ir(), ur(1)));
	qn(at, (e) => {
		et() || _n("navigation", e ?? void 0);
	});
	let st = Gn(() => bn.stream$);
	qn(st, (e) => {
		e?.processResourceId && Ze(e.processResourceId, e.processStartData ?? {}, e.appId, e.buildId);
	});
	let ct = k(() => {
		let e = Oe(), t = typeof Se?.appId == "string" ? Se.appId : void 0, n = typeof Se?.buildId == "string" ? Se.buildId : void 0;
		return {
			projectId: t || e?.appInfo?.appId || g.appId,
			appVersionId: n || e?.buildId || x
		};
	}, [
		g.appId,
		x,
		Se?.appId,
		Se?.buildId
	]), lt = k(() => Ne.map((e) => ({
		label: "displayOptions" in e && "flowxProps" in e.displayOptions && "title" in e.displayOptions.flowxProps ? e.displayOptions.flowxProps.title : "",
		config: e,
		onClick: () => it({ flowxUuid: e.flowxUuid })
	})), [Ne, it]), dt = D("@@sys_a11y_breadcrumb"), ft = d(), mt = k(() => Ie === void 0 ? null : /* @__PURE__ */ N(Fr, {
		open: !0,
		container: ft,
		className: Yn("flx-loader-modal", [`flx-loader-overlay ${Ie}`]),
		children: CC(E, Ie, Le) ?? /* @__PURE__ */ N(Ir, {
			backgroundColor: "var(--flxTheme-spinner-backgroundColor, #ffffff)",
			borderColor: "var(--flxTheme-spinner-accentColor, transparent)",
			visualType: "custom",
			size: "small",
			type: "indeterminate",
			className: Je ?? "",
			text: Re
		})
	}), [
		Ie,
		Le,
		Re,
		E,
		Je,
		ft
	]), gt = k(() => ({ register: rt }), [rt]), _t = O(async () => {
		let e = await mn();
		e && (await Aw(), _e(e));
	}, []);
	if (!ge && !ze) return /* @__PURE__ */ N(ai, {});
	let vt = gr(j.Breadcrumbs, "homeIcon"), yt = gr(j.Breadcrumbs, "separatorIcon"), bt = vt ? /* @__PURE__ */ N(Br, { path: vt ? ot(vt) : void 0 }) : null, xt = yt ? /* @__PURE__ */ N(Br, { path: yt ? ot(yt) : void 0 }) : null, St = ue ? /* @__PURE__ */ N(vw, { rootRef: we }) : null;
	return ye ? /* @__PURE__ */ qr(Kr, { children: [St, /* @__PURE__ */ N(TC, {
		apiUrl: de,
		authToken: pe,
		processApiPath: fe,
		language: p,
		themeId: m,
		resourceId: Se?.processResourceId,
		processStartData: Se?.processStartData,
		isDraft: !1,
		staticAssetsPath: T,
		workspaceId: S,
		organizationId: C,
		locale: w,
		cache: ee,
		projectInfo: ct,
		trigger: "action",
		customLoader: E
	})] }) : /* @__PURE__ */ N(Hr.Provider, { children: /* @__PURE__ */ qr("div", {
		ref: we,
		className: Yn("flx-ui-flow-renderer-root", { "flx-ui-flow-fill": We }),
		children: [St, /* @__PURE__ */ qr(i.Provider, {
			value: we,
			children: [/* @__PURE__ */ N(ai, {}), /* @__PURE__ */ qr(In, {
				fallback: /* @__PURE__ */ N(_, {}),
				children: [mt || null, ze ? /* @__PURE__ */ N(kw, {
					reason: ze,
					onStartNewSession: _t
				}) : /* @__PURE__ */ qr(Kr, { children: [
					He ? /* @__PURE__ */ N(Ew, { config: He }) : null,
					Be ? /* @__PURE__ */ N(br, {
						"data-uniqueid": Be.flowxUuid,
						"data-flowx-component": le.BREADCRUMBS,
						"data-testid": Be.dataTestId,
						items: lt,
						maxVisibleItems: Be?.maxItems,
						homeElement: Be?.showHomeIcon ? bt : null,
						separator: xt,
						className: Yn(Ge, Ke, ...qe),
						ariaLabel: dt,
						renderItem: (e) => /* @__PURE__ */ N(jw, { item: e })
					}) : null,
					Ve ? /* @__PURE__ */ N(s, { config: Ve }) : null,
					/* @__PURE__ */ qr(bw.Provider, {
						value: gt,
						children: [Qe && /* @__PURE__ */ N(gC, { config: Qe }), /* @__PURE__ */ N(ww, {})]
					}),
					Ue ? /* @__PURE__ */ N(Ow, { config: Ue }) : null
				] })]
			})]
		})]
	}) });
}
// libs/sdk/react/src/components/ui-flow-renderer/FlxUiFlowRendererPortal.tsx
function Nw(e) {
	let [t, n] = Un(void 0), r = O((e) => {
		n(e ?? void 0);
	}, []);
	return /* @__PURE__ */ N("div", {
		ref: r,
		style: {
			position: "relative",
			height: "100%"
		},
		children: /* @__PURE__ */ N(f.Provider, {
			value: t,
			children: /* @__PURE__ */ N(Mw, { ...e })
		})
	});
}
// libs/sdk/react/src/components/template-renderer/FlxTemplateRenderer.tsx
function Pw({ apiUrl: e, authToken: t, processApiPath: n, staticAssetsPath: r, projectId: i, projectVersionId: a, workspaceId: o, organizationId: s, dataModel: c, themeId: l, locale: u, language: d, reusableStartData: f, templateConfig: p, customComponents: m, ccMappings: h, onDataStoreChanged: g }) {
	let _ = A(t);
	_.current = t;
	let v = A(c);
	v.current = c;
	let y = A(f);
	y.current = f;
	let b = A(p);
	b.current = p;
	let x = A(m);
	x.current = m;
	let S = A(h);
	S.current = h;
	let C = A(g);
	C.current = g, Hn(() => {
		t && un(t);
	}, [t]), Vn(() => {
		xt({
			apiUrl: e,
			authToken: _.current,
			processApiPath: n,
			staticAssetsPath: r,
			appInfo: {
				appId: i,
				appVersionId: a
			},
			themeId: l,
			language: d,
			locale: u,
			reusableStartData: y.current,
			templateConfig: b.current,
			workspaceId: o,
			organizationId: s,
			dataModel: v.current,
			customComponents: x.current,
			ccMappings: S.current
		});
		let t = nt().subscribe((e) => {
			C.current?.(e);
		});
		return () => {
			t.unsubscribe(), Jt(), RS(), uC(), Xt();
		};
	}, [
		e,
		n,
		r,
		i,
		a,
		o,
		s,
		l,
		d,
		u
	]);
	let w = Kn(ln, null);
	return w ? /* @__PURE__ */ N(Hr.Provider, { children: /* @__PURE__ */ N(gC, { config: w.rootTemplates }) }) : null;
}
// libs/sdk/react/src/components/template-renderer/FlxTemplateRendererPortal.tsx
function Fw(e) {
	let [t, n] = Un(void 0), r = O((e) => {
		n(e ?? void 0);
	}, []);
	return /* @__PURE__ */ N("div", {
		ref: r,
		style: {
			position: "relative",
			height: "100%"
		},
		children: /* @__PURE__ */ N(f.Provider, {
			value: t,
			children: /* @__PURE__ */ N(Pw, { ...e })
		})
	});
}
// libs/sdk/react/src/components/sdk/chat-renderer/FlxChatRendererContent.tsx
var Iw = ({ messages: t, reasoning: n, showSuggestedPrompts: r, agentSuggestions: i, chatConfig: a, chatIcons: o, avatars: s, classNames: c, onSendMessage: l, onSendSuggestedPrompt: u, onSendConfiguredPrompt: f, onMessageCopied: p, onNewChat: m, headerControls: h, onVoiceMessage: g, showVoiceInput: _, activeView: v = "chat", onHistory: y, onBackFromHistory: b, chatSessions: x, onSelectSession: S, onLoadMoreSessions: C, hasMoreSessions: w, loadingMoreSessions: ee, emptyStateText: te, searchValue: ne, onSearchChange: re, onSearchClear: ie, searchPlaceholder: ae, searchClearAriaLabel: oe, searchIcons: se, searchHighlightText: ce, sessionGroupLabels: le, headerTooltips: ue, headerActionIcons: de, hasMoreMessages: fe, loadingMore: T, onLoadMore: pe, voiceLabels: E, sendAriaLabel: me, sendTooltip: he, stopAriaLabel: ge, stopTooltip: _e, voiceMicAriaLabel: ve, onStopResponse: ye, inputDisabled: be = !1, inputDisabledTooltip: xe, showFileUpload: Se, fileAccept: Ce, fileMaxFiles: we, fileMaxFilesSize: Te, fileInvalidTypeError: Ee, fileCountExceededError: De, fileSizeExceededError: ke, attachmentsUploadError: Ae, attachments: je, onAttachmentsChange: Me, onAttachmentsMessage: Ne, attachmentsLabels: Pe, downloadFile: Fe, messageActionsConfig: Ie, messageTimeGroupLabels: Le, locale: Re, feedbackTarget: ze, onFeedbackChange: Be, onFeedbackSubmit: Ve, onFeedbackRemove: We, onFeedbackCancel: Ge }) => {
	let Ke = d(), qe = (e, t) => {
		if (!Ie || e.isWelcome) return;
		let n = !!e.audioUrl || !!e.voiceMessageStatus, r = Ie.showCopyAction && !n && !!e.content && !e.hasError, i = Ie.showTimestamp && !!Le && !!e.timestamp, a = Ie.showResponseFeedback && e.sender === "receiver" && !!e.messageId && !n && !!e.content && !e.hasError;
		if (!r && !i && !a) return;
		let s = e.timestamp instanceof Date ? e.timestamp.toISOString() : e.timestamp;
		return /* @__PURE__ */ N(kr, {
			className: c.chatMessageActions || void 0,
			showTimestamp: i,
			showCopyAction: r,
			timestampLabel: i && Le && e.timestamp ? Ue(e.timestamp, Le, Re) : void 0,
			timestampTooltip: i && s ? He(s, Re) : void 0,
			copyText: e.content,
			copyIconPath: o.messageActionsIcons?.copyIcon,
			copySuccessIconPath: o.messageActionsIcons?.copySuccessIcon,
			copyAriaLabel: Ie.copyAriaLabel,
			copiedAriaLabel: Ie.copiedAriaLabel,
			onCopied: p,
			tooltipClassName: c.helperTooltip || void 0,
			alwaysVisible: t,
			dataTestId: Ie.dataTestId,
			showResponseFeedback: a,
			feedback: e.feedback?.value ?? null,
			thumbUpIconPath: o.messageActionsIcons?.thumbUpIcon,
			thumbUpSelectedIconPath: o.messageActionsIcons?.thumbUpSelectedIcon,
			thumbDownIconPath: o.messageActionsIcons?.thumbDownIcon,
			thumbDownSelectedIconPath: o.messageActionsIcons?.thumbDownSelectedIcon,
			thumbsUpAriaLabel: Ie.thumbsUpAriaLabel,
			thumbsDownAriaLabel: Ie.thumbsDownAriaLabel,
			onFeedbackChange: (t) => Be?.(e.messageId, t),
			readOnly: be
		});
	}, Je = t[t.length - 1]?.sender !== "receiver" || be ? void 0 : i?.length && !n ? /* @__PURE__ */ N(Nr, {
		prompts: i,
		onPromptSelected: u,
		className: c.chatSuggestedPrompts || void 0,
		tooltipClassName: c.helperTooltip || void 0
	}) : r && a?.suggestedPrompts?.length ? /* @__PURE__ */ N(Nr, {
		prompts: a.suggestedPrompts,
		title: a.suggestedPromptsTitle,
		onPromptSelected: (e) => f ? f(e) : l(e.label),
		className: c.chatSuggestedPrompts || void 0,
		tooltipClassName: c.helperTooltip || void 0
	}) : void 0, Ye = {
		displayMode: "fill",
		buttonClassName: c.chatHeaderButton || void 0,
		newChatLabel: a?.newChatLabel,
		onNewChat: be ? void 0 : m,
		newChatIcon: de?.newChatIcon ?? void 0,
		backIcon: de?.backIcon ?? void 0,
		newChatTooltip: ue?.newChat,
		historyTooltip: ue?.history,
		backTooltip: ue?.back,
		tooltipClassName: c.helperTooltip || void 0
	}, Xe = k(() => !x?.length || !le ? [] : gt(x, le), [x, le]);
	return v === "history" ? /* @__PURE__ */ N(wr, {
		className: c.chatHistory || void 0,
		headerClassName: c.chatHeader || void 0,
		onBack: b,
		emptyStateText: te,
		title: a?.historyTitle,
		onLoadMore: C,
		hasMore: w,
		loadingMore: ee,
		searchValue: ne,
		onSearchChange: re,
		onSearchClear: ie,
		searchPlaceholder: ae,
		searchClearAriaLabel: oe,
		searchIconPath: se?.searchIcon,
		searchClearIconPath: se?.clearIcon,
		searchClassName: c.chatHistorySearch || void 0,
		...Ye,
		children: Xe.map((e) => /* @__PURE__ */ N(Er, {
			title: e.title,
			className: c.chatHistorySection || void 0,
			children: e.sessions.map((e) => /* @__PURE__ */ N(Tr, {
				sessionId: e.sessionId,
				summary: e.summary,
				active: e.active,
				createdAt: e.createdAt,
				snippet: e.snippet,
				highlightText: ce,
				onSelectSession: S,
				className: c.chatHistoryItem || void 0,
				tooltipClassName: c.helperTooltip || void 0,
				locale: Oe()?.locale
			}, e.sessionId))
		}, e.code))
	}) : /* @__PURE__ */ qr(Sr, {
		className: c.chat || void 0,
		children: [
			/* @__PURE__ */ qr("div", {
				className: "flx-chat-header-wrapper",
				children: [/* @__PURE__ */ N(Cr, {
					className: c.chatHeader || void 0,
					chatAvatar: s.header,
					title: a?.title,
					subtitle: a?.subtitle,
					showSeparator: a?.showSeparator,
					onHistory: y,
					historyIcon: de?.historyIcon ?? void 0,
					...Ye
				}), h && /* @__PURE__ */ N("div", {
					className: "flx-chat-header-controls-slot",
					children: h
				})]
			}),
			/* @__PURE__ */ qr(jr, {
				hasMoreMessages: fe,
				loadingMore: T,
				onLoadMore: pe,
				className: c.chatMessages || void 0,
				children: [t.map(({ id: t, messageId: n, feedback: r, sender: i, content: l, hasError: u, audioUrl: d, voiceMessageStatus: f, audioDuration: p, onRetryVoice: m, files: h, timestamp: g }, _, v) => /* @__PURE__ */ N(Or, {
					message: {
						id: t,
						messageId: n,
						feedback: r,
						sender: i,
						content: l,
						hasError: u,
						audioUrl: d,
						voiceMessageStatus: f,
						audioDuration: p,
						onRetryVoice: m,
						files: h,
						timestamp: g
					},
					messageActions: qe(v[_], _ === v.length - 1),
					suggestedPrompts: _ === v.length - 1 ? Je : void 0,
					chatAvatar: i === "receiver" ? s.agent : void 0,
					errorIcon: o.errorIcon || void 0,
					errorMessage: a?.errorMessage,
					fetchAudio: e,
					voicePlayIconPath: o.voiceMessageIcons?.playIcon,
					voicePauseIconPath: o.voiceMessageIcons?.pauseIcon,
					voiceRetryIconPath: o.voiceMessageIcons?.retryIcon,
					voiceSendingLabel: E?.sendingLabel,
					voiceErrorLabel: E?.errorLabel,
					voiceRetryAriaLabel: E?.retryAriaLabel,
					voiceMessageLabel: E?.messageLabel,
					voicePlayAriaLabel: E?.messagePlayAriaLabel,
					voicePauseAriaLabel: E?.messagePauseAriaLabel,
					voiceProgressAriaLabel: E?.progressAriaLabel,
					downloadIconPath: o.fileDownloadIcon || void 0,
					downloadFile: Fe,
					attachmentsLabels: Pe,
					className: Xn(i === "receiver" ? c.chatAgentMessage || void 0 : c.chatUserMessage || void 0, i !== "receiver" && c.chatUserFileAttachments, u && c.chatErrorMessage)
				}, `${t}-${i}`)), n ? /* @__PURE__ */ N(Mr, {
					className: Xn(c.chatAgentMessage),
					message: a?.thinkingMessage,
					avatar: s.agent
				}) : null]
			}),
			Ie ? /* @__PURE__ */ N(Ar, {
				open: !!ze,
				title: Ie.feedbackTitle,
				reasons: Ie.feedbackReasons,
				reason: ze?.feedback?.reason ?? null,
				comment: ze?.feedback?.comment ?? null,
				isEdit: !!ze?.feedback,
				placeholder: Ie.feedbackPlaceholder,
				commentError: Ie.feedbackCommentError,
				cancelLabel: Ie.feedbackCancelLabel,
				submitLabel: Ie.feedbackSubmitLabel,
				removeLabel: Ie.feedbackRemoveLabel,
				onSubmit: (e) => Ve?.(e),
				onCancel: () => Ge?.(),
				onRemove: () => We?.(),
				className: c.feedbackModal || void 0,
				headerClassName: c.feedbackModalHeader || void 0,
				bodyClassName: c.chatMessageFeedback || void 0,
				textAreaClassName: c.feedbackTextArea || void 0,
				errorClassName: c.feedbackError || void 0,
				buttonClassName: c.button || void 0,
				container: Ke
			}) : null,
			/* @__PURE__ */ N(Dr, {
				sendMessage: l,
				inputPlaceholder: a?.inputPlaceholder || "Type your message...",
				className: Xn(c.chatInputArea, c.chatInputFileAttachments) || void 0,
				textAreaClassName: c.textArea || void 0,
				buttonClassName: c.button || c.chatHeaderButton || void 0,
				messageInput: "",
				sendDisabled: n,
				inputDisabled: be,
				inputDisabledTooltip: xe,
				onStopResponse: ye,
				stopIconPath: o.stopIcon || void 0,
				maxInputRows: a?.maxInputRows,
				sendIconPath: o.sendIcon || void 0,
				sendAriaLabel: me,
				sendTooltip: he,
				stopAriaLabel: ge,
				stopTooltip: _e,
				tooltipClassName: c.helperTooltip || void 0,
				voiceMicIconPath: o.voiceMicIcon || void 0,
				voiceMicAriaLabel: ve,
				onVoiceMessage: g,
				showVoiceInput: _ && !be,
				voiceCancelIconPath: o.voiceInputIcons?.cancelIcon,
				voiceConfirmIconPath: o.voiceInputIcons?.confirmIcon,
				voiceDeleteIconPath: o.voiceInputIcons?.deleteIcon,
				voicePlayIconPath: o.voiceInputIcons?.playIcon,
				voicePauseIconPath: o.voiceInputIcons?.pauseIcon,
				voiceListeningLabel: E?.listeningLabel,
				voiceMessageLabel: E?.voiceMessageLabel,
				voiceCancelAriaLabel: E?.cancelAriaLabel,
				voiceConfirmAriaLabel: E?.confirmAriaLabel,
				voiceDeleteAriaLabel: E?.deleteAriaLabel,
				voicePlayAriaLabel: E?.inputPlayAriaLabel,
				voicePauseAriaLabel: E?.inputPauseAriaLabel,
				voiceProgressAriaLabel: E?.progressAriaLabel,
				showFileUpload: Se && !be,
				accept: Ce,
				maxFiles: we,
				maxFilesSize: Te,
				invalidFileTypeError: Ee,
				filesExceededError: De,
				filesSizeExceededError: ke,
				uploadError: Ae,
				attachIconPath: o.attachFileIcon || void 0,
				deleteIconPath: o.fileDeleteIcon || void 0,
				attachmentsLabels: Pe,
				attachments: je,
				onAttachmentsChange: Me,
				onAttachmentsMessage: Ne
			})
		]
	});
}, Lw = (e) => {
	if (!e || typeof e != "object") return null;
	let t = e.value, n = e.appId, r = `${typeof n == "string" ? n : ""}${typeof t == "string" ? t : ""}`;
	return r ? at(r) ?? null : null;
}, Rw = (e, t) => {
	let n = gr(e, t);
	return n ? at(n) ?? null : null;
}, zw = (e) => {
	if (!e || typeof e != "object" || Array.isArray(e)) return;
	let t = e;
	if (typeof t.src == "string" && typeof t.alt == "string") return {
		src: t.src,
		alt: t.alt
	};
}, Bw = (e, t = !1) => {
	let n = k(() => ({
		welcomeMessage: e?.welcomeMessage,
		thinkingMessage: e?.thinkingMessage,
		title: e?.title,
		subtitle: e?.subtitle,
		showChatIcon: e?.showChatIcon,
		showSeparator: e?.showSeparator,
		newChatLabel: e?.newChatLabel,
		errorMessage: e?.errorMessage,
		canRegenerate: e?.canRegenerate,
		regenerateLabel: e?.regenerateLabel,
		inputPlaceholder: e?.inputPlaceholder,
		maxInputRows: e?.maxInputRows,
		suggestedPrompts: It(e?.suggestedPrompts),
		suggestedPromptsTitle: e?.suggestedPromptsTitle,
		historyTitle: e?.historyTitle
	}), [e]), r = k(() => ({
		headerIcon: Lw(e?.headerIcon) ?? Rw(j.ChatHeader, "headerIcon"),
		agentIcon: Lw(e?.agentIcon) ?? Rw(j.ChatAgentMessage, "agentIcon"),
		sendIcon: Lw(e?.sendIcon) ?? Rw(j.ChatInputArea, "sendMessageIcon"),
		stopIcon: Rw(j.ChatInputArea, "stopResponseIcon"),
		errorIcon: Rw(j.ChatErrorMessage, "errorIcon"),
		voiceMicIcon: Rw(j.ChatInputArea, "voiceInputIcon"),
		attachFileIcon: Rw(j.ChatInputArea, "attachFileIcon"),
		fileDeleteIcon: Rw(j.ChatInputFileItem, "deleteIcon"),
		fileDownloadIcon: Rw(j.ChatUserFileItem, "downloadIcon"),
		voiceInputIcons: {
			cancelIcon: Rw(j.ChatVoiceInput, "cancelIcon"),
			confirmIcon: Rw(j.ChatVoiceInput, "confirmIcon"),
			deleteIcon: Rw(j.ChatVoiceInput, "deleteIcon"),
			playIcon: Rw(j.ChatVoiceInput, "playIcon"),
			pauseIcon: Rw(j.ChatVoiceInput, "pauseIcon")
		},
		voiceMessageIcons: {
			playIcon: Rw(j.ChatUserVoiceMessage, "playIcon"),
			pauseIcon: Rw(j.ChatUserVoiceMessage, "pauseIcon"),
			retryIcon: Rw(j.ChatUserVoiceMessage, "retryIcon")
		},
		messageActionsIcons: {
			copyIcon: Rw(j.ChatMessageActions, "copyIcon"),
			copySuccessIcon: Rw(j.ChatMessageActions, "copySuccessIcon"),
			thumbUpIcon: Rw(j.ChatMessageActions, "thumbUpIcon"),
			thumbUpSelectedIcon: Rw(j.ChatMessageActions, "thumbUpSelectedIcon"),
			thumbDownIcon: Rw(j.ChatMessageActions, "thumbDownIcon"),
			thumbDownSelectedIcon: Rw(j.ChatMessageActions, "thumbDownSelectedIcon")
		}
	}), [
		e?.headerIcon,
		e?.agentIcon,
		e?.sendIcon,
		t
	]), i = k(() => ({
		newChatIcon: Rw(j.ChatHeader, "newChatIcon"),
		historyIcon: Rw(j.ChatHeader, "historyIcon"),
		backIcon: Rw(j.ChatHeader, "backIcon")
	}), [t]), a = k(() => ({
		searchIcon: Rw(j.ChatHistorySearch, "searchIcon"),
		clearIcon: Rw(j.ChatHistorySearch, "clearIcon")
	}), [t]);
	return {
		chatConfig: n,
		chatIcons: r,
		chatHeaderAvatar: k(() => {
			if (e?.showChatIcon !== !1) return r.headerIcon ? {
				src: r.headerIcon,
				alt: "Chat header icon"
			} : zw(e?.chatAvatar);
		}, [
			e?.showChatIcon,
			e?.chatAvatar,
			r.headerIcon
		]),
		headerActionIcons: i,
		searchIcons: a
	};
}, Vw = () => {
	let [e, t] = Un([]), [n, r] = Un(null), [i, a] = Un(!0), [o, s] = Un(!1), c = k(() => er([Te.stream$, E.stream$]).pipe(sr(([e, t]) => ({
		store: e,
		currentId: t
	}))), []);
	return qn(c, ({ store: e, currentId: n }) => {
		r(n);
		let i = Object.entries(e).map(([e, t]) => ({
			sessionId: e,
			summary: t.summary,
			messageCount: t.messageCount,
			active: e === n,
			createdAt: t.createdAt
		}));
		t(i);
	}), qn(ke.stream$, (e) => {
		a(e.hasMore), s(e.loading);
	}), {
		sessions: e,
		activeSessionId: n,
		selectSession: O((e) => {
			dn(e), Dn("chatSessionId", e), Ot(e);
		}, []),
		hasMoreSessions: i,
		loadingMoreSessions: o
	};
}, Hw = (e) => k(() => ({
	chat: [
		M(j.Chat),
		M(j.ChatVoiceInput),
		M(j.ChatUserVoiceMessage)
	].filter(Boolean).join(" ") || null,
	chatHeader: M(j.ChatHeader),
	chatMessages: M(j.ChatMessages),
	chatMessageActions: M(j.ChatMessageActions),
	chatMessageFeedback: [M(j.ChatMessageFeedback), M(j.ChatMessageFeedbackReason)].filter(Boolean).join(" ") || null,
	chatInputArea: M(j.ChatInputArea),
	chatUserMessage: M(j.ChatUserMessage),
	chatAgentMessage: M(j.ChatAgentMessage),
	chatErrorMessage: M(j.ChatErrorMessage),
	chatInput: M(j.ChatInput),
	chatHeaderButton: M(j.ChatHeaderButton),
	chatInputFileAttachments: [M(j.ChatInputFileAttachments), M(j.ChatInputFileItem)].filter(Boolean).join(" ") || null,
	chatUserFileAttachments: [M(j.ChatUserFileAttachments), M(j.ChatUserFileItem)].filter(Boolean).join(" ") || null,
	chatSuggestedPrompts: [
		M(j.ChatSuggestedPrompts),
		M(j.ChatSuggestedPromptsSection),
		M(j.ChatSuggestedPromptsItem)
	].filter(Boolean).join(" ") || null,
	chatHistory: M(j.ChatHistory),
	chatHistoryItem: M(j.ChatHistoryItem),
	chatHistorySection: M(j.ChatHistorySection),
	chatHistorySearch: M(j.ChatHistorySearch),
	helperTooltip: M(j.HelperTooltip),
	textArea: M(j.ChatInput),
	button: M(j.Button),
	feedbackTextArea: M(j.Textarea),
	feedbackError: M(j.Error),
	feedbackModal: M(j.Modal),
	feedbackModalHeader: M(j.ModalHeader)
}), [e]), Uw, Ww = /* @__PURE__ */ new Uint8Array(16);
function Gw() {
	if (!Uw && (Uw = typeof crypto < "u" && crypto.getRandomValues && crypto.getRandomValues.bind(crypto), !Uw)) throw Error("crypto.getRandomValues() not supported. See https://github.com/uuidjs/uuid#getrandomvalues-not-supported");
	return Uw(Ww);
}
// node_modules/uuid/dist/esm-browser/stringify.js
var Kw = [];
for (let e = 0; e < 256; ++e) Kw.push((e + 256).toString(16).slice(1));
function qw(e, t = 0) {
	return Kw[e[t + 0]] + Kw[e[t + 1]] + Kw[e[t + 2]] + Kw[e[t + 3]] + "-" + Kw[e[t + 4]] + Kw[e[t + 5]] + "-" + Kw[e[t + 6]] + Kw[e[t + 7]] + "-" + Kw[e[t + 8]] + Kw[e[t + 9]] + "-" + Kw[e[t + 10]] + Kw[e[t + 11]] + Kw[e[t + 12]] + Kw[e[t + 13]] + Kw[e[t + 14]] + Kw[e[t + 15]];
}
var Jw = { randomUUID: typeof crypto < "u" && crypto.randomUUID && crypto.randomUUID.bind(crypto) };
// node_modules/uuid/dist/esm-browser/v4.js
function Yw(e, t, n) {
	if (Jw.randomUUID && !t && !e) return Jw.randomUUID();
	e ||= {};
	let r = e.random || (e.rng || Gw)();
	if (r[6] = r[6] & 15 | 64, r[8] = r[8] & 63 | 128, t) {
		n ||= 0;
		for (let e = 0; e < 16; ++e) t[n + e] = r[e];
		return t;
	}
	return qw(r);
}
// libs/sdk/react/src/components/sdk/chat-renderer/utils/messageUtils.ts
var Xw = (e) => ({
	id: Yw(),
	content: e,
	sender: "receiver",
	timestamp: /* @__PURE__ */ new Date(),
	isWelcome: !0
}), Zw = (e, t) => e.filter((e) => e.message || e.type === ce.AUDIO || e.type === ce.ATTACHMENTS).map((e) => {
	let n = e._id ?? Yw(), r = e.type === ce.AUDIO, i;
	if (r && e.audioFile?.downloadPath) {
		let { apiUrl: t } = Oe();
		i = `${t}/document/${e.audioFile.downloadPath}`;
	}
	let a = e.type === ce.ATTACHMENTS, o;
	if (a && e.files?.length) {
		let { apiUrl: t } = Oe();
		o = e.files.map((e) => {
			let n = e.originalFileName || e.downloadPath.split("/").pop() || e.downloadPath;
			return {
				name: n,
				extension: Ur(n),
				mimeType: e.mimeType ?? "",
				downloadUrl: `${t}/document/${e.downloadPath}`
			};
		});
	}
	return {
		id: n,
		messageId: e.messageId,
		feedback: e.feedback ?? null,
		content: r ? "" : e.message,
		sender: e.actor === "human" ? "sender" : "receiver",
		timestamp: rn(n, e.timestamp, t),
		...i ? { audioUrl: i } : {},
		...r && e.audioFile?.duration ? { audioDuration: e.audioFile.duration } : {},
		...o ? { files: o } : {},
		...e.suggestions?.length ? { suggestions: e.suggestions } : {}
	};
}), Qw = (e, t, r = {}) => {
	let { language: i, locale: o, themeId: s, projectId: c, workspaceId: l, buildId: u, cache: d = !0, source: f } = e, { apiUrl: p, processApiPath: m, staticAssetsPath: h, authToken: g } = Qt(e), _ = g, [v, y] = Un(!1), [b, x] = Un(() => t ? [Xw(t)] : []), [S, ee] = Un(!1), [te, ne] = Un(!0), [ie, ae] = Un([]), [oe, se] = Un(!1), [le, ue] = Un(!1), [de, fe] = Un(null), T = A(null), pe = A(null), E = A(null), me = A(/* @__PURE__ */ new Map()), he = C(r), { applyCachedAudioUrls: ge, seedCache: _e } = a(b, x), { pendingVoice: ve, handleVoiceMessage: ye, handleRetryVoice: be, clearPendingVoice: xe, checkAndClearPendingVoice: Se } = w(_e, T, ee, r.voiceInput), { attachments: Ce, setAttachments: we, uploadError: Te, handleAttachmentsMessage: Ee, clearAttachments: De } = n(T, he.textMessageSent), Oe = k(() => ({
		authToken: _,
		apiUrl: p,
		staticAssetsPath: h,
		processApiPath: m,
		language: i,
		locale: o,
		themeId: s,
		projectId: c,
		workspaceId: l,
		buildId: u,
		cache: d,
		source: f
	}), [
		_,
		p,
		h,
		m,
		i,
		o,
		s,
		c,
		l,
		u,
		d,
		f
	]);
	return Vn(() => {
		let e = !0;
		return y(!1), x(t ? [Xw(t)] : []), ee(!1), fe(null), xe(), vt({
			authToken: _,
			apiUrl: p,
			staticAssetsPath: h,
			processApiPath: m,
			language: i,
			locale: o,
			themeId: s,
			workspaceId: l,
			buildId: u,
			source: f,
			appInfo: {
				appId: c,
				appVersionId: u
			},
			cache: d
		}).then(({ sendMessage: t, chat$: n, loadMoreMessages: r, stopResponse: i }) => {
			e && (T.current = t, pe.current = r, E.current = i, y(!0), fe(n));
		}), () => {
			e = !1, qt();
		};
	}, [
		Oe,
		_,
		p,
		h,
		m,
		i,
		o,
		s,
		l,
		u,
		d,
		f,
		c,
		t,
		xe
	]), qn(de ?? $n, ({ chatHistory: e, loading: n, hasMoreMessages: r, loadingMore: i }) => {
		if (ee(n), se(r ?? !1), ue(i ?? !1), ne(!e?.length), !e?.length) ae([]), x(t ? [Xw(t)] : []);
		else {
			ae(Qe(e));
			let t = Zw(e, me.current);
			Se(t), x(ge(t));
		}
	}), {
		chatLoaded: v,
		messages: k(() => re(b, ve, (e, t) => ({
			id: e.id,
			content: "",
			sender: "sender",
			timestamp: /* @__PURE__ */ new Date(),
			voiceMessageStatus: e.status,
			audioDuration: e.duration,
			onRetryVoice: t,
			...e.downloadUrl ? { audioUrl: e.downloadUrl } : {}
		}), be), [
			b,
			ve,
			be
		]),
		reasoning: S,
		showSuggestedPrompts: te,
		agentSuggestions: ie,
		handleSendMessage: O((e) => {
			T.current && (T.current(e), he.textMessageSent());
		}, [he]),
		handleSendSuggestedPrompt: O((e) => {
			T.current && (T.current(e.label, {
				type: ce.SUGGESTED_PROMPT,
				label: e.label,
				prompt: e.prompt || ""
			}), he.agentPromptSelected());
		}, [he]),
		handleSendConfiguredPrompt: O((e) => {
			T.current && (T.current(e.label), he.configuredPromptSelected(e.label));
		}, [he]),
		handleNewChat: O(() => {
			let e = yt();
			Dn("chatSessionId", e), me.current.clear(), x(t ? [Xw(t)] : []), ee(!1), ne(!0), ae([]), xe(), De();
		}, [
			t,
			xe,
			De
		]),
		handleVoiceMessage: ye,
		hasMoreMessages: oe,
		loadingMore: le,
		handleLoadMore: O(() => {
			oe && !le && pe.current?.();
		}, [oe, le]),
		handleStopResponse: O(() => {
			E.current?.();
		}, []),
		attachments: Ce,
		onAttachmentsChange: we,
		attachmentsUploadError: Te,
		handleAttachmentsMessage: Ee
	};
}, $w = (e) => {
	let { analytics: t } = e, n = e.chatConfig?.suggestedPrompts, r = e.messageActions?.feedbackReasons, i = k(() => we({
		analytics: t,
		suggestedPrompts: n,
		feedbackReasons: r
	}), [
		t,
		n,
		r
	]), a = C(i), s = Qw(e, e.chatConfig?.welcomeMessage, i), c = Bw(e.chatConfig, s.chatLoaded), l = Hw(s.chatLoaded), u = Vw(), d = o(e.source.id), f = te(i.messageActions), [p, m] = Un("chat"), h = k(() => c.chatIcons.agentIcon ? {
		src: c.chatIcons.agentIcon,
		alt: "Chat agent icon"
	} : c.chatHeaderAvatar, [c.chatHeaderAvatar, c.chatIcons.agentIcon]), g = O(async () => {
		try {
			await kt(e.source.id);
		} catch (e) {
			console.error("Failed to load conversations list", e);
		}
		m("history");
	}, [e.source.id]), _ = O(() => {
		d.clearSearch(), m("chat");
	}, [d.clearSearch]), v = O(async () => {
		await At(e.source.id);
	}, [e.source.id]), y = O(() => {
		s.handleNewChat(), m("chat");
	}, [s.handleNewChat]), b = O((e) => {
		u.selectSession(e), d.clearSearch(), m("chat");
	}, [u.selectSession, d.clearSearch]), x = k(() => ({
		newChat: D("@@sys_chat_tooltip_new_chat"),
		history: D("@@sys_chat_tooltip_chat_history"),
		back: D("@@sys_chat_tooltip_back")
	}), [s.chatLoaded]), S = k(() => D("@@sys_chat_conversations_empty_state"), [s.chatLoaded]), { searchPlaceholder: w, searchClearAriaLabel: ee, noSearchResultsText: ne } = k(() => ({
		searchPlaceholder: D("@@sys_chat_conversations_search_placeholder"),
		searchClearAriaLabel: D("@@sys_a11y_conversations_search_clear"),
		noSearchResultsText: D("@@sys_chat_conversations_no_results")
	}), [s.chatLoaded]), re = k(() => ({
		sys_chat_time_group_today: D("@@sys_chat_time_group_today"),
		sys_chat_time_group_yesterday: D("@@sys_chat_time_group_yesterday"),
		sys_chat_time_group_previous_7_days: D("@@sys_chat_time_group_previous_7_days"),
		sys_chat_time_group_previous_30_days: D("@@sys_chat_time_group_previous_30_days"),
		sys_chat_time_group_older: D("@@sys_chat_time_group_older")
	}), [s.chatLoaded]), ie = k(() => ({
		listeningLabel: D("@@sys_chat_voice_input_recording"),
		voiceMessageLabel: D("@@sys_chat_voice_input_message"),
		cancelAriaLabel: D("@@sys_a11y_chat_voice_input_cancel"),
		confirmAriaLabel: D("@@sys_a11y_chat_voice_input_confirm"),
		deleteAriaLabel: D("@@sys_a11y_chat_voice_input_delete"),
		inputPlayAriaLabel: D("@@sys_a11y_chat_voice_input_play"),
		inputPauseAriaLabel: D("@@sys_a11y_chat_voice_input_pause"),
		sendingLabel: D("@@sys_chat_voice_message_sending"),
		messageLabel: D("@@sys_chat_voice_message"),
		errorLabel: D("@@sys_chat_voice_message_error"),
		messagePlayAriaLabel: D("@@sys_a11y_chat_voice_message_play"),
		messagePauseAriaLabel: D("@@sys_a11y_chat_voice_message_pause"),
		retryAriaLabel: D("@@sys_a11y_chat_voice_message_retry"),
		progressAriaLabel: D("@@sys_a11y_chat_voice_message_progress")
	}), [s.chatLoaded]), ae = k(() => D("@@sys_a11y_chat_voice_input_record"), [s.chatLoaded]), { sendAriaLabel: oe, sendTooltip: se, stopAriaLabel: ce, stopTooltip: le } = k(() => ({
		sendAriaLabel: D("@@sys_a11y_chat_submit_message"),
		sendTooltip: D("@@sys_chat_submit_message"),
		stopAriaLabel: D("@@sys_a11y_chat_cancel_request"),
		stopTooltip: D("@@sys_chat_cancel_request")
	}), [s.chatLoaded]), ue = k(() => ({
		attachAriaLabel: D("@@sys_a11y_chat_attach_files"),
		removeAriaLabel: D("@@sys_a11y_chat_remove_file"),
		downloadAriaLabel: D("@@sys_a11y_chat_download_file")
	}), [s.chatLoaded]), de = k(() => {
		let t = e.fileUpload;
		return {
			showFileUpload: t?.enabled ?? !1,
			accept: t?.accept ?? "*/*",
			maxFiles: t?.maxFiles,
			maxFilesSize: t?.maxFilesSize,
			invalidTypeError: t?.invalidFileTypeError || "This format is not accepted",
			countExceededError: t?.filesExceededError || "Only maximum 10 files allowed",
			sizeExceededError: t?.filesSizeExceededError || "This file is too large"
		};
	}, [e.fileUpload]), fe = k(() => {
		let t = e.messageActions;
		if (t?.enabled !== !1) return nn(t, D);
	}, [e.messageActions, s.chatLoaded]), T = k(() => xe(D), [s.chatLoaded]), pe = O(async (e) => {
		if (!e.downloadUrl) return;
		let t = await Ie(e.downloadUrl);
		if (!t) return;
		let n = URL.createObjectURL(t), r = document.createElement("a");
		r.href = n, r.download = e.name, r.click(), URL.revokeObjectURL(n);
	}, []);
	return k(() => ({
		chatLoaded: s.chatLoaded,
		messages: s.messages,
		reasoning: s.reasoning,
		showSuggestedPrompts: s.showSuggestedPrompts,
		agentSuggestions: s.agentSuggestions,
		handleSendMessage: s.handleSendMessage,
		handleSendSuggestedPrompt: s.handleSendSuggestedPrompt,
		handleSendConfiguredPrompt: s.handleSendConfiguredPrompt,
		handleMessageCopied: a.messageCopied,
		handleNewChat: y,
		handleVoiceMessage: s.handleVoiceMessage,
		chatConfig: c.chatConfig,
		chatIcons: c.chatIcons,
		chatHeaderAvatar: c.chatHeaderAvatar,
		chatAgentAvatar: h,
		classNames: l,
		activeView: p,
		chatSessions: d.isSearchActive ? d.searchSessions : u.sessions,
		handleOpenHistory: g,
		handleCloseHistory: _,
		handleSelectSession: b,
		handleLoadMoreSessions: v,
		hasMoreSessions: !d.isSearchActive && u.hasMoreSessions,
		loadingMoreSessions: d.isSearchActive ? d.searchLoading : u.loadingMoreSessions,
		hasMoreMessages: s.hasMoreMessages,
		loadingMore: s.loadingMore,
		handleLoadMore: s.handleLoadMore,
		handleStopResponse: s.handleStopResponse,
		emptyStateText: d.isSearchActive ? d.searchLoading ? "" : ne : S,
		searchValue: d.searchText,
		handleSearchChange: d.onSearchChange,
		handleSearchClear: d.clearSearch,
		searchPlaceholder: w,
		searchClearAriaLabel: ee,
		searchIcons: c.searchIcons,
		searchHighlightText: d.appliedQuery,
		sessionGroupLabels: re,
		headerTooltips: x,
		headerActionIcons: c.headerActionIcons,
		voiceLabels: ie,
		sendAriaLabel: oe,
		sendTooltip: se,
		stopAriaLabel: ce,
		stopTooltip: le,
		voiceMicAriaLabel: ae,
		attachments: s.attachments,
		onAttachmentsChange: s.onAttachmentsChange,
		attachmentsUploadError: s.attachmentsUploadError,
		handleAttachmentsMessage: s.handleAttachmentsMessage,
		downloadAttachment: pe,
		attachmentsLabels: ue,
		fileUploadConfig: de,
		messageActionsConfig: fe,
		messageTimeGroupLabels: T,
		locale: e.locale,
		feedbackTarget: f.feedbackTarget,
		handleFeedbackChange: f.handleFeedbackChange,
		handleFeedbackSubmit: f.handleFeedbackSubmit,
		handleFeedbackRemove: f.handleFeedbackRemove,
		handleFeedbackCancel: f.handleFeedbackCancel
	}), [
		s.chatLoaded,
		s.messages,
		s.reasoning,
		s.showSuggestedPrompts,
		s.agentSuggestions,
		s.handleSendMessage,
		s.handleSendSuggestedPrompt,
		s.handleSendConfiguredPrompt,
		a,
		y,
		s.handleVoiceMessage,
		s.hasMoreMessages,
		s.loadingMore,
		s.handleLoadMore,
		s.handleStopResponse,
		s.attachments,
		s.onAttachmentsChange,
		s.attachmentsUploadError,
		s.handleAttachmentsMessage,
		pe,
		ue,
		de,
		fe,
		T,
		e.locale,
		c.chatConfig,
		c.chatIcons,
		c.chatHeaderAvatar,
		c.headerActionIcons,
		h,
		l,
		p,
		u.sessions,
		u.hasMoreSessions,
		u.loadingMoreSessions,
		d.isSearchActive,
		d.searchSessions,
		d.searchLoading,
		d.searchText,
		d.onSearchChange,
		d.clearSearch,
		d.appliedQuery,
		c.searchIcons,
		w,
		ee,
		ne,
		g,
		_,
		b,
		v,
		S,
		re,
		x,
		ie,
		ae,
		f.feedbackTarget,
		f.handleFeedbackChange,
		f.handleFeedbackSubmit,
		f.handleFeedbackRemove,
		f.handleFeedbackCancel
	]);
}, eT = (e) => {
	let t = $w(e);
	return t.chatLoaded ? /* @__PURE__ */ N(Hr.Provider, { children: /* @__PURE__ */ N("div", {
		className: "flx-chat-renderer",
		children: /* @__PURE__ */ N(Iw, {
			messages: t.messages,
			reasoning: t.reasoning,
			showSuggestedPrompts: t.showSuggestedPrompts,
			agentSuggestions: t.agentSuggestions,
			chatConfig: t.chatConfig,
			chatIcons: t.chatIcons,
			avatars: {
				header: t.chatHeaderAvatar,
				agent: t.chatAgentAvatar
			},
			classNames: t.classNames,
			onSendMessage: t.handleSendMessage,
			onSendSuggestedPrompt: t.handleSendSuggestedPrompt,
			onSendConfiguredPrompt: t.handleSendConfiguredPrompt,
			onMessageCopied: t.handleMessageCopied,
			onNewChat: t.handleNewChat,
			onVoiceMessage: t.handleVoiceMessage,
			showVoiceInput: !0,
			activeView: t.activeView,
			onHistory: t.handleOpenHistory,
			onBackFromHistory: t.handleCloseHistory,
			chatSessions: t.chatSessions,
			onSelectSession: t.handleSelectSession,
			onLoadMoreSessions: t.handleLoadMoreSessions,
			hasMoreSessions: t.hasMoreSessions,
			loadingMoreSessions: t.loadingMoreSessions,
			hasMoreMessages: t.hasMoreMessages,
			loadingMore: t.loadingMore,
			onLoadMore: t.handleLoadMore,
			emptyStateText: t.emptyStateText,
			searchValue: t.searchValue,
			onSearchChange: t.handleSearchChange,
			onSearchClear: t.handleSearchClear,
			searchPlaceholder: t.searchPlaceholder,
			searchClearAriaLabel: t.searchClearAriaLabel,
			searchIcons: t.searchIcons,
			searchHighlightText: t.searchHighlightText,
			sessionGroupLabels: t.sessionGroupLabels,
			headerTooltips: t.headerTooltips,
			headerActionIcons: t.headerActionIcons,
			voiceLabels: t.voiceLabels,
			sendAriaLabel: t.sendAriaLabel,
			sendTooltip: t.sendTooltip,
			stopAriaLabel: t.stopAriaLabel,
			stopTooltip: t.stopTooltip,
			voiceMicAriaLabel: t.voiceMicAriaLabel,
			onStopResponse: t.handleStopResponse,
			inputDisabled: e.inputDisabled ?? !1,
			inputDisabledTooltip: D("@@sys_chat_disabled_input"),
			showFileUpload: t.fileUploadConfig.showFileUpload,
			fileAccept: t.fileUploadConfig.accept,
			fileMaxFiles: t.fileUploadConfig.maxFiles,
			fileMaxFilesSize: t.fileUploadConfig.maxFilesSize,
			fileInvalidTypeError: t.fileUploadConfig.invalidTypeError,
			fileCountExceededError: t.fileUploadConfig.countExceededError,
			fileSizeExceededError: t.fileUploadConfig.sizeExceededError,
			attachmentsUploadError: t.attachmentsUploadError,
			attachments: t.attachments,
			onAttachmentsChange: t.onAttachmentsChange,
			onAttachmentsMessage: t.handleAttachmentsMessage,
			attachmentsLabels: t.attachmentsLabels,
			downloadFile: t.downloadAttachment,
			messageActionsConfig: t.messageActionsConfig,
			messageTimeGroupLabels: t.messageTimeGroupLabels,
			locale: t.locale,
			feedbackTarget: t.feedbackTarget,
			onFeedbackChange: (e, n) => t.handleFeedbackChange(e, n, t.messages.find((t) => t.messageId === e && t.sender === "receiver")?.feedback ?? null),
			onFeedbackSubmit: t.handleFeedbackSubmit,
			onFeedbackRemove: t.handleFeedbackRemove,
			onFeedbackCancel: t.handleFeedbackCancel
		})
	}) }) : /* @__PURE__ */ N("div", {
		className: "flx-chat-renderer-loading",
		children: /* @__PURE__ */ N(Ir, { visualType: "custom" })
	});
}, tT = (e, t) => {
	let [n, r] = Un([]);
	return Vn(() => {
		Xe(e, t).then(r);
	}, [e, t]), n;
}, nT = Me("useEnumeration", "useEnumerationItems", tT);
// libs/sdk/react/src/lib/custom-component-runtime/CustomComponentTest.tsx
function rT({ customComponentInfo: e }) {
	let [t, n] = Un(0);
	return Vn(() => (Xt(), Ct(e), n((e) => e + 1), () => {
		Xt();
	}), [e]), /* @__PURE__ */ N(gC, { config: Mt(e.componentDefinitions) }, t);
}
// libs/sdk/react/src/index.ts
var iT = /* @__PURE__ */ r({
	FlxChatRenderer: () => eT,
	FlxCustomComponentTest: () => rT,
	FlxProcessRenderer: () => EC,
	FlxProcessRendererPortal: () => yw,
	FlxTaskManager: () => u,
	FlxTemplateRenderer: () => Pw,
	FlxTemplateRendererPortal: () => Fw,
	FlxUiFlowRenderer: () => Mw,
	FlxUiFlowRendererPortal: () => Nw,
	SseMessageType: () => de,
	SseTaskEventType: () => fe,
	SseTaskMessageType: () => T,
	TaskActions: () => pe,
	fetchBulkAssignees: () => Fe,
	fetchTaskAssignees: () => Le,
	fetchTaskComments: () => Re,
	fetchTaskHistory: () => ze,
	fetchView: () => Be,
	fetchViewTasks: () => Ve,
	getEnumeration: () => Ye,
	getEnumerationItems: () => Xe,
	getEnumerationOptions: () => Ze,
	getMediaItemUrl: () => $e,
	getStaticAsset: () => it,
	getSubstitutionTag: () => st,
	getSubstitutionTagContent: () => ct,
	getTaskManagerResources: () => lt,
	initSseConnection: () => St,
	removeComment: () => Gt,
	saveComment: () => sn,
	updateBulkTaskAction: () => wn,
	updateTaskAction: () => Tn,
	updateTaskPriority: () => En,
	useBoolExpression: () => ie,
	useComputedValue: () => ne,
	useDynamicValue: () => ee,
	useEnumeration: () => nT,
	useEnumerationItems: () => tT
});
export { Pw as A, oC as B, Gt as C, En as D, Tn as E, yw as F, EC as I, TC as L, Mw as M, Sw as N, eT as O, xw as P, gC as R, St as S, wn as T, ze as _, it as a, Ze as b, nT as c, fe as d, T as f, Re as g, Le as h, $e as i, Nw as j, Fw as k, tT as l, Fe as m, Ye as n, st as o, pe as p, Xe as r, ct as s, rT as t, de as u, Be as v, sn as w, lt as x, Ve as y, pC as z };
